import { Prop } from '../interfaces/prop.interface';

export const propsJson: Prop[] = [
    {
        "id": "647ee90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Subarrendado (gestión)",
        "strategy": "1: SALE 2:RENT 3:BOTH",
        "address": " Torras Y Bages 51 ",
        "postalCode": "08030",
        "city": "1108019",
        "province": "08",
        "CCAA": "55",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "242.68",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "242.68",
        "surfaceTotal": "242.68",
        "timeAvailableFrom": "9/13/22 13:22",
        "name": "Nombre del Local",
        "visible": true,
        "features": "Terrace, Parking space included, Storeroom, Good condition",
        "highLights": "Incluidas 90 plazas de aparcamiento en el precio, Edificio exclusivo en parque empresarial, Rápido acceso a A-1, M-40, M-50 y R-2",
        "descShort": "Descripción corta",
        "descLong": "Descripción larga",
        "comment": "¡En oferta!",
        "lat": 41.4387768,
        "lng": 2.1908719,
        "id_ext": "0000FICTICIO-0000ficticio-114559"
    },
    {
        "id": "a47ce90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "2",
        "address": "Plaza Puerta De Ávila 18 ",
        "postalCode": "37700",
        "city": "1137046",
        "province": "37",
        "CCAA": "59",
        "country": "ES",
        "use": "5",
        "surfacebr": "146.25",
        "surfaceMezzanine": "0.00",
        "surfacepb": "219.37",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "263.25",
        "surfaceTotal": "365.62",
        "timeAvailableFrom": "9/13/22 13:21",
        "lat": 40.3858218,
        "lng": -5.7651022,
        "id_ext": "0049-GEN000-100144"
    },
    {
        "id": "a87ce90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "2",
        "askingPriceRent": "1026.67",
        "askingPriceSale": "114846.67",
        "address": "Calle Vera Cruz 2 ",
        "postalCode": "23680",
        "city": "1123002",
        "province": "23",
        "CCAA": "51",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "164.45",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "164.45",
        "surfaceTotal": "164.45",
        "timeAvailableFrom": "9/13/22 13:21",
        "lat": 37.4631074,
        "lng": -3.923405299999999,
        "id_ext": "0049-GEN000-100173"
    },
    {
        "id": "aa7ce90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "2",
        "address": "Calle Corredera De San Fernando 28 ",
        "postalCode": "23400",
        "city": "1123092",
        "province": "23",
        "CCAA": "51",
        "country": "ES",
        "use": "5",
        "surfacebr": "495.78",
        "surfaceMezzanine": "0.00",
        "surfacepb": "837.16",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "985.89",
        "surfaceTotal": "1332.94",
        "timeAvailableFrom": "9/13/22 13:21",
        "lat": 38.0114762,
        "lng": -3.3696754,
        "id_ext": "0049-GEN000-100178"
    },
    {
        "id": "ac7ce90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "2",
        "address": " Onze de Setembre 36 ",
        "postalCode": "17230",
        "city": "1117118",
        "province": "17",
        "CCAA": "55",
        "country": "ES",
        "use": "5",
        "surfacebr": "142.38",
        "surfaceMezzanine": "0.00",
        "surfacepb": "171.75",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "129.71",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "279.32",
        "surfaceTotal": "443.84",
        "timeAvailableFrom": "9/13/22 13:21",
        "lat": 41.8484713,
        "lng": 3.1283736,
        "id_ext": "0049-GEN000-100206"
    },
    {
        "id": "b87ce90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Subarrendado (gestión)",
        "strategy": "2",
        "askingPriceRent": "5866.00",
        "askingPriceSale": "1026550.00",
        "address": "Calle Herradores 47 ",
        "postalCode": "38201",
        "city": "1138023",
        "province": "38",
        "CCAA": "56",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "356.10",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "161.47",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "436.84",
        "surfaceTotal": "517.57",
        "timeAvailableFrom": "9/13/22 13:21",
        "lat": 28.4880088,
        "lng": -16.3168674,
        "id_ext": "0049-GEN000-100257"
    },
    {
        "id": "ba7ce90a-5633-ed11-9db1-0022489c4873",
        "active": false,
        "status": "Vendido",
        "strategy": "1",
        "askingPriceRent": "466.20",
        "askingPriceSale": "62160.00",
        "address": "Calle Real 2 ",
        "city": "1121013",
        "province": "21",
        "CCAA": "51",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "135.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "135.00",
        "surfaceTotal": "135.00",
        "timeAvailableFrom": "9/13/22 13:21",
        "lat": 37.3366246,
        "lng": -6.5362477,
        "id_ext": "0049-GEN000-100263"
    },
    {
        "id": "be7ce90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "2",
        "askingPriceRent": "1862.96",
        "askingPriceSale": "293822.89",
        "address": "Calle Ramiranes 1 ",
        "postalCode": "36400",
        "city": "1136039",
        "province": "36",
        "CCAA": "60",
        "country": "ES",
        "use": "5",
        "surfacebr": "122.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "116.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "119.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "212.10",
        "surfaceTotal": "357.00",
        "timeAvailableFrom": "9/13/22 13:21",
        "lat": 42.16302839999999,
        "lng": -8.6215005,
        "id_ext": "0049-GEN000-100291"
    },
    {
        "id": "c47ce90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "2",
        "askingPriceRent": "3160.50",
        "askingPriceSale": "526750.00",
        "address": "Calle Travessera De Las Corts 3 ",
        "postalCode": "08028",
        "city": "1108019",
        "province": "08",
        "CCAA": "55",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "165.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "165.00",
        "surfaceTotal": "165.00",
        "timeAvailableFrom": "9/13/22 13:21",
        "lat": 41.3760775,
        "lng": 2.1179829,
        "id_ext": "0049-GEN000-100326"
    },
    {
        "id": "c67ce90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Subarrendado (gestión)",
        "strategy": "2",
        "askingPriceRent": "1708.00",
        "askingPriceSale": "239120.00",
        "address": "Calle Antón 23 ",
        "postalCode": "30004",
        "city": "1130030",
        "province": "30",
        "CCAA": "43",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "144.13",
        "surfaceBasement1": "144.13",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "144.13",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "216.20",
        "surfaceTotal": "288.26",
        "timeAvailableFrom": "9/13/22 13:21",
        "lat": 37.9908454,
        "lng": -1.1407818,
        "id_ext": "0049-GEN000-100337"
    },
    {
        "id": "c87ce90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "2",
        "address": "Calle Real 34 ",
        "postalCode": "10210",
        "city": "1110113",
        "province": "10",
        "CCAA": "41",
        "country": "ES",
        "use": "5",
        "surfacebr": "114.81",
        "surfaceMezzanine": "0.00",
        "surfacepb": "139.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "173.44",
        "surfaceTotal": "253.81",
        "timeAvailableFrom": "9/13/22 13:21",
        "lat": 39.4255605,
        "lng": -5.756129899999999,
        "id_ext": "0049-GEN000-100352"
    },
    {
        "id": "ca7ce90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "2",
        "askingPriceRent": "1752.80",
        "askingPriceSale": "262920.00",
        "address": "Calle Morerillas 1 ",
        "postalCode": "41700",
        "city": "1141038",
        "province": "41",
        "CCAA": "51",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "300.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "300.00",
        "surfaceTotal": "300.00",
        "timeAvailableFrom": "9/13/22 13:21",
        "lat": 37.2840388,
        "lng": -5.9215691,
        "id_ext": "0049-GEN000-100356"
    },
    {
        "id": "d27ce90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "2",
        "askingPriceRent": "1578.50",
        "askingPriceSale": "238210.00",
        "address": "Calle Capitán Mendizábal 8 ",
        "postalCode": "48980",
        "city": "1148082",
        "province": "48",
        "CCAA": "53",
        "country": "ES",
        "use": "5",
        "surfacebr": "30.88",
        "surfaceMezzanine": "0.00",
        "surfacepb": "211.28",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "220.54",
        "surfaceTotal": "242.16",
        "timeAvailableFrom": "9/13/22 13:21",
        "lat": 43.3312004,
        "lng": -3.0333872,
        "id_ext": "0049-GEN000-100414"
    },
    {
        "id": "d47ce90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "2",
        "address": "Plaza Villa 2 ",
        "city": "1108169",
        "province": "08",
        "CCAA": "55",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "235.03",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "235.03",
        "surfaceTotal": "235.03",
        "timeAvailableFrom": "9/13/22 13:21",
        "lat": 41.3245953,
        "lng": 2.0934902,
        "id_ext": "0049-GEN000-100428"
    },
    {
        "id": "d87ce90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "2",
        "askingPriceRent": "2114.00",
        "askingPriceSale": "338240.00",
        "address": "Avenida Sancho Sancho El Sabio 33 ",
        "postalCode": "20010",
        "city": "1120069",
        "province": "20",
        "CCAA": "53",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "151.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "151.00",
        "surfaceTotal": "151.00",
        "timeAvailableFrom": "9/13/22 13:21",
        "lat": 43.308237,
        "lng": -1.9794923,
        "id_ext": "0049-GEN000-100469"
    },
    {
        "id": "de7ce90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "2",
        "askingPriceRent": "1137.99",
        "askingPriceSale": "170698.50",
        "address": " Paraguay 2 ",
        "postalCode": "01012",
        "city": "1101059",
        "province": "01",
        "CCAA": "53",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "162.57",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "162.57",
        "surfaceTotal": "162.57",
        "timeAvailableFrom": "9/13/22 13:21",
        "lat": 42.8566533,
        "lng": -2.678294,
        "id_ext": "0049-GEN000-100486"
    },
    {
        "id": "e27ce90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Subarrendado (gestión)",
        "strategy": "2",
        "askingPriceRent": "2822.40",
        "askingPriceSale": "441000.00",
        "address": "Calle Baleares ",
        "postalCode": "28937",
        "city": "1128092",
        "province": "28",
        "CCAA": "54",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "255.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "255.00",
        "surfaceTotal": "255.00",
        "timeAvailableFrom": "9/13/22 13:21",
        "lat": 40.3243561,
        "lng": -3.8563625,
        "id_ext": "0049-GEN000-100526"
    },
    {
        "id": "e47ce90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "2",
        "askingPriceRent": "2522.80",
        "askingPriceSale": "385840.00",
        "address": "Calle Gava 62 ",
        "postalCode": "08014",
        "city": "1108019",
        "province": "08",
        "CCAA": "55",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "198.63",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "198.63",
        "surfaceTotal": "198.63",
        "timeAvailableFrom": "9/13/22 13:21",
        "lat": 41.3709922,
        "lng": 2.139250800000001,
        "id_ext": "0049-GEN000-100531"
    },
    {
        "id": "e67ce90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "2",
        "address": "Travesía Bayona 1 ",
        "postalCode": "31011",
        "city": "1131201",
        "province": "31",
        "CCAA": "11",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "245.16",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "245.16",
        "surfaceTotal": "245.16",
        "timeAvailableFrom": "9/13/22 13:21",
        "lat": 42.8142918,
        "lng": -1.6581462,
        "id_ext": "0049-GEN000-100533"
    },
    {
        "id": "ea7ce90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "2",
        "askingPriceRent": "1232.00",
        "askingPriceSale": "231000.00",
        "address": "Avenida Constitución 19 ",
        "postalCode": "33208",
        "city": "1133024",
        "province": "33",
        "CCAA": "31",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "143.50",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "143.50",
        "surfaceTotal": "143.50",
        "timeAvailableFrom": "9/13/22 13:21",
        "lat": 43.5363433,
        "lng": -5.6661481,
        "id_ext": "0049-GEN000-100544"
    },
    {
        "id": "ec7ce90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Subarrendado (gestión)",
        "strategy": "2",
        "askingPriceRent": "33600.00",
        "askingPriceSale": "9240000.00",
        "address": " Goya 77 ",
        "postalCode": "28001",
        "city": "1128079",
        "province": "28",
        "CCAA": "54",
        "country": "ES",
        "use": "5",
        "surfacebr": "173.81",
        "surfaceMezzanine": "0.00",
        "surfacepb": "185.49",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "237.63",
        "surfaceTotal": "359.30",
        "timeAvailableFrom": "9/13/22 13:21",
        "lat": 40.4250704,
        "lng": -3.678411,
        "id_ext": "0049-GEN000-100557"
    },
    {
        "id": "f07ce90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "2",
        "askingPriceRent": "1178.10",
        "askingPriceSale": "160650.00",
        "address": " Pedro Aleixandre 25 ",
        "postalCode": "46006",
        "city": "1146250",
        "province": "46",
        "CCAA": "42",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "134.52",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "134.52",
        "surfaceTotal": "134.52",
        "timeAvailableFrom": "9/13/22 13:21",
        "lat": 39.4605843,
        "lng": -0.3627177,
        "id_ext": "0049-GEN000-100572"
    },
    {
        "id": "f27ce90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "2",
        "askingPriceRent": "2058.00",
        "askingPriceSale": "323400.00",
        "address": "Avenida Madrid 191 ",
        "postalCode": "50017",
        "city": "1150297",
        "province": "50",
        "CCAA": "10",
        "country": "ES",
        "use": "5",
        "surfacebr": "175.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "198.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "250.50",
        "surfaceTotal": "373.00",
        "timeAvailableFrom": "9/13/22 13:21",
        "lat": 41.6524632,
        "lng": -0.9082194000000001,
        "id_ext": "0049-GEN000-100585"
    },
    {
        "id": "f67ce90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "2",
        "askingPriceRent": "2595.60",
        "askingPriceSale": "389340.00",
        "address": "Calle Tomás Ortuño 83 ",
        "postalCode": "03500",
        "city": "1103031",
        "province": "03",
        "CCAA": "42",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "219.34",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "219.34",
        "surfaceTotal": "219.34",
        "timeAvailableFrom": "9/13/22 13:21",
        "lat": 38.54158,
        "lng": -0.13209,
        "id_ext": "0049-GEN000-100601"
    },
    {
        "id": "fa7ce90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - En legal",
        "strategy": "2",
        "address": "Calle O'Donnell 23 ",
        "district": "2807902",
        "postalCode": "28005",
        "city": "1128079",
        "province": "28",
        "CCAA": "54",
        "country": "ES",
        "use": "5",
        "smokeStractor": true,
        "surfacebr": "221.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "376.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "442.30",
        "surfaceTotal": "597.00",
        "timeAvailableFrom": "9/13/22 13:21",
        "lat": 40.421788,
        "lng": -3.6777797,
        "id_ext": "0049-GEN000-100626"
    },
    {
        "id": "fe7ce90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "2",
        "askingPriceRent": "2166.15",
        "askingPriceSale": "346584.00",
        "address": "Calle Ecuador 2 ",
        "postalCode": "45004",
        "city": "1145168",
        "province": "45",
        "CCAA": "40",
        "country": "ES",
        "use": "5",
        "surfacebr": "190.91",
        "surfaceMezzanine": "0.00",
        "surfacepb": "190.91",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "248.18",
        "surfaceTotal": "381.82",
        "timeAvailableFrom": "9/13/22 13:21",
        "lat": 39.8669882,
        "lng": -4.0294013,
        "id_ext": "0049-GEN000-100647"
    },
    {
        "id": "067de90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "2",
        "address": " Mármol 10 ",
        "postalCode": "28850",
        "city": "1128148",
        "province": "28",
        "CCAA": "54",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "157.41",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "157.41",
        "surfaceTotal": "157.41",
        "timeAvailableFrom": "9/13/22 13:21",
        "lat": 40.4494564,
        "lng": -3.4686378,
        "id_ext": "0049-GEN000-100681"
    },
    {
        "id": "087de90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "2",
        "askingPriceRent": "1766.24",
        "askingPriceSale": "203057.92",
        "address": "Calle Jabonería 53 ",
        "postalCode": "28921",
        "city": "1128007",
        "province": "28",
        "CCAA": "54",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "106.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "60.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "136.00",
        "surfaceTotal": "166.00",
        "timeAvailableFrom": "9/13/22 13:21",
        "lat": 40.3493006,
        "lng": -3.824473,
        "id_ext": "0049-GEN000-100683"
    },
    {
        "id": "0e7de90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Subarrendado (gestión)",
        "strategy": "2",
        "address": "Calle San Pedro De Mezonzo 3 ",
        "postalCode": "15705",
        "city": "1115078",
        "province": "15",
        "CCAA": "60",
        "country": "ES",
        "use": "5",
        "surfacebr": "217.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "208.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "273.10",
        "surfaceTotal": "425.00",
        "timeAvailableFrom": "9/13/22 13:21",
        "lat": 42.8740523,
        "lng": -8.548798099999999,
        "id_ext": "0049-GEN000-100712"
    },
    {
        "id": "107de90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Subarrendado (gestión)",
        "strategy": "2",
        "address": "Calle Costa Rica 9 ",
        "postalCode": "28005",
        "city": "1128079",
        "province": "28",
        "CCAA": "54",
        "country": "ES",
        "use": "11",
        "surfacebr": "139.40",
        "surfaceMezzanine": "0.00",
        "surfacepb": "310.08",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "351.90",
        "surfaceTotal": "449.48",
        "timeAvailableFrom": "9/13/22 13:21",
        "lat": 40.4588807,
        "lng": -3.6750384,
        "id_ext": "0049-GEN000-100735"
    },
    {
        "id": "127de90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "2",
        "askingPriceRent": "1359.75",
        "askingPriceSale": "199430.00",
        "address": " Pinto ",
        "postalCode": "28980",
        "city": "1128106",
        "province": "28",
        "CCAA": "54",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "266.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "266.00",
        "surfaceTotal": "266.00",
        "timeAvailableFrom": "9/13/22 13:21",
        "lat": 40.2375052,
        "lng": -3.6967718,
        "id_ext": "0049-GEN000-100743"
    },
    {
        "id": "1a7de90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "2",
        "askingPriceRent": "1217.16",
        "askingPriceSale": "210974.40",
        "address": "Plaza Mercadal C/V Mayor ",
        "postalCode": "25600",
        "city": "1125040",
        "province": "25",
        "CCAA": "55",
        "country": "ES",
        "use": "5",
        "surfacebr": "277.76",
        "surfaceMezzanine": "0.00",
        "surfacepb": "180.88",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "182.76",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "355.59",
        "surfaceTotal": "641.40",
        "timeAvailableFrom": "9/13/22 13:21",
        "lat": 41.7897376,
        "lng": 0.8052786,
        "id_ext": "0049-GEN000-100789"
    },
    {
        "id": "1e7de90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "strategy": "1",
        "status": "Comercializable",
        "address": "Calle Mallorca 547 ",
        "city": "1108019",
        "province": "08",
        "CCAA": "55",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "44.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "44.00",
        "surfaceTotal": "44.00",
        "timeAvailableFrom": "9/13/22 13:21",
        "lat": 41.409747,
        "lng": 2.1835645,
        "id_ext": "0049-GEN000-100798"
    },
    {
        "id": "207de90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "2",
        "askingPriceRent": "2401.00",
        "askingPriceSale": "351467.04",
        "address": "Calle Autonomía 20 ",
        "postalCode": "48012",
        "city": "1148020",
        "province": "48",
        "CCAA": "53",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "161.25",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "161.25",
        "surfaceTotal": "161.25",
        "timeAvailableFrom": "9/13/22 13:21",
        "lat": 43.2575487,
        "lng": -2.9376287,
        "id_ext": "0049-GEN000-100807"
    },
    {
        "id": "247de90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - En legal",
        "strategy": "2",
        "address": "Avenida Constitución 15 ",
        "postalCode": "18001",
        "city": "1118087",
        "province": "18",
        "CCAA": "51",
        "country": "ES",
        "use": "5",
        "surfacebr": "155.31",
        "surfaceMezzanine": "0.00",
        "surfacepb": "155.31",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "201.90",
        "surfaceTotal": "310.62",
        "timeAvailableFrom": "9/13/22 13:21",
        "lat": 37.18391630000001,
        "lng": -3.6044879,
        "id_ext": "0049-GEN000-100832"
    },
    {
        "id": "287de90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "2",
        "askingPriceRent": "1079.40",
        "askingPriceSale": "161910.00",
        "address": "Calle Agua 2 ",
        "postalCode": "14900",
        "city": "1114038",
        "province": "14",
        "CCAA": "51",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "324.35",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "324.35",
        "surfaceTotal": "324.35",
        "timeAvailableFrom": "9/13/22 13:21",
        "lat": 37.4086756,
        "lng": -4.4876616,
        "id_ext": "0049-GEN000-100848"
    },
    {
        "id": "2a7de90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Subarrendado (gestión)",
        "strategy": "2",
        "address": "Calle Borne 36 ",
        "postalCode": "08240",
        "city": "1108113",
        "province": "08",
        "CCAA": "55",
        "country": "ES",
        "use": "11",
        "surfacebr": "148.63",
        "surfaceMezzanine": "0.00",
        "surfacepb": "204.70",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "249.29",
        "surfaceTotal": "353.33",
        "timeAvailableFrom": "9/13/22 13:21",
        "lat": 41.72509540000001,
        "lng": 1.8243723,
        "id_ext": "0049-GEN000-100851"
    },
    {
        "id": "307de90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "2",
        "askingPriceRent": "1400.00",
        "askingPriceSale": "210000.00",
        "address": "Calle San Francisco 4 ",
        "postalCode": "30510",
        "city": "1130043",
        "province": "30",
        "CCAA": "43",
        "country": "ES",
        "use": "5",
        "surfacebr": "208.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "450.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "512.40",
        "surfaceTotal": "658.00",
        "timeAvailableFrom": "9/13/22 13:21",
        "lat": 38.6138891,
        "lng": -1.115255,
        "id_ext": "0049-GEN000-100910"
    },
    {
        "id": "3a7de90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "2",
        "address": "Calle Pons I Ariola, 10 ",
        "postalCode": "25240",
        "city": "1125122",
        "province": "25",
        "CCAA": "55",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "105.95",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "105.95",
        "surfaceTotal": "105.95",
        "timeAvailableFrom": "9/13/22 13:21",
        "lat": 41.7102995,
        "lng": 0.9024835999999999,
        "id_ext": "0049-GEN000-100982"
    },
    {
        "id": "3c7de90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "2",
        "address": "Calle Carnicerias 2 ",
        "postalCode": "31593",
        "city": "1131105",
        "province": "31",
        "CCAA": "11",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "112.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "112.00",
        "surfaceTotal": "112.00",
        "timeAvailableFrom": "9/13/22 13:21",
        "lat": 42.056272,
        "lng": -1.8589985,
        "id_ext": "0049-GEN000-100984"
    },
    {
        "id": "3e7de90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "2",
        "address": " L'Horta 11 ",
        "postalCode": "25126",
        "city": "1125021",
        "province": "25",
        "CCAA": "55",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "153.18",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "153.18",
        "surfaceTotal": "153.18",
        "timeAvailableFrom": "9/13/22 13:21",
        "lat": 41.7970523,
        "lng": 0.5680948,
        "id_ext": "0049-GEN000-100985"
    },
    {
        "id": "427de90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Subarrendado (gestión)",
        "strategy": "2",
        "askingPriceRent": "13300.00",
        "askingPriceSale": "2660000.00",
        "address": "Calle Santa Mónica 6 ",
        "postalCode": "08002",
        "city": "1108019",
        "province": "08",
        "CCAA": "55",
        "country": "ES",
        "use": "3",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "410.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "410.00",
        "surfaceTotal": "410.00",
        "timeAvailableFrom": "9/13/22 13:21",
        "lat": 41.3772716,
        "lng": 2.1750519,
        "id_ext": "0049-GEN000-101022"
    },
    {
        "id": "447de90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "2",
        "askingPriceRent": "3957.80",
        "askingPriceSale": "791560.00",
        "address": "Vía Augusta 81 ",
        "postalCode": "08006",
        "city": "1108019",
        "province": "08",
        "CCAA": "55",
        "country": "ES",
        "use": "5",
        "surfacebr": "75.35",
        "surfaceMezzanine": "0.00",
        "surfacepb": "175.81",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "198.42",
        "surfaceTotal": "251.16",
        "timeAvailableFrom": "9/13/22 13:21",
        "lat": 41.4007095,
        "lng": 2.1502226,
        "id_ext": "0049-GEN000-101023"
    },
    {
        "id": "467de90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Subarrendado (gestión)",
        "strategy": "2",
        "askingPriceRent": "4900.00",
        "askingPriceSale": "931000.00",
        "address": "Calle Marqués De Sentmenat 44 ",
        "postalCode": "08014",
        "city": "1108019",
        "province": "08",
        "CCAA": "55",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "389.24",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "389.24",
        "surfaceTotal": "389.24",
        "timeAvailableFrom": "9/13/22 13:21",
        "lat": 41.3848427,
        "lng": 2.1369888,
        "id_ext": "0049-GEN000-101026"
    },
    {
        "id": "4a7de90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Subarrendado (gestión)",
        "strategy": "2",
        "askingPriceRent": "1114.40",
        "askingPriceSale": "174125.00",
        "address": "Avenida Libertad 26 ",
        "postalCode": "03690",
        "city": "1103122",
        "province": "03",
        "CCAA": "42",
        "country": "ES",
        "use": "5",
        "surfacebr": "49.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "196.62",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "111.40",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "267.02",
        "surfaceTotal": "357.02",
        "timeAvailableFrom": "9/13/22 13:22",
        "lat": 38.3972278,
        "lng": -0.522645,
        "id_ext": "0049-GEN000-101054"
    },
    {
        "id": "547de90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "2",
        "askingPriceRent": "2655.80",
        "askingPriceSale": "478044.00",
        "address": "Avenida Peña Prieta 57 ",
        "district": "2807913",
        "postalCode": "28038",
        "city": "1128079",
        "province": "28",
        "CCAA": "54",
        "country": "ES",
        "use": "5",
        "surfacebr": "88.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "181.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "207.40",
        "surfaceTotal": "269.00",
        "timeAvailableFrom": "9/13/22 13:22",
        "lat": 40.4023244,
        "lng": -3.6644507,
        "id_ext": "0049-GEN000-101085"
    },
    {
        "id": "667de90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Subarrendado (gestión)",
        "strategy": "2",
        "askingPriceRent": "3186.40",
        "askingPriceSale": "605416.00",
        "address": "Calle Emperador Carlos V 1 ",
        "postalCode": "50009",
        "city": "1150297",
        "province": "50",
        "CCAA": "10",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "200.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "200.00",
        "surfaceTotal": "200.00",
        "timeAvailableFrom": "9/13/22 13:22",
        "lat": 41.6379994,
        "lng": -0.8981281,
        "id_ext": "0049-GEN000-101140"
    },
    {
        "id": "727de90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "2",
        "askingPriceRent": "4591.10",
        "askingPriceSale": "819840.00",
        "address": "Avenida Zaragoza 11 ",
        "postalCode": "31003",
        "city": "1131201",
        "province": "31",
        "CCAA": "11",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "234.24",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "234.24",
        "surfaceTotal": "234.24",
        "timeAvailableFrom": "9/13/22 13:22",
        "lat": 42.8110955,
        "lng": -1.6432708,
        "id_ext": "0049-GEN000-101163"
    },
    {
        "id": "767de90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "2",
        "address": "Calle Estación 58 ",
        "postalCode": "09200",
        "city": "1109219",
        "province": "09",
        "CCAA": "59",
        "country": "ES",
        "use": "5",
        "surfacebr": "295.54",
        "surfaceMezzanine": "0.00",
        "surfacepb": "295.54",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "384.20",
        "surfaceTotal": "591.08",
        "timeAvailableFrom": "9/13/22 13:22",
        "lat": 42.68819200000001,
        "lng": -2.9430187,
        "id_ext": "0049-GEN000-101168"
    },
    {
        "id": "7a7de90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "2",
        "askingPriceRent": "891.80",
        "askingPriceSale": "152880.00",
        "address": " Rioja 8 ",
        "postalCode": "28915",
        "city": "1128074",
        "province": "28",
        "CCAA": "54",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "84.04",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "84.04",
        "surfaceTotal": "84.04",
        "timeAvailableFrom": "9/13/22 13:22",
        "lat": 40.3341964,
        "lng": -3.756238599999999,
        "id_ext": "0049-GEN000-101206"
    },
    {
        "id": "807de90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Subarrendado (gestión)",
        "strategy": "2",
        "askingPriceRent": "2028.60",
        "askingPriceSale": "251160.00",
        "address": "Camino De Vinateros 63 ",
        "postalCode": "28030",
        "city": "1128079",
        "province": "28",
        "CCAA": "54",
        "country": "ES",
        "use": "5",
        "smokeStractor": false,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "183.15",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "183.15",
        "surfaceTotal": "183.15",
        "timeAvailableFrom": "9/13/22 13:22",
        "lat": 40.4104247,
        "lng": -3.6519351,
        "id_ext": "0049-GEN000-101220"
    },
    {
        "id": "827de90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Subarrendado (gestión)",
        "strategy": "2",
        "address": " Aribau 249 ",
        "postalCode": "08021",
        "city": "1108019",
        "province": "08",
        "CCAA": "55",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "152.50",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "152.50",
        "surfaceTotal": "152.50",
        "timeAvailableFrom": "9/13/22 13:22",
        "lat": 41.3984354,
        "lng": 2.146508,
        "id_ext": "0049-GEN000-101226"
    },
    {
        "id": "927de90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "2",
        "address": "Calle Caldereros 6 ",
        "postalCode": "05200",
        "city": "1105016",
        "province": "05",
        "CCAA": "59",
        "country": "ES",
        "use": "5",
        "surfacebr": "119.50",
        "surfaceMezzanine": "0.00",
        "surfacepb": "119.50",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "119.50",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "215.10",
        "surfaceTotal": "358.50",
        "timeAvailableFrom": "9/13/22 13:22",
        "lat": 41.0626779,
        "lng": -4.719558999999999,
        "id_ext": "0049-GEN000-110075"
    },
    {
        "id": "967de90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "2",
        "askingPriceRent": "1134.00",
        "askingPriceSale": "157500.00",
        "address": " Julio Antonio 1 ",
        "district": "2807911",
        "postalCode": "28025",
        "city": "1128079",
        "province": "28",
        "CCAA": "54",
        "country": "ES",
        "use": "5",
        "surfacebr": "87.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "87.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "113.10",
        "surfaceTotal": "174.00",
        "timeAvailableFrom": "9/13/22 13:22",
        "lat": 40.3827965,
        "lng": -3.7301068,
        "id_ext": "0049-GEN000-110203"
    },
    {
        "id": "9c7de90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Subarrendado (gestión)",
        "strategy": "2",
        "address": "Calle Arenal 19 ",
        "district": "2807901",
        "postalCode": "28013",
        "city": "1128079",
        "province": "28",
        "CCAA": "54",
        "country": "ES",
        "use": "5",
        "surfacebr": "148.85",
        "surfaceMezzanine": "0.00",
        "surfacepb": "165.93",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "210.59",
        "surfaceTotal": "314.78",
        "timeAvailableFrom": "9/13/22 13:22",
        "lat": 40.4175537,
        "lng": -3.708034,
        "id_ext": "0049-GEN000-110257"
    },
    {
        "id": "9e7de90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "2",
        "address": "Calle Del Padró 12 ",
        "postalCode": "08291",
        "city": "1108180",
        "province": "08",
        "CCAA": "55",
        "country": "ES",
        "use": "5",
        "surfacebr": "132.60",
        "surfaceMezzanine": "0.00",
        "surfacepb": "288.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "198.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "426.78",
        "surfaceTotal": "618.60",
        "timeAvailableFrom": "9/13/22 13:22",
        "lat": 41.4969245,
        "lng": 2.1547513,
        "id_ext": "0049-GEN000-110271"
    },
    {
        "id": "a07de90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "2",
        "address": " Caspe 70 ",
        "postalCode": "08010",
        "city": "1108019",
        "province": "08",
        "CCAA": "55",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "297.94",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "297.94",
        "surfaceTotal": "297.94",
        "timeAvailableFrom": "9/13/22 13:22",
        "lat": 41.3922598,
        "lng": 2.1749557,
        "id_ext": "0049-GEN000-110319"
    },
    {
        "id": "a87de90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "2",
        "askingPriceRent": "1411.20",
        "askingPriceSale": "241920.00",
        "address": " Batllori 7 ",
        "postalCode": "08031",
        "city": "1108019",
        "province": "08",
        "CCAA": "55",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "129.65",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "62.40",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "160.85",
        "surfaceTotal": "192.05",
        "timeAvailableFrom": "9/13/22 13:22",
        "lat": 41.4433249,
        "lng": 2.1778586,
        "id_ext": "0049-GEN000-110373"
    },
    {
        "id": "aa7de90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Subarrendado (gestión)",
        "strategy": "2",
        "askingPriceRent": "1694.00",
        "askingPriceSale": "321860.00",
        "address": "Vía Augusta 264 ",
        "postalCode": "08017",
        "city": "1108019",
        "province": "08",
        "CCAA": "55",
        "country": "ES",
        "use": "5",
        "surfacebr": "48.59",
        "surfaceMezzanine": "0.00",
        "surfacepb": "96.85",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "111.43",
        "surfaceTotal": "145.44",
        "timeAvailableFrom": "9/13/22 13:22",
        "lat": 41.3980003,
        "lng": 2.1325794,
        "id_ext": "0049-GEN000-110401"
    },
    {
        "id": "ac7de90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "2",
        "address": " Balmes 423 ",
        "postalCode": "08022",
        "city": "1108019",
        "province": "08",
        "CCAA": "55",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "155.80",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "155.80",
        "surfaceTotal": "155.80",
        "timeAvailableFrom": "9/13/22 13:22",
        "lat": 41.4081853,
        "lng": 2.1377393,
        "id_ext": "0049-GEN000-110403"
    },
    {
        "id": "ae7de90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Subarrendado (gestión)",
        "strategy": "2",
        "askingPriceRent": "2492.00",
        "askingPriceSale": "448560.00",
        "address": "Paseo Manuel Girona 12 ",
        "postalCode": "08034",
        "city": "1108019",
        "province": "08",
        "CCAA": "55",
        "country": "ES",
        "use": "5",
        "surfacebr": "129.42",
        "surfaceMezzanine": "0.00",
        "surfacepb": "128.32",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "167.15",
        "surfaceTotal": "257.74",
        "timeAvailableFrom": "9/13/22 13:22",
        "lat": 41.3898955,
        "lng": 2.1209755,
        "id_ext": "0049-GEN000-110419"
    },
    {
        "id": "b07de90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Subarrendado (gestión)",
        "strategy": "2",
        "askingPriceRent": "1680.07",
        "askingPriceSale": "303598.39",
        "address": " Santa Susana 27 ",
        "postalCode": "28033",
        "city": "1128079",
        "province": "28",
        "CCAA": "54",
        "country": "ES",
        "use": "5",
        "surfacebr": "97.38",
        "surfaceMezzanine": "0.00",
        "surfacepb": "75.62",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "104.83",
        "surfaceTotal": "173.00",
        "timeAvailableFrom": "9/13/22 13:22",
        "lat": 40.477192,
        "lng": -3.6462847,
        "id_ext": "0049-GEN000-110435"
    },
    {
        "id": "b47de90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Subarrendado (gestión)",
        "strategy": "2",
        "askingPriceRent": "4253.76",
        "askingPriceSale": "797580.00",
        "address": "Avenida Doctor Areilza 26 ",
        "postalCode": "48011",
        "city": "1148020",
        "province": "48",
        "CCAA": "53",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "189.90",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "189.90",
        "surfaceTotal": "189.90",
        "timeAvailableFrom": "9/13/22 13:22",
        "lat": 43.2620432,
        "lng": -2.9424527,
        "id_ext": "0049-GEN000-110517"
    },
    {
        "id": "ba7de90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "2",
        "askingPriceRent": "1813.00",
        "askingPriceSale": "310800.00",
        "address": " Vitoria 141 ",
        "postalCode": "09007",
        "city": "1109059",
        "province": "09",
        "CCAA": "59",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "185.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "185.00",
        "surfaceTotal": "185.00",
        "timeAvailableFrom": "9/13/22 13:22",
        "lat": 42.3504045,
        "lng": -3.6747213,
        "id_ext": "0049-GEN000-110631"
    },
    {
        "id": "bc7de90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Subarrendado (gestión)",
        "strategy": "2",
        "askingPriceRent": "2387.28",
        "askingPriceSale": "341040.00",
        "address": "Avenida Rafael Puig s/n ",
        "postalCode": "38670",
        "city": "1138660",
        "province": "38",
        "CCAA": "56",
        "country": "ES",
        "use": "5",
        "surfacebr": "56.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "100.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "116.80",
        "surfaceTotal": "156.00",
        "timeAvailableFrom": "9/13/22 13:22",
        "lat": 28.0618615,
        "lng": -16.7312336,
        "id_ext": "0049-GEN000-110686"
    },
    {
        "id": "be7de90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "2",
        "address": "Calle Aire 21 ",
        "city": "1130016",
        "province": "30",
        "CCAA": "43",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "0.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "229.70",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "114.85",
        "surfaceTotal": "229.70",
        "timeAvailableFrom": "9/13/22 13:22",
        "lat": 37.6004379,
        "lng": -0.9856703999999998,
        "id_ext": "0049-GEN000-110747"
    },
    {
        "id": "c87de90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "2",
        "askingPriceRent": "1345.68",
        "askingPriceSale": "201852.00",
        "address": " Tomas Morales 83 ",
        "postalCode": "35004",
        "city": "1135016",
        "province": "35",
        "CCAA": "56",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "160.20",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "160.20",
        "surfaceTotal": "160.20",
        "timeAvailableFrom": "9/13/22 13:22",
        "lat": 28.1162089,
        "lng": -15.4262567,
        "id_ext": "0049-GEN000-111120"
    },
    {
        "id": "ca7de90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "2",
        "askingPriceRent": "1217.41",
        "askingPriceSale": "197581.60",
        "address": "Calle Cervantes 14 ",
        "postalCode": "28904",
        "city": "1128065",
        "province": "28",
        "CCAA": "54",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "146.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "146.00",
        "surfaceTotal": "146.00",
        "timeAvailableFrom": "9/13/22 13:22",
        "lat": 40.3046381,
        "lng": -3.7364753,
        "id_ext": "0049-GEN000-111125"
    },
    {
        "id": "cc7de90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "2",
        "askingPriceRent": "1916.88",
        "askingPriceSale": "319480.00",
        "address": " Pozo 1 ",
        "postalCode": "24003",
        "city": "1124089",
        "province": "24",
        "CCAA": "59",
        "country": "ES",
        "use": "5",
        "surfacebr": "74.21",
        "surfaceMezzanine": "0.00",
        "surfacepb": "92.55",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "114.81",
        "surfaceTotal": "166.76",
        "timeAvailableFrom": "9/13/22 13:22",
        "lat": 21.1250077,
        "lng": -101.6859605,
        "id_ext": "0049-GEN000-111152"
    },
    {
        "id": "ce7de90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "2",
        "address": "Avenida República Argentina 1 ",
        "city": "1146145",
        "province": "46",
        "CCAA": "42",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "193.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "193.00",
        "surfaceTotal": "193.00",
        "timeAvailableFrom": "9/13/22 13:22",
        "lat": 38.990317,
        "lng": -0.5229710000000001,
        "id_ext": "0049-GEN000-111310"
    },
    {
        "id": "d07de90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "2",
        "address": "Calle Prat De La Riva 29 ",
        "postalCode": "25008",
        "city": "1125120",
        "province": "25",
        "CCAA": "55",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "113.25",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "113.25",
        "surfaceTotal": "113.25",
        "timeAvailableFrom": "9/13/22 13:22",
        "lat": 41.620752,
        "lng": 0.6229604999999999,
        "id_ext": "0049-GEN000-111337"
    },
    {
        "id": "d27de90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Subarrendado (gestión)",
        "strategy": "2",
        "askingPriceRent": "4100.60",
        "askingPriceSale": "593880.00",
        "address": "Calle Can Mora 7 ",
        "postalCode": "08190",
        "city": "1108205",
        "province": "08",
        "CCAA": "55",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "189.77",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "189.77",
        "surfaceTotal": "189.77",
        "timeAvailableFrom": "9/13/22 13:22",
        "lat": 41.46835,
        "lng": 2.08287,
        "id_ext": "0049-GEN000-111366"
    },
    {
        "id": "d47de90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Subarrendado (gestión)",
        "strategy": "2",
        "askingPriceRent": "6832.00",
        "askingPriceSale": "1537200.00",
        "address": " Lagasca 13 ",
        "postalCode": "28001",
        "city": "1128079",
        "province": "28",
        "CCAA": "54",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "120.28",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "120.28",
        "surfaceTotal": "120.28",
        "timeAvailableFrom": "9/13/22 13:22",
        "lat": 40.422172,
        "lng": -3.6858377,
        "id_ext": "0049-GEN000-111404"
    },
    {
        "id": "d67de90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Subarrendado (gestión)",
        "strategy": "2",
        "askingPriceRent": "7938.00",
        "askingPriceSale": "1481760.00",
        "address": "Plaza Cascorro 23 ",
        "postalCode": "28005",
        "city": "1128079",
        "province": "28",
        "CCAA": "54",
        "country": "ES",
        "use": "5",
        "surfacebr": "188.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "172.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "450.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "453.40",
        "surfaceTotal": "810.00",
        "timeAvailableFrom": "9/13/22 13:22",
        "lat": 40.4113063,
        "lng": -3.7073651,
        "id_ext": "0049-GEN000-111444"
    },
    {
        "id": "d87de90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Subarrendado (gestión)",
        "strategy": "2",
        "askingPriceRent": "26180.70",
        "askingPriceSale": "7230860.00",
        "address": " Carretas 14 ",
        "district": "2807902",
        "postalCode": "28012",
        "city": "1128079",
        "province": "28",
        "CCAA": "54",
        "country": "ES",
        "use": "5",
        "smokeStractor": false,
        "surfacebr": "166.48",
        "surfaceMezzanine": "0.00",
        "surfacepb": "142.04",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "175.34",
        "surfaceTotal": "308.52",
        "agent": "Sara Carracedo Culebras",
        "timeAvailableFrom": "9/13/22 13:22",
        "lat": 40.4148114,
        "lng": -3.7036534,
        "id_ext": "0049-GEN000-111463"
    },
    {
        "id": "da7de90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "2",
        "askingPriceRent": "5559.68",
        "askingPriceSale": "1077188.00",
        "address": " Cea Bermudez 25-27 ",
        "district": "2807907",
        "postalCode": "28003",
        "city": "1128079",
        "province": "28",
        "CCAA": "54",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "248.20",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "248.20",
        "surfaceTotal": "248.20",
        "timeAvailableFrom": "9/13/22 13:22",
        "lat": 40.438726,
        "lng": -3.7102691,
        "id_ext": "0049-GEN000-111466"
    },
    {
        "id": "dc7de90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Subarrendado (gestión)",
        "strategy": "2",
        "askingPriceSale": "173040.00",
        "address": " Miguel Angel 3 ",
        "postalCode": "28010",
        "city": "1128079",
        "province": "28",
        "CCAA": "54",
        "country": "ES",
        "use": "5",
        "surfacebr": "83.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "115.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "57.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "168.40",
        "surfaceTotal": "255.00",
        "timeAvailableFrom": "9/13/22 13:22",
        "lat": 40.4338658,
        "lng": -3.6916067,
        "id_ext": "0049-GEN000-111493"
    },
    {
        "id": "ea7de90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Subarrendado (gestión)",
        "strategy": "2",
        "address": "Plaza Emilio Díaz De Revenga 1 ",
        "postalCode": "30008",
        "city": "1130030",
        "province": "30",
        "CCAA": "43",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "433.69",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "35.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "451.19",
        "surfaceTotal": "468.69",
        "timeAvailableFrom": "9/13/22 13:22",
        "lat": 37.9911078,
        "lng": -1.134886,
        "id_ext": "0049-GEN000-111700"
    },
    {
        "id": "f67de90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "2",
        "askingPriceRent": "1156.40",
        "askingPriceSale": "165200.00",
        "address": "Paseo Olmos 18 ",
        "postalCode": "20016",
        "city": "1120069",
        "province": "20",
        "CCAA": "53",
        "country": "ES",
        "use": "5",
        "surfacebr": "110.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "85.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "118.00",
        "surfaceTotal": "195.00",
        "timeAvailableFrom": "9/13/22 13:22",
        "lat": 43.3204706,
        "lng": -1.9407086,
        "id_ext": "0049-GEN000-112032"
    },
    {
        "id": "f87de90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - En legal",
        "strategy": "2",
        "askingPriceRent": "2177.00",
        "askingPriceSale": "326550.00",
        "address": " Usandizaga 29 ",
        "postalCode": "20002",
        "city": "1120069",
        "province": "20",
        "CCAA": "53",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "75.00",
        "surfacepb": "118.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "75.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "155.50",
        "surfaceTotal": "193.00",
        "timeAvailableFrom": "9/13/22 13:22",
        "lat": 43.3244951,
        "lng": -1.9754999,
        "id_ext": "0049-GEN000-112034"
    },
    {
        "id": "027ee90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "2",
        "askingPriceRent": "640.50",
        "askingPriceSale": "85400.00",
        "address": "Avenida Italia 18 ",
        "postalCode": "35100",
        "city": "1135019",
        "province": "35",
        "CCAA": "56",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "117.20",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "117.20",
        "surfaceTotal": "117.20",
        "timeAvailableFrom": "9/13/22 13:22",
        "lat": 27.7602316,
        "lng": -15.5681384,
        "id_ext": "0049-GEN000-112174"
    },
    {
        "id": "047ee90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - En legal",
        "strategy": "2",
        "askingPriceRent": "1171.10",
        "askingPriceSale": "150500.00",
        "address": "Plaza Bayarri 6 ",
        "postalCode": "12540",
        "city": "1112135",
        "province": "12",
        "CCAA": "42",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "301.10",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "357.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "479.60",
        "surfaceTotal": "658.10",
        "timeAvailableFrom": "9/13/22 13:22",
        "lat": 39.9388215,
        "lng": -0.0992884,
        "id_ext": "0049-GEN000-112175"
    },
    {
        "id": "067ee90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Subarrendado (gestión)",
        "strategy": "2",
        "askingPriceRent": "2598.96",
        "askingPriceSale": "498134.00",
        "address": " Gran Via 46- 48 ",
        "postalCode": "50005",
        "city": "1150297",
        "province": "50",
        "CCAA": "10",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "154.70",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "154.70",
        "surfaceTotal": "154.70",
        "timeAvailableFrom": "9/13/22 13:22",
        "lat": 41.6449633,
        "lng": -0.8914605,
        "id_ext": "0049-GEN000-112582"
    },
    {
        "id": "0a7ee90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "2",
        "askingPriceRent": "1190.00",
        "askingPriceSale": "142800.00",
        "address": " Miraflores 105 ",
        "postalCode": "08905",
        "city": "1108101",
        "province": "08",
        "CCAA": "55",
        "country": "ES",
        "use": "8",
        "surfacebr": "10.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "0.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "3.00",
        "surfaceTotal": "10.00",
        "timeAvailableFrom": "9/13/22 13:22",
        "lat": 41.372552,
        "lng": 2.1065599,
        "id_ext": "0049-GEN000-112863"
    },
    {
        "id": "0e7ee90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Subarrendado (gestión)",
        "strategy": "2",
        "askingPriceRent": "873.60",
        "askingPriceSale": "123760.00",
        "address": " Doctor Loureiro Crespo 20 ",
        "postalCode": "36004",
        "city": "1136038",
        "province": "36",
        "CCAA": "60",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "115.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "115.00",
        "surfaceTotal": "115.00",
        "timeAvailableFrom": "9/13/22 13:22",
        "lat": 42.4283935,
        "lng": -8.6350368,
        "id_ext": "0049-GEN000-112959"
    },
    {
        "id": "167ee90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "2",
        "address": "Carretera Cartagena-Alicante ",
        "postalCode": "30730",
        "city": "1130035",
        "province": "30",
        "CCAA": "43",
        "country": "ES",
        "use": "5",
        "surfacebr": "131.80",
        "surfaceMezzanine": "0.00",
        "surfacepb": "163.60",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "203.14",
        "surfaceTotal": "295.40",
        "timeAvailableFrom": "9/13/22 13:22",
        "lat": 38.3459963,
        "lng": -0.4906855,
        "id_ext": "0049-GEN000-113051"
    },
    {
        "id": "1c7ee90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "2",
        "address": " Francesc Layret 13 ",
        "postalCode": "08208",
        "city": "1108187",
        "province": "08",
        "CCAA": "55",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "108.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "108.00",
        "surfaceTotal": "108.00",
        "timeAvailableFrom": "9/13/22 13:22",
        "lat": 41.5591403,
        "lng": 2.0979741,
        "id_ext": "0049-GEN000-113177"
    },
    {
        "id": "1e7ee90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "2",
        "askingPriceRent": "690.90",
        "askingPriceSale": "105280.00",
        "address": "Paseo General Dávila ",
        "postalCode": "39007",
        "city": "1139075",
        "province": "39",
        "CCAA": "30",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "144.21",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "144.21",
        "surfaceTotal": "144.21",
        "timeAvailableFrom": "9/13/22 13:22",
        "lat": 43.4673632,
        "lng": -3.8082696,
        "id_ext": "0049-GEN000-113180"
    },
    {
        "id": "207ee90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "2",
        "askingPriceRent": "1335.60",
        "askingPriceSale": "222600.00",
        "address": "Calle Ervedelo 37 ",
        "city": "1132054",
        "province": "32",
        "CCAA": "60",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "164.14",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "164.14",
        "surfaceTotal": "164.14",
        "timeAvailableFrom": "9/13/22 13:22",
        "lat": 42.3399301,
        "lng": -7.8717774,
        "id_ext": "0049-GEN000-113205"
    },
    {
        "id": "247ee90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "2",
        "askingPriceRent": "2004.80",
        "askingPriceSale": "350840.00",
        "address": "Calle Gran Via Carles III 94 ",
        "postalCode": "08028",
        "city": "1108019",
        "province": "08",
        "CCAA": "55",
        "country": "ES",
        "use": "5",
        "smokeStractor": false,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "170.95",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "170.95",
        "surfaceTotal": "170.95",
        "timeAvailableFrom": "9/13/22 13:22",
        "lat": 41.38617199999999,
        "lng": 2.1277248,
        "id_ext": "0049-GEN000-113255"
    },
    {
        "id": "267ee90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Subarrendado (gestión)",
        "strategy": "2",
        "askingPriceRent": "1209.60",
        "askingPriceSale": "188160.00",
        "address": "Avenida Ana De Viya 54 ",
        "postalCode": "11009",
        "city": "1111012",
        "province": "11",
        "CCAA": "51",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "96.10",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "96.10",
        "surfaceTotal": "96.10",
        "timeAvailableFrom": "9/13/22 13:22",
        "lat": 36.5081718,
        "lng": -6.2782073,
        "id_ext": "0049-GEN000-113258"
    },
    {
        "id": "2a7ee90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "2",
        "address": "Plaza De Fornells 23 ",
        "postalCode": "08033",
        "city": "1108019",
        "province": "08",
        "CCAA": "55",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "109.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "109.00",
        "surfaceTotal": "109.00",
        "timeAvailableFrom": "9/13/22 13:22",
        "lat": 40.05714469999999,
        "lng": 4.1302671,
        "id_ext": "0049-GEN000-113275"
    },
    {
        "id": "2c7ee90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Subarrendado (gestión)",
        "strategy": "2",
        "address": " Marques De Paradas 26 ",
        "postalCode": "41001",
        "city": "1141091",
        "province": "41",
        "CCAA": "51",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "188.91",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "188.91",
        "surfaceTotal": "188.91",
        "timeAvailableFrom": "9/13/22 13:22",
        "lat": 37.3896996,
        "lng": -6.0011975,
        "id_ext": "0049-GEN000-113301"
    },
    {
        "id": "2e7ee90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Subarrendado (gestión)",
        "strategy": "2",
        "address": "Avenida De Los Playeros ",
        "postalCode": "38650",
        "city": "1138650",
        "province": "38",
        "CCAA": "56",
        "country": "ES",
        "use": "5",
        "surfacebr": "163.25",
        "surfaceMezzanine": "0.00",
        "surfacepb": "121.29",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "170.27",
        "surfaceTotal": "284.54",
        "timeAvailableFrom": "9/13/22 13:22",
        "lat": 28.0503209,
        "lng": -16.7177511,
        "id_ext": "0049-GEN000-113302"
    },
    {
        "id": "307ee90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "2",
        "askingPriceRent": "966.00",
        "askingPriceSale": "144900.00",
        "address": "Paseo Estacion 42401 ",
        "postalCode": "37003",
        "city": "1137274",
        "province": "37",
        "CCAA": "59",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "115.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "115.00",
        "surfaceTotal": "115.00",
        "timeAvailableFrom": "9/13/22 13:22",
        "lat": 40.9707287,
        "lng": -5.6522982,
        "id_ext": "0049-GEN000-113367"
    },
    {
        "id": "347ee90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "2",
        "askingPriceRent": "1389.88",
        "askingPriceSale": "203849.80",
        "address": " Ezequiel Solana 97 ",
        "district": "2807920",
        "postalCode": "28017",
        "city": "1128079",
        "province": "28",
        "CCAA": "54",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "132.37",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "132.37",
        "surfaceTotal": "132.37",
        "timeAvailableFrom": "9/13/22 13:22",
        "lat": 40.4273974,
        "lng": -3.6420678,
        "id_ext": "0049-GEN000-113411"
    },
    {
        "id": "367ee90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Subarrendado (gestión)",
        "strategy": "2",
        "askingPriceRent": "1354.50",
        "askingPriceSale": "210700.00",
        "address": "Avenida Sancho El Fuerte 24 ",
        "postalCode": "31007",
        "city": "1131201",
        "province": "31",
        "CCAA": "11",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "107.50",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "107.50",
        "surfaceTotal": "107.50",
        "timeAvailableFrom": "9/13/22 13:22",
        "lat": 42.8104527,
        "lng": -1.6561444,
        "id_ext": "0049-GEN000-113455"
    },
    {
        "id": "387ee90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Subarrendado (gestión)",
        "strategy": "2",
        "askingPriceRent": "2158.52",
        "askingPriceSale": "325604.44",
        "address": "Urbanización San Eugenio ",
        "postalCode": "38660",
        "city": "1138660",
        "province": "38",
        "CCAA": "56",
        "country": "ES",
        "use": "5",
        "surfacebr": "54.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "0.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "215.54",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "123.97",
        "surfaceTotal": "269.54",
        "timeAvailableFrom": "9/13/22 13:22",
        "lat": 28.0613928,
        "lng": -16.7267975,
        "id_ext": "0049-GEN000-113476"
    },
    {
        "id": "3a7ee90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "2",
        "askingPriceRent": "1965.60",
        "askingPriceSale": "294840.00",
        "address": " Limones SN ",
        "postalCode": "35570",
        "city": "1135034",
        "province": "35",
        "CCAA": "56",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "131.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "131.00",
        "surfaceTotal": "131.00",
        "timeAvailableFrom": "9/13/22 13:22",
        "lat": 28.9568368,
        "lng": -13.7984428,
        "id_ext": "0049-GEN000-113480"
    },
    {
        "id": "3c7ee90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Subarrendado (gestión)",
        "strategy": "2",
        "askingPriceRent": "1041.60",
        "askingPriceSale": "156240.00",
        "address": " Eric Lionel Fox 3 ",
        "postalCode": "38005",
        "city": "1138038",
        "province": "38",
        "CCAA": "56",
        "country": "ES",
        "use": "5",
        "surfacebr": "70.15",
        "surfaceMezzanine": "0.00",
        "surfacepb": "109.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "130.05",
        "surfaceTotal": "179.15",
        "timeAvailableFrom": "9/13/22 13:22",
        "lat": 28.4598826,
        "lng": -16.2628562,
        "id_ext": "0049-GEN000-113555"
    },
    {
        "id": "427ee90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Subarrendado (gestión)",
        "strategy": "2",
        "askingPriceRent": "1951.72",
        "askingPriceSale": "305487.00",
        "address": " Doctor J.J. Domine 14 ",
        "postalCode": "46011",
        "city": "1146250",
        "province": "46",
        "CCAA": "42",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "242.45",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "242.45",
        "surfaceTotal": "242.45",
        "timeAvailableFrom": "9/13/22 13:22",
        "lat": 39.46217499999999,
        "lng": -0.331273,
        "id_ext": "0049-GEN000-113631"
    },
    {
        "id": "447ee90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Subarrendado (gestión)",
        "strategy": "2",
        "askingPriceRent": "2615.34",
        "askingPriceSale": "496244.00",
        "address": " Rodriguez San Pedro 8 ",
        "district": "2807907",
        "postalCode": "28015",
        "city": "1128079",
        "province": "28",
        "CCAA": "54",
        "country": "ES",
        "use": "5",
        "surfacebr": "84.37",
        "surfaceMezzanine": "0.00",
        "surfacepb": "69.42",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "28.75",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "109.11",
        "surfaceTotal": "182.54",
        "timeAvailableFrom": "9/13/22 13:22",
        "lat": 40.4316576,
        "lng": -3.7067561,
        "id_ext": "0049-GEN000-113649"
    },
    {
        "id": "467ee90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Subarrendado (gestión)",
        "strategy": "2",
        "askingPriceRent": "1035.22",
        "askingPriceSale": "198416.40",
        "address": "Avenida Juan De Austria, 32 ",
        "postalCode": "28804",
        "city": "1128005",
        "province": "28",
        "CCAA": "54",
        "country": "ES",
        "use": "5",
        "surfacebr": "179.71",
        "surfaceMezzanine": "0.00",
        "surfacepb": "145.66",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "199.57",
        "surfaceTotal": "325.37",
        "timeAvailableFrom": "9/13/22 13:22",
        "lat": 40.4871697,
        "lng": -3.3508794,
        "id_ext": "0049-GEN000-113659"
    },
    {
        "id": "487ee90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "2",
        "askingPriceRent": "2033.29",
        "askingPriceSale": "346493.05",
        "address": "Carretera De Canillas 21 ",
        "district": "2807916",
        "postalCode": "28043",
        "city": "1128079",
        "province": "28",
        "CCAA": "54",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "138.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "138.00",
        "surfaceTotal": "138.00",
        "timeAvailableFrom": "9/13/22 13:22",
        "lat": 40.4630331,
        "lng": -3.650125,
        "id_ext": "0049-GEN000-113661"
    },
    {
        "id": "527ee90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Subarrendado (gestión)",
        "strategy": "2",
        "askingPriceRent": "4306.54",
        "askingPriceSale": "974638.00",
        "address": " Doctor Fleming 16 ",
        "district": "2807905",
        "postalCode": "28036",
        "city": "1128079",
        "province": "28",
        "CCAA": "54",
        "country": "ES",
        "use": "5",
        "surfacebr": "207.50",
        "surfaceMezzanine": "0.00",
        "surfacepb": "136.96",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "199.21",
        "surfaceTotal": "344.46",
        "timeAvailableFrom": "9/13/22 13:22",
        "lat": 40.4557361,
        "lng": -3.6881744,
        "id_ext": "0049-GEN000-113818"
    },
    {
        "id": "547ee90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "2",
        "askingPriceRent": "1558.94",
        "askingPriceSale": "268413.60",
        "address": " Numancia 6 ",
        "district": "2807906",
        "postalCode": "28039",
        "city": "1128079",
        "province": "28",
        "CCAA": "54",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "147.48",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "147.48",
        "surfaceTotal": "147.48",
        "timeAvailableFrom": "9/13/22 13:22",
        "lat": 40.4541213,
        "lng": -3.712296,
        "id_ext": "0049-GEN000-113821"
    },
    {
        "id": "567ee90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "2",
        "askingPriceRent": "2114.91",
        "askingPriceSale": "344652.00",
        "address": "Calle Claret 10 ",
        "district": "2807905",
        "postalCode": "28002",
        "city": "1128079",
        "province": "28",
        "CCAA": "54",
        "country": "ES",
        "use": "5",
        "surfacebr": "36.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "76.34",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "87.14",
        "surfaceTotal": "112.34",
        "timeAvailableFrom": "9/13/22 13:22",
        "lat": 40.4477974,
        "lng": -3.6641263,
        "id_ext": "0049-GEN000-113827"
    },
    {
        "id": "587ee90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "2",
        "askingPriceRent": "2768.50",
        "askingPriceSale": "569520.00",
        "address": "Calle Mejía Lequerica 16 ",
        "district": "2807901",
        "postalCode": "28004",
        "city": "1128079",
        "province": "28",
        "CCAA": "54",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "112.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "112.00",
        "surfaceTotal": "112.00",
        "timeAvailableFrom": "9/13/22 13:22",
        "lat": 40.42742570000001,
        "lng": -3.6989164,
        "id_ext": "0049-GEN000-113837"
    },
    {
        "id": "5a7ee90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "2",
        "address": " Retuerto 60 ",
        "postalCode": "48903",
        "city": "1148013",
        "province": "48",
        "CCAA": "53",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "171.73",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "171.73",
        "surfaceTotal": "171.73",
        "timeAvailableFrom": "9/13/22 13:22",
        "lat": 43.2887919,
        "lng": -3.0081977,
        "id_ext": "0049-GEN000-113839"
    },
    {
        "id": "5c7ee90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Subarrendado (gestión)",
        "strategy": "2",
        "address": " Sant Miquel 51 ",
        "postalCode": "07002",
        "city": "1107040",
        "province": "07",
        "CCAA": "44",
        "country": "ES",
        "use": "11",
        "surfacebr": "105.51",
        "surfaceMezzanine": "0.00",
        "surfacepb": "144.42",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "80.26",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "216.20",
        "surfaceTotal": "330.19",
        "timeAvailableFrom": "9/13/22 13:22",
        "lat": 39.57417299999999,
        "lng": 2.6520591,
        "id_ext": "0049-GEN000-113858"
    },
    {
        "id": "5e7ee90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "2",
        "askingPriceRent": "1511.84",
        "askingPriceSale": "288026.29",
        "address": " Valdelasierra 10 ",
        "district": "2807902",
        "postalCode": "28005",
        "city": "1128079",
        "province": "28",
        "CCAA": "54",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "126.30",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "126.30",
        "surfaceTotal": "126.30",
        "timeAvailableFrom": "9/13/22 13:22",
        "lat": 40.3975692,
        "lng": -3.7048242,
        "id_ext": "0049-GEN000-113871"
    },
    {
        "id": "627ee90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Subarrendado (gestión)",
        "strategy": "2",
        "askingPriceRent": "2833.60",
        "askingPriceSale": "453376.00",
        "address": "Plaza De La Inmaculada 7 ",
        "postalCode": "24001",
        "city": "1124089",
        "province": "24",
        "CCAA": "59",
        "country": "ES",
        "use": "5",
        "surfacebr": "53.80",
        "surfaceMezzanine": "0.00",
        "surfacepb": "211.68",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "227.82",
        "surfaceTotal": "265.48",
        "timeAvailableFrom": "9/13/22 13:22",
        "lat": 42.6000032,
        "lng": -5.575819699999999,
        "id_ext": "0049-GEN000-113915"
    },
    {
        "id": "6a7ee90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "2",
        "address": "Calle Vista Alegre 5 ",
        "postalCode": "39001",
        "city": "1139075",
        "province": "39",
        "CCAA": "30",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "116.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "116.00",
        "surfaceTotal": "116.00",
        "timeAvailableFrom": "9/13/22 13:22",
        "lat": 43.4645032,
        "lng": -3.8103025,
        "id_ext": "0049-GEN000-114865"
    },
    {
        "id": "6e7ee90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "2",
        "askingPriceRent": "1394.40",
        "askingPriceSale": "209160.00",
        "address": " Oceano Atlantico 3 ",
        "postalCode": "28820",
        "city": "1128049",
        "province": "28",
        "CCAA": "54",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "165.74",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "165.74",
        "surfaceTotal": "165.74",
        "timeAvailableFrom": "9/13/22 13:22",
        "lat": 40.4186786,
        "lng": -3.5698007,
        "id_ext": "0049-GEN000-114899"
    },
    {
        "id": "707ee90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Subarrendado (gestión)",
        "strategy": "2",
        "askingPriceRent": "1969.80",
        "askingPriceSale": "309540.00",
        "address": " Amador D. Rios 48-50 ",
        "postalCode": "41003",
        "city": "1141091",
        "province": "41",
        "CCAA": "51",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "184.33",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "184.33",
        "surfaceTotal": "184.33",
        "agent": "Sara Carracedo Culebras",
        "timeAvailableFrom": "9/13/22 13:22",
        "lat": 37.3921393,
        "lng": -5.982257499999999,
        "id_ext": "0049-GEN000-114976"
    },
    {
        "id": "767ee90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "2",
        "askingPriceRent": "994.22",
        "askingPriceSale": "149133.60",
        "address": " Txomin Garat, 7 ",
        "postalCode": "48004",
        "city": "1148020",
        "province": "48",
        "CCAA": "53",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "118.36",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "118.36",
        "surfaceTotal": "118.36",
        "timeAvailableFrom": "9/13/22 13:22",
        "lat": 43.257711,
        "lng": -2.9087168,
        "id_ext": "0049-GEN000-115072"
    },
    {
        "id": "807ee90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "2",
        "askingPriceRent": "2772.00",
        "askingPriceSale": "400400.00",
        "address": "Calle De De La Cala ",
        "postalCode": "29649",
        "city": "1129070",
        "province": "29",
        "CCAA": "51",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "178.00",
        "surfaceBasement1": "178.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "178.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "267.00",
        "surfaceTotal": "356.00",
        "timeAvailableFrom": "9/13/22 13:22",
        "lat": 36.504559,
        "lng": -4.679652,
        "id_ext": "0049-GEN000-115173"
    },
    {
        "id": "847ee90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "2",
        "askingPriceRent": "1302.00",
        "askingPriceSale": "182280.00",
        "address": "Calle Sor Valentina Mirón 82 ",
        "postalCode": "10600",
        "city": "1110148",
        "province": "10",
        "CCAA": "41",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "186.05",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "186.05",
        "surfaceTotal": "186.05",
        "timeAvailableFrom": "9/13/22 13:22",
        "lat": 40.0338622,
        "lng": -6.0881721,
        "id_ext": "0049-GEN000-115255"
    },
    {
        "id": "887ee90a-5633-ed11-9db1-0022489c4873",
        "active": false,
        "status": "Vendido",
        "strategy": "1",
        "askingPriceRent": "699.30",
        "askingPriceSale": "87723.48",
        "address": " Antonio Huertas 149 ",
        "city": "1113082",
        "province": "13",
        "CCAA": "40",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "111.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "111.00",
        "surfaceTotal": "111.00",
        "timeAvailableFrom": "9/13/22 13:22",
        "lat": 39.1522653,
        "lng": -3.0132667,
        "id_ext": "0049-GEN000-115302"
    },
    {
        "id": "ea7ee90a-5633-ed11-9db1-0022489c4873",
        "active": false,
        "status": "Vendido",
        "strategy": "1",
        "askingPriceSale": "288148.00",
        "address": "Rua De Galicia 10 ",
        "city": "1115057",
        "province": "15",
        "CCAA": "60",
        "country": "ES",
        "use": "5",
        "surfacebr": "130.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "130.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "235.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "286.50",
        "surfaceTotal": "495.00",
        "timeAvailableFrom": "9/13/22 13:22",
        "lat": 42.7841592,
        "lng": -8.887869799999999,
        "id_ext": "0049-GEN000-117899"
    },
    {
        "id": "007fe90a-5633-ed11-9db1-0022489c4873",
        "active": false,
        "status": "Vendido",
        "strategy": "1",
        "askingPriceRent": "1282.15",
        "askingPriceSale": "221060.00",
        "address": "Calle Ramiro I ",
        "postalCode": "33012",
        "city": "1133044",
        "province": "33",
        "CCAA": "31",
        "country": "ES",
        "use": "5",
        "surfacebr": "129.57",
        "surfaceMezzanine": "0.00",
        "surfacepb": "125.91",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "164.78",
        "surfaceTotal": "255.48",
        "timeAvailableFrom": "9/13/22 13:22",
        "lat": 43.3650111,
        "lng": -5.860415,
        "id_ext": "0049-GEN000-117968"
    },
    {
        "id": "2280e90a-5633-ed11-9db1-0022489c4873",
        "active": false,
        "status": "Vendido",
        "strategy": "1",
        "askingPriceRent": "705.60",
        "askingPriceSale": "114660.00",
        "address": "Avenida De Andalucia 31 ",
        "postalCode": "29570",
        "city": "1129038",
        "province": "29",
        "CCAA": "51",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "124.29",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "124.29",
        "surfaceTotal": "124.29",
        "timeAvailableFrom": "9/13/22 13:23",
        "lat": 36.7363451,
        "lng": -4.6057597,
        "id_ext": "0049-GEN000-118993"
    },
    {
        "id": "4c81e90a-5633-ed11-9db1-0022489c4873",
        "active": false,
        "status": "Vendido",
        "strategy": "1",
        "askingPriceRent": "797.89",
        "askingPriceSale": "99736.00",
        "address": "Plaza DeEspaña 19 ",
        "city": "1116067",
        "province": "31",
        "CCAA": "11",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "142.48",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "142.48",
        "surfaceTotal": "142.48",
        "timeAvailableFrom": "9/13/22 13:24",
        "lat": 42.1711903,
        "lng": -1.6905154,
        "id_ext": "0049-GEN000-119934"
    },
    {
        "id": "8c82e90a-5633-ed11-9db1-0022489c4873",
        "active": false,
        "status": "Vendido",
        "strategy": "1",
        "askingPriceRent": "593.60",
        "askingPriceSale": "74200.00",
        "address": " La Libertad 24 ",
        "city": "1133980",
        "province": "33",
        "CCAA": "31",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "0.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "103.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "51.50",
        "surfaceTotal": "103.00",
        "timeAvailableFrom": "9/13/22 13:25",
        "lat": 43.2450108,
        "lng": -5.561657299999999,
        "id_ext": "0049-GEN000-122734"
    },
    {
        "id": "7a845e94-6233-ed11-9db1-0022489ca4d1",
        "active": true,
        "status": "Comercializable",
        "address": "Calle Mallorca 547 ",
        "city": "1108019",
        "province": "08",
        "CCAA": "55",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "0.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "98.74",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "49.37",
        "surfaceTotal": "98.74",
        "timeAvailableFrom": "9/13/22 14:50",
        "lat": 41.409747,
        "lng": 2.1835645,
        "id_ext": "0049-GEN000-123803"
    },
    {
        "id": "a47de90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "2",
        "address": "Calle Valencia 617 ",
        "city": "1108019",
        "province": "08",
        "CCAA": "55",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "202.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "202.00",
        "surfaceTotal": "202.00",
        "timeAvailableFrom": "9/13/22 13:22",
        "lat": 41.4100841,
        "lng": 2.1862596,
        "id_ext": "0628-FICT000-110348"
    },
    {
        "id": "ee7de90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Subarrendado (gestión)",
        "strategy": "2",
        "askingPriceRent": "1436.40",
        "askingPriceSale": "191520.00",
        "address": " Michelena 26 ",
        "postalCode": "36002",
        "city": "1136038",
        "province": "36",
        "CCAA": "60",
        "country": "ES",
        "use": "5",
        "surfacebr": "179.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "360.00",
        "surfaceBasement1": "358.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "358.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "592.70",
        "surfaceTotal": "897.00",
        "timeAvailableFrom": "9/13/22 13:22",
        "lat": 42.431316,
        "lng": -8.6456312,
        "id_ext": "0628-FICT000-111864"
    },
    {
        "id": "ae7ce90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "2",
        "address": "Plaza goiko portala 4 ",
        "postalCode": "48270",
        "city": "1148060",
        "province": "48",
        "CCAA": "53",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "73.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "73.00",
        "surfaceTotal": "73.00",
        "timeAvailableFrom": "9/13/22 13:21",
        "lat": 43.2674969,
        "lng": -2.4981302,
        "id_ext": "0723-FICT000-100217"
    },
    {
        "id": "b07ce90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "2",
        "address": "Plaza samuel picazo 3 ",
        "postalCode": "01110",
        "city": "1101017",
        "province": "01",
        "CCAA": "53",
        "country": "ES",
        "use": "5",
        "surfacebr": "90.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "82.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "109.00",
        "surfaceTotal": "172.00",
        "timeAvailableFrom": "9/13/22 13:21",
        "lat": 42.69332379999999,
        "lng": -2.3517526,
        "id_ext": "0723-FICT000-100222"
    },
    {
        "id": "b47ce90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "2",
        "address": "Plaza españa 27 ",
        "postalCode": "06370",
        "city": "1106022",
        "province": "06",
        "CCAA": "41",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "157.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "157.00",
        "surfaceTotal": "157.00",
        "timeAvailableFrom": "9/13/22 13:21",
        "lat": 38.3820414,
        "lng": -6.590122,
        "id_ext": "0723-FICT000-100227"
    },
    {
        "id": "bc7ce90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "2",
        "address": "Plaza emilio castelar 5 ",
        "postalCode": "46100",
        "city": "1146078",
        "province": "46",
        "CCAA": "42",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "215.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "215.00",
        "surfaceTotal": "215.00",
        "timeAvailableFrom": "9/13/22 13:21",
        "lat": 39.5089007,
        "lng": -0.4105484,
        "id_ext": "0723-FICT000-100285"
    },
    {
        "id": "c27ce90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Subarrendado (gestión)",
        "strategy": "2",
        "address": "Avenida Alameda 8 ",
        "postalCode": "03803",
        "city": "1103009",
        "province": "03",
        "CCAA": "42",
        "country": "ES",
        "use": "5",
        "surfacebr": "175.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "208.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "3.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "262.00",
        "surfaceTotal": "386.00",
        "timeAvailableFrom": "9/13/22 13:21",
        "lat": 38.6990623,
        "lng": -0.480554,
        "id_ext": "0723-FICT000-100312"
    },
    {
        "id": "cc7ce90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "2",
        "address": " Gran de la Sagrera 158 ",
        "postalCode": "08027",
        "city": "1108019",
        "province": "08",
        "CCAA": "55",
        "country": "ES",
        "use": "5",
        "surfacebr": "119.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "220.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "255.70",
        "surfaceTotal": "339.00",
        "timeAvailableFrom": "9/13/22 13:21",
        "lat": 41.4252865,
        "lng": 2.1912217,
        "id_ext": "0723-FICT000-100367"
    },
    {
        "id": "d07ce90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "2",
        "address": "Calle borbolla 13 ",
        "postalCode": "41004",
        "city": "1141091",
        "province": "41",
        "CCAA": "51",
        "country": "ES",
        "use": "5",
        "surfacebr": "67.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "200.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "220.10",
        "surfaceTotal": "267.00",
        "timeAvailableFrom": "9/13/22 13:21",
        "lat": 37.37660109999999,
        "lng": -5.9843195,
        "id_ext": "0723-FICT000-100410"
    },
    {
        "id": "da7ce90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "2",
        "address": " santa ana 21 ",
        "postalCode": "20540",
        "city": "1120034",
        "province": "20",
        "CCAA": "53",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "68.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "68.00",
        "surfaceTotal": "68.00",
        "timeAvailableFrom": "9/13/22 13:21",
        "lat": 43.0165575,
        "lng": -2.5278399,
        "id_ext": "0723-FICT000-100470"
    },
    {
        "id": "dc7ce90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "2",
        "address": "Calle iturriza ",
        "postalCode": "48240",
        "city": "1148019",
        "province": "48",
        "CCAA": "53",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "194.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "194.00",
        "surfaceTotal": "194.00",
        "timeAvailableFrom": "9/13/22 13:21",
        "lat": 43.1758507,
        "lng": -2.5768462,
        "id_ext": "0723-FICT000-100479"
    },
    {
        "id": "ee7ce90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "2",
        "address": "Avenida pino montano 22 ",
        "postalCode": "41008",
        "city": "1141091",
        "province": "41",
        "CCAA": "51",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "250.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "250.00",
        "surfaceTotal": "250.00",
        "timeAvailableFrom": "9/13/22 13:21",
        "lat": 37.4061633,
        "lng": -5.9743973,
        "id_ext": "0723-FICT000-100561"
    },
    {
        "id": "fc7ce90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "2",
        "address": "Calle begoñalde 3 ",
        "postalCode": "48007",
        "city": "1148020",
        "province": "48",
        "CCAA": "53",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "166.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "166.00",
        "surfaceTotal": "166.00",
        "timeAvailableFrom": "9/13/22 13:21",
        "lat": 43.2534399,
        "lng": -2.9016656,
        "id_ext": "0723-FICT000-100629"
    },
    {
        "id": "007de90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Comité",
        "strategy": "2",
        "address": "Avenida Burjasot 33 ",
        "postalCode": "46002",
        "city": "1146250",
        "province": "46",
        "CCAA": "42",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "154.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "154.00",
        "surfaceTotal": "154.00",
        "timeAvailableFrom": "9/13/22 13:21",
        "lat": 39.4847945,
        "lng": -0.3853197,
        "id_ext": "0723-FICT000-100648"
    },
    {
        "id": "027de90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "2",
        "address": "Paseo generalitat 18 ",
        "postalCode": "08500",
        "city": "1108298",
        "province": "08",
        "CCAA": "55",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "93.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "93.00",
        "surfaceTotal": "93.00",
        "timeAvailableFrom": "9/13/22 13:21",
        "lat": 41.9237093,
        "lng": 2.2532019,
        "id_ext": "0723-FICT000-100654"
    },
    {
        "id": "047de90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "2",
        "address": "Avenida república argentina 41 ",
        "postalCode": "46700",
        "city": "1146131",
        "province": "46",
        "CCAA": "42",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "145.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "145.00",
        "surfaceTotal": "145.00",
        "timeAvailableFrom": "9/13/22 13:21",
        "lat": 38.9684123,
        "lng": -0.1857564,
        "id_ext": "0723-FICT000-100655"
    },
    {
        "id": "187de90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "2",
        "address": "Avenida Holanda 10 ",
        "postalCode": "03540",
        "city": "1103014",
        "province": "03",
        "CCAA": "42",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "153.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "153.00",
        "surfaceTotal": "153.00",
        "timeAvailableFrom": "9/13/22 13:21",
        "lat": 38.368408,
        "lng": -0.413914,
        "id_ext": "0723-FICT000-100768"
    },
    {
        "id": "327de90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "2",
        "address": " real 67 ",
        "postalCode": "02110",
        "city": "1102035",
        "province": "02",
        "CCAA": "40",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "124.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "124.00",
        "surfaceTotal": "124.00",
        "timeAvailableFrom": "9/13/22 13:21",
        "lat": 39.1132781,
        "lng": -1.9961056,
        "id_ext": "0723-FICT000-100943"
    },
    {
        "id": "367de90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "2",
        "address": "Calle rodrigo rebolledo 36 ",
        "postalCode": "50002",
        "city": "1150297",
        "province": "50",
        "CCAA": "10",
        "country": "ES",
        "use": "5",
        "surfacebr": "123.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "140.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "176.90",
        "surfaceTotal": "263.00",
        "timeAvailableFrom": "9/13/22 13:21",
        "lat": 41.6458315,
        "lng": -0.862095,
        "id_ext": "0723-FICT000-100958"
    },
    {
        "id": "507de90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "2",
        "address": "Calle vázquez de parga 5 ",
        "postalCode": "15100",
        "city": "1115019",
        "province": "15",
        "CCAA": "60",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "250.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "250.00",
        "surfaceTotal": "250.00",
        "timeAvailableFrom": "9/13/22 13:22",
        "lat": 43.2139603,
        "lng": -8.690708599999999,
        "id_ext": "0723-FICT000-101063"
    },
    {
        "id": "527de90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Subarrendado (gestión)",
        "strategy": "2",
        "address": "Calle Villaviciosa 36 ",
        "district": "2807910",
        "postalCode": "28024",
        "city": "1128079",
        "province": "28",
        "CCAA": "54",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "91.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "91.00",
        "surfaceTotal": "91.00",
        "timeAvailableFrom": "9/13/22 13:22",
        "lat": 40.397111,
        "lng": -3.7710345,
        "id_ext": "0723-FICT000-101079"
    },
    {
        "id": "567de90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "2",
        "address": "Calle peñón 5 ",
        "postalCode": "28923",
        "city": "1128007",
        "province": "28",
        "CCAA": "54",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "147.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "147.00",
        "surfaceTotal": "147.00",
        "timeAvailableFrom": "9/13/22 13:22",
        "lat": 40.3481177,
        "lng": -3.8197588,
        "id_ext": "0723-FICT000-101101"
    },
    {
        "id": "587de90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "2",
        "address": " san adrian 133 ",
        "postalCode": "08030",
        "city": "1108019",
        "province": "08",
        "CCAA": "55",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "136.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "136.00",
        "surfaceTotal": "136.00",
        "timeAvailableFrom": "9/13/22 13:22",
        "lat": 41.436485,
        "lng": 2.2056452,
        "id_ext": "0723-FICT000-101103"
    },
    {
        "id": "5a7de90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "2",
        "address": "Calle j. rubio i orts o rosello 67 31 ",
        "postalCode": "08830",
        "city": "1108200",
        "province": "08",
        "CCAA": "55",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "200.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "200.00",
        "surfaceTotal": "200.00",
        "timeAvailableFrom": "9/13/22 13:22",
        "lat": 41.3476725,
        "lng": 2.0288506,
        "id_ext": "0723-FICT000-101110"
    },
    {
        "id": "5c7de90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "2",
        "address": " Singladura 7 ",
        "postalCode": "07610",
        "city": "1107040",
        "province": "07",
        "CCAA": "44",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "137.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "137.00",
        "surfaceTotal": "137.00",
        "timeAvailableFrom": "9/13/22 13:22",
        "lat": 39.5370107,
        "lng": 2.7174493,
        "id_ext": "0723-FICT000-101112"
    },
    {
        "id": "5e7de90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "2",
        "address": "Calle mar 29 ",
        "postalCode": "07680",
        "city": "1107033",
        "province": "07",
        "CCAA": "44",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "122.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "136.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "190.00",
        "surfaceTotal": "258.00",
        "timeAvailableFrom": "9/13/22 13:22",
        "lat": 39.54042760000001,
        "lng": 3.3330087,
        "id_ext": "0723-FICT000-101115"
    },
    {
        "id": "687de90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "2",
        "address": "Avenida juan carlos i 1 ",
        "postalCode": "30840",
        "city": "1130008",
        "province": "30",
        "CCAA": "43",
        "country": "ES",
        "use": "5",
        "surfacebr": "134.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "111.00",
        "surfaceBasement1": "108.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "108.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "134.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "205.20",
        "surfaceTotal": "353.00",
        "timeAvailableFrom": "9/13/22 13:22",
        "lat": 37.8511809,
        "lng": -1.422888,
        "id_ext": "0723-FICT000-101143"
    },
    {
        "id": "6a7de90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "2",
        "address": " juan xxiii 10 ",
        "postalCode": "07470",
        "city": "1107042",
        "province": "07",
        "CCAA": "44",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "170.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "170.00",
        "surfaceTotal": "170.00",
        "timeAvailableFrom": "9/13/22 13:22",
        "lat": 39.8771939,
        "lng": 3.0162026,
        "id_ext": "0723-FICT000-101152"
    },
    {
        "id": "707de90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "2",
        "address": "Plaza trinidad 5 ",
        "postalCode": "08033",
        "city": "1108019",
        "province": "08",
        "CCAA": "55",
        "country": "ES",
        "use": "5",
        "surfacebr": "215.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "39.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "103.50",
        "surfaceTotal": "254.00",
        "timeAvailableFrom": "9/13/22 13:22",
        "lat": 41.4499891,
        "lng": 2.1912217,
        "id_ext": "0723-FICT000-101161"
    },
    {
        "id": "7c7de90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "2",
        "address": " Mosen Jacinto Verdaguer 136 ",
        "postalCode": "08923",
        "city": "1108245",
        "province": "08",
        "CCAA": "55",
        "country": "ES",
        "use": "5",
        "surfacebr": "21.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "89.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "95.30",
        "surfaceTotal": "110.00",
        "timeAvailableFrom": "9/13/22 13:22",
        "lat": 41.4489328,
        "lng": 2.2178829,
        "id_ext": "0723-FICT000-101213"
    },
    {
        "id": "7e7de90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "2",
        "address": " navarra 16 ",
        "postalCode": "41015",
        "city": "1141091",
        "province": "41",
        "CCAA": "51",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "120.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "120.00",
        "surfaceTotal": "120.00",
        "timeAvailableFrom": "9/13/22 13:22",
        "lat": 37.4226813,
        "lng": -5.983408799999999,
        "id_ext": "0723-FICT000-101219"
    },
    {
        "id": "867de90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "2",
        "address": " callao 42 ",
        "postalCode": "28945",
        "city": "1128058",
        "province": "28",
        "CCAA": "54",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "142.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "142.00",
        "surfaceTotal": "142.00",
        "timeAvailableFrom": "9/13/22 13:22",
        "lat": 40.2930774,
        "lng": -3.785768,
        "id_ext": "0723-FICT000-101233"
    },
    {
        "id": "907de90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "2",
        "address": " San Jerónimo 20 ",
        "postalCode": "11640",
        "city": "1111010",
        "province": "11",
        "CCAA": "51",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "132.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "132.00",
        "surfaceTotal": "132.00",
        "timeAvailableFrom": "9/13/22 13:22",
        "lat": 36.818063,
        "lng": -5.743377,
        "id_ext": "0723-FICT000-101946"
    },
    {
        "id": "947de90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "2",
        "address": " alcalde manuel alberola 10 ",
        "postalCode": "03660",
        "city": "1103093",
        "province": "03",
        "CCAA": "42",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "126.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "126.00",
        "surfaceTotal": "126.00",
        "timeAvailableFrom": "9/13/22 13:22",
        "lat": 38.3846539,
        "lng": -0.7653509,
        "id_ext": "0723-FICT000-110126"
    },
    {
        "id": "b27de90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "2",
        "address": "Avenida de la Cañada 27 ",
        "postalCode": "11203",
        "city": "1111004",
        "province": "11",
        "CCAA": "51",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "128.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "128.00",
        "surfaceTotal": "128.00",
        "timeAvailableFrom": "9/13/22 13:22",
        "lat": 40.42378009999999,
        "lng": -3.5367805,
        "id_ext": "0723-FICT000-110451"
    },
    {
        "id": "b87de90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "2",
        "address": "Avenida ernesto che guevara 5 ",
        "postalCode": "15172",
        "city": "1115058",
        "province": "15",
        "CCAA": "60",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "220.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "220.00",
        "surfaceTotal": "220.00",
        "timeAvailableFrom": "9/13/22 13:22",
        "lat": 43.3335162,
        "lng": -8.3789705,
        "id_ext": "0723-FICT000-110561"
    },
    {
        "id": "c67de90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "2",
        "address": " hirigoien 1 ",
        "postalCode": "20210",
        "city": "1120049",
        "province": "20",
        "CCAA": "53",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "144.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "144.00",
        "surfaceTotal": "144.00",
        "timeAvailableFrom": "9/13/22 13:22",
        "lat": 43.0331475,
        "lng": -2.1863061,
        "id_ext": "0723-FICT000-111090"
    },
    {
        "id": "ec7de90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "2",
        "address": " parque municipal 4 ",
        "postalCode": "15680",
        "city": "1115059",
        "province": "15",
        "CCAA": "60",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "217.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "49.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "241.50",
        "surfaceTotal": "266.00",
        "timeAvailableFrom": "9/13/22 13:22",
        "lat": 43.0770613,
        "lng": -8.407864199999999,
        "id_ext": "0723-FICT000-111713"
    },
    {
        "id": "fe7de90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "2",
        "address": "Avenida primero de junio 46 ",
        "postalCode": "34200",
        "city": "1134023",
        "province": "34",
        "CCAA": "59",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "221.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "221.00",
        "surfaceTotal": "221.00",
        "timeAvailableFrom": "9/13/22 13:22",
        "lat": 41.9199746,
        "lng": -4.4966208,
        "id_ext": "0723-FICT000-112138"
    },
    {
        "id": "007ee90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "2",
        "address": "Paseo Riera 124 ",
        "postalCode": "08329",
        "city": "1108281",
        "province": "08",
        "CCAA": "55",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "167.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "167.00",
        "surfaceTotal": "167.00",
        "timeAvailableFrom": "9/13/22 13:22",
        "lat": 41.4964205,
        "lng": 2.3218228,
        "id_ext": "0723-FICT000-112164"
    },
    {
        "id": "0c7ee90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "2",
        "address": " brasil 20 ",
        "postalCode": "33213",
        "city": "1133024",
        "province": "33",
        "CCAA": "31",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "114.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "114.00",
        "surfaceTotal": "114.00",
        "timeAvailableFrom": "9/13/22 13:22",
        "lat": 43.5322015,
        "lng": -5.6611195,
        "id_ext": "0723-FICT000-112882"
    },
    {
        "id": "127ee90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "2",
        "address": " mayor 20 ",
        "postalCode": "31600",
        "city": "1131060",
        "province": "31",
        "CCAA": "11",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "123.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "58.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "152.00",
        "surfaceTotal": "181.00",
        "timeAvailableFrom": "9/13/22 13:22",
        "lat": 42.8264759,
        "lng": -1.6156261,
        "id_ext": "0723-FICT000-112992"
    },
    {
        "id": "147ee90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "2",
        "address": " castelar 7 ",
        "postalCode": "30366",
        "city": "1130016",
        "province": "30",
        "CCAA": "43",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "110.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "110.00",
        "surfaceTotal": "110.00",
        "timeAvailableFrom": "9/13/22 13:22",
        "lat": 37.6899267,
        "lng": -0.9640312999999998,
        "id_ext": "0723-FICT000-113048"
    },
    {
        "id": "1a7ee90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "2",
        "address": " el piñal 15 ",
        "postalCode": "39313",
        "city": "1139054",
        "province": "39",
        "CCAA": "30",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "103.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "103.00",
        "surfaceTotal": "103.00",
        "timeAvailableFrom": "9/13/22 13:22",
        "lat": 19.4340199,
        "lng": -99.19560120000001,
        "id_ext": "0723-FICT000-113123"
    },
    {
        "id": "287ee90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "2",
        "address": "Travesía de les Corts 371 ",
        "postalCode": "08029",
        "city": "1108019",
        "province": "08",
        "CCAA": "55",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "167.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "167.00",
        "surfaceTotal": "167.00",
        "timeAvailableFrom": "9/13/22 13:22",
        "lat": 41.390319,
        "lng": 2.1403804,
        "id_ext": "0723-FICT000-113262"
    },
    {
        "id": "4a7ee90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "2",
        "address": "Ronda industria 49 ",
        "postalCode": "08210",
        "city": "1108252",
        "province": "08",
        "CCAA": "55",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "120.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "104.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "172.00",
        "surfaceTotal": "224.00",
        "timeAvailableFrom": "9/13/22 13:22",
        "lat": 41.5156583,
        "lng": 2.1296375,
        "id_ext": "0723-FICT000-113672"
    },
    {
        "id": "4c7ee90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - En legal",
        "strategy": "2",
        "address": "Avenida coruña 9 ",
        "postalCode": "15189",
        "city": "1101021",
        "province": "15",
        "CCAA": "60",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "138.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "138.00",
        "surfaceTotal": "138.00",
        "timeAvailableFrom": "9/13/22 13:22",
        "lat": 43.3161759,
        "lng": -8.3659383,
        "id_ext": "0723-FICT000-113740"
    },
    {
        "id": "4e7ee90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Subarrendado (gestión)",
        "strategy": "2",
        "address": "Calle juan dominguez perez 19 ",
        "postalCode": "35008",
        "city": "1135016",
        "province": "35",
        "CCAA": "56",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "224.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "224.00",
        "surfaceTotal": "224.00",
        "timeAvailableFrom": "9/13/22 13:22",
        "lat": 28.1564841,
        "lng": -15.415821,
        "id_ext": "0723-FICT000-113761"
    },
    {
        "id": "507ee90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "2",
        "address": "Avenida hytasa 36 ",
        "postalCode": "41006",
        "city": "1141091",
        "province": "41",
        "CCAA": "51",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "200.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "200.00",
        "surfaceTotal": "200.00",
        "timeAvailableFrom": "9/13/22 13:22",
        "lat": 37.3678965,
        "lng": -5.9556303,
        "id_ext": "0723-FICT000-113799"
    },
    {
        "id": "667ee90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "2",
        "address": "Paseo del espolon 24 ",
        "postalCode": "42001",
        "city": "1142173",
        "province": "42",
        "CCAA": "59",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "136.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "136.00",
        "surfaceTotal": "136.00",
        "timeAvailableFrom": "9/13/22 13:22",
        "lat": 41.76509129999999,
        "lng": -2.4732812,
        "id_ext": "0723-FICT000-114651"
    },
    {
        "id": "687ee90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Subarrendado (gestión)",
        "strategy": "2",
        "address": "Calle Molini s/n ",
        "postalCode": "41012",
        "city": "1141091",
        "province": "41",
        "CCAA": "51",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "155.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "155.00",
        "surfaceTotal": "155.00",
        "timeAvailableFrom": "9/13/22 13:22",
        "lat": 37.3989451,
        "lng": -5.9923181,
        "id_ext": "0723-FICT000-114673"
    },
    {
        "id": "6c7ee90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "2",
        "address": "Avenida maria fortuny 40 ",
        "postalCode": "43201",
        "city": "1143123",
        "province": "43",
        "CCAA": "55",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "146.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "135.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "213.50",
        "surfaceTotal": "281.00",
        "timeAvailableFrom": "9/13/22 13:22",
        "lat": 41.1567251,
        "lng": 1.1175964,
        "id_ext": "0723-FICT000-114891"
    },
    {
        "id": "747ee90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "2",
        "address": "Calle de tremp 31 ",
        "postalCode": "08032",
        "city": "1108019",
        "province": "08",
        "CCAA": "55",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "101.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "101.00",
        "surfaceTotal": "101.00",
        "timeAvailableFrom": "9/13/22 13:22",
        "lat": 41.43852649999999,
        "lng": 2.1877948,
        "id_ext": "0723-FICT000-115039"
    },
    {
        "id": "787ee90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "2",
        "address": " el hayedo 1 ",
        "postalCode": "24007",
        "city": "1124089",
        "province": "24",
        "CCAA": "59",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "270.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "270.00",
        "surfaceTotal": "270.00",
        "timeAvailableFrom": "9/13/22 13:22",
        "lat": 42.6045555,
        "lng": -5.5625578,
        "id_ext": "0723-FICT000-115073"
    },
    {
        "id": "827ee90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "2",
        "address": "Avenida La Torrecilla 3 ",
        "postalCode": "14013",
        "city": "1114021",
        "province": "14",
        "CCAA": "51",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "167.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "167.00",
        "surfaceTotal": "167.00",
        "timeAvailableFrom": "9/13/22 13:22",
        "lat": 37.861742,
        "lng": -4.7865772,
        "id_ext": "0723-FICT000-115196"
    },
    {
        "id": "d081e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "2",
        "address": " renteria 1 ",
        "postalCode": "20301",
        "city": "1120045",
        "province": "20",
        "CCAA": "53",
        "country": "ES",
        "use": "5",
        "surfacebr": "49.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "0.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "14.70",
        "surfaceTotal": "49.00",
        "timeAvailableFrom": "9/13/22 13:24",
        "lat": 43.3081107,
        "lng": -1.8912823,
        "id_ext": "0723-FICT000-121313"
    },
    {
        "id": "de82e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "2",
        "address": " clunia 6 ",
        "postalCode": "09005",
        "city": "1109059",
        "province": "09",
        "CCAA": "59",
        "country": "ES",
        "use": "5",
        "surfacebr": "145.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "0.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "43.50",
        "surfaceTotal": "145.00",
        "timeAvailableFrom": "9/13/22 13:25",
        "lat": 42.3472308,
        "lng": -3.6955869,
        "id_ext": "0723-FICT000-123802"
    },
    {
        "id": "e082e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "2",
        "address": "Calle zaratán 2 ",
        "district": "2807915",
        "postalCode": "28037",
        "city": "1128079",
        "province": "28",
        "CCAA": "54",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "36.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "36.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "54.00",
        "surfaceTotal": "72.00",
        "timeAvailableFrom": "9/13/22 13:25",
        "lat": 40.4281891,
        "lng": -3.6254782,
        "id_ext": "0723-FICT000-123804"
    },
    {
        "id": "ce7ce90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "1",
        "askingPriceRent": "525.00",
        "askingPriceSale": "73500.00",
        "address": "Calle Marcelino Suarez 12 ",
        "postalCode": "32300",
        "city": "1132009",
        "province": "32",
        "CCAA": "60",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "149.20",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "149.20",
        "surfaceTotal": "149.20",
        "timeAvailableFrom": "9/13/22 13:21",
        "lat": 42.4161794,
        "lng": -6.9821789,
        "id_ext": "4160-GEN000-100387"
    },
    {
        "id": "e07ce90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "1",
        "askingPriceRent": "908.88",
        "askingPriceSale": "136332.00",
        "address": "Carretera de Gabriel Ciscar 1 ",
        "postalCode": "46780",
        "city": "1146181",
        "province": "46",
        "CCAA": "42",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "475.19",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "183.69",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "567.04",
        "surfaceTotal": "658.88",
        "timeAvailableFrom": "9/13/22 13:21",
        "lat": 38.9187512,
        "lng": -0.1179521,
        "id_ext": "4160-GEN000-100524"
    },
    {
        "id": "e87ce90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Subarrendado (gestión)",
        "strategy": "2",
        "askingPriceRent": "1065.12",
        "askingPriceSale": "116497.50",
        "address": "Calle Carracido 4 ",
        "priceVisible": false,
        "postalCode": "33900",
        "city": "1133900",
        "province": "33",
        "CCAA": "31",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "111.25",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "111.25",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "166.88",
        "surfaceTotal": "222.50",
        "timeAvailableFrom": "9/13/22 13:21",
        "lat": 43.2959841,
        "lng": -5.683948,
        "id_ext": "4160-GEN000-100541"
    },
    {
        "id": "f47ce90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "2",
        "askingPriceRent": "4977.70",
        "askingPriceSale": "650930.00",
        "address": "Calle Enric Prat De La Riba 155 ",
        "postalCode": "08901",
        "city": "1108101",
        "province": "08",
        "CCAA": "55",
        "country": "ES",
        "use": "5",
        "surfacebr": "9.02",
        "surfaceMezzanine": "0.00",
        "surfacepb": "548.15",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "550.86",
        "surfaceTotal": "557.17",
        "timeAvailableFrom": "9/13/22 13:21",
        "lat": 41.3623892,
        "lng": 2.1089451,
        "id_ext": "4160-GEN000-100593"
    },
    {
        "id": "f87ce90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "1",
        "askingPriceRent": "688.80",
        "askingPriceSale": "114800.00",
        "address": "Calle Marqués De Pontejos 4 ",
        "postalCode": "15001",
        "city": "1115030",
        "province": "15",
        "CCAA": "60",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "88.77",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "88.77",
        "surfaceTotal": "88.77",
        "timeAvailableFrom": "9/13/22 13:21",
        "lat": 43.3720986,
        "lng": -8.3985708,
        "id_ext": "4160-GEN000-100617"
    },
    {
        "id": "0a7de90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "1",
        "askingPriceRent": "1713.60",
        "askingPriceSale": "278460.00",
        "address": "Calle Pablo Picasso 7 ",
        "city": "1128130",
        "province": "28",
        "CCAA": "54",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "137.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "137.00",
        "surfaceTotal": "137.00",
        "timeAvailableFrom": "9/13/22 13:21",
        "lat": 40.4258776,
        "lng": -3.5325333,
        "id_ext": "4160-GEN000-100687"
    },
    {
        "id": "0c7de90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "2",
        "askingPriceRent": "4953.90",
        "askingPriceSale": "707700.00",
        "address": "Calle Doutor Teixeiro 20 ",
        "postalCode": "15701",
        "city": "1115078",
        "province": "15",
        "CCAA": "60",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "324.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "64.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "356.00",
        "surfaceTotal": "388.00",
        "timeAvailableFrom": "9/13/22 13:21",
        "lat": 42.8747502,
        "lng": -8.545537,
        "id_ext": "4160-GEN000-100700"
    },
    {
        "id": "147de90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "1",
        "askingPriceRent": "778.75",
        "askingPriceSale": "124600.00",
        "address": "Camino Del Magros 95 ",
        "postalCode": "03202",
        "city": "1103065",
        "province": "03",
        "CCAA": "42",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "214.82",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "214.82",
        "surfaceTotal": "214.82",
        "timeAvailableFrom": "9/13/22 13:21",
        "lat": 38.2847647,
        "lng": -0.7089597,
        "id_ext": "4160-GEN000-100765"
    },
    {
        "id": "227de90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "1",
        "askingPriceRent": "705.60",
        "askingPriceSale": "105840.00",
        "address": "Calle Mayor 38 ",
        "postalCode": "30100",
        "city": "1130100",
        "province": "30",
        "CCAA": "43",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "390.16",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "390.16",
        "surfaceTotal": "390.16",
        "timeAvailableFrom": "9/13/22 13:21",
        "lat": 38.0088655,
        "lng": -1.1518313,
        "id_ext": "4160-GEN000-100825"
    },
    {
        "id": "267de90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "2",
        "askingPriceRent": "1423.17",
        "askingPriceSale": "189756.00",
        "address": "Calle El Rabal 26 ",
        "postalCode": "02400",
        "city": "1102037",
        "province": "02",
        "CCAA": "40",
        "country": "ES",
        "use": "5",
        "surfacebr": "531.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "409.40",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "568.70",
        "surfaceTotal": "940.40",
        "timeAvailableFrom": "9/13/22 13:21",
        "lat": 38.5126317,
        "lng": -1.7016408,
        "id_ext": "4160-GEN000-100834"
    },
    {
        "id": "2c7de90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "1",
        "askingPriceRent": "169.40",
        "askingPriceSale": "18480.00",
        "address": "Plaza Villa 45 ",
        "postalCode": "08760",
        "city": "1108114",
        "province": "08",
        "CCAA": "55",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "15.87",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "15.87",
        "surfaceTotal": "15.87",
        "timeAvailableFrom": "9/13/22 13:21",
        "lat": 41.4746792,
        "lng": 1.9313529,
        "id_ext": "4160-GEN000-100852"
    },
    {
        "id": "2e7de90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "1",
        "askingPriceRent": "859.11",
        "askingPriceSale": "114548.00",
        "address": "Avenida De España 2 ",
        "city": "1131254",
        "province": "31",
        "CCAA": "11",
        "country": "ES",
        "use": "5",
        "surfacebr": "53.21",
        "surfaceMezzanine": "0.00",
        "surfacepb": "213.10",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "229.06",
        "surfaceTotal": "266.31",
        "timeAvailableFrom": "9/13/22 13:21",
        "lat": 40.3100679,
        "lng": -3.7237161,
        "id_ext": "4160-GEN000-100905"
    },
    {
        "id": "387de90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Subarrendado (gestión)",
        "strategy": "2",
        "askingPriceRent": "2669.52",
        "askingPriceSale": "419496.00",
        "address": " Coso 102 ",
        "postalCode": "50001",
        "city": "1150297",
        "province": "50",
        "CCAA": "10",
        "country": "ES",
        "use": "5",
        "surfacebr": "241.93",
        "surfaceMezzanine": "0.00",
        "surfacepb": "257.07",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "329.65",
        "surfaceTotal": "499.00",
        "timeAvailableFrom": "9/13/22 13:21",
        "lat": 41.6506587,
        "lng": -0.8768323,
        "id_ext": "4160-GEN000-100959"
    },
    {
        "id": "4c7de90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "2",
        "askingPriceRent": "1212.12",
        "askingPriceSale": "202020.00",
        "address": "Paseo Del Altillo 3 ",
        "postalCode": "18690",
        "city": "1118017",
        "province": "18",
        "CCAA": "51",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "156.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "99.93",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "205.97",
        "surfaceTotal": "255.93",
        "timeAvailableFrom": "9/13/22 13:22",
        "lat": 36.7318927,
        "lng": -3.6892642,
        "id_ext": "4160-GEN000-101058"
    },
    {
        "id": "607de90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Subarrendado (gestión)",
        "strategy": "2",
        "askingPriceRent": "1904.00",
        "askingPriceSale": "228480.00",
        "address": "Plaza Española 8 ",
        "postalCode": "08904",
        "city": "1108101",
        "province": "08",
        "CCAA": "55",
        "country": "ES",
        "use": "5",
        "smokeStractor": false,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "225.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "225.00",
        "surfaceTotal": "225.00",
        "timeAvailableFrom": "9/13/22 13:22",
        "lat": 41.3705933,
        "lng": 2.1218538,
        "id_ext": "4160-GEN000-101124"
    },
    {
        "id": "627de90a-5633-ed11-9db1-0022489c4873",
        "active": false,
        "status": "Vendido",
        "address": "Calle Marti I Codolar, 39 - 41 ",
        "postalCode": "08902",
        "city": "1108101",
        "province": "08",
        "CCAA": "55",
        "country": "ES",
        "use": "8",
        "surfacebr": "41.80",
        "surfaceMezzanine": "0.00",
        "surfacepb": "0.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "12.54",
        "surfaceTotal": "41.80",
        "timeAvailableFrom": "9/13/22 13:22",
        "lat": 41.3681349,
        "lng": 2.1297714,
        "id_ext": "4160-GEN000-101125"
    },
    {
        "id": "3e845e94-6233-ed11-9db1-0022489ca4d1",
        "active": false,
        "status": "Vendido",
        "address": "Calle Marti I Codolar, 39 - 41 ",
        "postalCode": "08902",
        "city": "1108101",
        "province": "08",
        "CCAA": "55",
        "country": "ES",
        "use": "8",
        "surfacebr": "41.80",
        "surfaceMezzanine": "0.00",
        "surfacepb": "0.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "12.54",
        "surfaceTotal": "41.80",
        "timeAvailableFrom": "9/13/22 14:50",
        "lat": 41.3681349,
        "lng": 2.1297714,
        "id_ext": "4160-GEN000-101126"
    },
    {
        "id": "40845e94-6233-ed11-9db1-0022489ca4d1",
        "active": false,
        "status": "Vendido",
        "address": "Calle Marti I Codolar, 39 - 41 ",
        "postalCode": "08902",
        "city": "1108101",
        "province": "08",
        "CCAA": "55",
        "country": "ES",
        "use": "8",
        "surfacebr": "41.80",
        "surfaceMezzanine": "0.00",
        "surfacepb": "0.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "12.54",
        "surfaceTotal": "41.80",
        "timeAvailableFrom": "9/13/22 14:50",
        "lat": 41.3681349,
        "lng": 2.1297714,
        "id_ext": "4160-GEN000-101127"
    },
    {
        "id": "42845e94-6233-ed11-9db1-0022489ca4d1",
        "active": false,
        "status": "Vendido",
        "address": "Calle Marti I Codolar, 39 - 41 ",
        "postalCode": "08902",
        "city": "1108101",
        "province": "08",
        "CCAA": "55",
        "country": "ES",
        "use": "8",
        "surfacebr": "41.80",
        "surfaceMezzanine": "0.00",
        "surfacepb": "0.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "12.54",
        "surfaceTotal": "41.80",
        "timeAvailableFrom": "9/13/22 14:50",
        "lat": 41.3681349,
        "lng": 2.1297714,
        "id_ext": "4160-GEN000-101128"
    },
    {
        "id": "44845e94-6233-ed11-9db1-0022489ca4d1",
        "active": false,
        "status": "Vendido",
        "address": "Calle Marti I Codolar, 39 - 41 ",
        "postalCode": "08902",
        "city": "1108101",
        "province": "08",
        "CCAA": "55",
        "country": "ES",
        "use": "8",
        "surfacebr": "41.80",
        "surfaceMezzanine": "0.00",
        "surfacepb": "0.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "12.54",
        "surfaceTotal": "41.80",
        "timeAvailableFrom": "9/13/22 14:50",
        "lat": 41.3681349,
        "lng": 2.1297714,
        "id_ext": "4160-GEN000-101129"
    },
    {
        "id": "787de90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - En legal",
        "strategy": "2",
        "askingPriceRent": "1621.20",
        "askingPriceSale": "243180.00",
        "address": " Esperanza de Triana 41 ",
        "postalCode": "41010",
        "city": "1141091",
        "province": "41",
        "CCAA": "51",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "180.45",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "180.45",
        "surfaceTotal": "180.45",
        "timeAvailableFrom": "9/13/22 13:22",
        "lat": 37.379629,
        "lng": -6.003709499999999,
        "id_ext": "4160-GEN000-101172"
    },
    {
        "id": "987de90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "2",
        "askingPriceRent": "4301.50",
        "askingPriceSale": "739858.00",
        "address": "Calle Jose Abascal ",
        "district": "2807907",
        "postalCode": "28003",
        "city": "1128079",
        "province": "28",
        "CCAA": "54",
        "country": "ES",
        "use": "5",
        "surfacebr": "75.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "97.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "58.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "148.50",
        "surfaceTotal": "230.00",
        "timeAvailableFrom": "9/13/22 13:22",
        "lat": 40.4383502,
        "lng": -3.6974384,
        "id_ext": "4160-GEN000-110224"
    },
    {
        "id": "9a7de90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "2",
        "askingPriceRent": "3696.00",
        "askingPriceSale": "672000.00",
        "address": "Calle Valderribas ",
        "postalCode": "28007",
        "city": "1128079",
        "province": "28",
        "CCAA": "54",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "144.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "78.70",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "183.35",
        "surfaceTotal": "222.70",
        "timeAvailableFrom": "9/13/22 13:22",
        "lat": 40.4039167,
        "lng": -3.6744662,
        "id_ext": "4160-GEN000-110253"
    },
    {
        "id": "a27de90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Subarrendado (gestión)",
        "strategy": "1",
        "askingPriceRent": "6272.00",
        "askingPriceSale": "1505280.00",
        "address": "Calle Sants 76 ",
        "postalCode": "08014",
        "city": "1108019",
        "province": "08",
        "CCAA": "55",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "224.33",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "224.33",
        "surfaceTotal": "224.33",
        "timeAvailableFrom": "9/13/22 13:22",
        "lat": 41.375478,
        "lng": 2.1370769,
        "id_ext": "4160-GEN000-110333"
    },
    {
        "id": "a67de90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "2",
        "askingPriceRent": "1150.80",
        "askingPriceSale": "172620.00",
        "address": "Calle Constitución 37 ",
        "postalCode": "08014",
        "city": "1108019",
        "province": "08",
        "CCAA": "55",
        "country": "ES",
        "use": "5",
        "surfacebr": "74.33",
        "surfaceMezzanine": "0.00",
        "surfacepb": "74.33",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "96.63",
        "surfaceTotal": "148.66",
        "timeAvailableFrom": "9/13/22 13:22",
        "lat": 41.3697092,
        "lng": 2.1366807,
        "id_ext": "4160-GEN000-110368"
    },
    {
        "id": "b67de90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "2",
        "askingPriceRent": "1505.00",
        "askingPriceSale": "210700.00",
        "address": "Calle Concepción 6 ",
        "postalCode": "46870",
        "city": "1146184",
        "province": "46",
        "CCAA": "42",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "289.13",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "39.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "308.63",
        "surfaceTotal": "328.13",
        "timeAvailableFrom": "9/13/22 13:22",
        "lat": 38.8255071,
        "lng": -0.603502,
        "id_ext": "4160-GEN000-110532"
    },
    {
        "id": "c07de90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Subarrendado (gestión)",
        "strategy": "CAMBIO DE USO",
        "askingPriceRent": "2142.00",
        "askingPriceSale": "333200.00",
        "address": "Carretera De Cornella 121 ",
        "postalCode": "08950",
        "city": "1108077",
        "province": "08",
        "CCAA": "55",
        "country": "ES",
        "use": "5",
        "surfacebr": "100.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "140.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "170.00",
        "surfaceTotal": "240.00",
        "timeAvailableFrom": "9/13/22 13:22",
        "lat": 41.37068,
        "lng": 2.08251,
        "id_ext": "4160-GEN000-110890"
    },
    {
        "id": "c27de90a-5633-ed11-9db1-0022489c4873",
        "active": false,
        "status": "Vendido",
        "strategy": "2",
        "askingPriceRent": "10885.88",
        "askingPriceSale": "2327325.00",
        "address": "Calle Rosendo Arus 39 ",
        "postalCode": "08901",
        "city": "1108101",
        "province": "08",
        "CCAA": "55",
        "country": "ES",
        "use": "5",
        "surfacebr": "114.35",
        "surfaceMezzanine": "0.00",
        "surfacepb": "122.36",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "45.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "179.17",
        "surfaceTotal": "281.71",
        "timeAvailableFrom": "9/13/22 13:22",
        "lat": 41.35807399999999,
        "lng": 2.1001846,
        "id_ext": "4160-GEN000-110993"
    },
    {
        "id": "de7de90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Subarrendado (gestión)",
        "strategy": "2",
        "askingPriceRent": "2816.02",
        "askingPriceSale": "530073.60",
        "address": "Avenida Reina Victoria 70 ",
        "district": "2807907",
        "postalCode": "28003",
        "city": "1128079",
        "province": "28",
        "CCAA": "54",
        "country": "ES",
        "use": "5",
        "surfacebr": "69.73",
        "surfaceMezzanine": "0.00",
        "surfacepb": "74.65",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "123.14",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "157.14",
        "surfaceTotal": "267.52",
        "agent": "Sara Carracedo Culebras",
        "timeAvailableFrom": "9/13/22 13:22",
        "lat": 40.4463442,
        "lng": -3.7144371,
        "id_ext": "4160-GEN000-111501"
    },
    {
        "id": "e07de90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Subarrendado (gestión)",
        "strategy": "2",
        "askingPriceRent": "6796.30",
        "askingPriceSale": "1395030.00",
        "address": "Calle O'Donell 43 ",
        "postalCode": "28009",
        "city": "1128079",
        "province": "28",
        "CCAA": "54",
        "country": "ES",
        "use": "5",
        "surfacebr": "115.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "200.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "234.50",
        "surfaceTotal": "315.00",
        "timeAvailableFrom": "9/13/22 13:22",
        "lat": 40.4216539,
        "lng": -3.6747361,
        "id_ext": "4160-GEN000-111508"
    },
    {
        "id": "e27de90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Subarrendado (gestión)",
        "strategy": "2",
        "askingPriceRent": "3613.75",
        "askingPriceSale": "702100.00",
        "address": "Calle Alcalá 205 ",
        "postalCode": "28028",
        "city": "1128079",
        "province": "28",
        "CCAA": "54",
        "country": "ES",
        "use": "5",
        "surfacebr": "33.08",
        "surfaceMezzanine": "0.00",
        "surfacepb": "142.10",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "152.02",
        "surfaceTotal": "175.18",
        "timeAvailableFrom": "9/13/22 13:22",
        "lat": 40.42920230000001,
        "lng": -3.6670872,
        "id_ext": "4160-GEN000-111511"
    },
    {
        "id": "e87de90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Subarrendado (gestión)",
        "strategy": "2",
        "askingPriceRent": "578.76",
        "askingPriceSale": "66780.00",
        "address": "Avenida Pablo Iglesias 1 ",
        "postalCode": "47800",
        "city": "1147086",
        "province": "47",
        "CCAA": "59",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "157.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "157.00",
        "surfaceTotal": "157.00",
        "timeAvailableFrom": "9/13/22 13:22",
        "lat": 41.8832126,
        "lng": -5.0442973,
        "id_ext": "4160-GEN000-111663"
    },
    {
        "id": "f27de90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "2",
        "askingPriceRent": "652.40",
        "askingPriceSale": "45668.00",
        "address": "Calle Conde De Garay 3 ",
        "postalCode": "34100",
        "city": "1134157",
        "province": "34",
        "CCAA": "59",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "190.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "190.00",
        "surfaceTotal": "190.00",
        "timeAvailableFrom": "9/13/22 13:22",
        "lat": 42.5213757,
        "lng": -4.736257999999999,
        "id_ext": "4160-GEN000-111933"
    },
    {
        "id": "107ee90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "1",
        "askingPriceRent": "2175.32",
        "askingPriceSale": "348051.20",
        "address": "Calle Eustasio Amilibia 12 ",
        "postalCode": "20011",
        "city": "1120069",
        "province": "20",
        "CCAA": "53",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "150.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "150.00",
        "surfaceTotal": "150.00",
        "timeAvailableFrom": "9/13/22 13:22",
        "lat": 43.3050669,
        "lng": -1.9783452,
        "id_ext": "4160-GEN000-112983"
    },
    {
        "id": "3e7ee90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "2",
        "askingPriceRent": "1181.60",
        "askingPriceSale": "177240.00",
        "address": " Obispo Romo 14 ",
        "postalCode": "35011",
        "city": "1135016",
        "province": "35",
        "CCAA": "56",
        "country": "ES",
        "use": "5",
        "surfacebr": "13.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "186.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "189.90",
        "surfaceTotal": "199.00",
        "timeAvailableFrom": "9/13/22 13:22",
        "lat": 28.1146851,
        "lng": -15.4351335,
        "id_ext": "4160-GEN000-113616"
    },
    {
        "id": "407ee90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Subarrendado (gestión)",
        "strategy": "2",
        "askingPriceRent": "633.92",
        "askingPriceSale": "95088.00",
        "address": "Calle San Salvador 1 ",
        "postalCode": "15402",
        "city": "1115036",
        "province": "15",
        "CCAA": "60",
        "country": "ES",
        "use": "5",
        "surfacebr": "87.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "111.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "87.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "137.10",
        "surfaceTotal": "198.00",
        "timeAvailableFrom": "9/13/22 13:22",
        "lat": 43.4909109,
        "lng": -8.217689,
        "id_ext": "4160-GEN000-113620"
    },
    {
        "id": "7c7ee90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "1",
        "askingPriceRent": "697.20",
        "askingPriceSale": "92960.00",
        "address": "Calle Lorca ",
        "postalCode": "30320",
        "city": "1102033",
        "province": "30",
        "CCAA": "43",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "155.38",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "155.38",
        "surfaceTotal": "155.38",
        "timeAvailableFrom": "9/13/22 13:22",
        "lat": 37.7237765,
        "lng": -1.1718824,
        "id_ext": "4160-GEN000-115128"
    },
    {
        "id": "7e7ee90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Subarrendado (gestión)",
        "strategy": "CAMBIO DE USO",
        "askingPriceRent": "1291.50",
        "askingPriceSale": "200900.00",
        "address": "Avenida Euskadi 28 ",
        "postalCode": "48902",
        "city": "1148013",
        "province": "48",
        "CCAA": "53",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "190.20",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "190.20",
        "surfaceTotal": "190.20",
        "timeAvailableFrom": "9/13/22 13:22",
        "lat": 43.2915561,
        "lng": -2.9917371,
        "id_ext": "4160-GEN000-115167"
    },
    {
        "id": "867ee90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Subarrendado (gestión)",
        "strategy": "1",
        "askingPriceRent": "264.60",
        "askingPriceSale": "35280.00",
        "address": "Calle Francesc Layret 59 ",
        "postalCode": "08100",
        "city": "1108124",
        "province": "08",
        "CCAA": "55",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "164.95",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "164.95",
        "surfaceTotal": "164.95",
        "timeAvailableFrom": "9/13/22 13:22",
        "lat": 41.5463345,
        "lng": 2.2038023,
        "id_ext": "4160-GEN000-115295"
    },
    {
        "id": "5a845e94-6233-ed11-9db1-0022489ca4d1",
        "active": true,
        "status": "No comercializable - Alquilado - Subarrendado (gestión)",
        "address": "Calle Marti I Codolar, 39 - 41 ",
        "postalCode": "08902",
        "city": "1108101",
        "province": "08",
        "CCAA": "55",
        "country": "ES",
        "use": "5",
        "surfacebr": "97.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "164.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "193.10",
        "surfaceTotal": "261.00",
        "timeAvailableFrom": "9/13/22 14:50",
        "lat": 41.3681349,
        "lng": 2.1297714,
        "id_ext": "4160-GEN000-120318"
    },
    {
        "id": "a67ce90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "2",
        "askingPriceRent": "2315.25",
        "askingPriceSale": "324135.00",
        "address": "Calle Nuevo 27 ",
        "postalCode": "41530",
        "city": "1141065",
        "province": "41",
        "CCAA": "51",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "353.05",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "353.05",
        "surfaceTotal": "353.05",
        "timeAvailableFrom": "9/13/22 13:21",
        "lat": 37.1205814,
        "lng": -5.4513437,
        "id_ext": "4205-100160-100160"
    },
    {
        "id": "b27ce90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "2",
        "askingPriceRent": "1018.08",
        "askingPriceSale": "152712.00",
        "address": "Calle Juan Alvarado 9 ",
        "postalCode": "24100",
        "city": "1124202",
        "province": "24",
        "CCAA": "59",
        "country": "ES",
        "use": "5",
        "surfacebr": "48.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "227.69",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "242.09",
        "surfaceTotal": "275.69",
        "timeAvailableFrom": "9/13/22 13:21",
        "lat": 42.9390778,
        "lng": -6.3162588,
        "id_ext": "4205-100224-100224"
    },
    {
        "id": "b67ce90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Arrendado (propiedad)",
        "strategy": "2",
        "askingPriceRent": "1052.80",
        "askingPriceSale": "203980.00",
        "address": "Plaza De La Constitucion 10 ",
        "postalCode": "38300",
        "city": "1138026",
        "province": "38",
        "CCAA": "56",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "115.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "115.00",
        "surfaceTotal": "115.00",
        "timeAvailableFrom": "9/13/22 13:21",
        "lat": 28.3900576,
        "lng": -16.5235211,
        "id_ext": "4205-100249-100249"
    },
    {
        "id": "c07ce90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "1",
        "askingPriceRent": "364.00",
        "askingPriceSale": "54600.00",
        "address": " Tostado 1 ",
        "postalCode": "05220",
        "city": "1105114",
        "province": "05",
        "CCAA": "59",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "180.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "180.00",
        "surfaceTotal": "180.00",
        "timeAvailableFrom": "9/13/22 13:21",
        "lat": 41.0893068,
        "lng": -4.9980684,
        "id_ext": "4205-100296-100296"
    },
    {
        "id": "d67ce90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "2",
        "askingPriceRent": "1855.90",
        "askingPriceSale": "222564.80",
        "address": "Avenida Zumalacarregui 6 ",
        "postalCode": "20110",
        "city": "1120064",
        "province": "20",
        "CCAA": "53",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "220.94",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "220.94",
        "surfaceTotal": "220.94",
        "timeAvailableFrom": "9/13/22 13:21",
        "lat": 43.32547030000001,
        "lng": -1.9301396,
        "id_ext": "4205-100461-100461"
    },
    {
        "id": "167de90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "1",
        "askingPriceRent": "1621.20",
        "askingPriceSale": "297220.00",
        "address": "Avenida Juan Carlos I 26 ",
        "postalCode": "03710",
        "city": "1103047",
        "province": "03",
        "CCAA": "42",
        "country": "ES",
        "use": "5",
        "surfacebr": "78.20",
        "surfaceMezzanine": "0.00",
        "surfacepb": "170.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "193.46",
        "surfaceTotal": "248.20",
        "timeAvailableFrom": "9/13/22 13:21",
        "lat": 38.6454651,
        "lng": 0.0728883,
        "id_ext": "4205-100766-100766"
    },
    {
        "id": "1c7de90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Arrendado (propiedad)",
        "strategy": "2",
        "askingPriceRent": "16362.50",
        "askingPriceSale": "4775503.71",
        "address": "Gran Vía De Gracia 75 ",
        "postalCode": "08012",
        "city": "1108019",
        "province": "08",
        "CCAA": "55",
        "country": "ES",
        "use": "11",
        "surfacebr": "494.50",
        "surfaceMezzanine": "0.00",
        "surfacepb": "481.50",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "629.85",
        "surfaceTotal": "976.00",
        "timeAvailableFrom": "9/13/22 13:21",
        "lat": 41.3885334,
        "lng": 2.1691051,
        "id_ext": "4205-100794-100794"
    },
    {
        "id": "347de90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "2",
        "askingPriceRent": "1739.50",
        "askingPriceSale": "232505.00",
        "address": " Mayor 11 ",
        "postalCode": "45100",
        "city": "1145163",
        "province": "45",
        "CCAA": "40",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "203.22",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "294.56",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "350.50",
        "surfaceTotal": "497.78",
        "timeAvailableFrom": "9/13/22 13:21",
        "lat": 39.6764458,
        "lng": -3.9754467,
        "id_ext": "4205-100951-100951"
    },
    {
        "id": "407de90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "1",
        "askingPriceRent": "901.60",
        "askingPriceSale": "123970.00",
        "address": " Caballeros 3 ",
        "postalCode": "42200",
        "city": "1142020",
        "province": "42",
        "CCAA": "59",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "150.21",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "150.21",
        "surfaceTotal": "150.21",
        "timeAvailableFrom": "9/13/22 13:21",
        "lat": 41.5128796,
        "lng": -2.5594214,
        "id_ext": "4205-101005-101005"
    },
    {
        "id": "487de90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "CAMBIO DE USO",
        "askingPriceRent": "4099.20",
        "askingPriceSale": "614880.00",
        "address": "Calle Balmes 386 ",
        "postalCode": "08002",
        "city": "1108019",
        "province": "08",
        "CCAA": "55",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "191.14",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "175.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "278.64",
        "surfaceTotal": "366.14",
        "timeAvailableFrom": "9/13/22 13:22",
        "lat": 41.4050496,
        "lng": 2.139982,
        "id_ext": "4205-101040-101040"
    },
    {
        "id": "4e7de90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "2",
        "askingPriceRent": "1108.80",
        "askingPriceSale": "124740.00",
        "address": "Avenida De Gonzalez Mayo 30 ",
        "postalCode": "33870",
        "city": "1133073",
        "province": "33",
        "CCAA": "31",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "198.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "198.00",
        "surfaceTotal": "198.00",
        "timeAvailableFrom": "9/13/22 13:22",
        "lat": 43.3369192,
        "lng": -6.415847299999999,
        "id_ext": "4205-101062-101062"
    },
    {
        "id": "647de90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "2",
        "askingPriceRent": "900.90",
        "askingPriceSale": "124740.00",
        "address": "Avenida Condomina 19 ",
        "postalCode": "03002",
        "city": "1103014",
        "province": "03",
        "CCAA": "42",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "143.58",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "143.58",
        "surfaceTotal": "143.58",
        "timeAvailableFrom": "9/13/22 13:22",
        "lat": 38.3636728,
        "lng": -0.4441291,
        "id_ext": "4205-101138-101138"
    },
    {
        "id": "6c7de90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "2",
        "askingPriceRent": "1984.50",
        "askingPriceSale": "340200.00",
        "address": " San Juan 62 ",
        "postalCode": "46020",
        "city": "1146205",
        "province": "46",
        "CCAA": "42",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "396.66",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "396.66",
        "surfaceTotal": "396.66",
        "timeAvailableFrom": "9/13/22 13:22",
        "lat": 39.6167085,
        "lng": -0.3024512,
        "id_ext": "4205-101155-101155"
    },
    {
        "id": "6e7de90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "2",
        "askingPriceRent": "1642.55",
        "askingPriceSale": "277970.00",
        "address": " Eugenio Gross 10 ",
        "postalCode": "29016",
        "city": "1129067",
        "province": "29",
        "CCAA": "51",
        "country": "ES",
        "use": "5",
        "surfacebr": "140.00",
        "surfaceMezzanine": "19.43",
        "surfacepb": "135.30",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "19.43",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "140.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "187.02",
        "surfaceTotal": "294.73",
        "timeAvailableFrom": "9/13/22 13:22",
        "lat": 36.7223182,
        "lng": -4.435663,
        "id_ext": "4205-101156-101156"
    },
    {
        "id": "747de90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "1",
        "askingPriceRent": "839.48",
        "askingPriceSale": "129150.00",
        "address": " La Reina 166 ",
        "postalCode": "46002",
        "city": "1146250",
        "province": "46",
        "CCAA": "42",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "158.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "158.00",
        "surfaceTotal": "158.00",
        "timeAvailableFrom": "9/13/22 13:22",
        "lat": 39.4700619,
        "lng": -0.3283401,
        "id_ext": "4205-101166-101166"
    },
    {
        "id": "847de90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "1",
        "askingPriceRent": "1292.59",
        "askingPriceSale": "215432.00",
        "address": " Gerona 25 ",
        "postalCode": "08400",
        "city": "1108096",
        "province": "08",
        "CCAA": "55",
        "country": "ES",
        "use": "5",
        "surfacebr": "100.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "143.88",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "173.88",
        "surfaceTotal": "243.88",
        "timeAvailableFrom": "9/13/22 13:22",
        "lat": 41.61065370000001,
        "lng": 2.2906858,
        "id_ext": "4205-101229-101229"
    },
    {
        "id": "887de90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "1",
        "askingPriceRent": "2847.60",
        "askingPriceSale": "427140.00",
        "address": " Francisco Ruiz 9 ",
        "district": "2807902",
        "postalCode": "28005",
        "city": "1128079",
        "province": "28",
        "CCAA": "54",
        "country": "ES",
        "use": "1",
        "surfacebr": "3209.98",
        "surfaceMezzanine": "0.00",
        "surfacepb": "0.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "962.99",
        "surfaceTotal": "3209.98",
        "timeAvailableFrom": "9/13/22 13:22",
        "lat": 40.3821502,
        "lng": -3.7034895,
        "id_ext": "4205-101570-101570"
    },
    {
        "id": "8a7de90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "address": "Avenida Instituto Obrero Valencia 23 ",
        "postalCode": "46002",
        "city": "1146250",
        "province": "46",
        "CCAA": "42",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "303.76",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "303.76",
        "surfaceTotal": "303.76",
        "timeAvailableFrom": "9/13/22 13:22",
        "lat": 39.4559482,
        "lng": -0.3576652,
        "id_ext": "4205-101625-101625"
    },
    {
        "id": "46845e94-6233-ed11-9db1-0022489ca4d1",
        "active": true,
        "status": "Comercializable",
        "address": "Avenida Instituto Obrero Valencia 23 ",
        "postalCode": "46002",
        "city": "1146250",
        "province": "46",
        "CCAA": "42",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "186.74",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "186.74",
        "surfaceTotal": "186.74",
        "timeAvailableFrom": "9/13/22 14:50",
        "lat": 39.4559482,
        "lng": -0.3576652,
        "id_ext": "4205-101625-101626"
    },
    {
        "id": "48845e94-6233-ed11-9db1-0022489ca4d1",
        "active": true,
        "status": "Comercializable",
        "address": "Avenida Instituto Obrero Valencia 23 ",
        "postalCode": "46002",
        "city": "1146250",
        "province": "46",
        "CCAA": "42",
        "country": "ES",
        "use": "8",
        "surfacebr": "10.80",
        "surfaceMezzanine": "0.00",
        "surfacepb": "0.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "3.24",
        "surfaceTotal": "10.80",
        "timeAvailableFrom": "9/13/22 14:50",
        "lat": 39.4559482,
        "lng": -0.3576652,
        "id_ext": "4205-101625-101630"
    },
    {
        "id": "4a845e94-6233-ed11-9db1-0022489ca4d1",
        "active": true,
        "status": "Comercializable",
        "address": "Avenida Instituto Obrero Valencia 23 ",
        "postalCode": "46002",
        "city": "1146250",
        "province": "46",
        "CCAA": "42",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "186.70",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "186.70",
        "surfaceTotal": "186.70",
        "timeAvailableFrom": "9/13/22 14:50",
        "lat": 39.4559482,
        "lng": -0.3576652,
        "id_ext": "4205-101625-120421"
    },
    {
        "id": "4c845e94-6233-ed11-9db1-0022489ca4d1",
        "active": true,
        "status": "Comercializable",
        "address": "Avenida Instituto Obrero Valencia 23 ",
        "postalCode": "46002",
        "city": "1146250",
        "province": "46",
        "CCAA": "42",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "215.26",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "215.26",
        "surfaceTotal": "215.26",
        "timeAvailableFrom": "9/13/22 14:50",
        "lat": 39.4559482,
        "lng": -0.3576652,
        "id_ext": "4205-101625-120422"
    },
    {
        "id": "4e845e94-6233-ed11-9db1-0022489ca4d1",
        "active": true,
        "status": "Comercializable",
        "address": "Avenida Instituto Obrero Valencia 23 ",
        "postalCode": "46002",
        "city": "1146250",
        "province": "46",
        "CCAA": "42",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "244.27",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "244.27",
        "surfaceTotal": "244.27",
        "timeAvailableFrom": "9/13/22 14:50",
        "lat": 39.4559482,
        "lng": -0.3576652,
        "id_ext": "4205-101625-120423"
    },
    {
        "id": "50845e94-6233-ed11-9db1-0022489ca4d1",
        "active": true,
        "status": "Comercializable",
        "address": "Avenida Instituto Obrero Valencia 23 ",
        "postalCode": "46002",
        "city": "1146250",
        "province": "46",
        "CCAA": "42",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "306.80",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "306.80",
        "surfaceTotal": "306.80",
        "timeAvailableFrom": "9/13/22 14:50",
        "lat": 39.4559482,
        "lng": -0.3576652,
        "id_ext": "4205-101625-120424"
    },
    {
        "id": "52845e94-6233-ed11-9db1-0022489ca4d1",
        "active": true,
        "status": "Comercializable",
        "address": "Avenida Instituto Obrero Valencia 23 ",
        "postalCode": "46002",
        "city": "1146250",
        "province": "46",
        "CCAA": "42",
        "country": "ES",
        "use": "8",
        "surfacebr": "10.35",
        "surfaceMezzanine": "0.00",
        "surfacepb": "0.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "3.10",
        "surfaceTotal": "10.35",
        "timeAvailableFrom": "9/13/22 14:50",
        "lat": 39.4559482,
        "lng": -0.3576652,
        "id_ext": "4205-101625-120425"
    },
    {
        "id": "8c7de90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "1",
        "askingPriceRent": "3255.00",
        "askingPriceSale": "524300.00",
        "address": " Miguel Barcelo 2 ",
        "postalCode": "43730",
        "city": "1143055",
        "province": "43",
        "CCAA": "55",
        "country": "ES",
        "use": "5",
        "surfacebr": "85.44",
        "surfaceMezzanine": "0.00",
        "surfacepb": "463.62",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "128.04",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "553.27",
        "surfaceTotal": "677.10",
        "timeAvailableFrom": "9/13/22 13:22",
        "lat": 41.1448302,
        "lng": 0.8205283999999999,
        "id_ext": "4205-101638-101638"
    },
    {
        "id": "8e7de90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "1",
        "askingPriceRent": "1372.00",
        "askingPriceSale": "205800.00",
        "address": " Real 14Planta. 2 ",
        "postalCode": "14400",
        "city": "1114054",
        "province": "14",
        "CCAA": "51",
        "country": "ES",
        "use": "11",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "0.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "230.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "115.00",
        "surfaceTotal": "230.00",
        "timeAvailableFrom": "9/13/22 13:22",
        "lat": 38.3770629,
        "lng": -4.8494709,
        "id_ext": "4205-101873-101873"
    },
    {
        "id": "c47de90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Arrendado (propiedad)",
        "strategy": "2",
        "askingPriceRent": "913.50",
        "askingPriceSale": "127286.93",
        "address": " Edificio Plaza De La Cruz 6 ",
        "postalCode": "08700",
        "city": "1108102",
        "province": "08",
        "CCAA": "55",
        "country": "ES",
        "use": "11",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "120.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "120.00",
        "surfaceTotal": "120.00",
        "timeAvailableFrom": "9/13/22 13:22",
        "lat": 41.5847817,
        "lng": 1.6226538,
        "id_ext": "4205-111054-111054"
    },
    {
        "id": "e47de90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Arrendado (propiedad)",
        "strategy": "2",
        "askingPriceRent": "3024.00",
        "askingPriceSale": "504000.00",
        "address": "Calle de San Germán, 43 ",
        "district": "2807906",
        "postalCode": "28020",
        "city": "1128079",
        "province": "28",
        "CCAA": "54",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "227.86",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "227.86",
        "surfaceTotal": "227.86",
        "timeAvailableFrom": "9/13/22 13:22",
        "lat": 40.4569756,
        "lng": -3.6995717,
        "id_ext": "4205-111519-111519"
    },
    {
        "id": "e67de90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Arrendado (propiedad)",
        "strategy": "2",
        "askingPriceRent": "1338.28",
        "askingPriceSale": "259896.00",
        "address": " Real 76 ",
        "postalCode": "28700",
        "city": "1128134",
        "province": "28",
        "CCAA": "54",
        "country": "ES",
        "use": "5",
        "surfacebr": "103.50",
        "surfaceMezzanine": "0.00",
        "surfacepb": "155.90",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "186.95",
        "surfaceTotal": "259.40",
        "timeAvailableFrom": "9/13/22 13:22",
        "lat": 40.5481434,
        "lng": -3.6245168,
        "id_ext": "4205-111567-111567"
    },
    {
        "id": "f07de90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "2",
        "address": " Michelena 26 ",
        "postalCode": "36002",
        "city": "1136038",
        "province": "36",
        "CCAA": "60",
        "country": "ES",
        "use": "13",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "0.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "0.00",
        "surfaceTotal": "0.00",
        "timeAvailableFrom": "9/13/22 13:22",
        "lat": 42.431316,
        "lng": -8.6456312,
        "id_ext": "4205-111867-111867"
    },
    {
        "id": "f47de90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "2",
        "askingPriceRent": "1295.00",
        "askingPriceSale": "207200.00",
        "address": " Cerdeña 76-84 ",
        "postalCode": "08830",
        "city": "1108200",
        "province": "08",
        "CCAA": "55",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "185.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "185.00",
        "surfaceTotal": "185.00",
        "timeAvailableFrom": "9/13/22 13:22",
        "lat": 41.3458415,
        "lng": 2.035041,
        "id_ext": "4205-112000-112000"
    },
    {
        "id": "fa7de90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "1",
        "askingPriceRent": "277.20",
        "askingPriceSale": "47124.00",
        "address": " Felix Rguez. De La Fuente 1-3 ",
        "postalCode": "41920",
        "city": "1141086",
        "province": "41",
        "CCAA": "51",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "86.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "86.00",
        "surfaceTotal": "86.00",
        "timeAvailableFrom": "9/13/22 13:22",
        "lat": 37.3592432,
        "lng": -6.0343054,
        "id_ext": "4205-112083-112083"
    },
    {
        "id": "fc7de90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "1",
        "askingPriceRent": "373.68",
        "askingPriceSale": "47880.00",
        "address": "Avenida Castilla Y Leon, 2 ",
        "postalCode": "34200",
        "city": "1134023",
        "province": "34",
        "CCAA": "59",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "65.47",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "65.47",
        "surfaceTotal": "65.47",
        "timeAvailableFrom": "9/13/22 13:22",
        "lat": 41.9182147,
        "lng": -4.498277,
        "id_ext": "4205-112136-112136"
    },
    {
        "id": "087ee90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Arrendado (propiedad)",
        "strategy": "2",
        "askingPriceRent": "6366.50",
        "askingPriceSale": "1154288.66",
        "address": " Lealtad 21 ",
        "postalCode": "39002",
        "city": "1139075",
        "province": "39",
        "CCAA": "30",
        "country": "ES",
        "use": "11",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "262.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "262.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "393.00",
        "surfaceTotal": "524.00",
        "timeAvailableFrom": "9/13/22 13:22",
        "lat": 43.4614062,
        "lng": -3.8084357,
        "id_ext": "4205-112781-112781"
    },
    {
        "id": "187ee90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Arrendado (propiedad)",
        "strategy": "2",
        "address": " Martinez Padin 2 ",
        "postalCode": "36700",
        "city": "1136055",
        "province": "36",
        "CCAA": "60",
        "country": "ES",
        "use": "5",
        "surfacebr": "157.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "157.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "165.65",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "204.10",
        "surfaceTotal": "314.00",
        "timeAvailableFrom": "9/13/22 13:22",
        "lat": 42.0490974,
        "lng": -8.6468457,
        "id_ext": "4205-113107-113107"
    },
    {
        "id": "227ee90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "2",
        "askingPriceRent": "699.72",
        "askingPriceSale": "98784.00",
        "address": "Avenida Chapi 2 ",
        "postalCode": "03600",
        "city": "1103066",
        "province": "03",
        "CCAA": "42",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "140.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "140.00",
        "surfaceTotal": "140.00",
        "timeAvailableFrom": "9/13/22 13:22",
        "lat": 38.476176,
        "lng": -0.7965637,
        "id_ext": "4205-113242-113242"
    },
    {
        "id": "327ee90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "2",
        "askingPriceRent": "1948.80",
        "askingPriceSale": "259840.00",
        "address": "Calle Angli 39 ",
        "postalCode": "08017",
        "city": "1108019",
        "province": "08",
        "CCAA": "55",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "120.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "120.00",
        "surfaceTotal": "120.00",
        "timeAvailableFrom": "9/13/22 13:22",
        "lat": 41.401347,
        "lng": 2.1249814,
        "id_ext": "4205-113384-113384"
    },
    {
        "id": "607ee90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "1",
        "askingPriceRent": "791.00",
        "askingPriceSale": "126560.00",
        "address": "Plaza España 5 ",
        "postalCode": "11130",
        "city": "1111015",
        "province": "11",
        "CCAA": "51",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "290.00",
        "surfaceBasement1": "114.04",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "114.04",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "347.02",
        "surfaceTotal": "404.04",
        "timeAvailableFrom": "9/13/22 13:22",
        "lat": 36.4198135,
        "lng": -6.1452218,
        "id_ext": "4205-113884-113884"
    },
    {
        "id": "3481e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "2",
        "askingPriceRent": "1708.00",
        "askingPriceSale": "257552.89",
        "address": " Huelva S/N ",
        "postalCode": "21004",
        "city": "1121041",
        "province": "21",
        "CCAA": "51",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "99.77",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "99.77",
        "surfaceTotal": "99.77",
        "timeAvailableFrom": "9/13/22 13:24",
        "lat": 37.2619585,
        "lng": -6.9427327,
        "id_ext": "4205-115007-119918"
    },
    {
        "id": "727ee90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "2",
        "askingPriceRent": "2431.80",
        "askingPriceSale": "351260.00",
        "address": "Calle Mendizabal 10 ",
        "postalCode": "35001",
        "city": "1135016",
        "province": "35",
        "CCAA": "56",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "220.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "220.00",
        "surfaceTotal": "220.00",
        "timeAvailableFrom": "9/13/22 13:22",
        "lat": 28.1021578,
        "lng": -15.4136948,
        "id_ext": "4205-115027-115027"
    },
    {
        "id": "7a7ee90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "1",
        "askingPriceRent": "2364.60",
        "askingPriceSale": "315280.00",
        "address": " Fuentemar 43 ",
        "postalCode": "28820",
        "city": "1128049",
        "province": "28",
        "CCAA": "54",
        "country": "ES",
        "use": "6",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "209.76",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "105.10",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "262.31",
        "surfaceTotal": "314.86",
        "timeAvailableFrom": "9/13/22 13:22",
        "lat": 40.4352999,
        "lng": -3.5429247,
        "id_ext": "4205-115122-115122"
    },
    {
        "id": "8a7ee90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "2",
        "askingPriceRent": "1106.00",
        "askingPriceSale": "159264.00",
        "address": " General De Palafox 5 ",
        "postalCode": "08860",
        "city": "1108056",
        "province": "08",
        "CCAA": "55",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "134.75",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "134.75",
        "surfaceTotal": "134.75",
        "timeAvailableFrom": "9/13/22 13:22",
        "lat": 41.286191,
        "lng": 1.981673,
        "id_ext": "4205-115343-115343"
    },
    {
        "id": "8c7ee90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "2",
        "askingPriceSale": "87920.00",
        "address": "Carretera Castilla 107 ",
        "postalCode": "15407",
        "city": "1115054",
        "province": "15",
        "CCAA": "60",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "167.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "167.00",
        "surfaceTotal": "167.00",
        "timeAvailableFrom": "9/13/22 13:22",
        "lat": 43.4979907,
        "lng": -8.1992183,
        "id_ext": "4205-115349-115349"
    },
    {
        "id": "8e7ee90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "1",
        "askingPriceRent": "729.12",
        "askingPriceSale": "97216.00",
        "address": " Carlos Iii ",
        "postalCode": "14120",
        "city": "1114030",
        "province": "14",
        "CCAA": "51",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "173.60",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "173.60",
        "surfaceTotal": "173.60",
        "timeAvailableFrom": "9/13/22 13:22",
        "lat": 37.7055557,
        "lng": -5.1039618,
        "id_ext": "4205-115356-115356"
    },
    {
        "id": "907ee90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Arrendado (propiedad)",
        "strategy": "2",
        "address": "Paseo De Las Delicias 51 ",
        "postalCode": "28045",
        "city": "1128079",
        "province": "28",
        "CCAA": "54",
        "country": "ES",
        "use": "11",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "150.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "150.00",
        "surfaceTotal": "150.00",
        "timeAvailableFrom": "9/13/22 13:22",
        "lat": 40.4025509,
        "lng": -3.693565,
        "id_ext": "4205-116195-116195"
    },
    {
        "id": "927ee90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "2",
        "askingPriceRent": "693.00",
        "askingPriceSale": "101640.00",
        "address": "Plaza De España 2 ",
        "postalCode": "41567",
        "city": "1141050",
        "province": "41",
        "CCAA": "51",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "105.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "105.00",
        "surfaceTotal": "105.00",
        "timeAvailableFrom": "9/13/22 13:22",
        "lat": 37.3652629,
        "lng": -4.8497614,
        "id_ext": "4205-117623-117623"
    },
    {
        "id": "947ee90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "1",
        "askingPriceRent": "2310.00",
        "askingPriceSale": "420000.00",
        "address": "Avenida De La Industria 6 ",
        "postalCode": "28108",
        "city": "1128006",
        "province": "28",
        "CCAA": "54",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "222.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "222.00",
        "surfaceTotal": "222.00",
        "timeAvailableFrom": "9/13/22 13:22",
        "lat": 40.53554200000001,
        "lng": -3.64298,
        "id_ext": "4205-117639-117639"
    },
    {
        "id": "967ee90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Arrendado (propiedad)",
        "strategy": "2",
        "askingPriceRent": "4941.72",
        "askingPriceSale": "1043252.00",
        "address": "Calle Maldonado 31 ",
        "district": "2807905",
        "postalCode": "28006",
        "city": "1128079",
        "province": "28",
        "CCAA": "54",
        "country": "ES",
        "use": "5",
        "surfacebr": "53.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "77.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "53.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "92.90",
        "surfaceTotal": "130.00",
        "timeAvailableFrom": "9/13/22 13:22",
        "lat": 40.4339842,
        "lng": -3.681439,
        "id_ext": "4205-117646-117646"
    },
    {
        "id": "987ee90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "1",
        "askingPriceRent": "1557.71",
        "askingPriceSale": "274890.00",
        "address": " Mar De Aral 9 ",
        "district": "2807916",
        "postalCode": "28033",
        "city": "1128079",
        "province": "28",
        "CCAA": "54",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "237.36",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "237.36",
        "surfaceTotal": "237.36",
        "timeAvailableFrom": "9/13/22 13:22",
        "lat": 40.4745693,
        "lng": -3.6436596,
        "id_ext": "4205-117648-117648"
    },
    {
        "id": "9a7ee90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Arrendado (propiedad)",
        "strategy": "2",
        "askingPriceRent": "2701.44",
        "askingPriceSale": "383061.25",
        "address": "Avenida Marques De Corbera 15 ",
        "postalCode": "28017",
        "city": "1128079",
        "province": "28",
        "CCAA": "54",
        "country": "ES",
        "use": "5",
        "surfacebr": "144.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "144.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "144.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "259.20",
        "surfaceTotal": "432.00",
        "timeAvailableFrom": "9/13/22 13:22",
        "lat": 40.4237422,
        "lng": -3.6549893,
        "id_ext": "4205-117650-117650"
    },
    {
        "id": "9c7ee90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "CAMBIO DE USO",
        "askingPriceRent": "1344.00",
        "askingPriceSale": "201600.00",
        "address": "Calle Moquetas 1 ",
        "district": "2807908",
        "postalCode": "28029",
        "city": "1128079",
        "province": "28",
        "CCAA": "54",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "120.90",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "120.90",
        "surfaceTotal": "120.90",
        "timeAvailableFrom": "9/13/22 13:22",
        "lat": 40.4661605,
        "lng": -3.7009246,
        "id_ext": "4205-117657-117657"
    },
    {
        "id": "9e7ee90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "CAMBIO DE USO",
        "askingPriceRent": "1740.48",
        "askingPriceSale": "323232.00",
        "address": "Calle Mota Del Cuervo 21 ",
        "district": "2807916",
        "postalCode": "28043",
        "city": "1128079",
        "province": "28",
        "CCAA": "54",
        "country": "ES",
        "use": "5",
        "surfacebr": "121.91",
        "surfaceMezzanine": "0.00",
        "surfacepb": "151.91",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "188.48",
        "surfaceTotal": "273.82",
        "timeAvailableFrom": "9/13/22 13:22",
        "lat": 40.4653883,
        "lng": -3.630666199999999,
        "id_ext": "4205-117661-117661"
    },
    {
        "id": "a07ee90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "2",
        "askingPriceRent": "4916.80",
        "askingPriceSale": "737520.00",
        "address": "Avenida Ntra. Sra. Fátima 4 ",
        "district": "2807910",
        "postalCode": "28047",
        "city": "1128079",
        "province": "28",
        "CCAA": "54",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "471.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "471.00",
        "surfaceTotal": "471.00",
        "timeAvailableFrom": "9/13/22 13:22",
        "lat": 40.3867764,
        "lng": -3.7438462,
        "id_ext": "4205-117663-117663"
    },
    {
        "id": "a27ee90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "2",
        "askingPriceRent": "1565.20",
        "askingPriceSale": "267288.00",
        "address": "Calle Nuestra Señora De Valverde, 25 ",
        "district": "2807908",
        "postalCode": "28034",
        "city": "1128079",
        "province": "28",
        "CCAA": "54",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "172.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "172.00",
        "surfaceTotal": "172.00",
        "timeAvailableFrom": "9/13/22 13:22",
        "lat": 40.4931125,
        "lng": -3.6870949,
        "id_ext": "4205-117664-117664"
    },
    {
        "id": "a47ee90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "2",
        "askingPriceRent": "5500.00",
        "askingPriceSale": "1809360.00",
        "address": "Calle Nuñez De Balboa 61 ",
        "district": "2807904",
        "postalCode": "28001",
        "city": "1128079",
        "province": "28",
        "CCAA": "54",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "278.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "50.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "303.00",
        "surfaceTotal": "328.00",
        "timeAvailableFrom": "9/13/22 13:22",
        "lat": 40.428341,
        "lng": -3.682633699999999,
        "id_ext": "4205-117665-117665"
    },
    {
        "id": "a67ee90a-5633-ed11-9db1-0022489c4873",
        "active": false,
        "status": "Vendido",
        "strategy": "1",
        "askingPriceRent": "4054.62",
        "askingPriceSale": "750855.00",
        "address": "Avenida Presidente Carmona 10 ",
        "postalCode": "28020",
        "city": "1128079",
        "province": "28",
        "CCAA": "54",
        "country": "ES",
        "use": "5",
        "surfacebr": "104.12",
        "surfaceMezzanine": "0.00",
        "surfacepb": "204.12",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "104.12",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "235.36",
        "surfaceTotal": "308.24",
        "timeAvailableFrom": "9/13/22 13:22",
        "lat": 40.4544248,
        "lng": -3.6968133,
        "id_ext": "4205-117671-117671"
    },
    {
        "id": "a87ee90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "CAMBIO DE USO",
        "askingPriceRent": "4048.80",
        "askingPriceSale": "769272.00",
        "address": "Calle Puenteareas 17 ",
        "district": "2807905",
        "postalCode": "28002",
        "city": "1128079",
        "province": "28",
        "CCAA": "54",
        "country": "ES",
        "use": "5",
        "smokeStractor": false,
        "surfacebr": "235.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "263.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "333.50",
        "surfaceTotal": "498.00",
        "timeAvailableFrom": "9/13/22 13:22",
        "lat": 40.4442149,
        "lng": -3.6692264,
        "id_ext": "4205-117675-117675"
    },
    {
        "id": "aa7ee90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "CAMBIO DE USO",
        "askingPriceRent": "1456.02",
        "askingPriceSale": "216264.36",
        "address": "Avenida Real De Pinto 13 ",
        "district": "2807917",
        "postalCode": "28021",
        "city": "1128079",
        "province": "28",
        "CCAA": "54",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "141.45",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "141.45",
        "surfaceTotal": "141.45",
        "timeAvailableFrom": "9/13/22 13:22",
        "lat": 40.34802699999999,
        "lng": -3.7061509,
        "id_ext": "4205-117679-117679"
    },
    {
        "id": "ac7ee90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "2",
        "askingPriceRent": "2926.00",
        "askingPriceSale": "523600.00",
        "address": "Calle Sanchez Barcaiztegui 4 ",
        "district": "2807903",
        "postalCode": "28007",
        "city": "1128079",
        "province": "28",
        "CCAA": "54",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "218.28",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "218.28",
        "surfaceTotal": "218.28",
        "timeAvailableFrom": "9/13/22 13:22",
        "lat": 40.4025197,
        "lng": -3.6756938,
        "id_ext": "4205-117691-117691"
    },
    {
        "id": "ae7ee90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "2",
        "askingPriceRent": "1512.00",
        "askingPriceSale": "196560.00",
        "address": "Calle Sierra Contraviesa 28 ",
        "district": "2807913",
        "postalCode": "28053",
        "city": "1128079",
        "province": "28",
        "CCAA": "54",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "203.75",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "203.75",
        "surfaceTotal": "203.75",
        "timeAvailableFrom": "9/13/22 13:22",
        "lat": 40.3834032,
        "lng": -3.6714547,
        "id_ext": "4205-117702-117702"
    },
    {
        "id": "b07ee90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Arrendado (propiedad)",
        "strategy": "2",
        "askingPriceRent": "2734.20",
        "askingPriceSale": "468720.00",
        "address": "Calle Sierra Vieja 72 ",
        "district": "2807918",
        "postalCode": "28031",
        "city": "1128079",
        "province": "28",
        "CCAA": "54",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "279.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "279.00",
        "surfaceTotal": "279.00",
        "timeAvailableFrom": "9/13/22 13:22",
        "lat": 40.3789958,
        "lng": -3.6227853,
        "id_ext": "4205-117703-117703"
    },
    {
        "id": "b27ee90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "2",
        "askingPriceRent": "2771.19",
        "askingPriceSale": "320874.40",
        "address": "Calle Valdecanillas 35 ",
        "district": "2807915",
        "postalCode": "28037",
        "city": "1128079",
        "province": "28",
        "CCAA": "54",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "208.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "208.00",
        "surfaceTotal": "208.00",
        "timeAvailableFrom": "9/13/22 13:22",
        "lat": 40.4318702,
        "lng": -3.6273327,
        "id_ext": "4205-117709-117709"
    },
    {
        "id": "b47ee90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "2",
        "askingPriceRent": "3640.00",
        "askingPriceSale": "746200.00",
        "address": "Calle Doctor Esquerdo 6 ",
        "district": "2807904",
        "postalCode": "28028",
        "city": "1128079",
        "province": "28",
        "CCAA": "54",
        "country": "ES",
        "use": "5",
        "surfacebr": "111.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "63.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "96.30",
        "surfaceTotal": "174.00",
        "timeAvailableFrom": "9/13/22 13:22",
        "lat": 40.4266101,
        "lng": -3.668793899999999,
        "id_ext": "4205-117715-117715"
    },
    {
        "id": "b67ee90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "2",
        "askingPriceRent": "1115.10",
        "askingPriceSale": "123900.00",
        "address": "Calle Jaime Janer 24 ",
        "postalCode": "36900",
        "city": "1136026",
        "province": "36",
        "CCAA": "60",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "171.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "171.00",
        "surfaceTotal": "171.00",
        "timeAvailableFrom": "9/13/22 13:22",
        "lat": 42.39052,
        "lng": -8.702259999999999,
        "id_ext": "4205-117725-117725"
    },
    {
        "id": "b87ee90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Arrendado (propiedad)",
        "strategy": "2",
        "askingPriceRent": "966.00",
        "askingPriceSale": "115920.00",
        "address": "Avenida Pablo Iglesias 2 ",
        "postalCode": "47800",
        "city": "1147086",
        "province": "47",
        "CCAA": "59",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "263.67",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "263.67",
        "surfaceTotal": "263.67",
        "timeAvailableFrom": "9/13/22 13:22",
        "lat": 41.8831643,
        "lng": -5.0440737,
        "id_ext": "4205-117737-117737"
    },
    {
        "id": "ba7ee90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "2",
        "askingPriceRent": "1300.89",
        "askingPriceSale": "216814.50",
        "address": "Paseo Del Terraple 25 ",
        "postalCode": "08750",
        "city": "1108123",
        "province": "08",
        "CCAA": "55",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "163.86",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "163.86",
        "surfaceTotal": "163.86",
        "timeAvailableFrom": "9/13/22 13:22",
        "lat": 41.41068,
        "lng": 2.01623,
        "id_ext": "4205-117741-117741"
    },
    {
        "id": "bc7ee90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "1",
        "askingPriceRent": "346.88",
        "askingPriceSale": "46375.00",
        "address": "Plaza De España 6 ",
        "postalCode": "09100",
        "city": "1109211",
        "province": "09",
        "CCAA": "59",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "186.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "186.00",
        "surfaceTotal": "186.00",
        "timeAvailableFrom": "9/13/22 13:22",
        "lat": 42.4026689,
        "lng": -4.2448712,
        "id_ext": "4205-117747-117747"
    },
    {
        "id": "be7ee90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Arrendado (propiedad)",
        "strategy": "2",
        "askingPriceRent": "1390.98",
        "askingPriceSale": "199953.95",
        "address": "Avenida De Galicia 34 ",
        "postalCode": "27400",
        "city": "1127031",
        "province": "27",
        "CCAA": "60",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "55.17",
        "surfacepb": "220.80",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "55.17",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "248.39",
        "surfaceTotal": "275.97",
        "timeAvailableFrom": "9/13/22 13:22",
        "lat": 42.5206954,
        "lng": -7.515005599999999,
        "id_ext": "4205-117754-117754"
    },
    {
        "id": "c07ee90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "2",
        "askingPriceRent": "4038.30",
        "askingPriceSale": "477855.00",
        "address": "Calle Carrera 17 ",
        "postalCode": "23600",
        "city": "1123060",
        "province": "23",
        "CCAA": "51",
        "country": "ES",
        "use": "5",
        "surfacebr": "419.83",
        "surfaceMezzanine": "0.00",
        "surfacepb": "177.98",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "153.17",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "380.51",
        "surfaceTotal": "750.98",
        "timeAvailableFrom": "9/13/22 13:22",
        "lat": 37.7213433,
        "lng": -3.969569,
        "id_ext": "4205-117755-117755"
    },
    {
        "id": "c27ee90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "1",
        "askingPriceRent": "595.00",
        "askingPriceSale": "89250.00",
        "address": "Calle Gregorio Solabarrieta 1 ",
        "postalCode": "09200",
        "city": "1109219",
        "province": "09",
        "CCAA": "59",
        "country": "ES",
        "use": "5",
        "surfacebr": "277.50",
        "surfaceMezzanine": "0.00",
        "surfacepb": "247.40",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "330.65",
        "surfaceTotal": "524.90",
        "timeAvailableFrom": "9/13/22 13:22",
        "lat": 42.6848641,
        "lng": -2.9490826,
        "id_ext": "4205-117768-117768"
    },
    {
        "id": "c47ee90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "2",
        "askingPriceRent": "1254.40",
        "askingPriceSale": "211680.00",
        "address": "Calle Floridablanca 3 ",
        "postalCode": "30002",
        "city": "1130030",
        "province": "30",
        "CCAA": "43",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "280.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "280.00",
        "surfaceTotal": "280.00",
        "timeAvailableFrom": "9/13/22 13:22",
        "lat": 37.9786313,
        "lng": -1.1307672,
        "id_ext": "4205-117775-117775"
    },
    {
        "id": "c67ee90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "1",
        "askingPriceRent": "1204.00",
        "askingPriceSale": "192640.00",
        "address": "Calle Ronda De Levante 49 ",
        "postalCode": "30008",
        "city": "1130030",
        "province": "30",
        "CCAA": "43",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "171.60",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "171.60",
        "surfaceTotal": "171.60",
        "timeAvailableFrom": "9/13/22 13:22",
        "lat": 37.99113090000001,
        "lng": -1.1213992,
        "id_ext": "4205-117779-117779"
    },
    {
        "id": "c87ee90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "2",
        "askingPriceRent": "814.80",
        "askingPriceSale": "135800.00",
        "address": "Plaza Bages 15 ",
        "postalCode": "08242",
        "city": "1108113",
        "province": "08",
        "CCAA": "55",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "205.33",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "114.66",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "262.66",
        "surfaceTotal": "319.99",
        "timeAvailableFrom": "9/13/22 13:22",
        "lat": 41.7345455,
        "lng": 1.823816,
        "id_ext": "4205-117796-117796"
    },
    {
        "id": "ca7ee90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "2",
        "askingPriceRent": "1322.72",
        "askingPriceSale": "198408.00",
        "address": "Paseo Pere lii 6 ",
        "postalCode": "08240",
        "city": "1108113",
        "province": "08",
        "CCAA": "55",
        "country": "ES",
        "use": "5",
        "surfacebr": "102.80",
        "surfaceMezzanine": "0.00",
        "surfacepb": "360.32",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "118.10",
        "surfacesr": "118.10",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "450.21",
        "surfaceTotal": "581.22",
        "timeAvailableFrom": "9/13/22 13:22",
        "lat": 41.7258175,
        "lng": 1.8238172,
        "id_ext": "4205-117798-117798"
    },
    {
        "id": "cc7ee90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "2",
        "askingPriceRent": "730.80",
        "askingPriceSale": "103530.00",
        "address": "Calle Glorieta 5 ",
        "postalCode": "04638",
        "city": "1104064",
        "province": "04",
        "CCAA": "51",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "87.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "87.00",
        "surfaceTotal": "87.00",
        "timeAvailableFrom": "9/13/22 13:22",
        "lat": 37.1406407,
        "lng": -1.8515094,
        "id_ext": "4205-117801-117801"
    },
    {
        "id": "ce7ee90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "2",
        "askingPriceSale": "157164.00",
        "address": "Plaza De La Constitucion 1 ",
        "postalCode": "30500",
        "city": "1130027",
        "province": "30",
        "CCAA": "43",
        "country": "ES",
        "use": "5",
        "surfacebr": "151.89",
        "surfaceMezzanine": "0.00",
        "surfacepb": "169.63",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "215.20",
        "surfaceTotal": "321.52",
        "timeAvailableFrom": "9/13/22 13:22",
        "lat": 38.0507565,
        "lng": -1.2105534,
        "id_ext": "4205-117802-117802"
    },
    {
        "id": "d07ee90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "2",
        "askingPriceRent": "1293.60",
        "askingPriceSale": "176960.00",
        "address": "Avenida Torres Murciano 10 ",
        "postalCode": "29600",
        "city": "1129069",
        "province": "29",
        "CCAA": "51",
        "country": "ES",
        "use": "5",
        "surfacebr": "39.35",
        "surfaceMezzanine": "0.00",
        "surfacepb": "65.60",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "77.41",
        "surfaceTotal": "104.95",
        "timeAvailableFrom": "9/13/22 13:22",
        "lat": 36.5124205,
        "lng": -4.875605699999999,
        "id_ext": "4205-117819-117819"
    },
    {
        "id": "d27ee90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "1",
        "askingPriceRent": "347.20",
        "askingPriceSale": "52080.00",
        "address": "Calle Maria Fortuny 1 ",
        "postalCode": "08110",
        "city": "1108125",
        "province": "08",
        "CCAA": "55",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "56.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "56.00",
        "surfaceTotal": "56.00",
        "timeAvailableFrom": "9/13/22 13:22",
        "lat": 41.4969362,
        "lng": 2.1813595,
        "id_ext": "4205-117827-117827"
    },
    {
        "id": "d47ee90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Arrendado (propiedad)",
        "strategy": "1",
        "askingPriceRent": "875.14",
        "askingPriceSale": "139650.00",
        "address": "Calle Santos Justo Y Pastor 3 ",
        "postalCode": "46940",
        "city": "1146159",
        "province": "46",
        "CCAA": "42",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "70.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "60.10",
        "surfacesr": "60.10",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "100.05",
        "surfaceTotal": "130.10",
        "timeAvailableFrom": "9/13/22 13:22",
        "lat": 39.4934052,
        "lng": -0.4663584,
        "id_ext": "4205-117844-117844"
    },
    {
        "id": "d67ee90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "1",
        "askingPriceRent": "1645.00",
        "askingPriceSale": "298060.00",
        "address": "Calle Riber 38 ",
        "postalCode": "43400",
        "city": "1143086",
        "province": "43",
        "CCAA": "55",
        "country": "ES",
        "use": "5",
        "surfacebr": "16.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "96.38",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "91.38",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "146.87",
        "surfaceTotal": "203.76",
        "timeAvailableFrom": "9/13/22 13:22",
        "lat": 41.3764917,
        "lng": 1.163502,
        "id_ext": "4205-117846-117846"
    },
    {
        "id": "d87ee90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "2",
        "askingPriceRent": "1675.80",
        "askingPriceSale": "299880.00",
        "address": "Paseo Ramon Berenguer 133 ",
        "postalCode": "08303",
        "city": "1108121",
        "province": "08",
        "CCAA": "55",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "220.24",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "220.24",
        "surfaceTotal": "220.24",
        "timeAvailableFrom": "9/13/22 13:22",
        "lat": 41.5385786,
        "lng": 2.4264686,
        "id_ext": "4205-117859-117859"
    },
    {
        "id": "da7ee90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "2",
        "askingPriceRent": "882.00",
        "askingPriceSale": "126000.00",
        "address": "Calle La Corredera 40 ",
        "postalCode": "14550",
        "city": "1114042",
        "province": "14",
        "CCAA": "51",
        "country": "ES",
        "use": "5",
        "surfacebr": "206.86",
        "surfaceMezzanine": "0.00",
        "surfacepb": "283.50",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "345.56",
        "surfaceTotal": "490.36",
        "timeAvailableFrom": "9/13/22 13:22",
        "lat": 37.5885372,
        "lng": -4.6387797,
        "id_ext": "4205-117869-117869"
    },
    {
        "id": "dc7ee90a-5633-ed11-9db1-0022489c4873",
        "active": false,
        "status": "Vendido",
        "strategy": "2",
        "askingPriceRent": "1453.20",
        "askingPriceSale": "169540.00",
        "address": "Calle Juan Ramon Jimenez 6 ",
        "postalCode": "21800",
        "city": "1121050",
        "province": "21",
        "CCAA": "51",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "304.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "304.00",
        "surfaceTotal": "304.00",
        "timeAvailableFrom": "9/13/22 13:22",
        "lat": 37.2761106,
        "lng": -6.837214599999999,
        "id_ext": "4205-117872-117872"
    },
    {
        "id": "de7ee90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "address": "Plaza Alta 12 ",
        "postalCode": "11201",
        "city": "1111004",
        "province": "11",
        "CCAA": "51",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "40.00",
        "surfacepb": "267.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "40.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "287.00",
        "surfaceTotal": "307.00",
        "timeAvailableFrom": "9/13/22 13:22",
        "lat": 36.1307875,
        "lng": -5.447254,
        "id_ext": "4205-117873-117873"
    },
    {
        "id": "e07ee90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "2",
        "askingPriceRent": "705.60",
        "askingPriceSale": "90720.00",
        "address": "Calle Real 5 ",
        "postalCode": "28410",
        "city": "1128082",
        "province": "28",
        "CCAA": "54",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "72.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "72.00",
        "surfaceTotal": "72.00",
        "timeAvailableFrom": "9/13/22 13:22",
        "lat": 40.725942,
        "lng": -3.8667664,
        "id_ext": "4205-117874-117874"
    },
    {
        "id": "e27ee90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "1",
        "askingPriceRent": "929.60",
        "askingPriceSale": "139440.00",
        "address": "Calle Regueral 2 ",
        "postalCode": "33710",
        "city": "1133041",
        "province": "33",
        "CCAA": "31",
        "country": "ES",
        "use": "5",
        "surfacebr": "140.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "143.67",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "185.67",
        "surfaceTotal": "283.67",
        "timeAvailableFrom": "9/13/22 13:22",
        "lat": 43.5387957,
        "lng": -6.724752,
        "id_ext": "4205-117878-117878"
    },
    {
        "id": "e47ee90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "2",
        "askingPriceRent": "1782.90",
        "askingPriceSale": "277340.00",
        "address": "Calle Via Canetum 6 ",
        "postalCode": "08360",
        "city": "1108040",
        "province": "08",
        "CCAA": "55",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "257.46",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "257.46",
        "surfaceTotal": "257.46",
        "timeAvailableFrom": "9/13/22 13:22",
        "lat": 41.5918998,
        "lng": 2.5726277,
        "id_ext": "4205-117882-117882"
    },
    {
        "id": "54845e94-6233-ed11-9db1-0022489ca4d1",
        "active": true,
        "status": "No comercializable - Alquilado - Arrendado (propiedad)",
        "address": "Plaza Alta 12 ",
        "postalCode": "11201",
        "city": "1111004",
        "province": "11",
        "CCAA": "51",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "0.00",
        "surfaceBasement1": "270.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "270.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "135.00",
        "surfaceTotal": "270.00",
        "timeAvailableFrom": "9/13/22 14:50",
        "lat": 36.1307875,
        "lng": -5.447254,
        "id_ext": "4205-117884-117884"
    },
    {
        "id": "e67ee90a-5633-ed11-9db1-0022489c4873",
        "active": false,
        "status": "Vendido",
        "strategy": "2",
        "address": "Calle El Parque 4 ",
        "postalCode": "04100",
        "city": "1104066",
        "province": "04",
        "CCAA": "51",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "137.35",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "137.35",
        "surfaceTotal": "137.35",
        "timeAvailableFrom": "9/13/22 13:22",
        "lat": 36.9659458,
        "lng": -2.2074125,
        "id_ext": "4205-117887-117887"
    },
    {
        "id": "e87ee90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Arrendado (propiedad)",
        "strategy": "2",
        "address": "Avenida España 4 ",
        "postalCode": "11205",
        "city": "1111004",
        "province": "11",
        "CCAA": "51",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "112.88",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "112.88",
        "surfaceTotal": "112.88",
        "timeAvailableFrom": "9/13/22 13:22",
        "lat": 36.1475235,
        "lng": -5.451941,
        "id_ext": "4205-117895-117895"
    },
    {
        "id": "ec7ee90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Arrendado (propiedad)",
        "strategy": "2",
        "askingPriceRent": "1167.60",
        "askingPriceSale": "175140.00",
        "address": "Glorieta Amadora s/n ",
        "postalCode": "14011",
        "city": "1114021",
        "province": "14",
        "CCAA": "51",
        "country": "ES",
        "use": "5",
        "surfacebr": "141.05",
        "surfaceMezzanine": "0.00",
        "surfacepb": "124.62",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "141.05",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "166.94",
        "surfaceTotal": "265.67",
        "timeAvailableFrom": "9/13/22 13:22",
        "lat": 37.8933066,
        "lng": -4.7989804,
        "id_ext": "4205-117921-117921"
    },
    {
        "id": "ee7ee90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "2",
        "askingPriceRent": "1503.60",
        "askingPriceSale": "200480.00",
        "address": "Camino De Los Sastres 3-5 ",
        "postalCode": "14004",
        "city": "1114021",
        "province": "14",
        "CCAA": "51",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "179.56",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "179.56",
        "surfaceTotal": "179.56",
        "timeAvailableFrom": "9/13/22 13:22",
        "lat": 37.8813255,
        "lng": -4.7896867,
        "id_ext": "4205-117922-117922"
    },
    {
        "id": "f07ee90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "2",
        "askingPriceRent": "1251.60",
        "askingPriceSale": "166880.00",
        "address": "Avenida Conde Vallellano 17 ",
        "postalCode": "14004",
        "city": "1114021",
        "province": "14",
        "CCAA": "51",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "149.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "149.00",
        "surfaceTotal": "149.00",
        "timeAvailableFrom": "9/13/22 13:22",
        "lat": 37.87645759999999,
        "lng": -4.7852198,
        "id_ext": "4205-117927-117927"
    },
    {
        "id": "f27ee90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "2",
        "askingPriceRent": "1251.48",
        "askingPriceSale": "183260.00",
        "address": "Avenida Cruz Juarez 10 ",
        "postalCode": "14006",
        "city": "1114021",
        "province": "14",
        "CCAA": "51",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "187.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "187.00",
        "surfaceTotal": "187.00",
        "timeAvailableFrom": "9/13/22 13:22",
        "lat": 37.8936537,
        "lng": -4.7805314,
        "id_ext": "4205-117930-117930"
    },
    {
        "id": "f47ee90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "2",
        "askingPriceSale": "135240.00",
        "address": "Calle Cuesta De La Polvora 2 ",
        "postalCode": "14010",
        "city": "1114021",
        "province": "14",
        "CCAA": "51",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "160.93",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "160.93",
        "surfaceTotal": "160.93",
        "timeAvailableFrom": "9/13/22 13:22",
        "lat": 37.8804062,
        "lng": -4.7668327,
        "id_ext": "4205-117931-117931"
    },
    {
        "id": "f67ee90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "2",
        "askingPriceRent": "886.90",
        "askingPriceSale": "126700.00",
        "address": "Avenida D'Alacant 21 ",
        "postalCode": "03760",
        "city": "1103095",
        "province": "03",
        "CCAA": "42",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "185.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "185.00",
        "surfaceTotal": "185.00",
        "timeAvailableFrom": "9/13/22 13:22",
        "lat": 38.8251161,
        "lng": 0.0194117,
        "id_ext": "4205-117936-117936"
    },
    {
        "id": "f87ee90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - En legal",
        "strategy": "2",
        "askingPriceRent": "1358.00",
        "askingPriceSale": "190120.00",
        "address": "Calle Rua Agro Do Medio 6 ",
        "postalCode": "15895",
        "city": "1115411",
        "province": "15",
        "CCAA": "60",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "177.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "177.00",
        "surfaceTotal": "177.00",
        "timeAvailableFrom": "9/13/22 13:22",
        "lat": 42.8442,
        "lng": -8.5778106,
        "id_ext": "4205-117938-117938"
    },
    {
        "id": "fa7ee90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "2",
        "askingPriceSale": "40740.00",
        "address": "Avenida Alfonso Molina 63 ",
        "postalCode": "15186",
        "city": "1115077",
        "province": "15",
        "CCAA": "60",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "140.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "140.00",
        "surfaceTotal": "140.00",
        "timeAvailableFrom": "9/13/22 13:22",
        "lat": 43.0338493,
        "lng": -8.8095116,
        "id_ext": "4205-117944-117944"
    },
    {
        "id": "fc7ee90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "2",
        "askingPriceRent": "1413.72",
        "askingPriceSale": "240856.00",
        "address": "Calle Cervantes 17 ",
        "postalCode": "33004",
        "city": "1133044",
        "province": "33",
        "CCAA": "31",
        "country": "ES",
        "use": "5",
        "surfacebr": "72.40",
        "surfaceMezzanine": "0.00",
        "surfacepb": "127.83",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "149.55",
        "surfaceTotal": "200.23",
        "timeAvailableFrom": "9/13/22 13:22",
        "lat": 43.3629612,
        "lng": -5.8563627,
        "id_ext": "4205-117965-117965"
    },
    {
        "id": "fe7ee90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "2",
        "askingPriceSale": "220500.00",
        "address": "Calle Fray Ceferino 40 ",
        "postalCode": "33011",
        "city": "1133044",
        "province": "33",
        "CCAA": "31",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "154.25",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "154.25",
        "surfaceTotal": "154.25",
        "timeAvailableFrom": "9/13/22 13:22",
        "lat": 43.3685299,
        "lng": -5.8488605,
        "id_ext": "4205-117966-117966"
    },
    {
        "id": "027fe90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "2",
        "askingPriceRent": "560.00",
        "askingPriceSale": "98000.00",
        "address": "Avenida Aureliano San Roman 41 ",
        "postalCode": "33011",
        "city": "1133044",
        "province": "33",
        "CCAA": "31",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "80.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "80.00",
        "surfaceTotal": "80.00",
        "timeAvailableFrom": "9/13/22 13:22",
        "lat": 43.3707845,
        "lng": -5.838556899999999,
        "id_ext": "4205-117970-117970"
    },
    {
        "id": "047fe90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "2",
        "askingPriceSale": "63168.00",
        "address": "Avenida De Navarra 31 ",
        "postalCode": "01320",
        "city": "1101043",
        "province": "01",
        "CCAA": "53",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "94.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "94.00",
        "surfaceTotal": "94.00",
        "timeAvailableFrom": "9/13/22 13:22",
        "lat": 42.504711,
        "lng": -2.4355867,
        "id_ext": "4205-117976-117976"
    },
    {
        "id": "067fe90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - En legal",
        "strategy": "2",
        "askingPriceRent": "6439.16",
        "askingPriceSale": "792512.00",
        "address": "Avenida Antonio Machado 29 ",
        "postalCode": "29630",
        "city": "1129631",
        "province": "29",
        "CCAA": "51",
        "country": "ES",
        "use": "5",
        "surfacebr": "428.40",
        "surfaceMezzanine": "0.00",
        "surfacepb": "407.59",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "428.40",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "536.11",
        "surfaceTotal": "835.99",
        "timeAvailableFrom": "9/13/22 13:22",
        "lat": 36.5966157,
        "lng": -4.5186568,
        "id_ext": "4205-117984-117984"
    },
    {
        "id": "087fe90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Arrendado (propiedad)",
        "strategy": "1",
        "askingPriceRent": "980.98",
        "askingPriceSale": "146510.00",
        "address": "Avenida Federico Garcia Lorca 37 ",
        "postalCode": "29630",
        "city": "1129631",
        "province": "29",
        "CCAA": "51",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "91.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "91.00",
        "surfaceTotal": "91.00",
        "timeAvailableFrom": "9/13/22 13:22",
        "lat": 36.5992694,
        "lng": -4.5317973,
        "id_ext": "4205-118006-118006"
    },
    {
        "id": "0a7fe90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Arrendado (propiedad)",
        "strategy": "2",
        "askingPriceRent": "3234.00",
        "askingPriceSale": "602564.01",
        "address": " Cataluña 200 ",
        "postalCode": "08184",
        "city": "1108156",
        "province": "08",
        "CCAA": "55",
        "country": "ES",
        "use": "11",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "308.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "308.00",
        "surfaceTotal": "308.00",
        "timeAvailableFrom": "9/13/22 13:22",
        "lat": 41.5855883,
        "lng": 2.1803999,
        "id_ext": "4205-118008-118008"
    },
    {
        "id": "0c7fe90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "2",
        "askingPriceRent": "5313.00",
        "askingPriceSale": "1030400.00",
        "address": "Avenida Gabriel Alomar I Villalonga, 6 ",
        "postalCode": "07002",
        "city": "1107040",
        "province": "07",
        "CCAA": "44",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "456.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "456.00",
        "surfaceTotal": "456.00",
        "timeAvailableFrom": "9/13/22 13:22",
        "lat": 39.5708556,
        "lng": 2.6566375,
        "id_ext": "4205-118021-118021"
    },
    {
        "id": "0e7fe90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "2",
        "askingPriceRent": "3731.42",
        "askingPriceSale": "576674.00",
        "address": "Avenida De Bayona 37 ",
        "postalCode": "31011",
        "city": "1131201",
        "province": "31",
        "CCAA": "11",
        "country": "ES",
        "use": "5",
        "surfacebr": "119.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "227.65",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "263.35",
        "surfaceTotal": "346.65",
        "timeAvailableFrom": "9/13/22 13:22",
        "lat": 42.8131303,
        "lng": -1.6607284,
        "id_ext": "4205-118032-118032"
    },
    {
        "id": "107fe90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "2",
        "askingPriceRent": "1729.50",
        "askingPriceSale": "281044.40",
        "address": "Calle Felipe Gorriti 31 ",
        "postalCode": "31004",
        "city": "1131201",
        "province": "31",
        "CCAA": "11",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "155.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "155.00",
        "surfaceTotal": "155.00",
        "timeAvailableFrom": "9/13/22 13:22",
        "lat": 42.8118339,
        "lng": -1.6361076,
        "id_ext": "4205-118034-118034"
    },
    {
        "id": "127fe90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "2",
        "askingPriceRent": "793.80",
        "askingPriceSale": "90720.00",
        "address": "Calle Capitan Rojas 34 ",
        "postalCode": "47300",
        "city": "1147114",
        "province": "47",
        "CCAA": "59",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "187.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "187.00",
        "surfaceTotal": "187.00",
        "timeAvailableFrom": "9/13/22 13:22",
        "lat": 41.5975749,
        "lng": -4.1193523,
        "id_ext": "4205-118036-118036"
    },
    {
        "id": "147fe90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "1",
        "askingPriceRent": "716.80",
        "askingPriceSale": "100800.00",
        "address": "Calle Larrinaga 1 ",
        "postalCode": "01470",
        "city": "1101002",
        "province": "01",
        "CCAA": "53",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "175.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "175.00",
        "surfaceTotal": "175.00",
        "timeAvailableFrom": "9/13/22 13:22",
        "lat": 43.0522466,
        "lng": -3.0015693,
        "id_ext": "4205-118039-118039"
    },
    {
        "id": "167fe90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "2",
        "askingPriceRent": "602.70",
        "askingPriceSale": "86100.00",
        "address": "Avenida De La Martina 30 ",
        "postalCode": "24400",
        "city": "1124115",
        "province": "24",
        "CCAA": "59",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "167.69",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "167.69",
        "surfaceTotal": "167.69",
        "timeAvailableFrom": "9/13/22 13:22",
        "lat": 42.5463663,
        "lng": -6.6167834,
        "id_ext": "4205-118041-118041"
    },
    {
        "id": "187fe90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Comité",
        "strategy": "1",
        "askingPriceRent": "972.16",
        "askingPriceSale": "138880.00",
        "address": "Avenida Galicia 82 ",
        "postalCode": "24400",
        "city": "1124115",
        "province": "24",
        "CCAA": "59",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "129.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "129.00",
        "surfaceTotal": "129.00",
        "timeAvailableFrom": "9/13/22 13:22",
        "lat": 42.5606612,
        "lng": -6.625151199999999,
        "id_ext": "4205-118043-118043"
    },
    {
        "id": "1a7fe90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "2",
        "askingPriceSale": "234155.25",
        "address": "Calle Estrella Antares 7 ",
        "postalCode": "28983",
        "city": "1128106",
        "province": "28",
        "CCAA": "54",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "221.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "221.00",
        "surfaceTotal": "221.00",
        "timeAvailableFrom": "9/13/22 13:22",
        "lat": 40.2288421,
        "lng": -3.755848799999999,
        "id_ext": "4205-118049-118049"
    },
    {
        "id": "1c7fe90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "2",
        "askingPriceRent": "1329.16",
        "askingPriceSale": "249217.50",
        "address": "Calle Juan Tadeo Cabrera 8 ",
        "postalCode": "35600",
        "city": "1135017",
        "province": "35",
        "CCAA": "56",
        "country": "ES",
        "use": "5",
        "surfacebr": "80.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "157.35",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "181.35",
        "surfaceTotal": "237.35",
        "timeAvailableFrom": "9/13/22 13:23",
        "lat": 28.4975105,
        "lng": -13.8612883,
        "id_ext": "4205-118053-118053"
    },
    {
        "id": "1e7fe90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Arrendado (propiedad)",
        "strategy": "2",
        "askingPriceRent": "1281.50",
        "askingPriceSale": "212249.10",
        "address": "Calle Talavera 26 ",
        "postalCode": "10600",
        "city": "1110148",
        "province": "10",
        "CCAA": "41",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "286.05",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "486.07",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "529.09",
        "surfaceTotal": "772.12",
        "timeAvailableFrom": "9/13/22 13:23",
        "lat": 40.0291598,
        "lng": -6.0894211,
        "id_ext": "4205-118056-118056"
    },
    {
        "id": "207fe90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "2",
        "address": "Calle Oceano S/N ",
        "postalCode": "11500",
        "city": "1111027",
        "province": "11",
        "CCAA": "51",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "161.40",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "161.40",
        "surfaceTotal": "161.40",
        "timeAvailableFrom": "9/13/22 13:23",
        "lat": 36.6110022,
        "lng": -6.2085841,
        "id_ext": "4205-118059-118059"
    },
    {
        "id": "227fe90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Arrendado (propiedad)",
        "strategy": "1",
        "askingPriceRent": "976.50",
        "askingPriceSale": "151900.00",
        "address": "Calle Font Del Gerro 65 ",
        "postalCode": "46980",
        "city": "1146190",
        "province": "46",
        "CCAA": "42",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "150.88",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "150.88",
        "surfaceTotal": "150.88",
        "timeAvailableFrom": "9/13/22 13:23",
        "lat": 39.5086015,
        "lng": -0.4549464,
        "id_ext": "4205-118071-118071"
    },
    {
        "id": "247fe90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Arrendado (propiedad)",
        "strategy": "2",
        "askingPriceRent": "2240.00",
        "askingPriceSale": "350000.00",
        "address": "Calle Concepcion 7 ",
        "postalCode": "28223",
        "city": "1128115",
        "province": "28",
        "CCAA": "54",
        "country": "ES",
        "use": "5",
        "surfacebr": "105.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "85.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "116.50",
        "surfaceTotal": "190.00",
        "timeAvailableFrom": "9/13/22 13:23",
        "lat": 40.4356176,
        "lng": -3.8138212,
        "id_ext": "4205-118078-118078"
    },
    {
        "id": "267fe90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Arrendado (propiedad)",
        "strategy": "2",
        "askingPriceRent": "2128.00",
        "askingPriceSale": "350016.35",
        "address": "Calle Hibisco 1 ",
        "postalCode": "35660",
        "city": "1135660",
        "province": "35",
        "CCAA": "56",
        "country": "ES",
        "use": "11",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "379.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "379.00",
        "surfaceTotal": "379.00",
        "timeAvailableFrom": "9/13/22 13:23",
        "lat": 28.7292425,
        "lng": -13.8643128,
        "id_ext": "4205-118085-118085"
    },
    {
        "id": "287fe90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "1",
        "askingPriceRent": "1218.00",
        "askingPriceSale": "194880.00",
        "address": "Calle Carretera De Sabadell 18 ",
        "postalCode": "08191",
        "city": "1108184",
        "province": "08",
        "CCAA": "55",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "173.77",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "173.77",
        "surfaceTotal": "173.77",
        "timeAvailableFrom": "9/13/22 13:23",
        "lat": 41.4973844,
        "lng": 2.0321877,
        "id_ext": "4205-118107-118107"
    },
    {
        "id": "2a7fe90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "1",
        "askingPriceRent": "1201.20",
        "askingPriceSale": "200200.00",
        "address": "Plaza Onze De Septiembre 2 ",
        "postalCode": "08291",
        "city": "1108180",
        "province": "08",
        "CCAA": "55",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "121.32",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "121.32",
        "surfaceTotal": "121.32",
        "timeAvailableFrom": "9/13/22 13:23",
        "lat": 41.4970233,
        "lng": 2.1578214,
        "id_ext": "4205-118115-118115"
    },
    {
        "id": "2c7fe90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "1",
        "askingPriceRent": "963.20",
        "askingPriceSale": "132440.00",
        "address": "Avenida Aduana 16 ",
        "postalCode": "04740",
        "city": "1104079",
        "province": "04",
        "CCAA": "51",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "19.43",
        "surfacepb": "214.73",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "19.43",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "224.45",
        "surfaceTotal": "234.16",
        "timeAvailableFrom": "9/13/22 13:23",
        "lat": 36.7668199,
        "lng": -2.6134578,
        "id_ext": "4205-118118-118118"
    },
    {
        "id": "2e7fe90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Arrendado (propiedad)",
        "strategy": "2",
        "askingPriceRent": "1293.60",
        "askingPriceSale": "184800.00",
        "address": "Calle Caja De Ahorros 13 ",
        "postalCode": "46900",
        "city": "1117197",
        "province": "46",
        "CCAA": "42",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "197.31",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "197.31",
        "surfaceTotal": "197.31",
        "timeAvailableFrom": "9/13/22 13:23",
        "lat": 39.430841,
        "lng": -0.4725859,
        "id_ext": "4205-118119-118119"
    },
    {
        "id": "307fe90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "2",
        "askingPriceRent": "1888.74",
        "askingPriceSale": "209860.00",
        "address": "Avenida De Navarra 26 ",
        "postalCode": "20100",
        "city": "1120067",
        "province": "20",
        "CCAA": "53",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "150.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "150.00",
        "surfaceTotal": "150.00",
        "timeAvailableFrom": "9/13/22 13:23",
        "lat": 43.3150486,
        "lng": -1.9022344,
        "id_ext": "4205-118124-118124"
    },
    {
        "id": "327fe90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "2",
        "askingPriceRent": "1759.38",
        "askingPriceSale": "208740.00",
        "address": "Plaza De La Llibertat 1 ",
        "postalCode": "43201",
        "city": "1143123",
        "province": "43",
        "CCAA": "55",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "213.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "213.00",
        "surfaceTotal": "213.00",
        "timeAvailableFrom": "9/13/22 13:23",
        "lat": 41.1577803,
        "lng": 1.1057711,
        "id_ext": "4205-118125-118125"
    },
    {
        "id": "347fe90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Arrendado (propiedad)",
        "strategy": "2",
        "askingPriceRent": "1421.00",
        "askingPriceSale": "205800.00",
        "address": "Calle Cincel 4 ",
        "postalCode": "28522",
        "city": "1128123",
        "province": "28",
        "CCAA": "54",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "150.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "150.00",
        "surfaceTotal": "150.00",
        "timeAvailableFrom": "9/13/22 13:23",
        "lat": 40.3494777,
        "lng": -3.5425987,
        "id_ext": "4205-118130-118130"
    },
    {
        "id": "367fe90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Arrendado (propiedad)",
        "strategy": "2",
        "askingPriceRent": "7815.79",
        "askingPriceSale": "1338152.90",
        "address": "Plaza De Vigo 1 ",
        "postalCode": "15706",
        "city": "1115078",
        "province": "15",
        "CCAA": "60",
        "country": "ES",
        "use": "11",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "460.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "460.00",
        "surfaceTotal": "460.00",
        "timeAvailableFrom": "9/13/22 13:23",
        "lat": 42.8737477,
        "lng": -8.551578899999999,
        "id_ext": "4205-118148-118148"
    },
    {
        "id": "387fe90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "2",
        "askingPriceRent": "4365.90",
        "askingPriceSale": "582120.00",
        "address": "Avenida De Catalunya 20 ",
        "postalCode": "08172",
        "city": "1108205",
        "province": "08",
        "CCAA": "55",
        "country": "ES",
        "use": "5",
        "surfacebr": "6.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "290.58",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "6.00",
        "surfaceWeighted": "292.38",
        "surfaceTotal": "296.58",
        "timeAvailableFrom": "9/13/22 13:23",
        "lat": 41.4727602,
        "lng": 2.0802962,
        "id_ext": "4205-118154-118154"
    },
    {
        "id": "3a7fe90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "1",
        "askingPriceRent": "700.00",
        "askingPriceSale": "114800.00",
        "address": "Avenida De Los Majuelos 69 ",
        "postalCode": "38107",
        "city": "1138038",
        "province": "38",
        "CCAA": "56",
        "country": "ES",
        "use": "5",
        "surfacebr": "36.68",
        "surfaceMezzanine": "0.00",
        "surfacepb": "174.83",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "185.83",
        "surfaceTotal": "211.51",
        "timeAvailableFrom": "9/13/22 13:23",
        "lat": 28.4364668,
        "lng": -16.3192802,
        "id_ext": "4205-118156-118156"
    },
    {
        "id": "3c7fe90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "1",
        "askingPriceRent": "492.62",
        "askingPriceSale": "69930.00",
        "address": "Carretera General Del Sur ",
        "postalCode": "38107",
        "city": "1138190",
        "province": "38",
        "CCAA": "56",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "113.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "113.00",
        "surfaceTotal": "113.00",
        "timeAvailableFrom": "9/13/22 13:23",
        "lat": 28.2490382,
        "lng": -16.4392596,
        "id_ext": "4205-118158-118158"
    },
    {
        "id": "3e7fe90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "2",
        "askingPriceRent": "1366.40",
        "askingPriceSale": "239120.00",
        "address": "Calle General Davila 256 ",
        "postalCode": "39006",
        "city": "1139075",
        "province": "39",
        "CCAA": "30",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "121.70",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "121.70",
        "surfaceTotal": "121.70",
        "timeAvailableFrom": "9/13/22 13:23",
        "lat": 43.4683534,
        "lng": -3.8094016,
        "id_ext": "4205-118175-118175"
    },
    {
        "id": "407fe90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "2",
        "askingPriceRent": "1410.50",
        "askingPriceSale": "191100.00",
        "address": "Calle Motrico 11 ",
        "postalCode": "28830",
        "city": "1128130",
        "province": "28",
        "CCAA": "54",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "137.53",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "137.53",
        "surfaceTotal": "137.53",
        "timeAvailableFrom": "9/13/22 13:23",
        "lat": 40.4191722,
        "lng": -3.52775,
        "id_ext": "4205-118188-118188"
    },
    {
        "id": "427fe90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Arrendado (propiedad)",
        "strategy": "2",
        "askingPriceRent": "1456.00",
        "askingPriceSale": "218400.00",
        "address": "Calle Rutlla 20 ",
        "postalCode": "17220",
        "city": "1117160",
        "province": "17",
        "CCAA": "55",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "145.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "145.00",
        "surfaceTotal": "145.00",
        "timeAvailableFrom": "9/13/22 13:23",
        "lat": 41.7823232,
        "lng": 3.0298517,
        "id_ext": "4205-118191-118191"
    },
    {
        "id": "447fe90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "1",
        "askingPriceRent": "824.60",
        "askingPriceSale": "124775.00",
        "address": "Avenida Antonio Machado 4 ",
        "postalCode": "18680",
        "city": "1118173",
        "province": "18",
        "CCAA": "51",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "155.37",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "155.37",
        "surfaceTotal": "155.37",
        "timeAvailableFrom": "9/13/22 13:23",
        "lat": 36.7455671,
        "lng": -3.5852099,
        "id_ext": "4205-118208-118208"
    },
    {
        "id": "467fe90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "2",
        "address": "Avenida De Lasalle 43 ",
        "postalCode": "37008",
        "city": "1137274",
        "province": "37",
        "CCAA": "59",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "43.63",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "43.63",
        "surfaceTotal": "43.63",
        "timeAvailableFrom": "9/13/22 13:23",
        "lat": 40.9548624,
        "lng": -5.6796734,
        "id_ext": "4205-118210-118210"
    },
    {
        "id": "487fe90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "2",
        "askingPriceRent": "2037.00",
        "askingPriceSale": "305550.00",
        "address": "Avenida Raimundo De Borgoña 1-15 ",
        "postalCode": "37005",
        "city": "1137274",
        "province": "37",
        "CCAA": "59",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "278.50",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "278.50",
        "surfaceTotal": "278.50",
        "timeAvailableFrom": "9/13/22 13:23",
        "lat": 40.9769777,
        "lng": -5.663625499999999,
        "id_ext": "4205-118213-118213"
    },
    {
        "id": "4a7fe90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "2",
        "askingPriceRent": "1347.29",
        "askingPriceSale": "188620.60",
        "address": "Carretera Nacional-340 km146 ",
        "postalCode": "29692",
        "city": "1129068",
        "province": "29",
        "CCAA": "51",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "192.47",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "192.47",
        "surfaceTotal": "192.47",
        "timeAvailableFrom": "9/13/22 13:23",
        "lat": 37.9752754,
        "lng": -1.2368537,
        "id_ext": "4205-118218-118218"
    },
    {
        "id": "4c7fe90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "1",
        "askingPriceRent": "548.80",
        "askingPriceSale": "75460.00",
        "address": "Calle Corredera Alta 2 ",
        "postalCode": "28680",
        "city": "1128133",
        "province": "28",
        "CCAA": "54",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "150.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "150.00",
        "surfaceTotal": "150.00",
        "timeAvailableFrom": "9/13/22 13:23",
        "lat": 40.3612211,
        "lng": -4.4009903,
        "id_ext": "4205-118222-118222"
    },
    {
        "id": "4e7fe90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "2",
        "askingPriceRent": "2921.52",
        "askingPriceSale": "389536.00",
        "address": "Calle Infante Don Fernando 21 ",
        "postalCode": "29200",
        "city": "1129015",
        "province": "29",
        "CCAA": "51",
        "country": "ES",
        "use": "5",
        "surfacebr": "65.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "479.23",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "389.90",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "693.68",
        "surfaceTotal": "934.13",
        "timeAvailableFrom": "9/13/22 13:23",
        "lat": 37.0177099,
        "lng": -4.561056,
        "id_ext": "4205-118228-118228"
    },
    {
        "id": "507fe90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "2",
        "askingPriceRent": "1158.00",
        "askingPriceSale": "154400.40",
        "address": "Avenida Artero Guirao 120 ",
        "postalCode": "30740",
        "city": "1130036",
        "province": "30",
        "CCAA": "43",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "184.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "184.00",
        "surfaceTotal": "184.00",
        "timeAvailableFrom": "9/13/22 13:23",
        "lat": 37.83500799999999,
        "lng": -0.7920279000000001,
        "id_ext": "4205-118236-118236"
    },
    {
        "id": "527fe90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Arrendado (propiedad)",
        "strategy": "2",
        "askingPriceRent": "1194.49",
        "askingPriceSale": "189371.00",
        "address": "Avenida De Los Quiñones 1 ",
        "postalCode": "28702",
        "city": "1128134",
        "province": "28",
        "CCAA": "54",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "104.05",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "104.05",
        "surfaceTotal": "104.05",
        "timeAvailableFrom": "9/13/22 13:23",
        "lat": 40.5620043,
        "lng": -3.6192624,
        "id_ext": "4205-118255-118255"
    },
    {
        "id": "547fe90a-5633-ed11-9db1-0022489c4873",
        "active": false,
        "status": "Vendido",
        "strategy": "CAMBIO DE USO",
        "askingPriceRent": "534.80",
        "askingPriceSale": "90916.00",
        "address": "Avenida Valdelasfuentes 9 ",
        "postalCode": "28700",
        "city": "1128134",
        "province": "28",
        "CCAA": "54",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "76.40",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "76.40",
        "surfaceTotal": "76.40",
        "timeAvailableFrom": "9/13/22 13:23",
        "lat": 40.5517467,
        "lng": -3.6335103,
        "id_ext": "4205-118258-118258"
    },
    {
        "id": "567fe90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "1",
        "askingPriceRent": "588.00",
        "askingPriceSale": "88200.00",
        "address": "Calle Jacint Verdaguer 278 ",
        "postalCode": "08620",
        "city": "1108263",
        "province": "08",
        "CCAA": "55",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "99.40",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "99.40",
        "surfaceTotal": "99.40",
        "timeAvailableFrom": "9/13/22 13:23",
        "lat": 41.4011368,
        "lng": 2.0054248,
        "id_ext": "4205-118267-118267"
    },
    {
        "id": "587fe90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Arrendado (propiedad)",
        "strategy": "1",
        "askingPriceRent": "1806.00",
        "askingPriceSale": "319200.00",
        "address": "Calle Dr.Jimenez Diaz 6 ",
        "postalCode": "41008",
        "city": "1141091",
        "province": "41",
        "CCAA": "51",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "107.96",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "109.71",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "162.82",
        "surfaceTotal": "217.67",
        "timeAvailableFrom": "9/13/22 13:23",
        "lat": 37.4038175,
        "lng": -5.980731899999999,
        "id_ext": "4205-118284-118284"
    },
    {
        "id": "5a7fe90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "2",
        "askingPriceRent": "1478.40",
        "askingPriceSale": "221760.00",
        "address": "Avenida Hytasa 61 ",
        "postalCode": "41006",
        "city": "1141091",
        "province": "41",
        "CCAA": "51",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "264.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "264.00",
        "surfaceTotal": "264.00",
        "timeAvailableFrom": "9/13/22 13:23",
        "lat": 37.3707229,
        "lng": -5.9599993,
        "id_ext": "4205-118286-118286"
    },
    {
        "id": "5c7fe90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Comité",
        "strategy": "1",
        "askingPriceRent": "646.80",
        "askingPriceSale": "92400.00",
        "address": "Calle Gramil 15 ",
        "postalCode": "41008",
        "city": "1141091",
        "province": "41",
        "CCAA": "51",
        "country": "ES",
        "use": "6",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "132.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "132.00",
        "surfaceTotal": "132.00",
        "timeAvailableFrom": "9/13/22 13:23",
        "lat": 37.40937,
        "lng": -5.96047,
        "id_ext": "4205-118293-118293"
    },
    {
        "id": "5e7fe90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "2",
        "askingPriceRent": "2530.50",
        "askingPriceSale": "371140.00",
        "address": "Calle Recaredo 5 ",
        "postalCode": "41003",
        "city": "1141091",
        "province": "41",
        "CCAA": "51",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "94.75",
        "surfacepb": "196.69",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "94.75",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "244.07",
        "surfaceTotal": "291.44",
        "timeAvailableFrom": "9/13/22 13:23",
        "lat": 37.3902388,
        "lng": -5.9844086,
        "id_ext": "4205-118296-118296"
    },
    {
        "id": "607fe90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Arrendado (propiedad)",
        "strategy": "2",
        "askingPriceRent": "2406.60",
        "askingPriceSale": "347620.00",
        "address": "Calle Riera Del Bisbe Pol 5 ",
        "postalCode": "08350",
        "city": "1108006",
        "province": "08",
        "CCAA": "55",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "181.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "181.00",
        "surfaceTotal": "181.00",
        "timeAvailableFrom": "9/13/22 13:23",
        "lat": 41.5792247,
        "lng": 2.5510798,
        "id_ext": "4205-118306-118306"
    },
    {
        "id": "627fe90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Arrendado (propiedad)",
        "strategy": "2",
        "askingPriceRent": "1659.00",
        "askingPriceSale": "309680.00",
        "address": "Paseo De Larios 1 ",
        "postalCode": "29740",
        "city": "1129740",
        "province": "29",
        "CCAA": "51",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "158.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "158.00",
        "surfaceTotal": "158.00",
        "timeAvailableFrom": "9/13/22 13:23",
        "lat": 36.741924,
        "lng": -4.0932879,
        "id_ext": "4205-118331-118331"
    },
    {
        "id": "647fe90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "2",
        "askingPriceRent": "936.60",
        "askingPriceSale": "124880.00",
        "address": "Calle Capitan Cortes 9 ",
        "postalCode": "45600",
        "city": "1145165",
        "province": "45",
        "CCAA": "40",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "207.71",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "207.71",
        "surfaceTotal": "207.71",
        "timeAvailableFrom": "9/13/22 13:23",
        "lat": 39.96583,
        "lng": -4.8236417,
        "id_ext": "4205-118347-118347"
    },
    {
        "id": "667fe90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "2",
        "askingPriceRent": "840.00",
        "askingPriceSale": "121800.00",
        "address": "Calle Rafael Quintana 16 ",
        "postalCode": "29620",
        "city": "1129901",
        "province": "29",
        "CCAA": "51",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "100.40",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "100.40",
        "surfaceTotal": "100.40",
        "timeAvailableFrom": "9/13/22 13:23",
        "lat": 36.6224427,
        "lng": -4.5052072,
        "id_ext": "4205-118355-118355"
    },
    {
        "id": "687fe90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Arrendado (propiedad)",
        "strategy": "2",
        "askingPriceRent": "573.30",
        "askingPriceSale": "70560.00",
        "address": "Avenida Maestro Serrano 1 ",
        "postalCode": "46290",
        "city": "1146015",
        "province": "46",
        "CCAA": "42",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "118.94",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "118.94",
        "surfaceTotal": "118.94",
        "timeAvailableFrom": "9/13/22 13:23",
        "lat": 39.3715521,
        "lng": -0.4410694,
        "id_ext": "4205-118361-118361"
    },
    {
        "id": "6a7fe90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "2",
        "askingPriceRent": "1125.60",
        "askingPriceSale": "126630.00",
        "address": "Travesía General Riego s/n ",
        "postalCode": "33870",
        "city": "1133073",
        "province": "33",
        "CCAA": "31",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "194.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "194.00",
        "surfaceTotal": "194.00",
        "timeAvailableFrom": "9/13/22 13:23",
        "lat": 43.3350916,
        "lng": -6.4168184,
        "id_ext": "4205-118362-118362"
    },
    {
        "id": "6c7fe90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "1",
        "askingPriceRent": "803.88",
        "askingPriceSale": "126672.00",
        "address": "Avenida Diego Ramirez Pastor 22 ",
        "postalCode": "03181",
        "city": "1103133",
        "province": "03",
        "CCAA": "42",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "169.40",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "169.40",
        "surfaceTotal": "169.40",
        "timeAvailableFrom": "9/13/22 13:23",
        "lat": 37.97939,
        "lng": -0.6892699999999999,
        "id_ext": "4205-118371-118371"
    },
    {
        "id": "6e7fe90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "1",
        "askingPriceRent": "839.20",
        "askingPriceSale": "127995.00",
        "address": "Avenida Estación 32 ",
        "postalCode": "30700",
        "city": "1130037",
        "province": "30",
        "CCAA": "43",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "158.50",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "158.50",
        "surfaceTotal": "158.50",
        "timeAvailableFrom": "9/13/22 13:23",
        "lat": 37.7443595,
        "lng": -0.9567668,
        "id_ext": "4205-118377-118377"
    },
    {
        "id": "707fe90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "CAMBIO DE USO",
        "askingPriceRent": "975.39",
        "askingPriceSale": "158172.00",
        "address": "Calle Independencia 44 ",
        "postalCode": "08225",
        "city": "1108279",
        "province": "08",
        "CCAA": "55",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "188.30",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "188.30",
        "surfaceTotal": "188.30",
        "timeAvailableFrom": "9/13/22 13:23",
        "lat": 41.5727526,
        "lng": 2.0144269,
        "id_ext": "4205-118378-118378"
    },
    {
        "id": "727fe90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "1",
        "askingPriceRent": "1136.80",
        "askingPriceSale": "194880.00",
        "address": "Plaza Del Toro S/N ",
        "postalCode": "28760",
        "city": "1128903",
        "province": "28",
        "CCAA": "54",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "112.30",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "112.30",
        "surfaceTotal": "112.30",
        "timeAvailableFrom": "9/13/22 13:23",
        "lat": 40.6061771,
        "lng": -3.7167757,
        "id_ext": "4205-118382-118382"
    },
    {
        "id": "747fe90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "1",
        "askingPriceRent": "804.65",
        "askingPriceSale": "118580.00",
        "address": "Calle Roma 3 ",
        "postalCode": "28850",
        "city": "1128148",
        "province": "28",
        "CCAA": "54",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "129.30",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "129.30",
        "surfaceTotal": "129.30",
        "timeAvailableFrom": "9/13/22 13:23",
        "lat": 40.458102,
        "lng": -3.4710192,
        "id_ext": "4205-118390-118390"
    },
    {
        "id": "767fe90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "2",
        "askingPriceRent": "1844.50",
        "askingPriceSale": "271250.00",
        "address": "Calle Pelotari 7 ",
        "postalCode": "20115",
        "city": "1120903",
        "province": "20",
        "CCAA": "53",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "155.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "155.00",
        "surfaceTotal": "155.00",
        "timeAvailableFrom": "9/13/22 13:23",
        "lat": 43.2826115,
        "lng": -1.948238,
        "id_ext": "4205-118394-118394"
    },
    {
        "id": "787fe90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "1",
        "askingPriceRent": "851.20",
        "askingPriceSale": "138320.00",
        "address": "Calle Sanchez Llevot 10 ",
        "postalCode": "37800",
        "city": "1137008",
        "province": "37",
        "CCAA": "59",
        "country": "ES",
        "use": "5",
        "surfacebr": "115.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "145.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "179.50",
        "surfaceTotal": "260.00",
        "timeAvailableFrom": "9/13/22 13:23",
        "lat": 40.8269469,
        "lng": -5.5135708,
        "id_ext": "4205-118405-118405"
    },
    {
        "id": "7a7fe90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "2",
        "askingPriceRent": "674.10",
        "askingPriceSale": "97370.00",
        "address": "Avenida De Palencia 9 ",
        "postalCode": "39300",
        "city": "1139087",
        "province": "39",
        "CCAA": "30",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "94.02",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "94.02",
        "surfaceTotal": "94.02",
        "timeAvailableFrom": "9/13/22 13:23",
        "lat": 43.3453095,
        "lng": -4.056539799999999,
        "id_ext": "4205-118406-118406"
    },
    {
        "id": "7c7fe90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "2",
        "askingPriceRent": "1131.20",
        "askingPriceSale": "175336.00",
        "address": "Plaza De Colon 5 ",
        "postalCode": "11600",
        "city": "1111038",
        "province": "11",
        "CCAA": "51",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "186.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "186.00",
        "surfaceTotal": "186.00",
        "timeAvailableFrom": "9/13/22 13:23",
        "lat": 36.6767992,
        "lng": -5.443650799999999,
        "id_ext": "4205-118413-118413"
    },
    {
        "id": "7e7fe90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "2",
        "askingPriceRent": "1367.10",
        "askingPriceSale": "197470.00",
        "address": "Calle 18 De Julio 30 ",
        "postalCode": "39610",
        "city": "1139008",
        "province": "39",
        "CCAA": "30",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "255.43",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "255.43",
        "surfaceTotal": "255.43",
        "timeAvailableFrom": "9/13/22 13:23",
        "lat": 43.40085089999999,
        "lng": -3.8241287,
        "id_ext": "4205-118417-118417"
    },
    {
        "id": "807fe90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Arrendado (propiedad)",
        "strategy": "2",
        "askingPriceRent": "723.80",
        "askingPriceSale": "101640.00",
        "address": "Calle Carrera 3 ",
        "postalCode": "23330",
        "city": "1123097",
        "province": "23",
        "CCAA": "51",
        "country": "ES",
        "use": "5",
        "surfacebr": "168.78",
        "surfaceMezzanine": "0.00",
        "surfacepb": "168.78",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "219.41",
        "surfaceTotal": "337.56",
        "timeAvailableFrom": "9/13/22 13:23",
        "lat": 38.16967169999999,
        "lng": -3.0092646,
        "id_ext": "4205-118434-118434"
    },
    {
        "id": "827fe90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "2",
        "askingPriceRent": "1584.66",
        "askingPriceSale": "226380.00",
        "address": "Calle Comandante Albarran 6 ",
        "postalCode": "05001",
        "city": "1105019",
        "province": "05",
        "CCAA": "59",
        "country": "ES",
        "use": "5",
        "surfacebr": "53.96",
        "surfaceMezzanine": "0.00",
        "surfacepb": "119.50",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "239.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "255.19",
        "surfaceTotal": "412.46",
        "timeAvailableFrom": "9/13/22 13:23",
        "lat": 40.6545384,
        "lng": -4.6946385,
        "id_ext": "4205-118439-118439"
    },
    {
        "id": "847fe90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "2",
        "askingPriceRent": "1778.00",
        "askingPriceSale": "284480.00",
        "address": "Calle De Modolell 52 ",
        "postalCode": "08840",
        "city": "1108301",
        "province": "08",
        "CCAA": "55",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "231.30",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "231.30",
        "surfaceTotal": "231.30",
        "timeAvailableFrom": "9/13/22 13:23",
        "lat": 41.318587,
        "lng": 2.0193036,
        "id_ext": "4205-118441-118441"
    },
    {
        "id": "867fe90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "2",
        "askingPriceRent": "1170.40",
        "askingPriceSale": "170240.00",
        "address": "Avenida Luis Espada 51 ",
        "postalCode": "32600",
        "city": "1132085",
        "province": "32",
        "CCAA": "60",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "280.42",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "280.42",
        "surfaceTotal": "280.42",
        "timeAvailableFrom": "9/13/22 13:23",
        "lat": 41.940337,
        "lng": -7.4369947,
        "id_ext": "4205-118446-118446"
    },
    {
        "id": "887fe90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "2",
        "askingPriceRent": "2205.00",
        "askingPriceSale": "378000.00",
        "address": " Gran Via 55 ",
        "postalCode": "36209",
        "city": "1136057",
        "province": "36",
        "CCAA": "60",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "225.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "225.00",
        "surfaceTotal": "225.00",
        "timeAvailableFrom": "9/13/22 13:23",
        "lat": 42.2302971,
        "lng": -8.718560799999999,
        "id_ext": "4205-118457-118457"
    },
    {
        "id": "8a7fe90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "1",
        "askingPriceRent": "787.50",
        "askingPriceSale": "113750.00",
        "address": "Calle Boulevar Ciudad De Vicar, 619 ",
        "postalCode": "04738",
        "city": "1104102",
        "province": "04",
        "CCAA": "51",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "119.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "119.00",
        "surfaceTotal": "119.00",
        "timeAvailableFrom": "9/13/22 13:23",
        "lat": 36.8050566,
        "lng": -2.6193275,
        "id_ext": "4205-118473-118473"
    },
    {
        "id": "8c7fe90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "2",
        "askingPriceRent": "1364.16",
        "askingPriceSale": "258720.00",
        "address": "Calle Canciller Ayala 9 ",
        "postalCode": "01004",
        "city": "1101059",
        "province": "01",
        "CCAA": "53",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "158.93",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "158.93",
        "surfaceTotal": "158.93",
        "timeAvailableFrom": "9/13/22 13:23",
        "lat": 42.8433321,
        "lng": -2.6654304,
        "id_ext": "4205-118477-118477"
    },
    {
        "id": "8e7fe90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "1",
        "askingPriceRent": "1406.16",
        "askingPriceSale": "272160.00",
        "address": "Calle Domingo Beltran 50 ",
        "postalCode": "01012",
        "city": "1101059",
        "province": "01",
        "CCAA": "53",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "156.83",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "156.83",
        "surfaceTotal": "156.83",
        "timeAvailableFrom": "9/13/22 13:23",
        "lat": 42.8538058,
        "lng": -2.6765297,
        "id_ext": "4205-118478-118478"
    },
    {
        "id": "907fe90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "2",
        "askingPriceRent": "1518.72",
        "askingPriceSale": "297416.00",
        "address": "Calle Francia 25 ",
        "postalCode": "01004",
        "city": "1101059",
        "province": "01",
        "CCAA": "53",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "225.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "225.00",
        "surfaceTotal": "225.00",
        "timeAvailableFrom": "9/13/22 13:23",
        "lat": 42.8486407,
        "lng": -2.6685404,
        "id_ext": "4205-118479-118479"
    },
    {
        "id": "927fe90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "2",
        "askingPriceRent": "1448.72",
        "askingPriceSale": "278600.00",
        "address": "Avenida Gasteiz 66 ",
        "postalCode": "01008",
        "city": "1101059",
        "province": "01",
        "CCAA": "53",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "196.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "196.00",
        "surfaceTotal": "196.00",
        "timeAvailableFrom": "9/13/22 13:23",
        "lat": 42.85185070000001,
        "lng": -2.6802212,
        "id_ext": "4205-118480-118480"
    },
    {
        "id": "947fe90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Arrendado (propiedad)",
        "strategy": "2",
        "askingPriceRent": "1080.80",
        "askingPriceSale": "141855.00",
        "address": "Avenida Burjasot 91 ",
        "postalCode": "46009",
        "city": "1146250",
        "province": "46",
        "CCAA": "42",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "196.64",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "196.64",
        "surfaceTotal": "196.64",
        "timeAvailableFrom": "9/13/22 13:23",
        "lat": 39.4880966,
        "lng": -0.3892198,
        "id_ext": "4205-118493-118493"
    },
    {
        "id": "967fe90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Arrendado (propiedad)",
        "strategy": "1",
        "askingPriceRent": "1347.02",
        "askingPriceSale": "202053.60",
        "address": "Calle Escultor Luis Bolinches ",
        "postalCode": "46023",
        "city": "1146250",
        "province": "46",
        "CCAA": "42",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "160.36",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "160.36",
        "surfaceTotal": "160.36",
        "timeAvailableFrom": "9/13/22 13:23",
        "lat": 39.4577091,
        "lng": -0.3464715,
        "id_ext": "4205-118504-118504"
    },
    {
        "id": "987fe90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "2",
        "askingPriceRent": "1997.10",
        "askingPriceSale": "310660.00",
        "address": "Calle Jaime Roig 26 ",
        "postalCode": "46010",
        "city": "1146250",
        "province": "46",
        "CCAA": "42",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "290.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "290.00",
        "surfaceTotal": "290.00",
        "timeAvailableFrom": "9/13/22 13:23",
        "lat": 39.4834113,
        "lng": -0.3627361,
        "id_ext": "4205-118508-118508"
    },
    {
        "id": "9a7fe90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Arrendado (propiedad)",
        "strategy": "2",
        "askingPriceRent": "1036.00",
        "askingPriceSale": "161875.00",
        "address": "Avenida Juan XXIII 44 ",
        "postalCode": "46025",
        "city": "1146250",
        "province": "46",
        "CCAA": "42",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "174.89",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "174.89",
        "surfaceTotal": "174.89",
        "timeAvailableFrom": "9/13/22 13:23",
        "lat": 39.49416009999999,
        "lng": -0.3832042000000001,
        "id_ext": "4205-118512-118512"
    },
    {
        "id": "9c7fe90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Arrendado (propiedad)",
        "strategy": "2",
        "askingPriceRent": "2009.07",
        "askingPriceSale": "312522.00",
        "address": " Marques De Montortal 2 ",
        "postalCode": "46019",
        "city": "1146250",
        "province": "46",
        "CCAA": "42",
        "country": "ES",
        "use": "5",
        "surfacebr": "360.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "284.83",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "392.83",
        "surfaceTotal": "644.83",
        "timeAvailableFrom": "9/13/22 13:23",
        "lat": 39.4922992,
        "lng": -0.3746712,
        "id_ext": "4205-118513-118513"
    },
    {
        "id": "9e7fe90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Arrendado (propiedad)",
        "strategy": "2",
        "askingPriceRent": "2368.50",
        "askingPriceSale": "383180.00",
        "address": "Avenida Regne De Valencia 2 ",
        "postalCode": "46005",
        "city": "1146250",
        "province": "46",
        "CCAA": "42",
        "country": "ES",
        "use": "5",
        "surfacebr": "186.62",
        "surfaceMezzanine": "0.00",
        "surfacepb": "331.37",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "387.36",
        "surfaceTotal": "517.99",
        "timeAvailableFrom": "9/13/22 13:23",
        "lat": 39.46469640000001,
        "lng": -0.3733274,
        "id_ext": "4205-118521-118521"
    },
    {
        "id": "a07fe90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "2",
        "address": " Polvoranca 39 ",
        "postalCode": "28923",
        "city": "1128007",
        "province": "28",
        "CCAA": "54",
        "country": "ES",
        "use": "5",
        "surfacebr": "170.75",
        "surfaceMezzanine": "0.00",
        "surfacepb": "150.19",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "201.42",
        "surfaceTotal": "320.94",
        "timeAvailableFrom": "9/13/22 13:23",
        "lat": 40.341086,
        "lng": -3.8155664,
        "id_ext": "4205-118527-118527"
    },
    {
        "id": "a27fe90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "2",
        "askingPriceRent": "856.80",
        "askingPriceSale": "128520.00",
        "address": "Calle Huelgas 10 ",
        "postalCode": "47005",
        "city": "1147186",
        "province": "47",
        "CCAA": "59",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "141.22",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "141.22",
        "surfaceTotal": "141.22",
        "timeAvailableFrom": "9/13/22 13:23",
        "lat": 41.6521014,
        "lng": -4.7165576,
        "id_ext": "4205-118541-118541"
    },
    {
        "id": "a47fe90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "2",
        "askingPriceRent": "1212.12",
        "askingPriceSale": "158508.00",
        "address": "Avenida Zamora 23 ",
        "postalCode": "47008",
        "city": "1147186",
        "province": "47",
        "CCAA": "59",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "133.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "133.00",
        "surfaceTotal": "133.00",
        "timeAvailableFrom": "9/13/22 13:23",
        "lat": 41.6225005,
        "lng": -4.7462279,
        "id_ext": "4205-118548-118548"
    },
    {
        "id": "a67fe90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "2",
        "askingPriceRent": "2028.60",
        "askingPriceSale": "260820.00",
        "address": "Calle Muelle De Portugal 21 ",
        "postalCode": "21400",
        "city": "1121010",
        "province": "21",
        "CCAA": "51",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "160.40",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "160.40",
        "surfaceTotal": "160.40",
        "timeAvailableFrom": "9/13/22 13:23",
        "lat": 37.2169594,
        "lng": -7.409236099999998,
        "id_ext": "4205-118550-118550"
    },
    {
        "id": "a87fe90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "1",
        "askingPriceRent": "1263.85",
        "askingPriceSale": "219800.00",
        "address": "Calle Dolores Ibarruri 4 ",
        "postalCode": "29700",
        "city": "1129094",
        "province": "29",
        "CCAA": "51",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "157.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "157.00",
        "surfaceTotal": "157.00",
        "timeAvailableFrom": "9/13/22 13:23",
        "lat": 36.7799228,
        "lng": -4.1005589,
        "id_ext": "4205-118557-118557"
    },
    {
        "id": "aa7fe90a-5633-ed11-9db1-0022489c4873",
        "active": false,
        "status": "Vendido",
        "strategy": "1",
        "askingPriceRent": "1514.69",
        "askingPriceSale": "243667.20",
        "address": "Paseo Chapi 9 ",
        "postalCode": "03400",
        "city": "1103140",
        "province": "03",
        "CCAA": "42",
        "country": "ES",
        "use": "5",
        "surfacebr": "342.04",
        "surfaceMezzanine": "0.00",
        "surfacepb": "280.18",
        "surfaceBasement1": "175.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "175.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "470.29",
        "surfaceTotal": "797.22",
        "timeAvailableFrom": "9/13/22 13:23",
        "lat": 38.6319733,
        "lng": -0.8657633,
        "id_ext": "4205-118560-118560"
    },
    {
        "id": "ac7fe90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "2",
        "askingPriceRent": "1684.20",
        "askingPriceSale": "224560.00",
        "address": "Calle Eras 17 ",
        "postalCode": "28670",
        "city": "1128181",
        "province": "28",
        "CCAA": "54",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "264.66",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "264.66",
        "surfaceTotal": "264.66",
        "timeAvailableFrom": "9/13/22 13:23",
        "lat": 40.3580031,
        "lng": -3.9028574,
        "id_ext": "4205-118581-118581"
    },
    {
        "id": "ae7fe90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "2",
        "askingPriceRent": "1218.00",
        "askingPriceSale": "162400.00",
        "address": "Calle Madrid 4 ",
        "postalCode": "28939",
        "city": "1110023",
        "province": "28",
        "CCAA": "54",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "145.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "145.00",
        "surfaceTotal": "145.00",
        "timeAvailableFrom": "9/13/22 13:23",
        "lat": 40.2703682,
        "lng": -3.9193367,
        "id_ext": "4205-118583-118583"
    },
    {
        "id": "b07fe90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "2",
        "askingPriceRent": "852.04",
        "askingPriceSale": "125300.00",
        "address": "Calle La Haba 17 ",
        "postalCode": "06700",
        "city": "1106153",
        "province": "06",
        "CCAA": "41",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "402.28",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "402.28",
        "surfaceTotal": "402.28",
        "timeAvailableFrom": "9/13/22 13:23",
        "lat": 38.9721489,
        "lng": -5.7991673,
        "id_ext": "4205-118587-118587"
    },
    {
        "id": "b27fe90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "1",
        "askingPriceRent": "797.58",
        "askingPriceSale": "110952.24",
        "address": "Calle Balbin Busto 20 ",
        "postalCode": "33300",
        "city": "1133076",
        "province": "33",
        "CCAA": "31",
        "country": "ES",
        "use": "5",
        "surfacebr": "75.70",
        "surfaceMezzanine": "0.00",
        "surfacepb": "118.56",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "141.27",
        "surfaceTotal": "194.26",
        "timeAvailableFrom": "9/13/22 13:23",
        "lat": 43.4801233,
        "lng": -5.4344409,
        "id_ext": "4205-118589-118589"
    },
    {
        "id": "b47fe90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "1",
        "askingPriceRent": "395.53",
        "askingPriceSale": "56504.00",
        "address": "Plaza La Orden 26 ",
        "postalCode": "02480",
        "city": "1102086",
        "province": "02",
        "CCAA": "40",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "100.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "100.00",
        "surfaceTotal": "100.00",
        "timeAvailableFrom": "9/13/22 13:23",
        "lat": 38.3654376,
        "lng": -2.321546,
        "id_ext": "4205-118600-118600"
    },
    {
        "id": "b67fe90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "2",
        "askingPriceRent": "1458.24",
        "askingPriceSale": "208320.00",
        "address": " Panchito Hernandez 8 ",
        "postalCode": "35400",
        "city": "1135006",
        "province": "35",
        "CCAA": "56",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "191.91",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "191.91",
        "surfaceTotal": "191.91",
        "timeAvailableFrom": "9/13/22 13:23",
        "lat": 28.1188371,
        "lng": -15.5254307,
        "id_ext": "4205-118607-118607"
    },
    {
        "id": "b87fe90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "1",
        "askingPriceRent": "1815.41",
        "askingPriceSale": "302568.00",
        "address": "Calle Orape Kalea 18 ",
        "postalCode": "20800",
        "city": "1120079",
        "province": "20",
        "CCAA": "53",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "144.08",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "144.08",
        "surfaceTotal": "144.08",
        "timeAvailableFrom": "9/13/22 13:23",
        "lat": 43.28585040000001,
        "lng": -2.1764572,
        "id_ext": "4205-118608-118608"
    },
    {
        "id": "ba7fe90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "2",
        "askingPriceRent": "868.56",
        "askingPriceSale": "133056.00",
        "address": "Avenida De Cataluña 23 ",
        "postalCode": "50014",
        "city": "1150297",
        "province": "50",
        "CCAA": "10",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "147.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "147.00",
        "surfaceTotal": "147.00",
        "timeAvailableFrom": "9/13/22 13:23",
        "lat": 41.6603583,
        "lng": -0.8694447999999999,
        "id_ext": "4205-118611-118611"
    },
    {
        "id": "bc7fe90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "1",
        "askingPriceRent": "1345.68",
        "askingPriceSale": "201852.00",
        "address": "Calle Pablo Ruiz Picasso 42 ",
        "postalCode": "50015",
        "city": "1150297",
        "province": "50",
        "CCAA": "10",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "160.20",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "160.20",
        "surfaceTotal": "160.20",
        "timeAvailableFrom": "9/13/22 13:23",
        "lat": 41.673874,
        "lng": -0.8898183,
        "id_ext": "4205-118619-118619"
    },
    {
        "id": "be7fe90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "2",
        "askingPriceRent": "4116.00",
        "askingPriceSale": "764400.00",
        "address": "Paseo Sagasta 80 ",
        "postalCode": "50006",
        "city": "1150297",
        "province": "50",
        "CCAA": "10",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "322.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "322.00",
        "surfaceTotal": "322.00",
        "timeAvailableFrom": "9/13/22 13:23",
        "lat": 41.6389772,
        "lng": -0.8865126000000001,
        "id_ext": "4205-118621-118621"
    },
    {
        "id": "c07fe90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "2",
        "askingPriceRent": "915.60",
        "askingPriceSale": "122080.00",
        "address": "Calle Carretera de Coín 78 ",
        "postalCode": "29140",
        "city": "1129140",
        "province": "29",
        "CCAA": "51",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "89.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "89.00",
        "surfaceTotal": "89.00",
        "timeAvailableFrom": "9/13/22 13:23",
        "lat": 36.6585867,
        "lng": -4.4899071,
        "id_ext": "4205-118635-118635"
    },
    {
        "id": "c27fe90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "2",
        "askingPriceRent": "2407.99",
        "askingPriceSale": "339042.93",
        "address": "Calle Porto Colon 14 ",
        "postalCode": "28924",
        "city": "1128007",
        "province": "28",
        "CCAA": "54",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "261.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "261.00",
        "surfaceTotal": "261.00",
        "timeAvailableFrom": "9/13/22 13:23",
        "lat": 40.3501699,
        "lng": -3.8177118,
        "id_ext": "4205-118638-118638"
    },
    {
        "id": "c47fe90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Arrendado (propiedad)",
        "strategy": "2",
        "address": "Avenida de los Descubrimientos 4 ",
        "postalCode": "41927",
        "city": "1141059",
        "province": "41",
        "CCAA": "51",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "111.50",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "111.50",
        "surfaceTotal": "111.50",
        "timeAvailableFrom": "9/13/22 13:23",
        "lat": 37.3512187,
        "lng": -6.048582499999999,
        "id_ext": "4205-118653-118653"
    },
    {
        "id": "c67fe90a-5633-ed11-9db1-0022489c4873",
        "active": false,
        "status": "Vendido",
        "strategy": "2",
        "askingPriceRent": "999.60",
        "askingPriceSale": "99960.00",
        "address": " Esteban Solis 13 ",
        "postalCode": "23250",
        "city": "1123079",
        "province": "23",
        "CCAA": "51",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "125.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "113.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "181.50",
        "surfaceTotal": "238.00",
        "timeAvailableFrom": "9/13/22 13:23",
        "lat": 38.2486767,
        "lng": -3.2068628,
        "id_ext": "4205-118675-118675"
    },
    {
        "id": "c87fe90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "2",
        "askingPriceRent": "1262.66",
        "askingPriceSale": "174160.00",
        "address": "Calle Feria 2 ",
        "postalCode": "49005",
        "city": "1149275",
        "province": "49",
        "CCAA": "59",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "311.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "311.00",
        "surfaceTotal": "311.00",
        "timeAvailableFrom": "9/13/22 13:23",
        "lat": 41.50498750000001,
        "lng": -5.747899599999999,
        "id_ext": "4205-118681-118681"
    },
    {
        "id": "ca7fe90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "2",
        "askingPriceRent": "1008.00",
        "askingPriceSale": "134400.00",
        "address": "Calle Valencia 1 ",
        "postalCode": "18100",
        "city": "1118021",
        "province": "18",
        "CCAA": "51",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "119.40",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "119.40",
        "surfaceTotal": "119.40",
        "timeAvailableFrom": "9/13/22 13:23",
        "lat": 37.1437339,
        "lng": -3.6287662,
        "id_ext": "4205-118688-118688"
    },
    {
        "id": "cc7fe90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "2",
        "askingPriceRent": "1744.05",
        "askingPriceSale": "279048.00",
        "address": "Calle Mayor 9 ",
        "postalCode": "45500",
        "city": "1145173",
        "province": "45",
        "CCAA": "40",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "442.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "442.00",
        "surfaceTotal": "442.00",
        "timeAvailableFrom": "9/13/22 13:23",
        "lat": 39.9815465,
        "lng": -4.2841116,
        "id_ext": "4205-118690-118690"
    },
    {
        "id": "ce7fe90a-5633-ed11-9db1-0022489c4873",
        "active": false,
        "status": "Vendido",
        "strategy": "1",
        "askingPriceRent": "431.20",
        "askingPriceSale": "49280.00",
        "address": "Calle San Pedro 35 ",
        "postalCode": "50800",
        "city": "1150298",
        "province": "50",
        "CCAA": "10",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "88.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "88.00",
        "surfaceTotal": "88.00",
        "timeAvailableFrom": "9/13/22 13:23",
        "lat": 41.8683136,
        "lng": -0.7868442999999999,
        "id_ext": "4205-118693-118693"
    },
    {
        "id": "d07fe90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "2",
        "askingPriceRent": "1062.43",
        "askingPriceSale": "128520.00",
        "address": "Plaza Trafalgar 8 ",
        "postalCode": "08913",
        "city": "1108015",
        "province": "08",
        "CCAA": "55",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "86.80",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "43.31",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "108.46",
        "surfaceTotal": "130.11",
        "timeAvailableFrom": "9/13/22 13:23",
        "lat": 41.437451,
        "lng": 2.2183034,
        "id_ext": "4205-118698-118698"
    },
    {
        "id": "d27fe90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "2",
        "askingPriceRent": "689.50",
        "askingPriceSale": "110320.00",
        "address": "Calle Iglesia 2 ",
        "postalCode": "23710",
        "city": "1123010",
        "province": "23",
        "CCAA": "51",
        "country": "ES",
        "use": "5",
        "surfacebr": "42.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "169.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "181.60",
        "surfaceTotal": "211.00",
        "timeAvailableFrom": "9/13/22 13:23",
        "lat": 38.095725,
        "lng": -3.775174099999999,
        "id_ext": "4205-118699-118699"
    },
    {
        "id": "d47fe90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Arrendado (propiedad)",
        "strategy": "2",
        "askingPriceRent": "6442.51",
        "askingPriceSale": "787417.40",
        "address": "Calle Fueros 3 ",
        "postalCode": "48901",
        "city": "1148013",
        "province": "48",
        "CCAA": "53",
        "country": "ES",
        "use": "5",
        "surfacebr": "355.20",
        "surfaceMezzanine": "0.00",
        "surfacepb": "475.79",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "582.35",
        "surfaceTotal": "830.99",
        "timeAvailableFrom": "9/13/22 13:23",
        "lat": 43.2962757,
        "lng": -2.9864821,
        "id_ext": "4205-118704-118704"
    },
    {
        "id": "d67fe90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "1",
        "askingPriceRent": "764.40",
        "askingPriceSale": "141960.00",
        "address": "Calle Marcelino Suarez 2 ",
        "postalCode": "32314",
        "city": "1132009",
        "province": "32",
        "CCAA": "60",
        "country": "ES",
        "use": "5",
        "surfacebr": "140.44",
        "surfaceMezzanine": "0.00",
        "surfacepb": "136.34",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "178.47",
        "surfaceTotal": "276.78",
        "timeAvailableFrom": "9/13/22 13:23",
        "lat": 42.4162109,
        "lng": -6.9815282,
        "id_ext": "4205-118708-118708"
    },
    {
        "id": "d87fe90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Arrendado (propiedad)",
        "strategy": "2",
        "askingPriceRent": "2967.30",
        "askingPriceSale": "538510.00",
        "address": "Paseo Bonanova 25 ",
        "postalCode": "08022",
        "city": "1108019",
        "province": "08",
        "CCAA": "55",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "148.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "148.00",
        "surfaceTotal": "148.00",
        "timeAvailableFrom": "9/13/22 13:23",
        "lat": 41.4055377,
        "lng": 2.1317069,
        "id_ext": "4205-118721-118721"
    },
    {
        "id": "da7fe90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "2",
        "askingPriceRent": "1923.60",
        "askingPriceSale": "288540.00",
        "address": "Calle Via Medular S/N ",
        "postalCode": "35500",
        "city": "1135004",
        "province": "35",
        "CCAA": "56",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "202.05",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "110.40",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "257.25",
        "surfaceTotal": "312.45",
        "timeAvailableFrom": "9/13/22 13:23",
        "lat": 28.9620701,
        "lng": -13.5619807,
        "id_ext": "4205-118736-118736"
    },
    {
        "id": "dc7fe90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "CAMBIO DE USO",
        "askingPriceRent": "991.20",
        "askingPriceSale": "181720.00",
        "address": "Avenida Mare De Deu Montserrat 237 ",
        "postalCode": "08041",
        "city": "1108019",
        "province": "08",
        "CCAA": "55",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "119.50",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "119.50",
        "surfaceTotal": "119.50",
        "timeAvailableFrom": "9/13/22 13:23",
        "lat": 41.4230007,
        "lng": 2.174962,
        "id_ext": "4205-118745-118745"
    },
    {
        "id": "de7fe90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Arrendado (propiedad)",
        "strategy": "2",
        "askingPriceRent": "6783.00",
        "askingPriceSale": "1492260.00",
        "address": "Avenida Marques De L'Argentera 3 ",
        "postalCode": "08003",
        "city": "1108019",
        "province": "08",
        "CCAA": "55",
        "country": "ES",
        "use": "11",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "0.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "323.34",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "161.67",
        "surfaceTotal": "323.34",
        "timeAvailableFrom": "9/13/22 13:23",
        "lat": 41.3837684,
        "lng": 2.1838838,
        "id_ext": "4205-118749-118749"
    },
    {
        "id": "e07fe90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "2",
        "askingPriceRent": "1974.00",
        "askingPriceSale": "375060.00",
        "address": "Avenida Republica Argentina 64 ",
        "postalCode": "08023",
        "city": "1108019",
        "province": "08",
        "CCAA": "55",
        "country": "ES",
        "use": "5",
        "surfacebr": "49.18",
        "surfaceMezzanine": "0.00",
        "surfacepb": "135.57",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "150.32",
        "surfaceTotal": "184.75",
        "timeAvailableFrom": "9/13/22 13:23",
        "lat": 41.4096631,
        "lng": 2.1466167,
        "id_ext": "4205-118762-118762"
    },
    {
        "id": "e27fe90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "CAMBIO DE USO",
        "askingPriceRent": "1474.20",
        "askingPriceSale": "327600.00",
        "address": "Calle Santa Amelia 20 ",
        "postalCode": "08034",
        "city": "1108019",
        "province": "08",
        "CCAA": "55",
        "country": "ES",
        "use": "5",
        "surfacebr": "90.10",
        "surfaceMezzanine": "0.00",
        "surfacepb": "90.10",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "117.13",
        "surfaceTotal": "180.20",
        "timeAvailableFrom": "9/13/22 13:23",
        "lat": 41.3945122,
        "lng": 2.1251937,
        "id_ext": "4205-118771-118771"
    },
    {
        "id": "e47fe90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "2",
        "askingPriceRent": "3939.60",
        "askingPriceSale": "787920.00",
        "address": "Calle Sicilia 284 ",
        "postalCode": "08013",
        "city": "1108019",
        "province": "08",
        "CCAA": "55",
        "country": "ES",
        "use": "5",
        "surfacebr": "370.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "321.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "432.00",
        "surfaceTotal": "691.00",
        "timeAvailableFrom": "9/13/22 13:23",
        "lat": 41.4014421,
        "lng": 2.1742113,
        "id_ext": "4205-118772-118772"
    },
    {
        "id": "e67fe90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Arrendado (propiedad)",
        "strategy": "CAMBIO DE USO",
        "askingPriceRent": "1125.60",
        "askingPriceSale": "150080.00",
        "address": "Vía Julia 154 - 158 ",
        "postalCode": "08016",
        "city": "1108019",
        "province": "08",
        "CCAA": "55",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "88.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "119.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "147.50",
        "surfaceTotal": "207.00",
        "timeAvailableFrom": "9/13/22 13:23",
        "lat": 41.4445845,
        "lng": 2.1792516,
        "id_ext": "4205-118775-118775"
    },
    {
        "id": "e87fe90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "2",
        "address": "Calle Jose María Pereda 8 ",
        "postalCode": "28806",
        "city": "1128005",
        "province": "28",
        "CCAA": "54",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "153.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "153.00",
        "surfaceTotal": "153.00",
        "timeAvailableFrom": "9/13/22 13:23",
        "lat": 40.4967951,
        "lng": -3.3631785,
        "id_ext": "4205-118780-118780"
    },
    {
        "id": "ea7fe90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Arrendado (propiedad)",
        "strategy": "2",
        "askingPriceRent": "891.80",
        "askingPriceSale": "137200.00",
        "address": "Calle Del Pla Dels Avellaners 8 ",
        "postalCode": "08210",
        "city": "1108252",
        "province": "08",
        "CCAA": "55",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "212.41",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "212.41",
        "surfaceTotal": "212.41",
        "timeAvailableFrom": "9/13/22 13:23",
        "lat": 41.5279162,
        "lng": 2.1460314,
        "id_ext": "4205-118782-118782"
    },
    {
        "id": "ec7fe90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "1",
        "askingPriceRent": "763.70",
        "askingPriceSale": "122192.00",
        "address": "Avenida Generalitat 68 ",
        "postalCode": "08210",
        "city": "1108252",
        "province": "08",
        "CCAA": "55",
        "country": "ES",
        "use": "5",
        "surfacebr": "260.68",
        "surfaceMezzanine": "0.00",
        "surfacepb": "83.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "161.20",
        "surfaceTotal": "343.68",
        "timeAvailableFrom": "9/13/22 13:23",
        "lat": 41.5153527,
        "lng": 2.1241199,
        "id_ext": "4205-118783-118783"
    },
    {
        "id": "ee7fe90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Arrendado (propiedad)",
        "strategy": "2",
        "address": "Calle Alameda 11 ",
        "postalCode": "03501",
        "city": "1103031",
        "province": "03",
        "CCAA": "42",
        "country": "ES",
        "use": "5",
        "surfacebr": "244.01",
        "surfaceMezzanine": "0.00",
        "surfacepb": "250.10",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "323.30",
        "surfaceTotal": "494.11",
        "timeAvailableFrom": "9/13/22 13:23",
        "lat": 38.53603,
        "lng": -0.1298114,
        "id_ext": "4205-118786-118786"
    },
    {
        "id": "f07fe90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "1",
        "askingPriceRent": "700.00",
        "askingPriceSale": "98000.00",
        "address": "Paseo De Irizar 2 ",
        "postalCode": "20570",
        "city": "1120074",
        "province": "20",
        "CCAA": "53",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "162.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "162.00",
        "surfaceTotal": "162.00",
        "timeAvailableFrom": "9/13/22 13:23",
        "lat": 43.1190388,
        "lng": -2.4132736,
        "id_ext": "4205-118797-118797"
    },
    {
        "id": "f27fe90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Arrendado (propiedad)",
        "strategy": "2",
        "askingPriceRent": "3990.00",
        "askingPriceSale": "714000.00",
        "address": "Calle Calixto Diez 3 ",
        "postalCode": "48012",
        "city": "1148020",
        "province": "48",
        "CCAA": "53",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "369.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "369.00",
        "surfaceTotal": "369.00",
        "timeAvailableFrom": "9/13/22 13:23",
        "lat": 43.2571298,
        "lng": -2.9412427,
        "id_ext": "4205-118801-118801"
    },
    {
        "id": "f47fe90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "2",
        "askingPriceRent": "1253.11",
        "askingPriceSale": "156639.00",
        "address": " Sagarminaga - Archivo ",
        "postalCode": "48001",
        "city": "1148020",
        "province": "48",
        "CCAA": "53",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "221.67",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "221.67",
        "surfaceTotal": "221.67",
        "timeAvailableFrom": "9/13/22 13:23",
        "lat": 43.2492132,
        "lng": -2.9127192,
        "id_ext": "4205-118810-118810"
    },
    {
        "id": "f67fe90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "2",
        "askingPriceRent": "840.00",
        "askingPriceSale": "126000.00",
        "address": "Calle San Esteban 9 ",
        "postalCode": "31010",
        "city": "1131901",
        "province": "31",
        "CCAA": "11",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "100.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "100.00",
        "surfaceTotal": "100.00",
        "timeAvailableFrom": "9/13/22 13:23",
        "lat": 42.8046592,
        "lng": -1.6797765,
        "id_ext": "4205-118829-118829"
    },
    {
        "id": "f87fe90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Arrendado (propiedad)",
        "strategy": "2",
        "askingPriceRent": "648.31",
        "askingPriceSale": "75636.40",
        "address": "Calle Cami Nou 95 ",
        "postalCode": "46910",
        "city": "1146054",
        "province": "46",
        "CCAA": "42",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "154.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "154.00",
        "surfaceTotal": "154.00",
        "timeAvailableFrom": "9/13/22 13:23",
        "lat": 39.421394,
        "lng": -0.3959723,
        "id_ext": "4205-118831-118831"
    },
    {
        "id": "fa7fe90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "1",
        "askingPriceRent": "862.40",
        "askingPriceSale": "123970.00",
        "address": "Calle Mayor 1 ",
        "postalCode": "42300",
        "city": "1142043",
        "province": "42",
        "CCAA": "59",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "140.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "140.00",
        "surfaceTotal": "140.00",
        "timeAvailableFrom": "9/13/22 13:23",
        "lat": 41.5873516,
        "lng": -3.0665807,
        "id_ext": "4205-118838-118838"
    },
    {
        "id": "fc7fe90a-5633-ed11-9db1-0022489c4873",
        "active": false,
        "status": "Vendido",
        "strategy": "1",
        "askingPriceRent": "411.60",
        "askingPriceSale": "58800.00",
        "address": "Calle Justo Canton Salazar 13 ",
        "postalCode": "09240",
        "city": "1109056",
        "province": "09",
        "CCAA": "59",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "84.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "84.00",
        "surfaceTotal": "84.00",
        "timeAvailableFrom": "9/13/22 13:23",
        "lat": 42.5508247,
        "lng": -3.3227989,
        "id_ext": "4205-118848-118848"
    },
    {
        "id": "fe7fe90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "2",
        "askingPriceRent": "1297.10",
        "askingPriceSale": "207536.00",
        "address": "Plaza Hnos.Gcia.Naveira 23 ",
        "postalCode": "15300",
        "city": "1115009",
        "province": "15",
        "CCAA": "60",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "200.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "200.00",
        "surfaceTotal": "200.00",
        "timeAvailableFrom": "9/13/22 13:23",
        "lat": 43.277864,
        "lng": -8.211826499999999,
        "id_ext": "4205-118859-118859"
    },
    {
        "id": "0080e90a-5633-ed11-9db1-0022489c4873",
        "active": false,
        "status": "Vendido",
        "strategy": "2",
        "address": "Avenida Reyes Catolicos 8 ",
        "postalCode": "09004",
        "city": "1109059",
        "province": "09",
        "CCAA": "59",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "220.62",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "220.62",
        "surfaceTotal": "220.62",
        "timeAvailableFrom": "9/13/22 13:23",
        "lat": 42.34464879999999,
        "lng": -3.6956664,
        "id_ext": "4205-118868-118868"
    },
    {
        "id": "0280e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "2",
        "address": "Calle Conde Don Alonso, 38 ",
        "postalCode": "14280",
        "city": "1114008",
        "province": "14",
        "CCAA": "51",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "90.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "90.00",
        "surfaceTotal": "90.00",
        "timeAvailableFrom": "9/13/22 13:23",
        "lat": 38.5751273,
        "lng": -5.1656188,
        "id_ext": "4205-118876-118876"
    },
    {
        "id": "0480e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "2",
        "address": "Avenida Jose Solis Ruiz 35 ",
        "postalCode": "14940",
        "city": "1114013",
        "province": "14",
        "CCAA": "51",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "149.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "149.00",
        "surfaceTotal": "149.00",
        "timeAvailableFrom": "9/13/22 13:23",
        "lat": 37.4729709,
        "lng": -4.4440773,
        "id_ext": "4205-118877-118877"
    },
    {
        "id": "58845e94-6233-ed11-9db1-0022489ca4d1",
        "active": true,
        "status": "Comercializable",
        "strategy": "2",
        "address": "Avenida Jose Solis Ruiz 35 ",
        "postalCode": "14940",
        "city": "1114013",
        "province": "14",
        "CCAA": "51",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "74.95",
        "surfaceBasement1": "74.95",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "74.95",
        "surfaceTotal": "74.95",
        "timeAvailableFrom": "9/13/22 14:50",
        "lat": 37.4729709,
        "lng": -4.4440773,
        "id_ext": "4205-118877-119977"
    },
    {
        "id": "62845e94-6233-ed11-9db1-0022489ca4d1",
        "active": true,
        "status": "Comercializable",
        "strategy": "2",
        "address": "Avenida Jose Solis Ruiz 35 ",
        "postalCode": "14940",
        "city": "1114013",
        "province": "14",
        "CCAA": "51",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "52.92",
        "surfaceBasement1": "52.92",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "52.92",
        "surfaceTotal": "52.92",
        "timeAvailableFrom": "9/13/22 14:50",
        "id_ext": "4205-118877-120456"
    },
    {
        "id": "64845e94-6233-ed11-9db1-0022489ca4d1",
        "active": true,
        "status": "Comercializable",
        "strategy": "2",
        "address": "Avenida Jose Solis Ruiz 35 ",
        "postalCode": "14940",
        "city": "1114013",
        "province": "14",
        "CCAA": "51",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "63.90",
        "surfaceBasement1": "63.90",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "63.90",
        "surfaceTotal": "63.90",
        "timeAvailableFrom": "9/13/22 14:50",
        "lat": 37.4729709,
        "lng": -4.4440773,
        "id_ext": "4205-118877-120457"
    },
    {
        "id": "66845e94-6233-ed11-9db1-0022489ca4d1",
        "active": true,
        "status": "Comercializable",
        "strategy": "2",
        "address": "Avenida Jose Solis Ruiz 35 ",
        "postalCode": "14940",
        "city": "1114013",
        "province": "14",
        "CCAA": "51",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "32.97",
        "surfaceBasement1": "32.97",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "32.97",
        "surfaceTotal": "32.97",
        "timeAvailableFrom": "9/13/22 14:50",
        "lat": 37.4729709,
        "lng": -4.4440773,
        "id_ext": "4205-118877-120458"
    },
    {
        "id": "0680e90a-5633-ed11-9db1-0022489c4873",
        "active": false,
        "status": "Vendido",
        "strategy": "1",
        "askingPriceRent": "1554.00",
        "askingPriceSale": "238280.00",
        "address": "Avenida De Andalucia 41 ",
        "postalCode": "11007",
        "city": "1111012",
        "province": "11",
        "CCAA": "51",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "179.65",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "179.65",
        "surfaceTotal": "179.65",
        "timeAvailableFrom": "9/13/22 13:23",
        "lat": 36.5210142,
        "lng": -6.2804565,
        "id_ext": "4205-118879-118879"
    },
    {
        "id": "0880e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "2",
        "askingPriceRent": "1612.80",
        "askingPriceSale": "241920.00",
        "address": "Plaza Juez Borrull 27 ",
        "postalCode": "12003",
        "city": "1112040",
        "province": "12",
        "CCAA": "42",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "202.50",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "202.50",
        "surfaceTotal": "202.50",
        "timeAvailableFrom": "9/13/22 13:23",
        "lat": 39.9838959,
        "lng": -0.0358799,
        "id_ext": "4205-118893-118893"
    },
    {
        "id": "0a80e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "1",
        "askingPriceRent": "924.00",
        "askingPriceSale": "134400.00",
        "address": "Avenida Cantabria 23 ",
        "postalCode": "39400",
        "city": "1139025",
        "province": "39",
        "CCAA": "30",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "140.20",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "140.20",
        "surfaceTotal": "140.20",
        "timeAvailableFrom": "9/13/22 13:23",
        "lat": 43.2607047,
        "lng": -4.0691508,
        "id_ext": "4205-118901-118901"
    },
    {
        "id": "0c80e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "2",
        "askingPriceRent": "2245.60",
        "askingPriceSale": "308770.00",
        "address": "Calle Julian Ribera 15 ",
        "postalCode": "46740",
        "city": "1146083",
        "province": "46",
        "CCAA": "42",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "410.55",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "410.55",
        "surfaceTotal": "410.55",
        "timeAvailableFrom": "9/13/22 13:23",
        "lat": 39.1215293,
        "lng": -0.4502517,
        "id_ext": "4205-118919-118919"
    },
    {
        "id": "0e80e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "1",
        "askingPriceRent": "744.80",
        "askingPriceSale": "98000.00",
        "address": " Doctor Ferran 1 ",
        "postalCode": "08440",
        "city": "1108046",
        "province": "08",
        "CCAA": "55",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "112.23",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "112.23",
        "surfaceTotal": "112.23",
        "timeAvailableFrom": "9/13/22 13:23",
        "lat": 41.6385414,
        "lng": 2.3550459,
        "id_ext": "4205-118923-118923"
    },
    {
        "id": "1080e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "2",
        "askingPriceRent": "1974.00",
        "askingPriceSale": "263200.00",
        "address": "Calle Ronda Ramon Otero Pedrayo 5 ",
        "postalCode": "08860",
        "city": "1108056",
        "province": "08",
        "CCAA": "55",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "247.66",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "247.66",
        "surfaceTotal": "247.66",
        "timeAvailableFrom": "9/13/22 13:23",
        "lat": 41.2866384,
        "lng": 1.9864324,
        "id_ext": "4205-118928-118928"
    },
    {
        "id": "1280e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "2",
        "askingPriceRent": "992.25",
        "askingPriceSale": "132300.00",
        "address": "Avenida Castelao 17 ",
        "postalCode": "15350",
        "city": "1115022",
        "province": "15",
        "CCAA": "60",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "178.93",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "178.93",
        "surfaceTotal": "178.93",
        "timeAvailableFrom": "9/13/22 13:23",
        "lat": 43.65959489999999,
        "lng": -8.0522719,
        "id_ext": "4205-118937-118937"
    },
    {
        "id": "1480e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "1",
        "askingPriceRent": "1567.97",
        "askingPriceSale": "250474.00",
        "address": "Calle Monturiol 17 ",
        "postalCode": "43820",
        "city": "1143037",
        "province": "43",
        "CCAA": "55",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "178.91",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "178.91",
        "surfaceTotal": "178.91",
        "timeAvailableFrom": "9/13/22 13:23",
        "lat": 41.1881735,
        "lng": 1.5731292,
        "id_ext": "4205-118943-118943"
    },
    {
        "id": "1680e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "2",
        "askingPriceRent": "693.00",
        "askingPriceSale": "77000.00",
        "address": " Reconquista 10 ",
        "postalCode": "33320",
        "city": "1133019",
        "province": "33",
        "CCAA": "31",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "83.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "83.00",
        "surfaceTotal": "83.00",
        "timeAvailableFrom": "9/13/22 13:23",
        "lat": 43.4846183,
        "lng": -5.2722394,
        "id_ext": "4205-118944-118944"
    },
    {
        "id": "1880e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Arrendado (propiedad)",
        "strategy": "2",
        "askingPriceRent": "3094.00",
        "askingPriceSale": "452200.00",
        "address": "Calle Helsinki- Costa Adeje SN ",
        "postalCode": "38670",
        "city": "1138001",
        "province": "38",
        "CCAA": "56",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "169.58",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "169.58",
        "surfaceTotal": "169.58",
        "timeAvailableFrom": "9/13/22 13:23",
        "lat": 28.0919129,
        "lng": -16.7300036,
        "id_ext": "4205-118958-118958"
    },
    {
        "id": "1a80e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "2",
        "askingPriceRent": "1540.00",
        "askingPriceSale": "224000.00",
        "address": "Calle Martires 20 ",
        "postalCode": "26500",
        "city": "1126036",
        "province": "26",
        "CCAA": "20",
        "country": "ES",
        "use": "5",
        "surfacebr": "149.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "149.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "193.70",
        "surfaceTotal": "298.00",
        "timeAvailableFrom": "9/13/22 13:23",
        "lat": 42.3030481,
        "lng": -1.963867,
        "id_ext": "4205-118960-118960"
    },
    {
        "id": "1c80e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "2",
        "askingPriceRent": "1097.46",
        "askingPriceSale": "154770.00",
        "address": "Calle Castillo 27 ",
        "postalCode": "13610",
        "city": "1113028",
        "province": "13",
        "CCAA": "40",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "178.72",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "178.72",
        "surfaceTotal": "178.72",
        "timeAvailableFrom": "9/13/22 13:23",
        "lat": 39.4039641,
        "lng": -3.1229465,
        "id_ext": "4205-118978-118978"
    },
    {
        "id": "1e80e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Arrendado (propiedad)",
        "strategy": "2",
        "askingPriceRent": "2076.90",
        "askingPriceSale": "276920.00",
        "address": "Avenida Costa Del Sol 1 ",
        "postalCode": "18690",
        "city": "1118017",
        "province": "18",
        "CCAA": "51",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "311.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "311.00",
        "surfaceTotal": "311.00",
        "timeAvailableFrom": "9/13/22 13:23",
        "lat": 36.7354223,
        "lng": -3.6913925,
        "id_ext": "4205-118980-118980"
    },
    {
        "id": "2080e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "2",
        "askingPriceRent": "717.50",
        "askingPriceSale": "100450.00",
        "address": "Avenida De Las Negras 93 ",
        "postalCode": "04110",
        "city": "1104105",
        "province": "04",
        "CCAA": "51",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "205.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "205.00",
        "surfaceTotal": "205.00",
        "timeAvailableFrom": "9/13/22 13:23",
        "lat": 36.9387165,
        "lng": -2.1353682,
        "id_ext": "4205-118987-118987"
    },
    {
        "id": "2480e90a-5633-ed11-9db1-0022489c4873",
        "active": false,
        "status": "Vendido",
        "strategy": "1",
        "askingPriceRent": "798.70",
        "askingPriceSale": "114100.00",
        "address": "Calle Major 10 ",
        "postalCode": "17244",
        "city": "1117044",
        "province": "17",
        "CCAA": "55",
        "country": "ES",
        "use": "5",
        "surfacebr": "70.50",
        "surfaceMezzanine": "0.00",
        "surfacepb": "134.80",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "70.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "190.95",
        "surfaceTotal": "275.30",
        "timeAvailableFrom": "9/13/22 13:23",
        "lat": 41.8882393,
        "lng": 2.8754029,
        "id_ext": "4205-119000-119000"
    },
    {
        "id": "2680e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "2",
        "askingPriceRent": "1982.40",
        "askingPriceSale": "231280.00",
        "address": "Calle Corredera 55 ",
        "postalCode": "11630",
        "city": "1111006",
        "province": "11",
        "CCAA": "51",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "227.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "227.00",
        "surfaceTotal": "227.00",
        "timeAvailableFrom": "9/13/22 13:23",
        "lat": 36.7501988,
        "lng": -5.8106841,
        "id_ext": "4205-119002-119002"
    },
    {
        "id": "2880e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "1",
        "askingPriceRent": "1486.80",
        "askingPriceSale": "220990.00",
        "address": "Avenida Reyes Catolicos 18 ",
        "postalCode": "16003",
        "city": "1116078",
        "province": "16",
        "CCAA": "40",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "176.93",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "176.93",
        "surfaceTotal": "176.93",
        "timeAvailableFrom": "9/13/22 13:23",
        "lat": 40.0638575,
        "lng": -2.1391817,
        "id_ext": "4205-119008-119008"
    },
    {
        "id": "2a80e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "2",
        "askingPriceRent": "1071.00",
        "askingPriceSale": "142800.00",
        "address": "Avenida San Pablo 26 ",
        "postalCode": "28823",
        "city": "1128049",
        "province": "28",
        "CCAA": "54",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "157.28",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "157.28",
        "surfaceTotal": "157.28",
        "timeAvailableFrom": "9/13/22 13:23",
        "lat": 40.436076,
        "lng": -3.5331259,
        "id_ext": "4205-119019-119019"
    },
    {
        "id": "2c80e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "2",
        "askingPriceRent": "1680.00",
        "askingPriceSale": "268800.00",
        "address": "Carretera Malaga A Almeria, Termino De Enix ",
        "postalCode": "04720",
        "city": "1104720",
        "province": "04",
        "CCAA": "51",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "192.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "192.00",
        "surfaceTotal": "192.00",
        "timeAvailableFrom": "9/13/22 13:23",
        "lat": 36.721261,
        "lng": -4.4212655,
        "id_ext": "4205-119036-119036"
    },
    {
        "id": "2e80e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "2",
        "askingPriceRent": "2688.00",
        "askingPriceSale": "402780.00",
        "address": " Familia Betancourt y Molina ",
        "postalCode": "38400",
        "city": "1138028",
        "province": "38",
        "CCAA": "56",
        "country": "ES",
        "use": "5",
        "surfacebr": "65.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "127.40",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "146.90",
        "surfaceTotal": "192.40",
        "timeAvailableFrom": "9/13/22 13:23",
        "lat": 28.4166181,
        "lng": -16.5443586,
        "id_ext": "4205-119038-119038"
    },
    {
        "id": "3080e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "2",
        "askingPriceRent": "908.25",
        "askingPriceSale": "115045.00",
        "address": "Calle Corredera 11 ",
        "postalCode": "41600",
        "city": "1141011",
        "province": "41",
        "CCAA": "51",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "160.14",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "160.14",
        "surfaceTotal": "160.14",
        "timeAvailableFrom": "9/13/22 13:23",
        "lat": 37.2618651,
        "lng": -5.54582,
        "id_ext": "4205-119051-119051"
    },
    {
        "id": "3280e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "2",
        "askingPriceRent": "2604.00",
        "askingPriceSale": "403200.00",
        "address": "Avenida Zumalacarregui 9 ",
        "postalCode": "20008",
        "city": "1120069",
        "province": "20",
        "CCAA": "53",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "26.00",
        "surfacepb": "144.71",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "26.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "157.71",
        "surfaceTotal": "170.71",
        "timeAvailableFrom": "9/13/22 13:23",
        "lat": 43.3146254,
        "lng": -2.0021516,
        "id_ext": "4205-119057-119057"
    },
    {
        "id": "3480e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Arrendado (propiedad)",
        "strategy": "1",
        "askingPriceRent": "672.59",
        "askingPriceSale": "89678.40",
        "address": "Calle Ilicitano Ausente 19 ",
        "postalCode": "03202",
        "city": "1103065",
        "province": "03",
        "CCAA": "42",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "128.11",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "128.11",
        "surfaceTotal": "128.11",
        "timeAvailableFrom": "9/13/22 13:23",
        "lat": 38.2772175,
        "lng": -0.6783769,
        "id_ext": "4205-119063-119063"
    },
    {
        "id": "3680e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "1",
        "askingPriceRent": "692.58",
        "askingPriceSale": "92344.00",
        "address": "Calle Olegario Domarco Seller 73 ",
        "postalCode": "03206",
        "city": "1103065",
        "province": "03",
        "CCAA": "42",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "164.90",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "164.90",
        "surfaceTotal": "164.90",
        "timeAvailableFrom": "9/13/22 13:23",
        "lat": 38.2719344,
        "lng": -0.707575,
        "id_ext": "4205-119064-119064"
    },
    {
        "id": "3880e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "1",
        "askingPriceRent": "1587.60",
        "askingPriceSale": "212912.00",
        "address": "Calle Dahellos 9 ",
        "postalCode": "03600",
        "city": "1103066",
        "province": "03",
        "CCAA": "42",
        "country": "ES",
        "use": "5",
        "surfacebr": "303.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "267.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "357.90",
        "surfaceTotal": "570.00",
        "timeAvailableFrom": "9/13/22 13:23",
        "lat": 38.4766925,
        "lng": -0.7939583,
        "id_ext": "4205-119077-119077"
    },
    {
        "id": "3a80e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "1",
        "askingPriceRent": "806.17",
        "askingPriceSale": "136794.00",
        "address": "Calle Trencall 38 ",
        "postalCode": "46540",
        "city": "1146204",
        "province": "46",
        "CCAA": "42",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "130.28",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "130.28",
        "surfaceTotal": "130.28",
        "timeAvailableFrom": "9/13/22 13:23",
        "lat": 39.5878854,
        "lng": -0.3046649,
        "id_ext": "4205-119085-119085"
    },
    {
        "id": "3c80e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "2",
        "askingPriceRent": "607.32",
        "askingPriceSale": "84350.00",
        "address": "Paseo de Andalucia 41 ",
        "postalCode": "14830",
        "city": "1114025",
        "province": "14",
        "CCAA": "51",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "226.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "226.00",
        "surfaceTotal": "226.00",
        "timeAvailableFrom": "9/13/22 13:23",
        "lat": 37.6789584,
        "lng": -4.5539203,
        "id_ext": "4205-119086-119086"
    },
    {
        "id": "3e80e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "2",
        "askingPriceRent": "885.50",
        "askingPriceSale": "112700.00",
        "address": "Calle Castelao 2 ",
        "postalCode": "29004",
        "city": "1129067",
        "province": "29",
        "CCAA": "51",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "172.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "172.00",
        "surfaceTotal": "172.00",
        "timeAvailableFrom": "9/13/22 13:23",
        "lat": 36.6920365,
        "lng": -4.4858562,
        "id_ext": "4205-119091-119091"
    },
    {
        "id": "4080e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "1",
        "askingPriceRent": "1234.24",
        "askingPriceSale": "152306.00",
        "address": "Calle Marques De Valdespina 14 ",
        "postalCode": "48260",
        "city": "1148034",
        "province": "48",
        "CCAA": "53",
        "country": "ES",
        "use": "5",
        "surfacebr": "116.74",
        "surfaceMezzanine": "0.00",
        "surfacepb": "116.74",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "151.76",
        "surfaceTotal": "233.48",
        "timeAvailableFrom": "9/13/22 13:23",
        "lat": 43.1863973,
        "lng": -2.5040119,
        "id_ext": "4205-119093-119093"
    },
    {
        "id": "4280e90a-5633-ed11-9db1-0022489c4873",
        "active": false,
        "status": "Vendido",
        "strategy": "2",
        "askingPriceRent": "3018.40",
        "askingPriceSale": "473378.30",
        "address": "Calle Baja Navarra 1 ",
        "postalCode": "31200",
        "city": "1131097",
        "province": "31",
        "CCAA": "11",
        "country": "ES",
        "use": "5",
        "surfacebr": "121.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "187.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "223.30",
        "surfaceTotal": "308.00",
        "timeAvailableFrom": "9/13/22 13:23",
        "lat": 42.67177239999999,
        "lng": -2.0319014,
        "id_ext": "4205-119097-119097"
    },
    {
        "id": "4480e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "2",
        "askingPriceRent": "1940.40",
        "askingPriceSale": "344960.00",
        "address": "Calle Cruz De Luisa 11 ",
        "postalCode": "28945",
        "city": "1128058",
        "province": "28",
        "CCAA": "54",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "290.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "290.00",
        "surfaceTotal": "290.00",
        "timeAvailableFrom": "9/13/22 13:23",
        "lat": 40.2836417,
        "lng": -3.7966588,
        "id_ext": "4205-119112-119112"
    },
    {
        "id": "4680e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "2",
        "askingPriceRent": "1270.22",
        "askingPriceSale": "200872.00",
        "address": "Avenida de Capuchinos 68 ",
        "postalCode": "29014",
        "city": "1129067",
        "province": "29",
        "CCAA": "51",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "176.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "176.00",
        "surfaceTotal": "176.00",
        "timeAvailableFrom": "9/13/22 13:23",
        "lat": 36.7286259,
        "lng": -4.4212475,
        "id_ext": "4205-119113-119113"
    },
    {
        "id": "4880e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Arrendado (propiedad)",
        "strategy": "2",
        "askingPriceRent": "1050.00",
        "askingPriceSale": "126000.00",
        "address": "Avenida Marques De Figueroa 4 ",
        "postalCode": "15500",
        "city": "1115035",
        "province": "15",
        "CCAA": "60",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "149.97",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "149.97",
        "surfaceTotal": "149.97",
        "agent": "Sara Carracedo Culebras",
        "timeAvailableFrom": "9/13/22 13:23",
        "lat": 43.47492,
        "lng": -8.167449999999999,
        "id_ext": "4205-119116-119116"
    },
    {
        "id": "4a80e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "2",
        "askingPriceRent": "4405.59",
        "askingPriceSale": "656194.00",
        "address": "Calle Rutlla 19 ",
        "postalCode": "17600",
        "city": "1117066",
        "province": "17",
        "CCAA": "55",
        "country": "ES",
        "use": "5",
        "surfacebr": "248.80",
        "surfaceMezzanine": "0.00",
        "surfacepb": "223.00",
        "surfaceBasement1": "104.90",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "104.90",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "248.80",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "350.09",
        "surfaceTotal": "576.70",
        "timeAvailableFrom": "9/13/22 13:23",
        "lat": 42.26639,
        "lng": 2.96416,
        "id_ext": "4205-119119-119119"
    },
    {
        "id": "4c80e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "2",
        "askingPriceRent": "1365.00",
        "askingPriceSale": "273000.00",
        "address": " Plaza 11 ",
        "postalCode": "07200",
        "city": "1107022",
        "province": "07",
        "CCAA": "44",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "156.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "156.00",
        "surfaceTotal": "156.00",
        "timeAvailableFrom": "9/13/22 13:23",
        "lat": 39.4696851,
        "lng": 3.148297,
        "id_ext": "4205-119122-119122"
    },
    {
        "id": "4e80e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "2",
        "askingPriceRent": "10934.00",
        "askingPriceSale": "875770.00",
        "address": "Calle Rubalcava 12 ",
        "postalCode": "15402",
        "city": "1115036",
        "province": "15",
        "CCAA": "60",
        "country": "ES",
        "use": "5",
        "surfacebr": "205.76",
        "surfaceMezzanine": "0.00",
        "surfacepb": "193.00",
        "surfaceBasement1": "194.77",
        "surfaceBasement2": "176.69",
        "surfaceRest": "128.70",
        "surfacesr": "500.16",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "504.81",
        "surfaceTotal": "898.92",
        "timeAvailableFrom": "9/13/22 13:23",
        "lat": 43.4841868,
        "lng": -8.231914999999999,
        "id_ext": "4205-119134-119134"
    },
    {
        "id": "5080e90a-5633-ed11-9db1-0022489c4873",
        "active": false,
        "status": "Vendido",
        "strategy": "2",
        "address": "Calle Comunidad De Madrid 2 ",
        "postalCode": "28597",
        "city": "1128060",
        "province": "28",
        "CCAA": "54",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfacepb": "110.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "110.00",
        "surfaceTotal": "110.00",
        "timeAvailableFrom": "9/13/22 13:23",
        "lat": 40.1185587,
        "lng": -3.1590147,
        "id_ext": "4205-119141-119141"
    },
    {
        "id": "5280e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Arrendado (propiedad)",
        "strategy": "1",
        "askingPriceRent": "999.60",
        "askingPriceSale": "152880.00",
        "address": "Paseo Germanias 83 ",
        "postalCode": "46702",
        "city": "1146131",
        "province": "46",
        "CCAA": "42",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "151.30",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "151.30",
        "surfaceTotal": "151.30",
        "timeAvailableFrom": "9/13/22 13:23",
        "lat": 38.9643757,
        "lng": -0.1778892,
        "id_ext": "4205-119166-119166"
    },
    {
        "id": "5480e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "1",
        "askingPriceRent": "656.60",
        "askingPriceSale": "93800.00",
        "address": "Calle Mayor 26 ",
        "postalCode": "03140",
        "city": "1103076",
        "province": "03",
        "CCAA": "42",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "134.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "134.00",
        "surfaceTotal": "134.00",
        "timeAvailableFrom": "9/13/22 13:23",
        "lat": 38.0917086,
        "lng": -0.6548951,
        "id_ext": "4205-119174-119174"
    },
    {
        "id": "5680e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "2",
        "askingPriceRent": "720.72",
        "askingPriceSale": "85176.00",
        "address": "Plaza Mayor 56 ",
        "postalCode": "46610",
        "city": "1146139",
        "province": "46",
        "CCAA": "42",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "140.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "140.00",
        "surfaceTotal": "140.00",
        "timeAvailableFrom": "9/13/22 13:23",
        "lat": 39.1859001,
        "lng": -0.4773694,
        "id_ext": "4205-119175-119175"
    },
    {
        "id": "5880e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "2",
        "askingPriceRent": "8752.80",
        "askingPriceSale": "1750000.29",
        "address": "Plaza Porxada 30 ",
        "postalCode": "08400",
        "city": "1108096",
        "province": "08",
        "CCAA": "55",
        "country": "ES",
        "use": "5",
        "surfacebr": "302.68",
        "surfaceMezzanine": "0.00",
        "surfacepb": "381.73",
        "surfaceBasement1": "217.73",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "217.73",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "302.68",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "581.40",
        "surfaceTotal": "902.14",
        "timeAvailableFrom": "9/13/22 13:23",
        "lat": 41.6078513,
        "lng": 2.287441,
        "id_ext": "4205-119178-119178"
    },
    {
        "id": "5a80e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "2",
        "askingPriceRent": "2584.05",
        "askingPriceSale": "381990.00",
        "address": "Calle Heroe De Sostoa 148 ",
        "postalCode": "29003",
        "city": "1129067",
        "province": "29",
        "CCAA": "51",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "313.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "313.00",
        "surfaceTotal": "313.00",
        "timeAvailableFrom": "9/13/22 13:23",
        "lat": 36.7035242,
        "lng": -4.4411739,
        "id_ext": "4205-119180-119180"
    },
    {
        "id": "5c80e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "2",
        "askingPriceRent": "1871.80",
        "askingPriceSale": "267400.00",
        "address": "Avenida De La Costa 147 ",
        "postalCode": "33203",
        "city": "1133024",
        "province": "33",
        "CCAA": "31",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "261.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "261.00",
        "surfaceTotal": "261.00",
        "timeAvailableFrom": "9/13/22 13:23",
        "lat": 43.5356124,
        "lng": -5.6468206,
        "id_ext": "4205-119188-119188"
    },
    {
        "id": "5e80e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "2",
        "askingPriceSale": "329280.00",
        "address": "Calle Torre Comares S/N ",
        "postalCode": "18008",
        "city": "1118087",
        "province": "18",
        "CCAA": "51",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "336.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "336.00",
        "surfaceTotal": "336.00",
        "timeAvailableFrom": "9/13/22 13:23",
        "lat": 37.1518768,
        "lng": -3.5946089,
        "id_ext": "4205-119217-119217"
    },
    {
        "id": "6080e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "CAMBIO DE USO",
        "askingPriceRent": "1380.12",
        "askingPriceSale": "211470.00",
        "address": "Avenida De España 37 ",
        "postalCode": "28903",
        "city": "1128065",
        "province": "28",
        "CCAA": "54",
        "country": "ES",
        "use": "5",
        "surfacebr": "203.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "159.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "219.90",
        "surfaceTotal": "362.00",
        "timeAvailableFrom": "9/13/22 13:23",
        "lat": 40.3140585,
        "lng": -3.7205825,
        "id_ext": "4205-119219-119219"
    },
    {
        "id": "6280e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "2",
        "askingPriceRent": "1413.24",
        "askingPriceSale": "232769.60",
        "address": "Calle Pablo Picasso 11 ",
        "postalCode": "48300",
        "city": "1148046",
        "province": "48",
        "CCAA": "53",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "118.76",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "118.76",
        "surfaceTotal": "118.76",
        "timeAvailableFrom": "9/13/22 13:23",
        "lat": 43.3138278,
        "lng": -2.6772866,
        "id_ext": "4205-119237-119237"
    },
    {
        "id": "6480e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "1",
        "askingPriceRent": "847.00",
        "askingPriceSale": "135520.00",
        "address": "Calle Arrabal 4 ",
        "postalCode": "26200",
        "city": "1126071",
        "province": "26",
        "CCAA": "20",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "120.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "120.00",
        "surfaceTotal": "120.00",
        "timeAvailableFrom": "9/13/22 13:23",
        "lat": 42.576847,
        "lng": -2.8473669,
        "id_ext": "4205-119242-119242"
    },
    {
        "id": "6680e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Arrendado (propiedad)",
        "strategy": "2",
        "askingPriceRent": "2240.00",
        "askingPriceSale": "403200.00",
        "address": "Calle Pedraforca 77 ",
        "postalCode": "08905",
        "city": "1108101",
        "province": "08",
        "CCAA": "55",
        "country": "ES",
        "use": "5",
        "surfacebr": "107.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "347.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "107.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "379.10",
        "surfaceTotal": "454.00",
        "timeAvailableFrom": "9/13/22 13:23",
        "lat": 41.3721711,
        "lng": 2.1095966,
        "id_ext": "4205-119247-119247"
    },
    {
        "id": "6880e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "2",
        "address": " Los Olivos 29 ",
        "postalCode": "22005",
        "city": "1122125",
        "province": "22",
        "CCAA": "10",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "231.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "231.00",
        "surfaceTotal": "231.00",
        "timeAvailableFrom": "9/13/22 13:23",
        "lat": 42.1344258,
        "lng": -0.4048303,
        "id_ext": "4205-119260-119260"
    },
    {
        "id": "6a80e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "2",
        "askingPriceRent": "1291.50",
        "askingPriceSale": "200900.00",
        "address": "Paseo Independencia 53 ",
        "postalCode": "21002",
        "city": "1121041",
        "province": "21",
        "CCAA": "51",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "206.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "206.00",
        "surfaceTotal": "206.00",
        "timeAvailableFrom": "9/13/22 13:23",
        "lat": 37.2636286,
        "lng": -6.9528918,
        "id_ext": "4205-119261-119261"
    },
    {
        "id": "6c80e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "2",
        "askingPriceRent": "4209.62",
        "askingPriceSale": "693350.00",
        "address": "Paseo De Colon 27 ",
        "postalCode": "20302",
        "city": "1120045",
        "province": "20",
        "CCAA": "53",
        "country": "ES",
        "use": "5",
        "surfacebr": "197.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "156.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "215.10",
        "surfaceTotal": "353.00",
        "timeAvailableFrom": "9/13/22 13:23",
        "lat": 43.339932,
        "lng": -1.7943873,
        "id_ext": "4205-119275-119275"
    },
    {
        "id": "6e80e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "2",
        "askingPriceRent": "1716.18",
        "askingPriceSale": "208392.80",
        "address": "Plaza Cortes De Aragon 6 ",
        "postalCode": "22700",
        "city": "1122130",
        "province": "22",
        "CCAA": "10",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "49.22",
        "surfacepb": "133.15",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "49.22",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "157.76",
        "surfaceTotal": "182.37",
        "timeAvailableFrom": "9/13/22 13:23",
        "lat": 42.56924739999999,
        "lng": -0.551055,
        "id_ext": "4205-119276-119276"
    },
    {
        "id": "7080e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "1",
        "askingPriceRent": "1192.10",
        "askingPriceSale": "201740.00",
        "address": "Calle Paraiso Nº 4. Edificio Jerez 74 ",
        "postalCode": "11405",
        "city": "1111020",
        "province": "11",
        "CCAA": "51",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "140.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "140.00",
        "surfaceTotal": "140.00",
        "timeAvailableFrom": "9/13/22 13:23",
        "lat": 36.6941748,
        "lng": -6.1286209,
        "id_ext": "4205-119293-119293"
    },
    {
        "id": "7280e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "2",
        "address": "Plaza Joaquina De Orea 2 ",
        "city": "1128035",
        "province": "28",
        "CCAA": "54",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "50.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "60.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "80.00",
        "surfaceTotal": "110.00",
        "timeAvailableFrom": "9/13/22 13:23",
        "lat": 40.2567602,
        "lng": -3.2376423,
        "id_ext": "4205-119297-119297"
    },
    {
        "id": "7480e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "2",
        "askingPriceRent": "1675.80",
        "askingPriceSale": "274624.88",
        "address": "Calle Alcalde Perez Arda 26 ",
        "postalCode": "15008",
        "city": "1115030",
        "province": "15",
        "CCAA": "60",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "138.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "138.00",
        "surfaceTotal": "138.00",
        "timeAvailableFrom": "9/13/22 13:23",
        "lat": 43.3506896,
        "lng": -8.4044296,
        "id_ext": "4205-119306-119306"
    },
    {
        "id": "7680e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "2",
        "askingPriceRent": "4198.95",
        "askingPriceSale": "671832.00",
        "address": "Cuesta La Palloza 1 ",
        "postalCode": "15006",
        "city": "1115030",
        "province": "15",
        "CCAA": "60",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "304.78",
        "surfaceBasement1": "101.70",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "101.70",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "355.63",
        "surfaceTotal": "406.48",
        "timeAvailableFrom": "9/13/22 13:23",
        "lat": 43.35848310000001,
        "lng": -8.403279,
        "id_ext": "4205-119312-119312"
    },
    {
        "id": "7880e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Arrendado (propiedad)",
        "strategy": "2",
        "askingPriceRent": "2079.00",
        "askingPriceSale": "399486.40",
        "address": "Avenida General Sanjurjo 121 ",
        "postalCode": "15006",
        "city": "1115030",
        "province": "15",
        "CCAA": "60",
        "country": "ES",
        "use": "11",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "198.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "198.00",
        "surfaceTotal": "198.00",
        "timeAvailableFrom": "9/13/22 13:23",
        "lat": 43.3541384,
        "lng": -8.3966005,
        "id_ext": "4205-119317-119317"
    },
    {
        "id": "7a80e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Arrendado (propiedad)",
        "strategy": "2",
        "askingPriceSale": "90860.00",
        "address": "Calle Vizcaya 1 ",
        "postalCode": "15007",
        "city": "1115030",
        "province": "15",
        "CCAA": "60",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "101.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "101.00",
        "surfaceTotal": "101.00",
        "timeAvailableFrom": "9/13/22 13:23",
        "lat": 43.3563558,
        "lng": -8.407949799999999,
        "id_ext": "4205-119319-119319"
    },
    {
        "id": "7c80e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Arrendado (propiedad)",
        "strategy": "2",
        "askingPriceRent": "739.20",
        "askingPriceSale": "97440.00",
        "address": "Calle Antonio Muñoz Zamora 2 ",
        "postalCode": "04007",
        "city": "1104013",
        "province": "04",
        "CCAA": "51",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "94.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "94.00",
        "surfaceTotal": "94.00",
        "timeAvailableFrom": "9/13/22 13:23",
        "lat": 36.8318033,
        "lng": -2.4433269,
        "id_ext": "4205-119332-119332"
    },
    {
        "id": "7e80e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "1",
        "askingPriceRent": "1001.00",
        "askingPriceSale": "160160.00",
        "address": "Avenida De Los Reyes Leoneses 12 ",
        "postalCode": "24008",
        "city": "1124089",
        "province": "24",
        "CCAA": "59",
        "country": "ES",
        "use": "5",
        "surfacebr": "69.79",
        "surfaceMezzanine": "0.00",
        "surfacepb": "135.88",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "156.82",
        "surfaceTotal": "205.67",
        "timeAvailableFrom": "9/13/22 13:23",
        "lat": 42.6041044,
        "lng": -5.579738,
        "id_ext": "4205-119343-119343"
    },
    {
        "id": "8080e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "CAMBIO DE USO",
        "askingPriceRent": "1209.85",
        "askingPriceSale": "201642.00",
        "address": "Calle El Sabinar 6 ",
        "postalCode": "24007",
        "city": "1124089",
        "province": "24",
        "CCAA": "59",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "288.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "288.00",
        "surfaceTotal": "288.00",
        "timeAvailableFrom": "9/13/22 13:23",
        "lat": 42.6041463,
        "lng": -5.5616049,
        "id_ext": "4205-119344-119344"
    },
    {
        "id": "8280e90a-5633-ed11-9db1-0022489c4873",
        "active": false,
        "status": "Vendido",
        "strategy": "1",
        "askingPriceRent": "967.68",
        "askingPriceSale": "135475.20",
        "address": "Calle General Gutierrez Mellado 28 ",
        "postalCode": "24010",
        "city": "1124089",
        "province": "24",
        "CCAA": "59",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "138.24",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "138.24",
        "surfaceTotal": "138.24",
        "timeAvailableFrom": "9/13/22 13:23",
        "lat": 42.6099784,
        "lng": -5.5931076,
        "id_ext": "4205-119345-119345"
    },
    {
        "id": "8480e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "1",
        "askingPriceRent": "1743.00",
        "askingPriceSale": "255640.00",
        "address": "Calle Velazquez 18 ",
        "postalCode": "24005",
        "city": "1124089",
        "province": "24",
        "CCAA": "59",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "166.40",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "166.40",
        "surfaceTotal": "166.40",
        "timeAvailableFrom": "9/13/22 13:23",
        "lat": 42.59016039999999,
        "lng": -5.5675783,
        "id_ext": "4205-119351-119351"
    },
    {
        "id": "8680e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Arrendado (propiedad)",
        "strategy": "2",
        "askingPriceRent": "1310.40",
        "askingPriceSale": "262080.00",
        "address": "Calle Lardero 18 ",
        "postalCode": "26002",
        "city": "1126089",
        "province": "26",
        "CCAA": "20",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "144.78",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "144.78",
        "surfaceTotal": "144.78",
        "timeAvailableFrom": "9/13/22 13:23",
        "lat": 42.4622964,
        "lng": -2.4518195,
        "id_ext": "4205-119366-119366"
    },
    {
        "id": "8880e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "2",
        "askingPriceRent": "2394.00",
        "askingPriceSale": "399000.00",
        "address": "Calle Corredera De San Marcos 45 ",
        "postalCode": "23700",
        "city": "1123055",
        "province": "23",
        "CCAA": "51",
        "country": "ES",
        "use": "5",
        "surfacebr": "135.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "341.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "381.50",
        "surfaceTotal": "476.00",
        "timeAvailableFrom": "9/13/22 13:23",
        "lat": 38.0975724,
        "lng": -3.6335559,
        "id_ext": "4205-119373-119373"
    },
    {
        "id": "8a80e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "2",
        "askingPriceRent": "785.51",
        "askingPriceSale": "117826.80",
        "address": "Plaza De La Victoria, 1 ",
        "postalCode": "18300",
        "city": "1118122",
        "province": "18",
        "CCAA": "51",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "280.54",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "280.54",
        "surfaceTotal": "280.54",
        "timeAvailableFrom": "9/13/22 13:23",
        "lat": 37.1671038,
        "lng": -4.1484964,
        "id_ext": "4205-119374-119374"
    },
    {
        "id": "8c80e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "2",
        "address": "Calle Major 1 ",
        "postalCode": "17490",
        "city": "1117092",
        "province": "17",
        "CCAA": "55",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "68.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "68.00",
        "surfaceTotal": "68.00",
        "timeAvailableFrom": "9/13/22 13:23",
        "lat": 42.3624203,
        "lng": 3.1519871,
        "id_ext": "4205-119376-119376"
    },
    {
        "id": "8e80e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "2",
        "askingPriceRent": "5929.00",
        "askingPriceSale": "974050.00",
        "address": "Avenida Francesc Macia 37 ",
        "postalCode": "25007",
        "city": "1125120",
        "province": "25",
        "CCAA": "55",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "313.77",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "283.62",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "455.58",
        "surfaceTotal": "597.39",
        "timeAvailableFrom": "9/13/22 13:23",
        "lat": 41.61674300000001,
        "lng": 0.6288737999999999,
        "id_ext": "4205-119377-119377"
    },
    {
        "id": "9080e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "2",
        "askingPriceRent": "2244.20",
        "askingPriceSale": "304570.00",
        "address": "Calle Roma Barnes 12 ",
        "postalCode": "17310",
        "city": "1117095",
        "province": "17",
        "CCAA": "55",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "229.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "229.00",
        "surfaceTotal": "229.00",
        "timeAvailableFrom": "9/13/22 13:23",
        "lat": 41.6982113,
        "lng": 2.8456495,
        "id_ext": "4205-119385-119385"
    },
    {
        "id": "9280e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Arrendado (propiedad)",
        "strategy": "2",
        "askingPriceRent": "1416.10",
        "askingPriceSale": "254560.50",
        "address": "Calle Martin Iriarte 9 ",
        "postalCode": "28290",
        "city": "1128127",
        "province": "28",
        "CCAA": "54",
        "country": "ES",
        "use": "11",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "122.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "122.00",
        "surfaceTotal": "122.00",
        "timeAvailableFrom": "9/13/22 13:23",
        "lat": 40.5518259,
        "lng": -3.8953353,
        "id_ext": "4205-119387-119387"
    },
    {
        "id": "9480e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "2",
        "askingPriceRent": "1890.00",
        "askingPriceSale": "283500.00",
        "address": "Plaza de Espronceda 8 ",
        "postalCode": "06200",
        "city": "1106011",
        "province": "06",
        "CCAA": "41",
        "country": "ES",
        "use": "5",
        "surfacebr": "138.55",
        "surfaceMezzanine": "0.00",
        "surfacepb": "268.76",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "310.33",
        "surfaceTotal": "407.31",
        "timeAvailableFrom": "9/13/22 13:23",
        "lat": 38.6826885,
        "lng": -6.408834700000001,
        "id_ext": "4205-119391-119391"
    },
    {
        "id": "9680e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "2",
        "askingPriceRent": "1609.78",
        "askingPriceSale": "241466.40",
        "address": "Avenida Juan XXIII 11 ",
        "postalCode": "35004",
        "city": "1135016",
        "province": "35",
        "CCAA": "56",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "161.64",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "161.64",
        "surfaceTotal": "161.64",
        "timeAvailableFrom": "9/13/22 13:23",
        "lat": 28.119035,
        "lng": -15.4260353,
        "id_ext": "4205-119396-119396"
    },
    {
        "id": "9880e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "1",
        "askingPriceRent": "2772.00",
        "askingPriceSale": "262808.00",
        "address": "Avenida Pintor Felo Monzon 27 ",
        "postalCode": "35019",
        "city": "1135016",
        "province": "35",
        "CCAA": "56",
        "country": "ES",
        "use": "5",
        "surfacebr": "86.75",
        "surfaceMezzanine": "0.00",
        "surfacepb": "125.21",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "138.22",
        "surfaceTotal": "211.96",
        "timeAvailableFrom": "9/13/22 13:23",
        "lat": 28.1017253,
        "lng": -15.4529491,
        "id_ext": "4205-119401-119401"
    },
    {
        "id": "9a80e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "2",
        "askingPriceRent": "2030.00",
        "askingPriceSale": "284200.00",
        "address": "Calle Ollerias 49 ",
        "postalCode": "23740",
        "city": "1123005",
        "province": "23",
        "CCAA": "51",
        "country": "ES",
        "use": "5",
        "surfacebr": "42.21",
        "surfaceMezzanine": "0.00",
        "surfacepb": "277.10",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "289.76",
        "surfaceTotal": "319.31",
        "timeAvailableFrom": "9/13/22 13:23",
        "lat": 38.0394192,
        "lng": -4.0546184,
        "id_ext": "4205-119413-119413"
    },
    {
        "id": "9c80e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "1",
        "askingPriceRent": "575.40",
        "askingPriceSale": "89187.00",
        "address": "Calle Real 7 ",
        "postalCode": "23200",
        "city": "1123024",
        "province": "23",
        "CCAA": "51",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "137.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "137.00",
        "surfaceTotal": "137.00",
        "timeAvailableFrom": "9/13/22 13:23",
        "lat": 38.2737155,
        "lng": -3.6153097,
        "id_ext": "4205-119417-119417"
    },
    {
        "id": "9e80e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "2",
        "askingPriceRent": "1092.00",
        "askingPriceSale": "145600.00",
        "address": " La Luz 4 ",
        "postalCode": "30710",
        "city": "1130902",
        "province": "30",
        "CCAA": "43",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "152.38",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "152.38",
        "surfaceTotal": "152.38",
        "timeAvailableFrom": "9/13/22 13:23",
        "lat": 37.7505094,
        "lng": -0.8476651,
        "id_ext": "4205-119418-119418"
    },
    {
        "id": "a080e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "2",
        "askingPriceRent": "1608.60",
        "askingPriceSale": "174265.00",
        "address": "Paseo Del Pilarin 1 ",
        "postalCode": "33700",
        "city": "1133700",
        "province": "33",
        "CCAA": "31",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "191.50",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "191.50",
        "surfaceTotal": "191.50",
        "timeAvailableFrom": "9/13/22 13:23",
        "lat": 43.5442928,
        "lng": -6.5352291,
        "id_ext": "4205-119428-119428"
    },
    {
        "id": "a280e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "2",
        "askingPriceRent": "901.60",
        "askingPriceSale": "130732.00",
        "address": "Calle Colon 2 ",
        "postalCode": "41440",
        "city": "1141055",
        "province": "41",
        "CCAA": "51",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "199.60",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "199.60",
        "surfaceTotal": "199.60",
        "timeAvailableFrom": "9/13/22 13:23",
        "lat": 37.6563259,
        "lng": -5.531469599999999,
        "id_ext": "4205-119437-119437"
    },
    {
        "id": "a480e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Arrendado (propiedad)",
        "strategy": "2",
        "askingPriceRent": "2030.00",
        "askingPriceSale": "253750.00",
        "address": "Avenida Alameda Del Valle 34 ",
        "district": "2807913",
        "postalCode": "28051",
        "city": "1128079",
        "province": "28",
        "CCAA": "54",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "139.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "139.00",
        "surfaceTotal": "139.00",
        "timeAvailableFrom": "9/13/22 13:23",
        "lat": 40.3657348,
        "lng": -3.6204652,
        "id_ext": "4205-119439-119439"
    },
    {
        "id": "a680e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "2",
        "askingPriceRent": "1480.19",
        "askingPriceSale": "222028.80",
        "address": "Calle Alamos 5 ",
        "postalCode": "23680",
        "city": "1123002",
        "province": "23",
        "CCAA": "51",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "264.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "264.00",
        "surfaceTotal": "264.00",
        "timeAvailableFrom": "9/13/22 13:23",
        "lat": 37.4621183,
        "lng": -3.9218527,
        "id_ext": "4205-119446-119446"
    },
    {
        "id": "a880e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - En legal",
        "strategy": "2",
        "askingPriceRent": "3724.00",
        "askingPriceSale": "588000.00",
        "address": " Bravo Murillo 307 ",
        "district": "2807906",
        "postalCode": "28020",
        "city": "1128079",
        "province": "28",
        "CCAA": "54",
        "country": "ES",
        "use": "5",
        "surfacebr": "36.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "194.90",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "136.43",
        "surfaceTotal": "230.90",
        "timeAvailableFrom": "9/13/22 13:23",
        "lat": 40.4627795,
        "lng": -3.697469599999999,
        "id_ext": "4205-119465-119465"
    },
    {
        "id": "aa80e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Arrendado (propiedad)",
        "strategy": "2",
        "askingPriceRent": "6804.00",
        "askingPriceSale": "1134000.00",
        "address": " Bravo Murillo 211 ",
        "district": "2807906",
        "postalCode": "28020",
        "city": "1128079",
        "province": "28",
        "CCAA": "54",
        "country": "ES",
        "use": "5",
        "surfacebr": "164.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "191.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "164.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "240.20",
        "surfaceTotal": "355.00",
        "timeAvailableFrom": "9/13/22 13:23",
        "lat": 40.4558671,
        "lng": -3.7026109,
        "id_ext": "4205-119466-119466"
    },
    {
        "id": "ac80e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "2",
        "askingPriceRent": "22540.00",
        "askingPriceSale": "6223000.00",
        "address": "Avenida De Felipe II 16 ",
        "district": "2807903",
        "postalCode": "28009",
        "city": "1128079",
        "province": "28",
        "CCAA": "54",
        "country": "ES",
        "use": "5",
        "surfacebr": "420.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "344.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "420.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "470.00",
        "surfaceTotal": "764.00",
        "agent": "Vicente Sánchez Molina",
        "timeAvailableFrom": "9/13/22 13:23",
        "lat": 40.4237634,
        "lng": -3.6752812,
        "id_ext": "4205-119506-119506"
    },
    {
        "id": "ae80e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "1",
        "askingPriceRent": "529.20",
        "askingPriceSale": "74970.00",
        "address": "Carretera De Jaen 50 ",
        "postalCode": "02006",
        "city": "1102003",
        "province": "02",
        "CCAA": "40",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "158.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "158.00",
        "surfaceTotal": "158.00",
        "timeAvailableFrom": "9/13/22 13:23",
        "lat": 38.9928158,
        "lng": -1.8750891,
        "id_ext": "4205-119524-119524"
    },
    {
        "id": "b080e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Arrendado (propiedad)",
        "strategy": "2",
        "askingPriceRent": "6339.20",
        "askingPriceSale": "1030120.00",
        "address": "Paseo Del Molino 2 ",
        "postalCode": "28045",
        "city": "1128079",
        "province": "28",
        "CCAA": "54",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "284.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "284.00",
        "surfaceTotal": "284.00",
        "timeAvailableFrom": "9/13/22 13:23",
        "lat": 40.390001,
        "lng": -3.6934969,
        "id_ext": "4205-119532-119532"
    },
    {
        "id": "b280e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Arrendado (propiedad)",
        "strategy": "2",
        "askingPriceRent": "9632.00",
        "askingPriceSale": "2022720.00",
        "address": "Calle Diego De Leon 54 ",
        "postalCode": "28006",
        "city": "1128079",
        "province": "28",
        "CCAA": "54",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "450.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "450.00",
        "surfaceTotal": "450.00",
        "timeAvailableFrom": "9/13/22 13:23",
        "lat": 40.43453290000001,
        "lng": -3.6781147,
        "id_ext": "4205-119536-119536"
    },
    {
        "id": "b480e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Arrendado (propiedad)",
        "strategy": "2",
        "askingPriceRent": "3645.60",
        "askingPriceSale": "668360.00",
        "address": "Calle Emilio Ferrari 24 ",
        "district": "2807920",
        "postalCode": "28017",
        "city": "1128079",
        "province": "28",
        "CCAA": "54",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "37.00",
        "surfacepb": "184.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "37.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "202.50",
        "surfaceTotal": "221.00",
        "timeAvailableFrom": "9/13/22 13:23",
        "lat": 40.4333648,
        "lng": -3.6431764,
        "id_ext": "4205-119538-119538"
    },
    {
        "id": "b680e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "CAMBIO DE USO",
        "askingPriceRent": "1582.00",
        "askingPriceSale": "261030.00",
        "address": "Calle Esteban Mora 43 ",
        "district": "2807915",
        "postalCode": "28027",
        "city": "1128079",
        "province": "28",
        "CCAA": "54",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "113.05",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "113.05",
        "surfaceTotal": "113.05",
        "timeAvailableFrom": "9/13/22 13:23",
        "lat": 40.4389442,
        "lng": -3.6541609,
        "id_ext": "4205-119540-119540"
    },
    {
        "id": "b880e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "2",
        "askingPriceRent": "2793.00",
        "askingPriceSale": "489990.69",
        "address": "Calle Estrella Polar 5 ",
        "postalCode": "28007",
        "city": "1128079",
        "province": "28",
        "CCAA": "54",
        "country": "ES",
        "use": "11",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "130.65",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "130.65",
        "surfaceTotal": "130.65",
        "timeAvailableFrom": "9/13/22 13:23",
        "lat": 40.4107432,
        "lng": -3.6673246,
        "id_ext": "4205-119543-119543"
    },
    {
        "id": "ba80e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "2",
        "askingPriceRent": "1733.13",
        "askingPriceSale": "269598.00",
        "address": "Carretera De Madrid 11 ",
        "postalCode": "02006",
        "city": "1102003",
        "province": "02",
        "CCAA": "40",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "275.10",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "275.10",
        "surfaceTotal": "275.10",
        "timeAvailableFrom": "9/13/22 13:23",
        "lat": 39.0043095,
        "lng": -1.8665999,
        "id_ext": "4205-119546-119546"
    },
    {
        "id": "bc80e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "CAMBIO DE USO",
        "askingPriceRent": "3530.80",
        "askingPriceSale": "651840.00",
        "address": "Calle Eugenio Salazar 20 ",
        "district": "2807905",
        "postalCode": "28002",
        "city": "1128079",
        "province": "28",
        "CCAA": "54",
        "country": "ES",
        "use": "5",
        "smokeStractor": false,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "194.55",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "194.55",
        "surfaceTotal": "194.55",
        "timeAvailableFrom": "9/13/22 13:23",
        "lat": 40.4457201,
        "lng": -3.6740987,
        "id_ext": "4205-119547-119547"
    },
    {
        "id": "be80e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Arrendado (propiedad)",
        "strategy": "2",
        "askingPriceSale": "723996.00",
        "address": " Ps Extremadura 57 ",
        "district": "2807909",
        "postalCode": "28011",
        "city": "1128079",
        "province": "28",
        "CCAA": "54",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "19.43",
        "surfacepb": "212.30",
        "surfaceBasement1": "75.20",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "94.63",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "259.62",
        "surfaceTotal": "306.93",
        "timeAvailableFrom": "9/13/22 13:23",
        "lat": 40.4126097,
        "lng": -3.7308448,
        "id_ext": "4205-119549-119549"
    },
    {
        "id": "c080e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "2",
        "askingPriceRent": "5250.00",
        "askingPriceSale": "945000.00",
        "address": " Francisco Silvela 53 ",
        "district": "2807904",
        "postalCode": "28028",
        "city": "1128079",
        "province": "28",
        "CCAA": "54",
        "country": "ES",
        "use": "5",
        "surfacebr": "167.65",
        "surfaceMezzanine": "0.00",
        "surfacepb": "186.83",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "237.13",
        "surfaceTotal": "354.48",
        "timeAvailableFrom": "9/13/22 13:23",
        "lat": 40.4337254,
        "lng": -3.6739358,
        "id_ext": "4205-119553-119553"
    },
    {
        "id": "c280e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - En legal",
        "strategy": "2",
        "askingPriceRent": "2956.80",
        "askingPriceSale": "564480.00",
        "address": "Calle Galileo 57 ",
        "district": "2807907",
        "postalCode": "28015",
        "city": "1128079",
        "province": "28",
        "CCAA": "54",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "191.14",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "191.14",
        "surfaceTotal": "191.14",
        "timeAvailableFrom": "9/13/22 13:23",
        "lat": 40.4357437,
        "lng": -3.7103929,
        "id_ext": "4205-119558-119558"
    },
    {
        "id": "c480e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "2",
        "askingPriceRent": "1592.50",
        "askingPriceSale": "250250.00",
        "address": "Calle General Ricardos 183 ",
        "district": "2807911",
        "postalCode": "28025",
        "city": "1128079",
        "province": "28",
        "CCAA": "54",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "162.50",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "162.50",
        "surfaceTotal": "162.50",
        "timeAvailableFrom": "9/13/22 13:23",
        "lat": 40.383185,
        "lng": -3.7413564,
        "id_ext": "4205-119565-119565"
    },
    {
        "id": "c680e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "CAMBIO DE USO",
        "askingPriceRent": "2217.60",
        "askingPriceSale": "291060.00",
        "address": "Calle Halcon 2 ",
        "district": "2807911",
        "postalCode": "28025",
        "city": "1128079",
        "province": "28",
        "CCAA": "54",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "198.35",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "198.35",
        "surfaceTotal": "198.35",
        "timeAvailableFrom": "9/13/22 13:23",
        "lat": 40.3896954,
        "lng": -3.7427552,
        "id_ext": "4205-119574-119574"
    },
    {
        "id": "c880e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "2",
        "askingPriceRent": "1540.00",
        "askingPriceSale": "246400.00",
        "address": "Calle Perez Galdos 25 ",
        "postalCode": "02003",
        "city": "1102003",
        "province": "02",
        "CCAA": "40",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "201.32",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "201.32",
        "surfaceTotal": "201.32",
        "timeAvailableFrom": "9/13/22 13:23",
        "lat": 38.9904888,
        "lng": -1.8596976,
        "id_ext": "4205-119579-119579"
    },
    {
        "id": "ca80e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Arrendado (propiedad)",
        "strategy": "2",
        "askingPriceRent": "2344.41",
        "askingPriceSale": "309605.21",
        "address": "Calle Jose Del Hierro 46 ",
        "postalCode": "28027",
        "city": "1128079",
        "province": "28",
        "CCAA": "54",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "177.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "177.00",
        "surfaceTotal": "177.00",
        "timeAvailableFrom": "9/13/22 13:23",
        "lat": 40.4396589,
        "lng": -3.6448993,
        "id_ext": "4205-119584-119584"
    },
    {
        "id": "cc80e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Arrendado (propiedad)",
        "strategy": "2",
        "askingPriceRent": "7000.00",
        "askingPriceSale": "1286562.10",
        "address": "Paseo Almeria 52 ",
        "postalCode": "04001",
        "city": "1104013",
        "province": "04",
        "CCAA": "51",
        "country": "ES",
        "use": "11",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "217.14",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "217.14",
        "surfaceTotal": "217.14",
        "timeAvailableFrom": "9/13/22 13:23",
        "lat": 36.8375162,
        "lng": -2.4633884,
        "id_ext": "4205-119734-119734"
    },
    {
        "id": "ce80e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "2",
        "askingPriceRent": "11165.00",
        "askingPriceSale": "2256659.31",
        "address": "Plaza Magdalena 9 ",
        "postalCode": "41001",
        "city": "1141091",
        "province": "41",
        "CCAA": "51",
        "country": "ES",
        "use": "11",
        "surfacebr": "465.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "365.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "504.50",
        "surfaceTotal": "830.00",
        "timeAvailableFrom": "9/13/22 13:23",
        "lat": 37.3914147,
        "lng": -5.9972014,
        "id_ext": "4205-119737-119737"
    },
    {
        "id": "d480e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Arrendado (propiedad)",
        "strategy": "2",
        "askingPriceRent": "6330.80",
        "askingPriceSale": "1020874.41",
        "address": " Doctor Esquerdo 197 ",
        "postalCode": "28007",
        "city": "1128079",
        "province": "28",
        "CCAA": "54",
        "country": "ES",
        "use": "11",
        "surfacebr": "173.60",
        "surfaceMezzanine": "0.00",
        "surfacepb": "173.60",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "225.68",
        "surfaceTotal": "347.20",
        "timeAvailableFrom": "9/13/22 13:23",
        "lat": 40.402909,
        "lng": -3.6728215,
        "id_ext": "4205-119764-119794"
    },
    {
        "id": "d080e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "1",
        "askingPriceRent": "371.52",
        "askingPriceSale": "54040.00",
        "address": "Calle Cervantes 4 ",
        "postalCode": "41590",
        "city": "1141082",
        "province": "41",
        "CCAA": "51",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "96.50",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "96.50",
        "surfaceTotal": "96.50",
        "timeAvailableFrom": "9/13/22 13:23",
        "lat": 37.1997958,
        "lng": -4.780192599999999,
        "id_ext": "4205-119792-119792"
    },
    {
        "id": "d280e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Arrendado (propiedad)",
        "strategy": "2",
        "askingPriceRent": "1741.32",
        "askingPriceSale": "306162.47",
        "address": "Calle Añastro 9 ",
        "postalCode": "28033",
        "city": "1128079",
        "province": "28",
        "CCAA": "54",
        "country": "ES",
        "use": "11",
        "surfacebr": "26.91",
        "surfaceMezzanine": "0.00",
        "surfacepb": "62.12",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "70.19",
        "surfaceTotal": "89.03",
        "timeAvailableFrom": "9/13/22 13:23",
        "lat": 40.4678195,
        "lng": -3.6631744,
        "id_ext": "4205-119793-119793"
    },
    {
        "id": "d680e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "1",
        "askingPriceRent": "212.80",
        "askingPriceSale": "26600.00",
        "address": "Calle Salvador 1 ",
        "postalCode": "06713",
        "city": "1106001",
        "province": "06",
        "CCAA": "41",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "86.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "86.00",
        "surfaceTotal": "86.00",
        "timeAvailableFrom": "9/13/22 13:23",
        "id_ext": "4205-119797-119797"
    },
    {
        "id": "d880e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "1",
        "askingPriceRent": "434.70",
        "askingPriceSale": "59570.00",
        "address": "Calle Manuel Lodares 5 ",
        "postalCode": "02639",
        "city": "1102015",
        "province": "02",
        "CCAA": "40",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "115.34",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "115.34",
        "surfaceTotal": "115.34",
        "timeAvailableFrom": "9/13/22 13:23",
        "lat": 39.0452356,
        "lng": -2.2009957,
        "id_ext": "4205-119798-119798"
    },
    {
        "id": "da80e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "1",
        "askingPriceRent": "463.04",
        "askingPriceSale": "67351.20",
        "address": " Santa Isabel 2 ",
        "postalCode": "26002",
        "city": "1126005",
        "province": "26",
        "CCAA": "20",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "115.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "115.00",
        "surfaceTotal": "115.00",
        "timeAvailableFrom": "9/13/22 13:23",
        "lat": 42.3574908,
        "lng": -2.4734555,
        "id_ext": "4205-119805-119805"
    },
    {
        "id": "dc80e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "2",
        "askingPriceRent": "725.69",
        "askingPriceSale": "64793.75",
        "address": "Calle La Botica ",
        "postalCode": "33790",
        "city": "1133041",
        "province": "33",
        "CCAA": "31",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "74.05",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "74.05",
        "surfaceTotal": "74.05",
        "timeAvailableFrom": "9/13/22 13:23",
        "lat": 43.53975210000001,
        "lng": -6.724565200000001,
        "id_ext": "4205-119807-119807"
    },
    {
        "id": "de80e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "2",
        "askingPriceRent": "5264.00",
        "askingPriceSale": "1184400.00",
        "address": "Calle Principe de Vergara 206 ",
        "district": "2807905",
        "postalCode": "28002",
        "city": "1128079",
        "province": "28",
        "CCAA": "54",
        "country": "ES",
        "use": "5",
        "surfacebr": "235.85",
        "surfaceMezzanine": "0.00",
        "surfacepb": "51.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "121.76",
        "surfaceTotal": "286.85",
        "timeAvailableFrom": "9/13/22 13:23",
        "lat": 40.4501524,
        "lng": -3.677258799999999,
        "id_ext": "4205-119813-119813"
    },
    {
        "id": "e080e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "1",
        "askingPriceRent": "465.50",
        "askingPriceSale": "55860.00",
        "address": " Mayor ",
        "postalCode": "37730",
        "city": "1137171",
        "province": "37",
        "CCAA": "59",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "126.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "126.00",
        "surfaceTotal": "126.00",
        "timeAvailableFrom": "9/13/22 13:23",
        "lat": 40.4692583,
        "lng": -5.7207683,
        "id_ext": "4205-119814-119814"
    },
    {
        "id": "e280e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "2",
        "askingPriceRent": "605.22",
        "askingPriceSale": "102784.90",
        "address": "Calle Les Voltes 15-17 ",
        "postalCode": "17100",
        "city": "1117022",
        "province": "17",
        "CCAA": "55",
        "country": "ES",
        "use": "11",
        "surfacebr": "0.00",
        "surfaceMezzanine": "77.71",
        "surfacepb": "92.25",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "77.71",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "131.11",
        "surfaceTotal": "169.96",
        "timeAvailableFrom": "9/13/22 13:23",
        "lat": 41.9610576,
        "lng": 3.0389344,
        "id_ext": "4205-119824-119824"
    },
    {
        "id": "e480e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "2",
        "askingPriceRent": "1064.63",
        "askingPriceSale": "177438.80",
        "address": "Carretera Malgrat 3 ",
        "postalCode": "17300",
        "city": "1117023",
        "province": "17",
        "CCAA": "55",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "181.06",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "181.06",
        "surfaceTotal": "181.06",
        "timeAvailableFrom": "9/13/22 13:23",
        "lat": 41.6763348,
        "lng": 2.7801,
        "id_ext": "4205-119825-119825"
    },
    {
        "id": "e680e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Arrendado (propiedad)",
        "strategy": "2",
        "askingPriceRent": "2576.00",
        "askingPriceSale": "274204.73",
        "address": "Avenida Marítima 37 ",
        "postalCode": "38040",
        "city": "1138040",
        "province": "38",
        "CCAA": "56",
        "country": "ES",
        "use": "11",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "86.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "86.00",
        "surfaceTotal": "86.00",
        "agent": "Sara Carracedo Culebras",
        "timeAvailableFrom": "9/13/22 13:23",
        "lat": 28.2972603,
        "lng": -16.8156254,
        "id_ext": "4205-119827-119827"
    },
    {
        "id": "e880e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "2",
        "askingPriceRent": "1383.20",
        "askingPriceSale": "191520.00",
        "address": "Calle Mago De Oz 7 ",
        "postalCode": "19005",
        "city": "1119130",
        "province": "19",
        "CCAA": "40",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "152.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "152.00",
        "surfaceTotal": "152.00",
        "timeAvailableFrom": "9/13/22 13:23",
        "lat": 40.64141,
        "lng": -3.1505899,
        "id_ext": "4205-119828-119828"
    },
    {
        "id": "ea80e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "2",
        "askingPriceRent": "5594.40",
        "askingPriceSale": "932400.00",
        "address": " General Vives 55 - 57 ",
        "postalCode": "35007",
        "city": "1135016",
        "province": "35",
        "CCAA": "56",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "324.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "240.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "444.00",
        "surfaceTotal": "564.00",
        "timeAvailableFrom": "9/13/22 13:23",
        "lat": 28.1392053,
        "lng": -15.4314069,
        "id_ext": "4205-119839-119839"
    },
    {
        "id": "ec80e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "1",
        "askingPriceRent": "768.32",
        "askingPriceSale": "80388.00",
        "address": "Carretera Nou 24 ",
        "postalCode": "46670",
        "city": "1146203",
        "province": "46",
        "CCAA": "42",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "175.17",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "168.36",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "259.35",
        "surfaceTotal": "343.53",
        "timeAvailableFrom": "9/13/22 13:23",
        "lat": 39.085908,
        "lng": -0.4768685,
        "id_ext": "4205-119850-119850"
    },
    {
        "id": "ee80e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "2",
        "askingPriceRent": "1008.00",
        "askingPriceSale": "100800.00",
        "address": " Mayor 25 ",
        "postalCode": "47320",
        "city": "1147175",
        "province": "47",
        "CCAA": "59",
        "country": "ES",
        "use": "5",
        "surfacebr": "139.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "170.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "211.70",
        "surfaceTotal": "309.00",
        "timeAvailableFrom": "9/13/22 13:24",
        "lat": 41.5843293,
        "lng": -4.5811439,
        "id_ext": "4205-119852-119852"
    },
    {
        "id": "f080e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "1",
        "askingPriceRent": "2492.00",
        "askingPriceSale": "352156.00",
        "address": "Avenida De Madrid 16 ",
        "postalCode": "32630",
        "city": "1132032",
        "province": "32",
        "CCAA": "60",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "101.41",
        "surfacepb": "137.35",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "101.41",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "188.06",
        "surfaceTotal": "238.76",
        "timeAvailableFrom": "9/13/22 13:24",
        "lat": 42.0622372,
        "lng": -7.7244213,
        "id_ext": "4205-119853-119853"
    },
    {
        "id": "f280e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "1",
        "askingPriceRent": "360.57",
        "askingPriceSale": "49490.00",
        "address": "Plaza De La Constitucion 7 ",
        "postalCode": "14620",
        "city": "1114018",
        "province": "14",
        "CCAA": "51",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "82.68",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "82.68",
        "surfaceTotal": "82.68",
        "timeAvailableFrom": "9/13/22 13:24",
        "lat": 37.9401584,
        "lng": -4.499105,
        "id_ext": "4205-119856-119856"
    },
    {
        "id": "f480e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "1",
        "askingPriceRent": "431.20",
        "askingPriceSale": "55440.00",
        "address": " Alamillo 18 ",
        "postalCode": "28360",
        "city": "1128170",
        "province": "28",
        "CCAA": "54",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "77.02",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "77.02",
        "surfaceTotal": "77.02",
        "timeAvailableFrom": "9/13/22 13:24",
        "lat": 40.103189,
        "lng": -3.4845413,
        "id_ext": "4205-119857-119857"
    },
    {
        "id": "f680e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "1",
        "askingPriceRent": "558.60",
        "askingPriceSale": "134064.00",
        "address": " Alejandro Soler 2 ",
        "postalCode": "46003",
        "city": "1146250",
        "province": "46",
        "CCAA": "42",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "327.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "327.00",
        "surfaceTotal": "327.00",
        "timeAvailableFrom": "9/13/22 13:24",
        "lat": 39.4699075,
        "lng": -0.3762881,
        "id_ext": "4205-119858-119858"
    },
    {
        "id": "f880e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "2",
        "askingPriceRent": "1120.00",
        "askingPriceSale": "168000.00",
        "address": " Veinte 74 ",
        "postalCode": "43100",
        "city": "1143148",
        "province": "43",
        "CCAA": "55",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "166.50",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "166.50",
        "surfaceTotal": "166.50",
        "timeAvailableFrom": "9/13/22 13:24",
        "lat": 41.1188827,
        "lng": 1.2444909,
        "id_ext": "4205-119860-119860"
    },
    {
        "id": "fa80e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "1",
        "askingPriceRent": "342.22",
        "askingPriceSale": "44100.00",
        "address": " Torogil 5 ",
        "postalCode": "34309",
        "city": "1134055",
        "province": "34",
        "CCAA": "59",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "61.20",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "61.20",
        "surfaceTotal": "61.20",
        "timeAvailableFrom": "9/13/22 13:24",
        "lat": 42.2905776,
        "lng": -4.769805799999999,
        "id_ext": "4205-119861-119861"
    },
    {
        "id": "fc80e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "2",
        "askingPriceRent": "952.00",
        "askingPriceSale": "133280.00",
        "address": " Major 72 ",
        "postalCode": "08970",
        "city": "1108217",
        "province": "08",
        "CCAA": "55",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "136.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "136.00",
        "surfaceTotal": "136.00",
        "timeAvailableFrom": "9/13/22 13:24",
        "lat": 41.3673523,
        "lng": 2.0566806,
        "id_ext": "4205-119862-119862"
    },
    {
        "id": "fe80e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "1",
        "askingPriceRent": "787.50",
        "askingPriceSale": "113750.00",
        "address": " Progreso-Portonovo 53 ",
        "postalCode": "36970",
        "city": "1136051",
        "province": "36",
        "CCAA": "60",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "100.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "100.00",
        "surfaceTotal": "100.00",
        "timeAvailableFrom": "9/13/22 13:24",
        "lat": 42.3938153,
        "lng": -8.8246901,
        "id_ext": "4205-119866-119866"
    },
    {
        "id": "0081e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "1",
        "askingPriceRent": "582.60",
        "askingPriceSale": "82222.00",
        "address": " Real 206 ",
        "postalCode": "18240",
        "city": "1118158",
        "province": "18",
        "CCAA": "51",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "124.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "124.00",
        "surfaceTotal": "124.00",
        "timeAvailableFrom": "9/13/22 13:24",
        "lat": 37.2514515,
        "lng": -3.7496132,
        "id_ext": "4205-119867-119867"
    },
    {
        "id": "0281e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "2",
        "askingPriceRent": "1486.68",
        "askingPriceSale": "202312.17",
        "address": "Vía Carpetana 81 ",
        "district": "2807911",
        "postalCode": "28047",
        "city": "1128079",
        "province": "28",
        "CCAA": "54",
        "country": "ES",
        "use": "5",
        "surfacebr": "81.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "98.30",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "122.60",
        "surfaceTotal": "179.30",
        "timeAvailableFrom": "9/13/22 13:24",
        "lat": 40.3960471,
        "lng": -3.7375782,
        "id_ext": "4205-119868-119868"
    },
    {
        "id": "0481e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "2",
        "askingPriceRent": "809.45",
        "askingPriceSale": "120291.11",
        "address": " Paseo De Los Castellanos, 65 65 ",
        "district": "2807911",
        "postalCode": "28025",
        "city": "1128079",
        "province": "28",
        "CCAA": "54",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "90.38",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "90.38",
        "surfaceTotal": "90.38",
        "timeAvailableFrom": "9/13/22 13:24",
        "lat": 40.37465419999999,
        "lng": -3.7429008,
        "id_ext": "4205-119869-119869"
    },
    {
        "id": "0681e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "1",
        "askingPriceRent": "1659.00",
        "askingPriceSale": "337981.69",
        "address": " Oña 69 ",
        "postalCode": "28050",
        "city": "1128079",
        "province": "28",
        "CCAA": "54",
        "country": "ES",
        "use": "5",
        "surfacebr": "139.23",
        "surfaceMezzanine": "0.00",
        "surfacepb": "118.72",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "160.49",
        "surfaceTotal": "257.95",
        "timeAvailableFrom": "9/13/22 13:24",
        "lat": 40.4892055,
        "lng": -3.6638286,
        "id_ext": "4205-119870-119870"
    },
    {
        "id": "0881e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "CAMBIO DE USO",
        "askingPriceRent": "4992.96",
        "askingPriceSale": "748944.00",
        "address": "Avenida Betanzos 72-74 ",
        "district": "2807908",
        "postalCode": "28034",
        "city": "1128079",
        "province": "28",
        "CCAA": "54",
        "country": "ES",
        "use": "5",
        "surfacebr": "258.86",
        "surfaceMezzanine": "0.00",
        "surfacepb": "163.20",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "148.94",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "315.33",
        "surfaceTotal": "571.00",
        "timeAvailableFrom": "9/13/22 13:24",
        "lat": 40.4822531,
        "lng": -3.7135222,
        "id_ext": "4205-119871-119871"
    },
    {
        "id": "0a81e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "1",
        "askingPriceRent": "614.60",
        "askingPriceSale": "98336.00",
        "address": "Travesía De Vigo 99 ",
        "postalCode": "36207",
        "city": "1136057",
        "province": "36",
        "CCAA": "60",
        "country": "ES",
        "use": "5",
        "surfacebr": "104.20",
        "surfaceMezzanine": "0.00",
        "surfacepb": "66.20",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "97.46",
        "surfaceTotal": "170.40",
        "timeAvailableFrom": "9/13/22 13:24",
        "lat": 42.2380807,
        "lng": -8.7037669,
        "id_ext": "4205-119872-119872"
    },
    {
        "id": "0c81e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "2",
        "askingPriceRent": "1060.37",
        "askingPriceSale": "123710.30",
        "address": " Corredera 53 ",
        "postalCode": "41520",
        "city": "1141102",
        "province": "41",
        "CCAA": "51",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "0.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "112.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "56.00",
        "surfaceTotal": "112.00",
        "timeAvailableFrom": "9/13/22 13:24",
        "lat": 37.3866565,
        "lng": -5.7229277,
        "id_ext": "4205-119873-119873"
    },
    {
        "id": "0e81e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "1",
        "askingPriceRent": "431.20",
        "askingPriceSale": "53900.00",
        "address": " Corredera 24 ",
        "postalCode": "14270",
        "city": "1114035",
        "province": "14",
        "CCAA": "51",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "100.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "100.00",
        "surfaceTotal": "100.00",
        "timeAvailableFrom": "9/13/22 13:24",
        "lat": 38.4992686,
        "lng": -5.1463629,
        "id_ext": "4205-119874-119874"
    },
    {
        "id": "1081e90a-5633-ed11-9db1-0022489c4873",
        "active": false,
        "status": "Vendido",
        "strategy": "1",
        "askingPriceRent": "835.27",
        "askingPriceSale": "134686.60",
        "address": " Comandante Fortea 32 ",
        "postalCode": "28008",
        "city": "1128079",
        "province": "28",
        "CCAA": "54",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "113.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "113.00",
        "surfaceTotal": "113.00",
        "timeAvailableFrom": "9/13/22 13:24",
        "lat": 40.4264504,
        "lng": -3.7310792,
        "id_ext": "4205-119875-119875"
    },
    {
        "id": "1281e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "2",
        "askingPriceRent": "1156.40",
        "askingPriceSale": "132160.00",
        "address": "Avenida Constitucion 16 ",
        "postalCode": "33678",
        "city": "1133002",
        "province": "33",
        "CCAA": "31",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "234.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "234.00",
        "surfaceTotal": "234.00",
        "timeAvailableFrom": "9/13/22 13:24",
        "lat": 43.1686978,
        "lng": -5.737428200000001,
        "id_ext": "4205-119877-119877"
    },
    {
        "id": "1481e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "2",
        "askingPriceRent": "4704.00",
        "askingPriceSale": "806400.00",
        "address": "Plaza Luca De Tena 7 ",
        "district": "2807902",
        "postalCode": "28045",
        "city": "1128079",
        "province": "28",
        "CCAA": "54",
        "country": "ES",
        "use": "5",
        "surfacebr": "398.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "491.43",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "610.83",
        "surfaceTotal": "889.43",
        "timeAvailableFrom": "9/13/22 13:24",
        "lat": 40.40131179999999,
        "lng": -3.6933482,
        "id_ext": "4205-119880-119880"
    },
    {
        "id": "1681e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "1",
        "askingPriceRent": "3724.00",
        "askingPriceSale": "425600.00",
        "address": "Calle Alqueria 10 ",
        "postalCode": "46469",
        "city": "1146065",
        "province": "46",
        "CCAA": "42",
        "country": "ES",
        "use": "6",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "1843.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "1843.00",
        "surfaceTotal": "1843.00",
        "timeAvailableFrom": "9/13/22 13:24",
        "lat": 39.4014761,
        "lng": -0.400742,
        "id_ext": "4205-119882-119882"
    },
    {
        "id": "1881e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "2",
        "askingPriceRent": "4831.18",
        "askingPriceSale": "644156.80",
        "address": " Salvador Manrique De Lara S/N ",
        "postalCode": "35010",
        "city": "1135016",
        "province": "35",
        "CCAA": "56",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "1123.22",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "1123.22",
        "surfaceTotal": "1123.22",
        "timeAvailableFrom": "9/13/22 13:24",
        "lat": 28.1309773,
        "lng": -15.4360929,
        "id_ext": "4205-119883-119883"
    },
    {
        "id": "1a81e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "1",
        "askingPriceRent": "430.71",
        "askingPriceSale": "57428.00",
        "address": "Plaza Constitución 2 ",
        "postalCode": "31252",
        "city": "1131053",
        "province": "31",
        "CCAA": "11",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "103.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "103.00",
        "surfaceTotal": "103.00",
        "timeAvailableFrom": "9/13/22 13:24",
        "lat": 42.5264213,
        "lng": -1.834649,
        "id_ext": "4205-119884-119884"
    },
    {
        "id": "1c81e90a-5633-ed11-9db1-0022489c4873",
        "active": false,
        "status": "Vendido",
        "strategy": "1",
        "askingPriceRent": "672.00",
        "askingPriceSale": "94080.00",
        "address": "Avenida De Barcelona 42 ",
        "postalCode": "29009",
        "city": "1129067",
        "province": "29",
        "CCAA": "51",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "0.00",
        "surfaceBasement1": "59.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "59.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "59.00",
        "surfaceTotal": "59.00",
        "timeAvailableFrom": "9/13/22 13:24",
        "lat": 36.7258541,
        "lng": -4.430629,
        "id_ext": "4205-119885-119885"
    },
    {
        "id": "1e81e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "1",
        "askingPriceRent": "957.60",
        "askingPriceSale": "167580.00",
        "address": "Calle Santa Fe 4 ",
        "postalCode": "45001",
        "city": "1145168",
        "province": "45",
        "CCAA": "40",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "171.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "171.00",
        "surfaceTotal": "171.00",
        "timeAvailableFrom": "9/13/22 13:24",
        "lat": 39.859383,
        "lng": -4.0207035,
        "id_ext": "4205-119886-119886"
    },
    {
        "id": "2081e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "2",
        "askingPriceRent": "1684.48",
        "askingPriceSale": "258048.00",
        "address": " Conjunto Playa Virginia 7 ",
        "postalCode": "29018",
        "city": "1129067",
        "province": "29",
        "CCAA": "51",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "255.51",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "255.51",
        "surfaceTotal": "255.51",
        "timeAvailableFrom": "9/13/22 13:24",
        "lat": 36.7178702,
        "lng": -4.3493501,
        "id_ext": "4205-119887-119887"
    },
    {
        "id": "2281e90a-5633-ed11-9db1-0022489c4873",
        "active": false,
        "status": "Vendido",
        "strategy": "1",
        "askingPriceRent": "2195.18",
        "askingPriceSale": "322872.23",
        "address": " Polig. Ind. Valle De Güimar ",
        "postalCode": "38500",
        "city": "1138011",
        "province": "38",
        "CCAA": "56",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "56.00",
        "surfacepb": "405.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "56.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "433.00",
        "surfaceTotal": "461.00",
        "timeAvailableFrom": "9/13/22 13:24",
        "lat": 28.3557192,
        "lng": -16.3719006,
        "id_ext": "4205-119888-119888"
    },
    {
        "id": "2481e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "2",
        "askingPriceRent": "1134.00",
        "askingPriceSale": "158760.00",
        "address": "Paseo De Olot s/n ",
        "postalCode": "17005",
        "city": "1117079",
        "province": "17",
        "CCAA": "55",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "161.81",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "161.81",
        "surfaceTotal": "161.81",
        "timeAvailableFrom": "9/13/22 13:24",
        "lat": 41.97636,
        "lng": 2.8088664,
        "id_ext": "4205-119889-119889"
    },
    {
        "id": "2681e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "2",
        "askingPriceRent": "2798.57",
        "askingPriceSale": "388080.00",
        "address": " Aragon 127 ",
        "postalCode": "07005",
        "city": "1107040",
        "province": "07",
        "CCAA": "44",
        "country": "ES",
        "use": "5",
        "surfacebr": "107.74",
        "surfaceMezzanine": "0.00",
        "surfacepb": "125.42",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "157.74",
        "surfaceTotal": "233.16",
        "timeAvailableFrom": "9/13/22 13:24",
        "lat": 39.580887,
        "lng": 2.6660445,
        "id_ext": "4205-119890-119890"
    },
    {
        "id": "2881e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "1",
        "askingPriceRent": "500.50",
        "askingPriceSale": "84700.00",
        "address": " Cola Y Goiti 9 ",
        "postalCode": "01003",
        "city": "1101059",
        "province": "01",
        "CCAA": "53",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "136.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "136.00",
        "surfaceTotal": "136.00",
        "timeAvailableFrom": "9/13/22 13:24",
        "lat": 42.8471653,
        "lng": -2.6635581,
        "id_ext": "4205-119891-119891"
    },
    {
        "id": "2a81e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "1",
        "askingPriceRent": "566.54",
        "askingPriceSale": "79316.30",
        "address": "Calle Real 103-105 ",
        "postalCode": "18240",
        "city": "1118158",
        "province": "18",
        "CCAA": "51",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "162.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "162.00",
        "surfaceTotal": "162.00",
        "timeAvailableFrom": "9/13/22 13:24",
        "lat": 37.2503296,
        "lng": -3.756366,
        "id_ext": "4205-119899-119899"
    },
    {
        "id": "2c81e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "1",
        "askingPriceRent": "340.27",
        "askingPriceSale": "49123.71",
        "address": "Carretera De Almarza 1 ",
        "postalCode": "24880",
        "city": "1124183",
        "province": "24",
        "CCAA": "59",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "116.72",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "116.72",
        "surfaceTotal": "116.72",
        "timeAvailableFrom": "9/13/22 13:24",
        "lat": 42.815659,
        "lng": -4.9472647,
        "id_ext": "4205-119908-119908"
    },
    {
        "id": "2e81e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Arrendado (propiedad)",
        "strategy": "2",
        "askingPriceRent": "4057.20",
        "askingPriceSale": "939801.36",
        "address": " Eustasio Amilibia 10 ",
        "postalCode": "20011",
        "city": "1120069",
        "province": "20",
        "CCAA": "53",
        "country": "ES",
        "use": "11",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "138.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "138.00",
        "surfaceTotal": "138.00",
        "agent": "Sara Carracedo Culebras",
        "timeAvailableFrom": "9/13/22 13:24",
        "lat": 43.3052458,
        "lng": -1.9779963,
        "id_ext": "4205-119914-119914"
    },
    {
        "id": "3081e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Arrendado (propiedad)",
        "strategy": "2",
        "askingPriceRent": "6081.88",
        "askingPriceSale": "1681555.74",
        "address": " San Francisco 25 ",
        "postalCode": "20001",
        "city": "1120069",
        "province": "20",
        "CCAA": "53",
        "country": "ES",
        "use": "11",
        "surfacebr": "329.28",
        "surfaceMezzanine": "0.00",
        "surfacepb": "120.11",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "218.89",
        "surfaceTotal": "449.39",
        "timeAvailableFrom": "9/13/22 13:24",
        "lat": 43.3247131,
        "lng": -1.972894,
        "id_ext": "4205-119915-119915"
    },
    {
        "id": "3281e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Pendiente validación técnica",
        "strategy": "2",
        "askingPriceRent": "1155.42",
        "askingPriceSale": "177941.64",
        "address": "Calle Figuera Major, 45 ",
        "postalCode": "08304",
        "city": "1108121",
        "province": "08",
        "CCAA": "55",
        "country": "ES",
        "use": "11",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "125.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "125.00",
        "surfaceTotal": "125.00",
        "timeAvailableFrom": "9/13/22 13:24",
        "lat": 41.5534865,
        "lng": 2.4414554,
        "id_ext": "4205-119917-119917"
    },
    {
        "id": "3681e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "2",
        "askingPriceRent": "1064.00",
        "askingPriceSale": "148960.00",
        "address": "Avenida Constitucion 207 ",
        "postalCode": "28850",
        "city": "1128148",
        "province": "28",
        "CCAA": "54",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "140.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "140.00",
        "surfaceTotal": "140.00",
        "timeAvailableFrom": "9/13/22 13:24",
        "lat": 40.4605862,
        "lng": -3.458222,
        "id_ext": "4205-119921-119921"
    },
    {
        "id": "3881e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "2",
        "askingPriceRent": "1489.60",
        "askingPriceSale": "211680.00",
        "address": "Avenida De La Industria 18 ",
        "postalCode": "28947",
        "city": "1128058",
        "province": "28",
        "CCAA": "54",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "217.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "217.00",
        "surfaceTotal": "217.00",
        "timeAvailableFrom": "9/13/22 13:24",
        "lat": 40.27131809999999,
        "lng": -3.7630183,
        "id_ext": "4205-119922-119922"
    },
    {
        "id": "3a81e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "1",
        "askingPriceRent": "808.50",
        "askingPriceSale": "115500.00",
        "address": "Paseo Santa Lucia 103 ",
        "postalCode": "31012",
        "city": "1131201",
        "province": "31",
        "CCAA": "11",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "156.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "156.00",
        "surfaceTotal": "156.00",
        "timeAvailableFrom": "9/13/22 13:24",
        "lat": 42.8251266,
        "lng": -1.6680639,
        "id_ext": "4205-119923-119923"
    },
    {
        "id": "3c81e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "CAMBIO DE USO",
        "askingPriceRent": "901.60",
        "askingPriceSale": "103040.00",
        "address": "Avenida Borbon 70 ",
        "postalCode": "08003",
        "city": "1108019",
        "province": "08",
        "CCAA": "55",
        "country": "ES",
        "use": "5",
        "surfacebr": "99.18",
        "surfaceMezzanine": "0.00",
        "surfacepb": "74.22",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "99.18",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "103.97",
        "surfaceTotal": "173.40",
        "timeAvailableFrom": "9/13/22 13:24",
        "lat": 41.4288834,
        "lng": 2.174672,
        "id_ext": "4205-119924-119924"
    },
    {
        "id": "3e81e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "2",
        "askingPriceRent": "1711.64",
        "askingPriceSale": "256746.00",
        "address": "Carretera De Matadepera 195-203 ",
        "postalCode": "08225",
        "city": "1108279",
        "province": "08",
        "CCAA": "55",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "305.65",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "305.65",
        "surfaceTotal": "305.65",
        "timeAvailableFrom": "9/13/22 13:24",
        "lat": 41.5755908,
        "lng": 2.0170177,
        "id_ext": "4205-119925-119925"
    },
    {
        "id": "4081e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "1",
        "askingPriceRent": "331.10",
        "askingPriceSale": "42140.00",
        "address": "Avenida Valencia 12 ",
        "postalCode": "46294",
        "city": "1146084",
        "province": "46",
        "CCAA": "42",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "86.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "86.00",
        "surfaceTotal": "86.00",
        "timeAvailableFrom": "9/13/22 13:24",
        "lat": 39.0674417,
        "lng": -0.5667420000000001,
        "id_ext": "4205-119927-119927"
    },
    {
        "id": "4281e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Arrendado (propiedad)",
        "strategy": "2",
        "askingPriceRent": "1423.52",
        "askingPriceSale": "222425.00",
        "address": " La Legion 6-8 ",
        "postalCode": "52001",
        "city": "1152001",
        "province": "52",
        "CCAA": "51",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "134.04",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "134.04",
        "surfaceTotal": "134.04",
        "timeAvailableFrom": "9/13/22 13:24",
        "lat": 35.2922775,
        "lng": -2.9380973,
        "id_ext": "4205-119929-119929"
    },
    {
        "id": "4481e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "2",
        "askingPriceRent": "1165.50",
        "askingPriceSale": "155400.00",
        "address": "Calle Jacinto Verdaguer 32 ",
        "postalCode": "08397",
        "city": "1108163",
        "province": "08",
        "CCAA": "55",
        "country": "ES",
        "use": "5",
        "surfacebr": "110.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "100.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "133.00",
        "surfaceTotal": "210.00",
        "timeAvailableFrom": "9/13/22 13:24",
        "lat": 41.6252839,
        "lng": 2.686147,
        "id_ext": "4205-119930-119930"
    },
    {
        "id": "4681e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "2",
        "askingPriceRent": "770.00",
        "askingPriceSale": "115500.00",
        "address": "Calle Olivo 4 ",
        "postalCode": "28970",
        "city": "1119151",
        "province": "28",
        "CCAA": "54",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "99.48",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "99.48",
        "surfaceTotal": "99.48",
        "timeAvailableFrom": "9/13/22 13:24",
        "lat": 40.2530078,
        "lng": -3.8289902,
        "id_ext": "4205-119931-119931"
    },
    {
        "id": "4881e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "1",
        "askingPriceRent": "483.00",
        "askingPriceSale": "56350.00",
        "address": "Calle Juan Jose Espejo 37 ",
        "postalCode": "14910",
        "city": "1114010",
        "province": "14",
        "CCAA": "51",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "115.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "115.00",
        "surfaceTotal": "115.00",
        "timeAvailableFrom": "9/13/22 13:24",
        "lat": 37.2682631,
        "lng": -4.5400216,
        "id_ext": "4205-119932-119932"
    },
    {
        "id": "4a81e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "CAMBIO DE USO",
        "askingPriceRent": "798.00",
        "askingPriceSale": "133000.00",
        "address": "Calle Mestre Falla 5 ",
        "postalCode": "08850",
        "city": "1108089",
        "province": "08",
        "CCAA": "55",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "95.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "95.00",
        "surfaceTotal": "95.00",
        "timeAvailableFrom": "9/13/22 13:24",
        "lat": 41.41623740000001,
        "lng": 1.9982279,
        "id_ext": "4205-119933-119933"
    },
    {
        "id": "4e81e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "1",
        "askingPriceRent": "480.20",
        "askingPriceSale": "54880.00",
        "address": "Calle Iglesias 10 ",
        "postalCode": "14470",
        "city": "1114074",
        "province": "14",
        "CCAA": "51",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "102.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "102.00",
        "surfaceTotal": "102.00",
        "timeAvailableFrom": "9/13/22 13:24",
        "lat": 40.6647768,
        "lng": -4.0385925,
        "id_ext": "4205-119935-119935"
    },
    {
        "id": "5081e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "2",
        "askingPriceRent": "1098.13",
        "askingPriceSale": "146417.60",
        "address": "Paseo De La Rosaleda ",
        "postalCode": "24400",
        "city": "1124115",
        "province": "24",
        "CCAA": "59",
        "country": "ES",
        "use": "5",
        "surfacebr": "247.44",
        "surfaceMezzanine": "0.00",
        "surfacepb": "236.72",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "310.95",
        "surfaceTotal": "484.16",
        "timeAvailableFrom": "9/13/22 13:24",
        "lat": 42.5499958,
        "lng": -6.598259000000001,
        "id_ext": "4205-119937-119937"
    },
    {
        "id": "5281e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - En legal",
        "strategy": "1",
        "askingPriceRent": "1075.20",
        "askingPriceSale": "161280.00",
        "address": "Calle Rambla de los Menceyes 14 ",
        "postalCode": "38530",
        "city": "1138011",
        "province": "38",
        "CCAA": "56",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "120.40",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "120.40",
        "surfaceTotal": "120.40",
        "timeAvailableFrom": "9/13/22 13:24",
        "lat": 28.3666212,
        "lng": -16.3656881,
        "id_ext": "4205-119938-119938"
    },
    {
        "id": "5481e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "1",
        "askingPriceRent": "1393.70",
        "askingPriceSale": "276220.00",
        "address": "Avenida Carlos Iii, 45 ",
        "postalCode": "14014",
        "city": "1114021",
        "province": "14",
        "CCAA": "51",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "166.24",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "166.24",
        "surfaceTotal": "166.24",
        "timeAvailableFrom": "9/13/22 13:24",
        "lat": 37.8969105,
        "lng": -4.757874,
        "id_ext": "4205-119940-119940"
    },
    {
        "id": "5681e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "2",
        "askingPriceRent": "3960.81",
        "askingPriceSale": "660135.00",
        "address": "Calle General Concha 22 ",
        "postalCode": "48010",
        "city": "1148020",
        "province": "48",
        "CCAA": "53",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "189.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "189.00",
        "surfaceTotal": "189.00",
        "timeAvailableFrom": "9/13/22 13:24",
        "lat": 43.2585428,
        "lng": -2.935446900000001,
        "id_ext": "4205-119942-119942"
    },
    {
        "id": "5881e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "1",
        "askingPriceRent": "879.20",
        "askingPriceSale": "120890.00",
        "address": "Calle Joaquín Chapaprieta 148 ",
        "postalCode": "03183",
        "city": "1103133",
        "province": "03",
        "CCAA": "42",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "157.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "157.00",
        "surfaceTotal": "157.00",
        "timeAvailableFrom": "9/13/22 13:24",
        "lat": 37.9842923,
        "lng": -0.6814821000000001,
        "id_ext": "4205-119943-119943"
    },
    {
        "id": "5a81e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Arrendado (propiedad)",
        "strategy": "2",
        "askingPriceRent": "1008.00",
        "askingPriceSale": "147840.00",
        "address": " Wisterra 6 ",
        "postalCode": "28232",
        "city": "1128127",
        "province": "28",
        "CCAA": "54",
        "country": "ES",
        "use": "11",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "96.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "96.00",
        "surfaceTotal": "96.00",
        "timeAvailableFrom": "9/13/22 13:24",
        "lat": 40.5166415,
        "lng": -3.9252661,
        "id_ext": "4205-119944-119944"
    },
    {
        "id": "5c81e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "1",
        "askingPriceRent": "1199.94",
        "askingPriceSale": "199990.00",
        "address": "Avenida Joan Prim 131-139 ",
        "postalCode": "08401",
        "city": "1108096",
        "province": "08",
        "CCAA": "55",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "134.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "134.00",
        "surfaceTotal": "134.00",
        "timeAvailableFrom": "9/13/22 13:24",
        "lat": 41.6130449,
        "lng": 2.2899545,
        "id_ext": "4205-119945-119945"
    },
    {
        "id": "5e81e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - En legal",
        "strategy": "2",
        "askingPriceRent": "4466.35",
        "askingPriceSale": "765660.00",
        "address": "Calle Travessera De Dalt 117-119 ",
        "postalCode": "08024",
        "city": "1108019",
        "province": "08",
        "CCAA": "55",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "375.00",
        "surfaceBasement1": "161.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "161.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "455.50",
        "surfaceTotal": "536.00",
        "timeAvailableFrom": "9/13/22 13:24",
        "lat": 41.412135,
        "lng": 2.1586365,
        "id_ext": "4205-119946-119946"
    },
    {
        "id": "6081e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Arrendado (propiedad)",
        "strategy": "2",
        "askingPriceRent": "1101.10",
        "askingPriceSale": "150150.00",
        "address": "Calle Almeria 14 ",
        "postalCode": "29018",
        "city": "1129067",
        "province": "29",
        "CCAA": "51",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "132.65",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "132.65",
        "surfaceTotal": "132.65",
        "timeAvailableFrom": "9/13/22 13:24",
        "lat": 36.720881,
        "lng": -4.3586681,
        "id_ext": "4205-119947-119947"
    },
    {
        "id": "6281e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "2",
        "askingPriceRent": "1281.00",
        "askingPriceSale": "179340.00",
        "address": "Avenida Quevedo 33 ",
        "postalCode": "24009",
        "city": "1124089",
        "province": "24",
        "CCAA": "59",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "182.98",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "182.98",
        "surfaceTotal": "182.98",
        "timeAvailableFrom": "9/13/22 13:24",
        "lat": 42.5995521,
        "lng": -5.5870421,
        "id_ext": "4205-119948-119948"
    },
    {
        "id": "6481e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "CAMBIO DE USO",
        "askingPriceRent": "1792.00",
        "askingPriceSale": "313600.00",
        "address": "Calle Puente De La Reina ",
        "postalCode": "28050",
        "city": "1128079",
        "province": "28",
        "CCAA": "54",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "120.53",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "120.53",
        "surfaceTotal": "120.53",
        "timeAvailableFrom": "9/13/22 13:24",
        "lat": 40.5021166,
        "lng": -3.6742316,
        "id_ext": "4205-119950-119950"
    },
    {
        "id": "6681e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "2",
        "askingPriceRent": "1047.20",
        "askingPriceSale": "157080.00",
        "address": "Calle Bruguers 22 ",
        "postalCode": "08820",
        "city": "1108169",
        "province": "08",
        "CCAA": "55",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "220.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "220.00",
        "surfaceTotal": "220.00",
        "timeAvailableFrom": "9/13/22 13:24",
        "lat": 41.3227154,
        "lng": 2.0873004,
        "id_ext": "4205-119951-119951"
    },
    {
        "id": "6881e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "1",
        "askingPriceRent": "676.20",
        "askingPriceSale": "91770.00",
        "address": "Calle Federico Garcia Lorca, 24 ",
        "postalCode": "08191",
        "city": "1108184",
        "province": "08",
        "CCAA": "55",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "133.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "133.00",
        "surfaceTotal": "133.00",
        "timeAvailableFrom": "9/13/22 13:24",
        "id_ext": "4205-119952-119952"
    },
    {
        "id": "6a81e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Arrendado (propiedad)",
        "strategy": "2",
        "askingPriceRent": "860.04",
        "askingPriceSale": "138647.76",
        "address": "Avenida Barcelona 176 ",
        "postalCode": "08700",
        "city": "1108102",
        "province": "08",
        "CCAA": "55",
        "country": "ES",
        "use": "11",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "293.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "293.00",
        "surfaceTotal": "293.00",
        "timeAvailableFrom": "9/13/22 13:24",
        "lat": 41.5833646,
        "lng": 1.6277535,
        "id_ext": "4205-119954-119954"
    },
    {
        "id": "6c81e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Arrendado (propiedad)",
        "strategy": "2",
        "askingPriceRent": "1117.41",
        "askingPriceSale": "131460.00",
        "address": "Calle Cataluña 1 ",
        "postalCode": "08740",
        "city": "1108196",
        "province": "08",
        "CCAA": "55",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "65.60",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "28.30",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "79.75",
        "surfaceTotal": "93.90",
        "timeAvailableFrom": "9/13/22 13:24",
        "lat": 41.4491478,
        "lng": 1.9724424,
        "id_ext": "4205-119955-119955"
    },
    {
        "id": "6e81e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "CAMBIO DE USO",
        "askingPriceRent": "1100.40",
        "askingPriceSale": "183400.00",
        "address": "Calle Calassanç Duran 12-18 ",
        "postalCode": "08203",
        "city": "1108187",
        "province": "08",
        "CCAA": "55",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "78.47",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "52.48",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "104.71",
        "surfaceTotal": "130.95",
        "timeAvailableFrom": "9/13/22 13:24",
        "lat": 41.5394053,
        "lng": 2.113271,
        "id_ext": "4205-119956-119956"
    },
    {
        "id": "7081e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "2",
        "askingPriceRent": "1575.00",
        "askingPriceSale": "231000.00",
        "address": "Carretera General Del Norte 63 ",
        "postalCode": "38350",
        "city": "1138043",
        "province": "38",
        "CCAA": "56",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "339.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "339.00",
        "surfaceTotal": "339.00",
        "timeAvailableFrom": "9/13/22 13:24",
        "lat": 28.4775,
        "lng": -16.41298,
        "id_ext": "4205-119957-119957"
    },
    {
        "id": "7281e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "2",
        "askingPriceRent": "1488.41",
        "askingPriceSale": "263914.00",
        "address": "Calle Minerva 15 ",
        "district": "2807919",
        "postalCode": "28032",
        "city": "1128079",
        "province": "28",
        "CCAA": "54",
        "country": "ES",
        "use": "5",
        "surfacebr": "66.62",
        "surfaceMezzanine": "0.00",
        "surfacepb": "68.03",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "88.02",
        "surfaceTotal": "134.65",
        "timeAvailableFrom": "9/13/22 13:24",
        "lat": 40.4032366,
        "lng": -3.5984222,
        "id_ext": "4205-119958-119958"
    },
    {
        "id": "7481e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "1",
        "askingPriceRent": "940.80",
        "askingPriceSale": "156800.00",
        "address": "Avenida Argentina 2 ",
        "postalCode": "28918",
        "city": "1128074",
        "province": "28",
        "CCAA": "54",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "112.50",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "112.50",
        "surfaceTotal": "112.50",
        "timeAvailableFrom": "9/13/22 13:24",
        "lat": 40.3319506,
        "lng": -3.7686545,
        "id_ext": "4205-119959-119959"
    },
    {
        "id": "7681e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "CAMBIO DE USO",
        "askingPriceRent": "873.60",
        "askingPriceSale": "145600.00",
        "address": "Calle Sant Boi De Llobregat 2 ",
        "postalCode": "08970",
        "city": "1108217",
        "province": "08",
        "CCAA": "55",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "104.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "104.00",
        "surfaceTotal": "104.00",
        "timeAvailableFrom": "9/13/22 13:24",
        "lat": 41.3686541,
        "lng": 2.0731263,
        "id_ext": "4205-119961-119961"
    },
    {
        "id": "7881e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "1",
        "askingPriceRent": "1444.80",
        "askingPriceSale": "234780.00",
        "address": "Avenida Minero Hiribidea 42 ",
        "postalCode": "48500",
        "city": "1148002",
        "province": "48",
        "CCAA": "53",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "125.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "125.00",
        "surfaceTotal": "125.00",
        "timeAvailableFrom": "9/13/22 13:24",
        "lat": 43.3147106,
        "lng": -3.0737145,
        "id_ext": "4205-119963-119963"
    },
    {
        "id": "7a81e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "2",
        "askingPriceRent": "749.70",
        "askingPriceSale": "83300.00",
        "address": "Paseo Buenavista 30 ",
        "postalCode": "12100",
        "city": "1112040",
        "province": "12",
        "CCAA": "42",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "116.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "116.00",
        "surfaceTotal": "116.00",
        "timeAvailableFrom": "9/13/22 13:24",
        "lat": 39.9736826,
        "lng": 0.0147038,
        "id_ext": "4205-119965-119965"
    },
    {
        "id": "7c81e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "2",
        "askingPriceRent": "1036.79",
        "askingPriceSale": "118490.40",
        "address": "Rua Das Teixugueiras ",
        "postalCode": "36212",
        "city": "1136057",
        "province": "36",
        "CCAA": "60",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "212.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "212.00",
        "surfaceTotal": "212.00",
        "timeAvailableFrom": "9/13/22 13:24",
        "lat": 42.2117667,
        "lng": -8.7547704,
        "id_ext": "4205-119966-119966"
    },
    {
        "id": "7e81e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "CAMBIO DE USO",
        "askingPriceRent": "2732.80",
        "askingPriceSale": "307440.00",
        "address": "Calle Escultor Monjo 13-14-15 ",
        "postalCode": "08340",
        "city": "1108219",
        "province": "08",
        "CCAA": "55",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "203.38",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "203.38",
        "surfaceTotal": "203.38",
        "timeAvailableFrom": "9/13/22 13:24",
        "lat": 41.50238969999999,
        "lng": 2.3906641,
        "id_ext": "4205-119970-119970"
    },
    {
        "id": "8081e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "2",
        "askingPriceRent": "635.04",
        "askingPriceSale": "75600.00",
        "address": "Plaza De La Era 2 ",
        "postalCode": "08800",
        "city": "1108307",
        "province": "08",
        "CCAA": "55",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "103.64",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "103.64",
        "surfaceTotal": "103.64",
        "timeAvailableFrom": "9/13/22 13:24",
        "lat": 41.2151504,
        "lng": 1.727446,
        "id_ext": "4205-119972-119972"
    },
    {
        "id": "8281e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Arrendado (propiedad)",
        "strategy": "2",
        "askingPriceRent": "1456.00",
        "askingPriceSale": "207416.26",
        "address": "Calle Alhambra ",
        "postalCode": "03189",
        "city": "1103099",
        "province": "03",
        "CCAA": "42",
        "country": "ES",
        "use": "11",
        "surfacebr": "135.35",
        "surfaceMezzanine": "0.00",
        "surfacepb": "245.64",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "286.25",
        "surfaceTotal": "380.99",
        "timeAvailableFrom": "9/13/22 13:24",
        "lat": 37.92728,
        "lng": -0.7281107,
        "id_ext": "4205-119978-119978"
    },
    {
        "id": "8481e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "1",
        "askingPriceRent": "505.12",
        "askingPriceSale": "71176.00",
        "address": "Avenida De Los Emigrantes 9 ",
        "postalCode": "06474",
        "city": "1106138",
        "province": "06",
        "CCAA": "41",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "178.40",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "178.40",
        "surfaceTotal": "178.40",
        "timeAvailableFrom": "9/13/22 13:24",
        "lat": 38.9142511,
        "lng": -6.0690257,
        "id_ext": "4205-119980-119980"
    },
    {
        "id": "8681e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "1",
        "askingPriceSale": "1503017.60",
        "address": "Carretera Dehesas A Fuenfria ",
        "postalCode": "28470",
        "city": "1128038",
        "province": "28",
        "CCAA": "54",
        "country": "ES",
        "use": "2",
        "surfacebr": "739.04",
        "surfaceMezzanine": "0.00",
        "surfacepb": "0.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "7418.10",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "3930.76",
        "surfaceTotal": "8157.14",
        "timeAvailableFrom": "9/13/22 13:24",
        "lat": 40.7553233,
        "lng": -4.0707656,
        "id_ext": "4205-119994-119994"
    },
    {
        "id": "8881e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "1",
        "askingPriceRent": "416.90",
        "askingPriceSale": "47865.86",
        "address": "Calle Hermanos Machado 21 ",
        "postalCode": "41860",
        "city": "1141045",
        "province": "41",
        "CCAA": "51",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "110.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "110.00",
        "surfaceTotal": "110.00",
        "timeAvailableFrom": "9/13/22 13:24",
        "lat": 37.5266902,
        "lng": -6.155968,
        "id_ext": "4205-119995-119995"
    },
    {
        "id": "8a81e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Arrendado (propiedad)",
        "strategy": "2",
        "askingPriceRent": "3528.00",
        "askingPriceSale": "640919.84",
        "address": " Juan Carlos I 86 ",
        "postalCode": "28916",
        "city": "1128074",
        "province": "28",
        "CCAA": "54",
        "country": "ES",
        "use": "11",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "146.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "146.00",
        "surfaceTotal": "146.00",
        "timeAvailableFrom": "9/13/22 13:24",
        "lat": 40.3319506,
        "lng": -3.7686545,
        "id_ext": "4205-119997-119997"
    },
    {
        "id": "8c81e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "2",
        "askingPriceRent": "4288.90",
        "askingPriceSale": "515200.00",
        "address": "Calle Mayor 2 ",
        "postalCode": "04620",
        "city": "1104100",
        "province": "04",
        "CCAA": "51",
        "country": "ES",
        "use": "5",
        "surfacebr": "86.56",
        "surfaceMezzanine": "0.00",
        "surfacepb": "129.50",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "409.40",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "360.17",
        "surfaceTotal": "625.46",
        "timeAvailableFrom": "9/13/22 13:24",
        "lat": 37.2475062,
        "lng": -1.8693933,
        "id_ext": "4205-120001-120001"
    },
    {
        "id": "8e81e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "2",
        "askingPriceRent": "745.50",
        "askingPriceSale": "104370.00",
        "address": "Calle San Benito 11 ",
        "postalCode": "29320",
        "city": "1129032",
        "province": "29",
        "CCAA": "51",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "193.78",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "66.02",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "226.79",
        "surfaceTotal": "259.80",
        "timeAvailableFrom": "9/13/22 13:24",
        "lat": 37.049943,
        "lng": -4.862125,
        "id_ext": "4205-120005-120005"
    },
    {
        "id": "9081e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "1",
        "askingPriceRent": "1072.96",
        "askingPriceSale": "160944.00",
        "address": "Calle Joaquin Chapaprieta 13 ",
        "postalCode": "03181",
        "city": "1103133",
        "province": "03",
        "CCAA": "42",
        "country": "ES",
        "use": "5",
        "surfacebr": "152.68",
        "surfaceMezzanine": "0.00",
        "surfacepb": "145.79",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "191.59",
        "surfaceTotal": "298.47",
        "timeAvailableFrom": "9/13/22 13:24",
        "lat": 37.97705250000001,
        "lng": -0.681252,
        "id_ext": "4205-120012-120012"
    },
    {
        "id": "9281e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "CAMBIO DE USO",
        "askingPriceRent": "1057.00",
        "askingPriceSale": "147980.00",
        "address": "Calle Circunvalacion 6 ",
        "postalCode": "28850",
        "city": "1128148",
        "province": "28",
        "CCAA": "54",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "151.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "151.00",
        "surfaceTotal": "151.00",
        "timeAvailableFrom": "9/13/22 13:24",
        "lat": 40.4500095,
        "lng": -3.4626024,
        "id_ext": "4205-120015-120015"
    },
    {
        "id": "9481e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "1",
        "askingPriceRent": "551.46",
        "askingPriceSale": "82719.00",
        "address": "Calle Real 118 ",
        "postalCode": "13380",
        "city": "1113009",
        "province": "13",
        "CCAA": "40",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "50.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "75.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "87.50",
        "surfaceTotal": "125.00",
        "timeAvailableFrom": "9/13/22 13:24",
        "lat": 38.7366259,
        "lng": -3.8398265,
        "id_ext": "4205-120018-120018"
    },
    {
        "id": "9681e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Okupado",
        "strategy": "1",
        "askingPriceRent": "1972.67",
        "askingPriceSale": "290843.78",
        "address": "Calle Zurbarán 4 ",
        "postalCode": "45511",
        "city": "1145077",
        "province": "45",
        "CCAA": "40",
        "country": "ES",
        "use": "6",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "1500.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "1500.00",
        "surfaceTotal": "1500.00",
        "timeAvailableFrom": "9/13/22 13:24",
        "lat": 40.0289173,
        "lng": -4.2013851,
        "id_ext": "4205-120019-120019"
    },
    {
        "id": "9881e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "2",
        "askingPriceRent": "1243.20",
        "askingPriceSale": "160580.00",
        "address": "Calle Eguia 7 ",
        "postalCode": "20012",
        "city": "1120069",
        "province": "20",
        "CCAA": "53",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "74.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "74.00",
        "surfaceTotal": "74.00",
        "timeAvailableFrom": "9/13/22 13:24",
        "lat": 43.3166859,
        "lng": -1.9734361,
        "id_ext": "4205-120021-120021"
    },
    {
        "id": "9a81e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Arrendado (propiedad)",
        "strategy": "2",
        "askingPriceRent": "2940.00",
        "askingPriceSale": "448000.00",
        "address": "Carretera De Moraira A Calpe 1221 ",
        "postalCode": "03725",
        "city": "1103128",
        "province": "03",
        "CCAA": "42",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "223.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "223.00",
        "surfaceTotal": "223.00",
        "timeAvailableFrom": "9/13/22 13:24",
        "lat": 38.6826531,
        "lng": 0.1216822,
        "id_ext": "4205-120023-120023"
    },
    {
        "id": "9c81e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "1",
        "askingPriceRent": "420.00",
        "askingPriceSale": "63000.00",
        "address": " Fco. Salzillo s/n ",
        "postalCode": "30166",
        "city": "1130030",
        "province": "30",
        "CCAA": "43",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "231.61",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "231.61",
        "surfaceTotal": "231.61",
        "timeAvailableFrom": "9/13/22 13:24",
        "lat": 37.9707225,
        "lng": -1.1729433,
        "id_ext": "4205-120024-120024"
    },
    {
        "id": "9e81e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "1",
        "askingPriceRent": "846.94",
        "askingPriceSale": "133728.00",
        "address": "Avenida Habaneras 83 ",
        "postalCode": "03182",
        "city": "1103133",
        "province": "03",
        "CCAA": "42",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "159.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "159.00",
        "surfaceTotal": "159.00",
        "timeAvailableFrom": "9/13/22 13:24",
        "lat": 37.9805576,
        "lng": -0.6688367,
        "id_ext": "4205-120025-120025"
    },
    {
        "id": "a081e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "2",
        "askingPriceRent": "1372.00",
        "askingPriceSale": "219520.00",
        "address": "Calle Onze De Setembre 26 ",
        "postalCode": "08170",
        "city": "1108136",
        "province": "08",
        "CCAA": "55",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "123.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "123.00",
        "surfaceTotal": "123.00",
        "timeAvailableFrom": "9/13/22 13:24",
        "lat": 41.5445244,
        "lng": 2.2670286,
        "id_ext": "4205-120027-120027"
    },
    {
        "id": "a281e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "2",
        "askingPriceRent": "822.08",
        "askingPriceSale": "106870.40",
        "address": " Santa Maria Del Aguila 36 ",
        "postalCode": "04700",
        "city": "1104902",
        "province": "04",
        "CCAA": "51",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "235.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "235.00",
        "surfaceTotal": "235.00",
        "timeAvailableFrom": "9/13/22 13:24",
        "lat": 36.7795637,
        "lng": -2.7750424,
        "id_ext": "4205-120031-120031"
    },
    {
        "id": "a481e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "CAMBIO DE USO",
        "askingPriceRent": "1960.00",
        "askingPriceSale": "313600.00",
        "address": "Calle Alonso Zamora Vicente, 6 ",
        "postalCode": "28703",
        "city": "1128134",
        "province": "28",
        "CCAA": "54",
        "country": "ES",
        "use": "5",
        "surfacebr": "29.17",
        "surfaceMezzanine": "0.00",
        "surfacepb": "102.88",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "111.63",
        "surfaceTotal": "132.05",
        "timeAvailableFrom": "9/13/22 13:24",
        "lat": 40.5634825,
        "lng": -3.6112134,
        "id_ext": "4205-120032-120032"
    },
    {
        "id": "a681e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "2",
        "askingPriceRent": "914.86",
        "askingPriceSale": "140279.30",
        "address": "Plaza Cardenal Sanz Y Flores 4 ",
        "postalCode": "46701",
        "city": "1146131",
        "province": "46",
        "CCAA": "42",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "174.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "174.00",
        "surfaceTotal": "174.00",
        "timeAvailableFrom": "9/13/22 13:24",
        "lat": 38.968032,
        "lng": -0.1844671,
        "id_ext": "4205-120034-120034"
    },
    {
        "id": "a881e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Arrendado (propiedad)",
        "strategy": "2",
        "askingPriceRent": "5586.00",
        "askingPriceSale": "1565142.79",
        "address": "Calle Luchana 31 ",
        "postalCode": "28010",
        "city": "1128079",
        "province": "28",
        "CCAA": "54",
        "country": "ES",
        "use": "11",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "221.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "65.66",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "253.83",
        "surfaceTotal": "286.66",
        "timeAvailableFrom": "9/13/22 13:24",
        "lat": 40.4320457,
        "lng": -3.6986493,
        "id_ext": "4205-120035-120035"
    },
    {
        "id": "aa81e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Arrendado (propiedad)",
        "strategy": "2",
        "askingPriceRent": "1505.35",
        "askingPriceSale": "212520.00",
        "address": "Calle Constitución 22 ",
        "postalCode": "28944",
        "city": "1128058",
        "province": "28",
        "CCAA": "54",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "245.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "245.00",
        "surfaceTotal": "245.00",
        "timeAvailableFrom": "9/13/22 13:24",
        "lat": 40.281795,
        "lng": -3.7887908,
        "id_ext": "4205-120036-120036"
    },
    {
        "id": "ac81e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Arrendado (propiedad)",
        "strategy": "2",
        "askingPriceRent": "2523.78",
        "askingPriceSale": "378567.00",
        "address": "Calle Verdiales 17 ",
        "postalCode": "18014",
        "city": "1118087",
        "province": "18",
        "CCAA": "51",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "300.45",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "300.45",
        "surfaceTotal": "300.45",
        "timeAvailableFrom": "9/13/22 13:24",
        "lat": 37.1957684,
        "lng": -3.6119688,
        "id_ext": "4205-120037-120037"
    },
    {
        "id": "ae81e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Arrendado (propiedad)",
        "strategy": "CAMBIO DE USO",
        "askingPriceRent": "1723.24",
        "askingPriceSale": "263554.20",
        "address": " Resureccion Maria De Azkue 43 ",
        "postalCode": "48902",
        "city": "1148013",
        "province": "48",
        "CCAA": "53",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "144.81",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "144.81",
        "surfaceTotal": "144.81",
        "agent": "Sara Carracedo Culebras",
        "timeAvailableFrom": "9/13/22 13:24",
        "lat": 43.3081881,
        "lng": -3.0028928,
        "id_ext": "4205-120038-120038"
    },
    {
        "id": "b081e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Arrendado (propiedad)",
        "strategy": "2",
        "askingPriceRent": "770.00",
        "askingPriceSale": "92400.00",
        "address": "Avenida Paisos Catalans 41 - 43 ",
        "postalCode": "43206",
        "city": "1143123",
        "province": "43",
        "CCAA": "55",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "107.56",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "107.56",
        "surfaceTotal": "107.56",
        "timeAvailableFrom": "9/13/22 13:24",
        "lat": 41.1539413,
        "lng": 1.0971255,
        "id_ext": "4205-120041-120041"
    },
    {
        "id": "b281e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "1",
        "askingPriceRent": "989.10",
        "askingPriceSale": "142870.00",
        "address": "Avenida Sant Iscle 23 ",
        "postalCode": "08290",
        "city": "1108266",
        "province": "08",
        "CCAA": "55",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "157.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "157.00",
        "surfaceTotal": "157.00",
        "timeAvailableFrom": "9/13/22 13:24",
        "lat": 41.4899701,
        "lng": 2.1440578,
        "id_ext": "4205-120043-120043"
    },
    {
        "id": "b481e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "1",
        "askingPriceRent": "862.40",
        "askingPriceSale": "117600.00",
        "address": "Calle Alcalde Jose Fernandin 6 ",
        "postalCode": "33450",
        "city": "1133747",
        "province": "33",
        "CCAA": "31",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "130.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "130.00",
        "surfaceTotal": "130.00",
        "timeAvailableFrom": "9/13/22 13:24",
        "lat": 43.5601305,
        "lng": -5.974206199999999,
        "id_ext": "4205-120046-120046"
    },
    {
        "id": "b681e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "2",
        "askingPriceRent": "1640.80",
        "askingPriceSale": "276885.00",
        "address": "Calle San Sebastian 13-19 ",
        "postalCode": "17430",
        "city": "1117180",
        "province": "17",
        "CCAA": "55",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "292.60",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "292.60",
        "surfaceTotal": "292.60",
        "timeAvailableFrom": "9/13/22 13:24",
        "lat": 41.8624336,
        "lng": 2.6650879,
        "id_ext": "4205-120049-120049"
    },
    {
        "id": "b881e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "2",
        "askingPriceRent": "882.70",
        "askingPriceSale": "115430.00",
        "address": "Calle Cami De Mao, 153 ",
        "postalCode": "07760",
        "city": "1107015",
        "province": "07",
        "CCAA": "44",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "97.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "97.00",
        "surfaceTotal": "97.00",
        "timeAvailableFrom": "9/13/22 13:24",
        "lat": 40.00403499999999,
        "lng": 3.8467481,
        "id_ext": "4205-120051-120051"
    },
    {
        "id": "ba81e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "1",
        "askingPriceRent": "568.40",
        "askingPriceSale": "73080.00",
        "address": "Calle San Roque 22 ",
        "postalCode": "24549",
        "city": "1124038",
        "province": "24",
        "CCAA": "59",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "116.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "116.00",
        "surfaceTotal": "116.00",
        "timeAvailableFrom": "9/13/22 13:24",
        "lat": 42.5563387,
        "lng": -6.7306836,
        "id_ext": "4205-120053-120053"
    },
    {
        "id": "bc81e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "address": "Calle Rincon De Ademuz 29 ",
        "postalCode": "46018",
        "city": "1146250",
        "province": "46",
        "CCAA": "42",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "194.29",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "194.29",
        "surfaceTotal": "194.29",
        "timeAvailableFrom": "9/13/22 13:24",
        "lat": 39.47061009999999,
        "lng": -0.402506,
        "id_ext": "4205-120058-120058"
    },
    {
        "id": "68845e94-6233-ed11-9db1-0022489ca4d1",
        "active": true,
        "status": "Comercializable",
        "address": "Calle Rincon De Ademuz 29 ",
        "postalCode": "46018",
        "city": "1146250",
        "province": "46",
        "CCAA": "42",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "124.09",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "124.09",
        "surfaceTotal": "124.09",
        "timeAvailableFrom": "9/13/22 14:50",
        "lat": 39.47061009999999,
        "lng": -0.402506,
        "id_ext": "4205-120058-120468"
    },
    {
        "id": "be81e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "1",
        "askingPriceRent": "1232.00",
        "askingPriceSale": "184800.00",
        "address": "Avenida España 3 ",
        "postalCode": "29680",
        "city": "1129051",
        "province": "29",
        "CCAA": "51",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "110.12",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "110.12",
        "surfaceTotal": "110.12",
        "timeAvailableFrom": "9/13/22 13:24",
        "lat": 36.4256875,
        "lng": -5.1431323,
        "id_ext": "4205-120061-120061"
    },
    {
        "id": "c081e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - En legal",
        "strategy": "2",
        "askingPriceRent": "5404.06",
        "askingPriceSale": "810608.40",
        "address": " Alcalde Ramirez Bethencourt 17 ",
        "postalCode": "35004",
        "city": "1135016",
        "province": "35",
        "CCAA": "56",
        "country": "ES",
        "use": "5",
        "surfacebr": "398.34",
        "surfaceMezzanine": "0.00",
        "surfacepb": "286.30",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "398.34",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "405.80",
        "surfaceTotal": "684.64",
        "timeAvailableFrom": "9/13/22 13:24",
        "lat": 28.1168518,
        "lng": -15.4202617,
        "id_ext": "4205-120062-120062"
    },
    {
        "id": "c281e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "2",
        "askingPriceRent": "2274.30",
        "askingPriceSale": "328510.00",
        "address": "Calle Antonio Gaudi 54 ",
        "postalCode": "08830",
        "city": "1108200",
        "province": "08",
        "CCAA": "55",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "361.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "361.00",
        "surfaceTotal": "361.00",
        "timeAvailableFrom": "9/13/22 13:24",
        "lat": 41.3487538,
        "lng": 2.030067,
        "id_ext": "4205-120063-120063"
    },
    {
        "id": "c481e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "2",
        "askingPriceRent": "1631.70",
        "askingPriceSale": "233100.00",
        "address": "Avenida Ollerias 37 ",
        "postalCode": "14001",
        "city": "1114021",
        "province": "14",
        "CCAA": "51",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "333.12",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "333.12",
        "surfaceTotal": "333.12",
        "timeAvailableFrom": "9/13/22 13:24",
        "lat": 37.892667,
        "lng": -4.7720386,
        "id_ext": "4205-120064-120064"
    },
    {
        "id": "c681e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "2",
        "askingPriceRent": "1393.00",
        "askingPriceSale": "208950.00",
        "address": "Calle Prior Tapia 19 ",
        "postalCode": "08222",
        "city": "1108279",
        "province": "08",
        "CCAA": "55",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "199.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "199.00",
        "surfaceTotal": "199.00",
        "timeAvailableFrom": "9/13/22 13:24",
        "lat": 41.5618626,
        "lng": 2.0203784,
        "id_ext": "4205-120072-120072"
    },
    {
        "id": "c881e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Arrendado (propiedad)",
        "strategy": "2",
        "askingPriceRent": "1121.40",
        "askingPriceSale": "195550.32",
        "address": " Gerald Brenan 62 ",
        "postalCode": "29004",
        "city": "1129067",
        "province": "29",
        "CCAA": "51",
        "country": "ES",
        "use": "11",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "179.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "179.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "268.50",
        "surfaceTotal": "358.00",
        "timeAvailableFrom": "9/13/22 13:24",
        "lat": 36.6909544,
        "lng": -4.4769311,
        "id_ext": "4205-120081-120081"
    },
    {
        "id": "ca81e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "2",
        "askingPriceRent": "1386.00",
        "askingPriceSale": "207900.00",
        "address": " Candilejas 72-74 ",
        "district": "2807902",
        "postalCode": "28005",
        "city": "1128079",
        "province": "28",
        "CCAA": "54",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "208.64",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "208.64",
        "surfaceTotal": "208.64",
        "timeAvailableFrom": "9/13/22 13:24",
        "lat": 40.3817121,
        "lng": -3.664822,
        "id_ext": "4205-120375-120375"
    },
    {
        "id": "56845e94-6233-ed11-9db1-0022489ca4d1",
        "active": true,
        "status": "Comercializable",
        "strategy": "2",
        "address": "Calle Ancha 4 ",
        "postalCode": "14700",
        "city": "1114049",
        "province": "14",
        "CCAA": "51",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "187.60",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "187.60",
        "surfaceTotal": "187.60",
        "timeAvailableFrom": "9/13/22 14:50",
        "lat": 37.6979035,
        "lng": -5.2821294,
        "id_ext": "4205-120381-119848"
    },
    {
        "id": "cc81e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "2",
        "address": "Calle Ancha 4 ",
        "postalCode": "14700",
        "city": "1114049",
        "province": "14",
        "CCAA": "51",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "0.00",
        "surfaceBasement1": "98.63",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "98.63",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "49.32",
        "surfaceTotal": "98.63",
        "timeAvailableFrom": "9/13/22 13:24",
        "lat": 37.6979035,
        "lng": -5.2821294,
        "id_ext": "4205-120381-120381"
    },
    {
        "id": "5c845e94-6233-ed11-9db1-0022489ca4d1",
        "active": true,
        "status": "Comercializable",
        "strategy": "2",
        "address": "Calle Ancha 4 ",
        "postalCode": "14700",
        "city": "1114049",
        "province": "14",
        "CCAA": "51",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "0.00",
        "surfaceBasement1": "93.34",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "93.34",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "46.67",
        "surfaceTotal": "93.34",
        "timeAvailableFrom": "9/13/22 14:50",
        "lat": 37.6979035,
        "lng": -5.2821294,
        "id_ext": "4205-120381-120382"
    },
    {
        "id": "5e845e94-6233-ed11-9db1-0022489ca4d1",
        "active": true,
        "status": "Comercializable",
        "strategy": "2",
        "address": "Calle Ancha 4 ",
        "postalCode": "14700",
        "city": "1114049",
        "province": "14",
        "CCAA": "51",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "0.00",
        "surfaceBasement1": "87.75",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "87.75",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "43.88",
        "surfaceTotal": "87.75",
        "timeAvailableFrom": "9/13/22 14:50",
        "lat": 37.6979035,
        "lng": -5.2821294,
        "id_ext": "4205-120381-120383"
    },
    {
        "id": "60845e94-6233-ed11-9db1-0022489ca4d1",
        "active": true,
        "status": "Comercializable",
        "strategy": "2",
        "address": "Calle Ancha 4 ",
        "postalCode": "14700",
        "city": "1114049",
        "province": "14",
        "CCAA": "51",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "0.00",
        "surfaceBasement1": "78.15",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "78.15",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "39.08",
        "surfaceTotal": "78.15",
        "timeAvailableFrom": "9/13/22 14:50",
        "lat": 37.6979035,
        "lng": -5.2821294,
        "id_ext": "4205-120381-120384"
    },
    {
        "id": "ce81e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "1",
        "askingPriceRent": "2492.00",
        "askingPriceSale": "352156.00",
        "address": "Avenida De Madrid 16 ",
        "postalCode": "32630",
        "city": "1132032",
        "province": "32",
        "CCAA": "60",
        "country": "ES",
        "use": "1",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "0.00",
        "surfaceBasement1": "132.26",
        "surfaceBasement2": "57.03",
        "surfaceRest": "0.00",
        "surfacesr": "189.29",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "94.65",
        "surfaceTotal": "189.29",
        "timeAvailableFrom": "9/13/22 13:24",
        "lat": 42.0622372,
        "lng": -7.7244213,
        "id_ext": "4205-120600-120600"
    },
    {
        "id": "d281e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "2",
        "askingPriceRent": "709.52",
        "askingPriceSale": "98826.00",
        "address": "Avenida Hispanidad 55 ",
        "postalCode": "03800",
        "city": "1103009",
        "province": "03",
        "CCAA": "42",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "161.67",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "161.67",
        "surfaceTotal": "161.67",
        "timeAvailableFrom": "9/13/22 13:24",
        "lat": 38.7087698,
        "lng": -0.4650173,
        "id_ext": "4205-121490-121490"
    },
    {
        "id": "d481e90a-5633-ed11-9db1-0022489c4873",
        "active": false,
        "status": "Vendido",
        "strategy": "1",
        "address": " Canoa 9 ",
        "postalCode": "04711",
        "city": "1104902",
        "province": "04",
        "CCAA": "51",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "84.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "84.00",
        "surfaceTotal": "84.00",
        "timeAvailableFrom": "9/13/22 13:24",
        "lat": 36.696896,
        "lng": -2.7898465,
        "id_ext": "4205-121497-121497"
    },
    {
        "id": "d681e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Arrendado (propiedad)",
        "strategy": "2",
        "askingPriceRent": "1494.50",
        "askingPriceSale": "256200.00",
        "address": "Avenida De La Horchata 24 ",
        "postalCode": "46120",
        "city": "1146013",
        "province": "46",
        "CCAA": "42",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "295.85",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "295.85",
        "surfaceTotal": "295.85",
        "timeAvailableFrom": "9/13/22 13:24",
        "lat": 39.4989552,
        "lng": -0.3510141,
        "id_ext": "4205-121527-121527"
    },
    {
        "id": "d881e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "1",
        "askingPriceRent": "443.52",
        "askingPriceSale": "60480.00",
        "address": "Avenida Jaume Nadal, 1bis ",
        "postalCode": "25125",
        "city": "1125016",
        "province": "25",
        "CCAA": "55",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "143.84",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "143.84",
        "surfaceTotal": "143.84",
        "timeAvailableFrom": "9/13/22 13:24",
        "lat": 41.73593,
        "lng": 0.58421,
        "id_ext": "4205-121529-121529"
    },
    {
        "id": "da81e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "2",
        "askingPriceRent": "506.80",
        "askingPriceSale": "81088.00",
        "address": "Avenida De Lleida 61 ",
        "postalCode": "25126",
        "city": "1125021",
        "province": "25",
        "CCAA": "55",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "157.99",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "157.99",
        "surfaceTotal": "157.99",
        "timeAvailableFrom": "9/13/22 13:24",
        "lat": 41.7973638,
        "lng": 0.5699344,
        "id_ext": "4205-121530-121530"
    },
    {
        "id": "dc81e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "1",
        "askingPriceRent": "839.16",
        "askingPriceSale": "129276.00",
        "address": " Jose De Madinabeitia 14 ",
        "postalCode": "01470",
        "city": "1101002",
        "province": "01",
        "CCAA": "53",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "161.86",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "161.86",
        "surfaceTotal": "161.86",
        "timeAvailableFrom": "9/13/22 13:24",
        "lat": 43.0513944,
        "lng": -3.0028396,
        "id_ext": "4205-121538-121538"
    },
    {
        "id": "de81e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "2",
        "askingPriceRent": "709.80",
        "askingPriceSale": "118300.00",
        "address": " La Mar 159 ",
        "postalCode": "03590",
        "city": "1103018",
        "province": "03",
        "CCAA": "42",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "168.94",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "168.94",
        "surfaceTotal": "168.94",
        "timeAvailableFrom": "9/13/22 13:24",
        "lat": 38.592994,
        "lng": -0.05553900000000001,
        "id_ext": "4205-121549-121549"
    },
    {
        "id": "e081e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "1",
        "askingPriceRent": "715.68",
        "askingPriceSale": "107352.00",
        "address": " Francesc Camprodon 23 ",
        "postalCode": "17401",
        "city": "1117009",
        "province": "17",
        "CCAA": "55",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "53.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "149.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "127.50",
        "surfaceTotal": "202.00",
        "timeAvailableFrom": "9/13/22 13:24",
        "lat": 41.8161558,
        "lng": 2.5153255,
        "id_ext": "4205-121556-121556"
    },
    {
        "id": "e281e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "1",
        "askingPriceRent": "304.50",
        "askingPriceSale": "36750.00",
        "address": " Domenech Cardenal 36 ",
        "postalCode": "25262",
        "city": "1125041",
        "province": "25",
        "CCAA": "55",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "75.45",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "75.45",
        "surfaceTotal": "75.45",
        "timeAvailableFrom": "9/13/22 13:24",
        "lat": 41.67701,
        "lng": 1.01722,
        "id_ext": "4205-121586-121586"
    },
    {
        "id": "e481e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "2",
        "askingPriceRent": "3181.08",
        "askingPriceSale": "636216.00",
        "address": "Calle Layret 1 ",
        "postalCode": "08911",
        "city": "1108015",
        "province": "08",
        "CCAA": "55",
        "country": "ES",
        "use": "5",
        "surfacebr": "149.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "0.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "444.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "266.70",
        "surfaceTotal": "593.00",
        "timeAvailableFrom": "9/13/22 13:24",
        "lat": 41.44950679999999,
        "lng": 2.2460688,
        "id_ext": "4205-121595-121595"
    },
    {
        "id": "e681e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "1",
        "askingPriceRent": "828.80",
        "askingPriceSale": "124320.00",
        "address": " Mozart 17 ",
        "postalCode": "08914",
        "city": "1108015",
        "province": "08",
        "CCAA": "55",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "155.10",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "155.10",
        "surfaceTotal": "155.10",
        "timeAvailableFrom": "9/13/22 13:24",
        "lat": 41.4545716,
        "lng": 2.2172681,
        "id_ext": "4205-121601-121601"
    },
    {
        "id": "e881e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Arrendado (propiedad)",
        "strategy": "2",
        "askingPriceRent": "1694.00",
        "askingPriceSale": "321860.00",
        "address": " Rosari 45 ",
        "postalCode": "08017",
        "city": "1108019",
        "province": "08",
        "CCAA": "55",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "110.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "99.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "159.50",
        "surfaceTotal": "209.00",
        "timeAvailableFrom": "9/13/22 13:24",
        "lat": 41.3981421,
        "lng": 2.1320788,
        "id_ext": "4205-121653-121653"
    },
    {
        "id": "ea81e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "2",
        "askingPriceRent": "5002.80",
        "askingPriceSale": "1073080.46",
        "address": "Avenida Diagonal 311 ",
        "postalCode": "08029",
        "city": "1108019",
        "province": "08",
        "CCAA": "55",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "340.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "340.00",
        "surfaceTotal": "340.00",
        "timeAvailableFrom": "9/13/22 13:24",
        "lat": 41.3994999,
        "lng": 2.1729962,
        "id_ext": "4205-121655-121655"
    },
    {
        "id": "ec81e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "CAMBIO DE USO",
        "askingPriceRent": "1768.87",
        "askingPriceSale": "235849.60",
        "address": " Ibargarai 26 ",
        "postalCode": "20570",
        "city": "1120074",
        "province": "20",
        "CCAA": "53",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "169.15",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "169.15",
        "surfaceTotal": "169.15",
        "timeAvailableFrom": "9/13/22 13:24",
        "lat": 43.1164119,
        "lng": -2.4160708,
        "id_ext": "4205-121677-121677"
    },
    {
        "id": "ee81e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Arrendado (propiedad)",
        "strategy": "1",
        "askingPriceRent": "21639.24",
        "askingPriceSale": "4183586.40",
        "address": " Gran Via Don Diego Lope De Haro 17 ",
        "postalCode": "48001",
        "city": "1148020",
        "province": "48",
        "CCAA": "53",
        "country": "ES",
        "use": "7",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "0.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "1062.44",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "1062.44",
        "surfaceTotal": "1062.44",
        "timeAvailableFrom": "9/13/22 13:24",
        "lat": 43.2633324,
        "lng": -2.9364132,
        "id_ext": "4205-121682-121682"
    },
    {
        "id": "f081e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "1",
        "askingPriceRent": "1089.56",
        "askingPriceSale": "155652.00",
        "address": "Plaza Mayor 14 ",
        "postalCode": "42300",
        "city": "1142043",
        "province": "42",
        "CCAA": "59",
        "country": "ES",
        "use": "5",
        "surfacebr": "35.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "100.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "35.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "110.50",
        "surfaceTotal": "135.00",
        "timeAvailableFrom": "9/13/22 13:24",
        "lat": 41.5869028,
        "lng": -3.0677644,
        "id_ext": "4205-121705-121705"
    },
    {
        "id": "f281e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "1",
        "askingPriceRent": "1607.26",
        "askingPriceSale": "311857.00",
        "address": " Santamañe 3 ",
        "postalCode": "48370",
        "city": "1148017",
        "province": "48",
        "CCAA": "53",
        "country": "ES",
        "use": "5",
        "surfacebr": "30.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "194.69",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "203.69",
        "surfaceTotal": "224.69",
        "timeAvailableFrom": "9/13/22 13:24",
        "lat": 43.4179804,
        "lng": -2.723668,
        "id_ext": "4205-121713-121713"
    },
    {
        "id": "f481e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "1",
        "askingPriceRent": "591.95",
        "askingPriceSale": "87696.00",
        "address": " Menendez Y Pelayo 2 ",
        "postalCode": "12530",
        "city": "1112032",
        "province": "12",
        "CCAA": "42",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "140.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "140.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "210.00",
        "surfaceTotal": "280.00",
        "timeAvailableFrom": "9/13/22 13:24",
        "lat": 39.8890151,
        "lng": -0.0865406,
        "id_ext": "4205-121716-121716"
    },
    {
        "id": "f681e90a-5633-ed11-9db1-0022489c4873",
        "active": false,
        "status": "Vendido",
        "strategy": "1",
        "askingPriceRent": "451.50",
        "askingPriceSale": "54180.00",
        "address": "Plaza De Ovando 20 ",
        "postalCode": "10950",
        "city": "1110032",
        "province": "10",
        "CCAA": "41",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "111.65",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "111.65",
        "surfaceTotal": "111.65",
        "timeAvailableFrom": "9/13/22 13:24",
        "lat": 39.6127096,
        "lng": -6.7781444,
        "id_ext": "4205-121717-121717"
    },
    {
        "id": "f881e90a-5633-ed11-9db1-0022489c4873",
        "active": false,
        "status": "Vendido",
        "strategy": "1",
        "askingPriceRent": "361.20",
        "askingPriceSale": "42140.00",
        "address": "Paseo De La Constitucion 32 ",
        "postalCode": "23280",
        "city": "1123012",
        "province": "23",
        "CCAA": "51",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "82.13",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "82.13",
        "surfaceTotal": "82.13",
        "timeAvailableFrom": "9/13/22 13:24",
        "lat": 38.2534703,
        "lng": -2.8888912,
        "id_ext": "4205-121718-121718"
    },
    {
        "id": "fa81e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - En legal",
        "strategy": "1",
        "askingPriceRent": "320.04",
        "askingPriceSale": "44450.00",
        "address": "Plaza Verge De Les Sogues 1 ",
        "postalCode": "25142",
        "city": "1125052",
        "province": "25",
        "CCAA": "55",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "117.01",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "117.01",
        "surfaceTotal": "117.01",
        "timeAvailableFrom": "9/13/22 13:24",
        "lat": 41.672876,
        "lng": 0.8178133000000001,
        "id_ext": "4205-121733-121733"
    },
    {
        "id": "fc81e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Arrendado (propiedad)",
        "strategy": "1",
        "askingPriceRent": "1753.92",
        "askingPriceSale": "347760.00",
        "address": "Calle San Wenceslao de Calypso 28 ",
        "postalCode": "29649",
        "city": "1129649",
        "province": "29",
        "CCAA": "51",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "108.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "108.00",
        "surfaceTotal": "108.00",
        "timeAvailableFrom": "9/13/22 13:24",
        "lat": 36.4895257,
        "lng": -4.7143593,
        "id_ext": "4205-121738-121738"
    },
    {
        "id": "fe81e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "2",
        "askingPriceRent": "1113.17",
        "askingPriceSale": "125231.40",
        "address": "Calle Julian Ribera 27 ",
        "postalCode": "46740",
        "city": "1146083",
        "province": "46",
        "CCAA": "42",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "198.78",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "198.78",
        "surfaceTotal": "198.78",
        "timeAvailableFrom": "9/13/22 13:24",
        "lat": 39.1214888,
        "lng": -0.4497762,
        "id_ext": "4205-121778-121778"
    },
    {
        "id": "0082e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "2",
        "askingPriceRent": "2447.20",
        "askingPriceSale": "322000.00",
        "address": " Llibertat 8 ",
        "postalCode": "08860",
        "city": "1108056",
        "province": "08",
        "CCAA": "55",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "190.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "190.00",
        "surfaceTotal": "190.00",
        "timeAvailableFrom": "9/13/22 13:24",
        "lat": 41.2789061,
        "lng": 1.9767421,
        "id_ext": "4205-121782-121782"
    },
    {
        "id": "0282e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "2",
        "askingPriceRent": "2518.95",
        "askingPriceSale": "352653.00",
        "address": "Calle Fuente 44905 ",
        "postalCode": "11130",
        "city": "1111015",
        "province": "11",
        "CCAA": "51",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "359.85",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "359.85",
        "surfaceTotal": "359.85",
        "timeAvailableFrom": "9/13/22 13:24",
        "lat": 36.4206001,
        "lng": -6.146621,
        "id_ext": "4205-121801-121801"
    },
    {
        "id": "0482e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - En legal",
        "strategy": "1",
        "askingPriceRent": "521.47",
        "askingPriceSale": "93221.93",
        "address": "Avenida De La Constitucion 87 ",
        "postalCode": "24800",
        "city": "1124056",
        "province": "24",
        "CCAA": "59",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "107.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "107.00",
        "surfaceTotal": "107.00",
        "timeAvailableFrom": "9/13/22 13:24",
        "lat": 42.8028971,
        "lng": -5.1277548,
        "id_ext": "4205-121808-121808"
    },
    {
        "id": "0682e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "2",
        "askingPriceRent": "2116.80",
        "askingPriceSale": "282240.00",
        "address": " Puerto De Barcelona ",
        "postalCode": "28821",
        "city": "1128049",
        "province": "28",
        "CCAA": "54",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "166.92",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "166.92",
        "surfaceTotal": "166.92",
        "timeAvailableFrom": "9/13/22 13:24",
        "lat": 40.4194596,
        "lng": -3.5722344,
        "id_ext": "4205-121862-121862"
    },
    {
        "id": "0882e90a-5633-ed11-9db1-0022489c4873",
        "active": false,
        "status": "Vendido",
        "strategy": "1",
        "askingPriceRent": "672.00",
        "askingPriceSale": "89600.00",
        "address": " Urbano Pineda s/n ",
        "postalCode": "29100",
        "city": "1129042",
        "province": "29",
        "CCAA": "51",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "159.88",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "159.88",
        "surfaceTotal": "159.88",
        "timeAvailableFrom": "9/13/22 13:24",
        "lat": 36.6611779,
        "lng": -4.7551085,
        "id_ext": "4205-121863-121863"
    },
    {
        "id": "0a82e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "2",
        "askingPriceRent": "1330.00",
        "askingPriceSale": "212800.00",
        "address": " Cervantes 70 ",
        "postalCode": "41100",
        "city": "1141034",
        "province": "41",
        "CCAA": "51",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "239.44",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "239.44",
        "surfaceTotal": "239.44",
        "timeAvailableFrom": "9/13/22 13:24",
        "lat": 37.2841986,
        "lng": -6.052636,
        "id_ext": "4205-121867-121867"
    },
    {
        "id": "0c82e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "2",
        "askingPriceRent": "1607.20",
        "askingPriceSale": "180924.80",
        "address": " Merlina 20 ",
        "postalCode": "41700",
        "city": "1141038",
        "province": "41",
        "CCAA": "51",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "222.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "222.00",
        "surfaceTotal": "222.00",
        "timeAvailableFrom": "9/13/22 13:24",
        "lat": 37.2810042,
        "lng": -5.991836999999999,
        "id_ext": "4205-121875-121875"
    },
    {
        "id": "0e82e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "2",
        "askingPriceRent": "1114.40",
        "askingPriceSale": "222880.00",
        "address": "Avenida Campo Torres 37 ",
        "postalCode": "03700",
        "city": "1103063",
        "province": "03",
        "CCAA": "42",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "214.30",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "214.30",
        "surfaceTotal": "214.30",
        "timeAvailableFrom": "9/13/22 13:24",
        "lat": 38.838625,
        "lng": 0.1000138,
        "id_ext": "4205-121881-121881"
    },
    {
        "id": "1082e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "1",
        "askingPriceRent": "833.00",
        "askingPriceSale": "119000.00",
        "address": " Charles Darwin 6 ",
        "postalCode": "03203",
        "city": "1103065",
        "province": "03",
        "CCAA": "42",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "170.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "170.00",
        "surfaceTotal": "170.00",
        "timeAvailableFrom": "9/13/22 13:24",
        "lat": 38.2922661,
        "lng": -0.6095290999999999,
        "id_ext": "4205-121901-121901"
    },
    {
        "id": "1282e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "1",
        "askingPriceRent": "769.86",
        "askingPriceSale": "110544.00",
        "address": " Diagonal 29 ",
        "postalCode": "03206",
        "city": "1103065",
        "province": "03",
        "CCAA": "42",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "140.24",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "140.24",
        "surfaceTotal": "140.24",
        "timeAvailableFrom": "9/13/22 13:24",
        "lat": 38.2699329,
        "lng": -0.7125608,
        "id_ext": "4205-121907-121907"
    },
    {
        "id": "1482e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "1",
        "askingPriceRent": "1601.60",
        "askingPriceSale": "246400.00",
        "address": " Cabañal 4 ",
        "city": "1146105",
        "province": "46",
        "CCAA": "42",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "180.11",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "180.11",
        "surfaceTotal": "180.11",
        "timeAvailableFrom": "9/13/22 13:24",
        "lat": 39.1642848,
        "lng": -0.2460687,
        "id_ext": "4205-121938-121938"
    },
    {
        "id": "1682e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Arrendado (propiedad)",
        "strategy": "2",
        "askingPriceRent": "1152.90",
        "askingPriceSale": "179340.00",
        "address": "Plaza Orient S/N ",
        "postalCode": "07580",
        "city": "1107014",
        "province": "07",
        "CCAA": "44",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "182.69",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "182.69",
        "surfaceTotal": "182.69",
        "timeAvailableFrom": "9/13/22 13:24",
        "lat": 39.7021506,
        "lng": 3.43403,
        "id_ext": "4205-121951-121951"
    },
    {
        "id": "1882e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "2",
        "askingPriceRent": "5434.80",
        "askingPriceSale": "695800.00",
        "address": " Hospici 7 ",
        "postalCode": "07200",
        "city": "1107022",
        "province": "07",
        "CCAA": "44",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "0.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "221.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "110.50",
        "surfaceTotal": "221.00",
        "timeAvailableFrom": "9/13/22 13:24",
        "lat": 39.4694903,
        "lng": 3.1505961,
        "id_ext": "4205-121968-121968"
    },
    {
        "id": "1a82e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "1",
        "askingPriceRent": "733.60",
        "askingPriceSale": "110040.00",
        "address": "Calle De Castela 104 ",
        "postalCode": "15578",
        "city": "1115054",
        "province": "15",
        "CCAA": "60",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "115.80",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "115.80",
        "surfaceTotal": "115.80",
        "timeAvailableFrom": "9/13/22 13:24",
        "lat": 43.497601,
        "lng": -8.199752199999999,
        "id_ext": "4205-121972-121972"
    },
    {
        "id": "1c82e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Arrendado (propiedad)",
        "strategy": "2",
        "askingPriceRent": "1036.35",
        "askingPriceSale": "128310.00",
        "address": "Avenida Santa Cruz 121 ",
        "postalCode": "38611",
        "city": "1138017",
        "province": "38",
        "CCAA": "56",
        "country": "ES",
        "use": "5",
        "surfacebr": "53.30",
        "surfaceMezzanine": "0.00",
        "surfacepb": "150.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "137.12",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "234.55",
        "surfaceTotal": "340.42",
        "timeAvailableFrom": "9/13/22 13:24",
        "lat": 28.0762229,
        "lng": -16.5570951,
        "id_ext": "4205-121990-121990"
    },
    {
        "id": "1e82e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Arrendado (propiedad)",
        "strategy": "2",
        "askingPriceRent": "5368.64",
        "askingPriceSale": "601809.60",
        "address": "Avenida Jose Luis Perez Pujada 7 ",
        "postalCode": "18006",
        "city": "1118087",
        "province": "18",
        "CCAA": "51",
        "country": "ES",
        "use": "7",
        "surfacebr": "34.97",
        "surfaceMezzanine": "0.00",
        "surfacepb": "0.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "460.46",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "240.72",
        "surfaceTotal": "495.43",
        "timeAvailableFrom": "9/13/22 13:24",
        "lat": 37.1604092,
        "lng": -3.6077322,
        "id_ext": "4205-122028-122028"
    },
    {
        "id": "2082e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "2",
        "askingPriceSale": "753130.00",
        "address": " Madrid 92 ",
        "postalCode": "28902",
        "city": "1128065",
        "province": "28",
        "CCAA": "54",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "286.30",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "286.30",
        "surfaceTotal": "286.30",
        "timeAvailableFrom": "9/13/22 13:24",
        "lat": 40.3082504,
        "lng": -3.7323934,
        "id_ext": "4205-122042-122042"
    },
    {
        "id": "2282e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Comité",
        "strategy": "2",
        "askingPriceSale": "147700.00",
        "address": "Avenida Del Ejercito 11 ",
        "postalCode": "19004",
        "city": "1119130",
        "province": "19",
        "CCAA": "40",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "202.81",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "202.81",
        "surfaceTotal": "202.81",
        "timeAvailableFrom": "9/13/22 13:24",
        "lat": 40.6322013,
        "lng": -3.1756518,
        "id_ext": "4205-122045-122045"
    },
    {
        "id": "2482e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "2",
        "askingPriceRent": "686.00",
        "askingPriceSale": "95550.00",
        "address": " Real 37 ",
        "postalCode": "04230",
        "city": "1104052",
        "province": "04",
        "CCAA": "51",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "161.98",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "161.98",
        "surfaceTotal": "161.98",
        "timeAvailableFrom": "9/13/22 13:24",
        "lat": 36.8881816,
        "lng": -2.4445519,
        "id_ext": "4205-122052-122052"
    },
    {
        "id": "2682e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "2",
        "askingPriceRent": "1520.40",
        "askingPriceSale": "177380.00",
        "address": " Zubiarte 33 ",
        "postalCode": "31620",
        "city": "1131122",
        "province": "31",
        "CCAA": "11",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "161.54",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "161.54",
        "surfaceTotal": "161.54",
        "timeAvailableFrom": "9/13/22 13:24",
        "lat": 42.8319895,
        "lng": -1.5894891,
        "id_ext": "4205-122064-122064"
    },
    {
        "id": "2882e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "2",
        "address": " Larga 18 ",
        "postalCode": "11004",
        "city": "1111020",
        "province": "11",
        "CCAA": "51",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "103.59",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "241.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "224.09",
        "surfaceTotal": "344.59",
        "timeAvailableFrom": "9/13/22 13:24",
        "lat": 36.68366,
        "lng": -6.136489999999999,
        "id_ext": "4205-122098-122098"
    },
    {
        "id": "2a82e90a-5633-ed11-9db1-0022489c4873",
        "active": false,
        "status": "Vendido",
        "strategy": "1",
        "askingPriceRent": "642.60",
        "askingPriceSale": "85680.00",
        "address": " Diputacion Foral 8 ",
        "postalCode": "31580",
        "city": "1131157",
        "province": "31",
        "CCAA": "11",
        "country": "ES",
        "use": "6",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "98.70",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "98.70",
        "surfaceTotal": "98.70",
        "timeAvailableFrom": "9/13/22 13:24",
        "lat": 42.4226679,
        "lng": -2.0791952,
        "id_ext": "4205-122157-122157"
    },
    {
        "id": "2c82e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Arrendado (propiedad)",
        "strategy": "2",
        "askingPriceRent": "1995.00",
        "askingPriceSale": "239400.00",
        "address": "Plaza Jose Ramon Aketxe 5 ",
        "postalCode": "48940",
        "city": "1148054",
        "province": "48",
        "CCAA": "53",
        "country": "ES",
        "use": "5",
        "smokeStractor": true,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "125.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "55.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "152.50",
        "surfaceTotal": "180.00",
        "timeAvailableFrom": "9/13/22 13:24",
        "lat": 43.3258801,
        "lng": -2.9864402,
        "id_ext": "4205-122158-122158"
    },
    {
        "id": "2e82e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "2",
        "askingPriceRent": "1863.68",
        "askingPriceSale": "279552.00",
        "address": " Rio Duero 46 ",
        "postalCode": "28913",
        "city": "1128074",
        "province": "28",
        "CCAA": "54",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "166.40",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "166.40",
        "surfaceTotal": "166.40",
        "timeAvailableFrom": "9/13/22 13:24",
        "lat": 40.3353441,
        "lng": -3.7705233,
        "id_ext": "4205-122164-122164"
    },
    {
        "id": "3082e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "2",
        "askingPriceRent": "1246.00",
        "askingPriceSale": "168210.00",
        "address": " Benizalon ",
        "postalCode": "04007",
        "city": "1104013",
        "province": "04",
        "CCAA": "51",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "174.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "174.00",
        "surfaceTotal": "174.00",
        "timeAvailableFrom": "9/13/22 13:24",
        "lat": 37.212213,
        "lng": -2.2411956,
        "id_ext": "4205-122166-122166"
    },
    {
        "id": "3282e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "2",
        "askingPriceRent": "1209.60",
        "askingPriceSale": "161280.00",
        "address": " Granada 131 ",
        "postalCode": "04009",
        "city": "1104013",
        "province": "04",
        "CCAA": "51",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "189.10",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "189.10",
        "surfaceTotal": "189.10",
        "timeAvailableFrom": "9/13/22 13:24",
        "lat": 36.834047,
        "lng": -2.4637136,
        "id_ext": "4205-122167-122167"
    },
    {
        "id": "3482e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "2",
        "askingPriceRent": "1037.40",
        "askingPriceSale": "141960.00",
        "address": "Avenida Cabo de Gata 141 ",
        "postalCode": "04007",
        "city": "1104013",
        "province": "04",
        "CCAA": "51",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "158.27",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "158.27",
        "surfaceTotal": "158.27",
        "timeAvailableFrom": "9/13/22 13:24",
        "lat": 36.8268352,
        "lng": -2.449403,
        "id_ext": "4205-122168-122168"
    },
    {
        "id": "3682e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "1",
        "askingPriceRent": "520.80",
        "askingPriceSale": "69440.00",
        "address": "Avenida Mariano Andres 182 ",
        "postalCode": "24008",
        "city": "1124089",
        "province": "24",
        "CCAA": "59",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "0.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "170.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "85.00",
        "surfaceTotal": "170.00",
        "timeAvailableFrom": "9/13/22 13:24",
        "lat": 42.6153355,
        "lng": -5.5684144,
        "id_ext": "4205-122174-122174"
    },
    {
        "id": "3882e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "2",
        "askingPriceSale": "155750.00",
        "address": " Jose Maria De Pereda 15 ",
        "postalCode": "24006",
        "city": "1124089",
        "province": "24",
        "CCAA": "59",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "175.12",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "175.12",
        "surfaceTotal": "175.12",
        "timeAvailableFrom": "9/13/22 13:24",
        "lat": 42.5915999,
        "lng": -5.5618715,
        "id_ext": "4205-122177-122177"
    },
    {
        "id": "3a82e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "2",
        "askingPriceRent": "640.64",
        "askingPriceSale": "99008.00",
        "address": "Avenida Jose Maria Fernandez 42 ",
        "postalCode": "24006",
        "city": "1124089",
        "province": "24",
        "CCAA": "59",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "104.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "104.00",
        "surfaceTotal": "104.00",
        "timeAvailableFrom": "9/13/22 13:24",
        "lat": 42.5986475,
        "lng": -5.5616746,
        "id_ext": "4205-122178-122178"
    },
    {
        "id": "3c82e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "2",
        "askingPriceRent": "1643.46",
        "askingPriceSale": "279930.00",
        "address": "Avenida Blas Infante s/n ",
        "postalCode": "21440",
        "city": "1121044",
        "province": "21",
        "CCAA": "51",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "290.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "290.00",
        "surfaceTotal": "290.00",
        "timeAvailableFrom": "9/13/22 13:24",
        "lat": 37.2515747,
        "lng": -7.2065574,
        "id_ext": "4205-122185-122185"
    },
    {
        "id": "3e82e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "2",
        "askingPriceSale": "45360.00",
        "address": "Plaza Fonte Dos Ranchos 6 ",
        "postalCode": "27004",
        "city": "1127028",
        "province": "27",
        "CCAA": "60",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "110.97",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "110.97",
        "surfaceTotal": "110.97",
        "timeAvailableFrom": "9/13/22 13:24",
        "lat": 43.01298,
        "lng": -7.565399999999999,
        "id_ext": "4205-122197-122197"
    },
    {
        "id": "4082e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "1",
        "askingPriceRent": "1309.24",
        "askingPriceSale": "206752.00",
        "address": " Quiroga 4 ",
        "postalCode": "27004",
        "city": "1127028",
        "province": "27",
        "CCAA": "60",
        "country": "ES",
        "use": "5",
        "surfacebr": "26.67",
        "surfaceMezzanine": "0.00",
        "surfacepb": "150.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "198.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "257.00",
        "surfaceTotal": "374.67",
        "timeAvailableFrom": "9/13/22 13:24",
        "lat": 43.0130821,
        "lng": -7.5658794,
        "id_ext": "4205-122198-122198"
    },
    {
        "id": "4282e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "CAMBIO DE USO",
        "askingPriceRent": "1659.00",
        "askingPriceSale": "185808.00",
        "address": "Avenida Onze De Setembre 33 ",
        "postalCode": "08120",
        "city": "1108105",
        "province": "08",
        "CCAA": "55",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "185.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "104.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "237.00",
        "surfaceTotal": "289.00",
        "timeAvailableFrom": "9/13/22 13:24",
        "lat": 41.512476,
        "lng": 2.1922326,
        "id_ext": "4205-122206-122206"
    },
    {
        "id": "4482e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "2",
        "address": " Puente 4 ",
        "postalCode": "36500",
        "city": "1136024",
        "province": "36",
        "CCAA": "60",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "189.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "189.00",
        "surfaceTotal": "189.00",
        "timeAvailableFrom": "9/13/22 13:24",
        "lat": 42.6611505,
        "lng": -8.1110256,
        "id_ext": "4205-122222-122222"
    },
    {
        "id": "4682e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "2",
        "askingPriceRent": "5565.00",
        "askingPriceSale": "890400.00",
        "address": " Juan Rejon 95 ",
        "postalCode": "35008",
        "city": "1135016",
        "province": "35",
        "CCAA": "56",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "560.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "560.00",
        "surfaceTotal": "560.00",
        "timeAvailableFrom": "9/13/22 13:24",
        "lat": 28.1495929,
        "lng": -15.4244147,
        "id_ext": "4205-122236-122236"
    },
    {
        "id": "4882e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "2",
        "askingPriceRent": "1440.60",
        "askingPriceSale": "174930.00",
        "address": "Avenida Libertad ",
        "postalCode": "30710",
        "city": "1130902",
        "province": "30",
        "CCAA": "43",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "147.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "147.00",
        "surfaceTotal": "147.00",
        "timeAvailableFrom": "9/13/22 13:24",
        "lat": 37.7429881,
        "lng": -0.8500143,
        "id_ext": "4205-122248-122248"
    },
    {
        "id": "4a82e90a-5633-ed11-9db1-0022489c4873",
        "active": false,
        "status": "Vendido",
        "strategy": "1",
        "askingPriceRent": "1154.30",
        "askingPriceSale": "237650.00",
        "address": " Torre Arias 6 ",
        "postalCode": "28022",
        "city": "1128079",
        "province": "28",
        "CCAA": "54",
        "country": "ES",
        "use": "5",
        "surfacebr": "96.59",
        "surfaceMezzanine": "0.00",
        "surfacepb": "0.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "102.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "79.98",
        "surfaceTotal": "198.59",
        "timeAvailableFrom": "9/13/22 13:24",
        "lat": 40.4459882,
        "lng": -3.6120582,
        "id_ext": "4205-122269-122269"
    },
    {
        "id": "4c82e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "CAMBIO DE USO",
        "askingPriceRent": "2128.00",
        "askingPriceSale": "404266.34",
        "address": "Avenida De La Osa Mayor 85 ",
        "district": "2807909",
        "postalCode": "28023",
        "city": "1128079",
        "province": "28",
        "CCAA": "54",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "76.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "76.00",
        "surfaceTotal": "76.00",
        "timeAvailableFrom": "9/13/22 13:24",
        "lat": 40.459037,
        "lng": -3.7837053,
        "id_ext": "4205-122270-122270"
    },
    {
        "id": "4e82e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "1",
        "askingPriceRent": "3763.20",
        "askingPriceSale": "721280.00",
        "address": "Carretera De Canillas 140 ",
        "district": "2807916",
        "postalCode": "28043",
        "city": "1128079",
        "province": "28",
        "CCAA": "54",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "96.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "128.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "160.00",
        "surfaceTotal": "224.00",
        "timeAvailableFrom": "9/13/22 13:24",
        "lat": 40.4650517,
        "lng": -3.6392157,
        "id_ext": "4205-122349-122349"
    },
    {
        "id": "5082e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Arrendado (propiedad)",
        "strategy": "2",
        "askingPriceRent": "2153.40",
        "askingPriceSale": "329560.72",
        "address": " Santa Virgilia 21 ",
        "district": "2807916",
        "postalCode": "28033",
        "city": "1128079",
        "province": "28",
        "CCAA": "54",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "215.94",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "215.94",
        "surfaceTotal": "215.94",
        "timeAvailableFrom": "9/13/22 13:24",
        "lat": 40.47670979999999,
        "lng": -3.6405177,
        "id_ext": "4205-122350-122350"
    },
    {
        "id": "5282e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Arrendado (propiedad)",
        "askingPriceRent": "7145.60",
        "askingPriceSale": "1339800.00",
        "address": "Calle Francisco Silvela 46 ",
        "strategy": "2",
        "district": "2807904",
        "postalCode": "28028",
        "city": "1128079",
        "province": "28",
        "CCAA": "54",
        "country": "ES",
        "use": "5",
        "surfacebr": "347.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "356.12",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "460.22",
        "surfaceTotal": "703.12",
        "timeAvailableFrom": "9/13/22 13:24",
        "lat": 40.43398639999999,
        "lng": -3.673423,
        "id_ext": "4205-122351-122351"
    },
    {
        "id": "6a845e94-6233-ed11-9db1-0022489ca4d1",
        "active": true,
        "status": "Comercializable",
        "address": "Calle Francisco Silvela 46 ",
        "district": "2807904",
        "postalCode": "28028",
        "city": "1128079",
        "province": "28",
        "CCAA": "54",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "0.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "308.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "154.00",
        "surfaceTotal": "308.00",
        "timeAvailableFrom": "9/13/22 14:50",
        "lat": 40.43398639999999,
        "lng": -3.673423,
        "id_ext": "4205-122352-122352"
    },
    {
        "id": "5482e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "1",
        "askingPriceRent": "5417.12",
        "askingPriceSale": "896000.00",
        "address": " Valderribas 72 ",
        "district": "2807903",
        "postalCode": "28007",
        "city": "1128079",
        "province": "28",
        "CCAA": "54",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "0.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "324.25",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "162.13",
        "surfaceTotal": "324.25",
        "timeAvailableFrom": "9/13/22 13:24",
        "lat": 40.4019916,
        "lng": -3.6701748,
        "id_ext": "4205-122369-122369"
    },
    {
        "id": "5682e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Arrendado (propiedad)",
        "strategy": "2",
        "askingPriceRent": "2419.83",
        "askingPriceSale": "403305.00",
        "address": " Gran Via de Hortaleza 59 ",
        "district": "2807901",
        "postalCode": "28004",
        "city": "1128079",
        "province": "28",
        "CCAA": "54",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "115.23",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "115.23",
        "surfaceTotal": "115.23",
        "timeAvailableFrom": "9/13/22 13:24",
        "lat": 40.4690049,
        "lng": -3.64551,
        "id_ext": "4205-122386-122386"
    },
    {
        "id": "5882e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "2",
        "askingPriceRent": "2636.21",
        "askingPriceSale": "341156.20",
        "address": " Hermanos Garcia Noblejas 18-20 ",
        "district": "2807915",
        "postalCode": "28037",
        "city": "1128079",
        "province": "28",
        "CCAA": "54",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "221.53",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "221.53",
        "surfaceTotal": "221.53",
        "timeAvailableFrom": "9/13/22 13:24",
        "lat": 40.43548759999999,
        "lng": -3.6366165,
        "id_ext": "4205-122387-122387"
    },
    {
        "id": "5a82e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Arrendado (propiedad)",
        "strategy": "2",
        "askingPriceRent": "10678.50",
        "askingPriceSale": "2273099.20",
        "address": " Lopez De Hoyos 135-137 ",
        "postalCode": "28079",
        "city": "1128079",
        "province": "28",
        "CCAA": "54",
        "country": "ES",
        "use": "11",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "565.39",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "565.39",
        "surfaceTotal": "565.39",
        "timeAvailableFrom": "9/13/22 13:24",
        "lat": 40.4471346,
        "lng": -3.6698059,
        "id_ext": "4205-122389-122389"
    },
    {
        "id": "5c82e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "2",
        "askingPriceRent": "1024.80",
        "askingPriceSale": "140910.00",
        "address": " Calvo Sotelo 9 ",
        "postalCode": "36900",
        "city": "1136026",
        "province": "36",
        "CCAA": "60",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "193.32",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "193.32",
        "surfaceTotal": "193.32",
        "timeAvailableFrom": "9/13/22 13:24",
        "id_ext": "4205-122397-122397"
    },
    {
        "id": "5e82e90a-5633-ed11-9db1-0022489c4873",
        "active": false,
        "status": "Vendido",
        "strategy": "1",
        "askingPriceRent": "487.20",
        "askingPriceSale": "60900.00",
        "address": "Calle Ana De Velasco 5 ",
        "postalCode": "31340",
        "city": "1131163",
        "province": "31",
        "CCAA": "11",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "87.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "87.00",
        "surfaceTotal": "87.00",
        "timeAvailableFrom": "9/13/22 13:24",
        "lat": 42.3271295,
        "lng": -1.7393763,
        "id_ext": "4205-122406-122406"
    },
    {
        "id": "6082e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "1",
        "askingPriceRent": "770.00",
        "askingPriceSale": "137443.89",
        "address": " Cirilo Santos 21 ",
        "postalCode": "24240",
        "city": "1124157",
        "province": "24",
        "CCAA": "59",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "186.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "186.00",
        "surfaceTotal": "186.00",
        "timeAvailableFrom": "9/13/22 13:24",
        "lat": 42.3528511,
        "lng": -5.7542094,
        "id_ext": "4205-122409-122409"
    },
    {
        "id": "6282e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "2",
        "askingPriceSale": "294000.00",
        "address": "Avenida Abenarabi 4 ",
        "postalCode": "30008",
        "city": "1130030",
        "province": "30",
        "CCAA": "43",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "112.60",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "112.60",
        "surfaceTotal": "112.60",
        "timeAvailableFrom": "9/13/22 13:24",
        "lat": 37.9964158,
        "lng": -1.1327857,
        "id_ext": "4205-122441-122441"
    },
    {
        "id": "6482e90a-5633-ed11-9db1-0022489c4873",
        "active": false,
        "status": "Vendido",
        "strategy": "1",
        "askingPriceRent": "478.04",
        "askingPriceSale": "61110.00",
        "address": " La Tercia 61 ",
        "postalCode": "13420",
        "city": "1113052",
        "province": "13",
        "CCAA": "40",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "96.88",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "96.88",
        "surfaceTotal": "96.88",
        "timeAvailableFrom": "9/13/22 13:24",
        "lat": 39.1668064,
        "lng": -3.853225,
        "id_ext": "4205-122443-122443"
    },
    {
        "id": "6682e90a-5633-ed11-9db1-0022489c4873",
        "active": false,
        "status": "Vendido",
        "strategy": "2",
        "askingPriceRent": "1103.26",
        "askingPriceSale": "128713.20",
        "address": " Orti Lara 4 ",
        "postalCode": "23770",
        "city": "1123059",
        "province": "23",
        "CCAA": "51",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "131.34",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "131.34",
        "surfaceTotal": "131.34",
        "timeAvailableFrom": "9/13/22 13:24",
        "lat": 38.0445283,
        "lng": -4.1701941,
        "id_ext": "4205-122447-122447"
    },
    {
        "id": "6882e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Arrendado (propiedad)",
        "strategy": "2",
        "askingPriceSale": "126840.00",
        "address": "Carretera Madrid Cartagena 381 ",
        "postalCode": "30500",
        "city": "1130027",
        "province": "30",
        "CCAA": "43",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "151.37",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "151.37",
        "surfaceTotal": "151.37",
        "timeAvailableFrom": "9/13/22 13:25",
        "lat": 38.048026,
        "lng": -1.2117416,
        "id_ext": "4205-122463-122463"
    },
    {
        "id": "6a82e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Arrendado (propiedad)",
        "strategy": "2",
        "askingPriceRent": "4681.60",
        "askingPriceSale": "790020.00",
        "address": " Ricardo Soriano 52 ",
        "postalCode": "29601",
        "city": "1129069",
        "province": "29",
        "CCAA": "51",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "209.30",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "209.30",
        "surfaceTotal": "209.30",
        "timeAvailableFrom": "9/13/22 13:25",
        "lat": 36.5107382,
        "lng": -4.8940898,
        "id_ext": "4205-122485-122485"
    },
    {
        "id": "6c82e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Arrendado (propiedad)",
        "strategy": "2",
        "askingPriceRent": "1834.69",
        "askingPriceSale": "224239.40",
        "address": "Plaza Marcelina De Monteys 5 ",
        "city": "1108118",
        "province": "08",
        "CCAA": "55",
        "country": "ES",
        "use": "5",
        "surfacebr": "163.57",
        "surfaceMezzanine": "0.00",
        "surfacepb": "133.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "182.07",
        "surfaceTotal": "296.57",
        "timeAvailableFrom": "9/13/22 13:25",
        "lat": 41.4826455,
        "lng": 2.3114706,
        "id_ext": "4205-122495-122495"
    },
    {
        "id": "6e82e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "2",
        "askingPriceRent": "1724.80",
        "askingPriceSale": "197120.00",
        "address": "Avenida De Enrique Mederos 20 ",
        "postalCode": "38760",
        "city": "1138024",
        "province": "38",
        "CCAA": "56",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "156.71",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "156.71",
        "surfaceTotal": "156.71",
        "timeAvailableFrom": "9/13/22 13:25",
        "lat": 28.6597398,
        "lng": -17.914911,
        "id_ext": "4205-122535-122535"
    },
    {
        "id": "7082e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Arrendado (propiedad)",
        "strategy": "2",
        "askingPriceRent": "1265.60",
        "askingPriceSale": "189840.00",
        "address": "Urbanización El Castillo ",
        "postalCode": "35630",
        "city": "1135003",
        "province": "35",
        "CCAA": "56",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "111.08",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "111.08",
        "surfaceTotal": "111.08",
        "timeAvailableFrom": "9/13/22 13:25",
        "lat": 14.5572969,
        "lng": -90.73322329999999,
        "id_ext": "4205-122537-122537"
    },
    {
        "id": "7282e90a-5633-ed11-9db1-0022489c4873",
        "active": false,
        "status": "Vendido",
        "strategy": "1",
        "askingPriceSale": "198240.00",
        "address": " Ingeniero J. De La Cierva s/n ",
        "postalCode": "14013",
        "city": "1114021",
        "province": "14",
        "CCAA": "51",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "176.65",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "176.65",
        "surfaceTotal": "176.65",
        "timeAvailableFrom": "9/13/22 13:25",
        "lat": 37.8881751,
        "lng": -4.7793835,
        "id_ext": "4205-122551-122551"
    },
    {
        "id": "7482e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "1",
        "askingPriceRent": "950.46",
        "askingPriceSale": "141036.00",
        "address": "Urbanización Aguamarina ",
        "postalCode": "03189",
        "city": "1103099",
        "province": "03",
        "CCAA": "42",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "170.85",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "170.85",
        "surfaceTotal": "170.85",
        "timeAvailableFrom": "9/13/22 13:25",
        "id_ext": "4205-122558-122558"
    },
    {
        "id": "7682e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "2",
        "askingPriceRent": "1374.24",
        "askingPriceSale": "192393.60",
        "address": " Astiigarrako Bidea 1 ",
        "postalCode": "20180",
        "city": "1120063",
        "province": "20",
        "CCAA": "53",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "196.32",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "196.32",
        "surfaceTotal": "196.32",
        "timeAvailableFrom": "9/13/22 13:25",
        "lat": 43.2993676,
        "lng": -1.8815009,
        "id_ext": "4205-122559-122559"
    },
    {
        "id": "7882e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "2",
        "askingPriceRent": "967.68",
        "askingPriceSale": "107520.00",
        "address": "Avenida De Zamora 61 ",
        "postalCode": "32005",
        "city": "1132054",
        "province": "32",
        "CCAA": "60",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "203.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "203.00",
        "surfaceTotal": "203.00",
        "timeAvailableFrom": "9/13/22 13:25",
        "lat": 42.325413,
        "lng": -7.8629984,
        "id_ext": "4205-122578-122578"
    },
    {
        "id": "7a82e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "1",
        "askingPriceRent": "952.00",
        "askingPriceSale": "202300.00",
        "address": "Carretera General 136 ",
        "postalCode": "33010",
        "city": "1133044",
        "province": "33",
        "CCAA": "31",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "155.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "155.00",
        "surfaceTotal": "155.00",
        "timeAvailableFrom": "9/13/22 13:25",
        "lat": 43.3785719,
        "lng": -5.7933356,
        "id_ext": "4205-122590-122590"
    },
    {
        "id": "7c82e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "2",
        "address": " La Cestilla 2 ",
        "postalCode": "34001",
        "city": "1134120",
        "province": "34",
        "CCAA": "59",
        "country": "ES",
        "use": "5",
        "surfacebr": "61.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "361.00",
        "surfaceBasement1": "132.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "132.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "61.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "445.30",
        "surfaceTotal": "554.00",
        "timeAvailableFrom": "9/13/22 13:25",
        "lat": 42.00971,
        "lng": -4.5334763,
        "id_ext": "4205-122606-122606"
    },
    {
        "id": "7e82e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - En legal",
        "strategy": "1",
        "askingPriceRent": "929.60",
        "askingPriceSale": "139440.00",
        "address": "Avenida De Asegra ",
        "postalCode": "18210",
        "city": "1118153",
        "province": "18",
        "CCAA": "51",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "166.01",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "166.01",
        "surfaceTotal": "166.01",
        "timeAvailableFrom": "9/13/22 13:25",
        "lat": 37.2235049,
        "lng": -3.6265043,
        "id_ext": "4205-122644-122644"
    },
    {
        "id": "8082e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "2",
        "askingPriceRent": "1612.80",
        "askingPriceSale": "241920.00",
        "address": " Francesç Marti I Mora ",
        "postalCode": "07011",
        "city": "1107040",
        "province": "07",
        "CCAA": "44",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "200.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "200.00",
        "surfaceTotal": "200.00",
        "timeAvailableFrom": "9/13/22 13:25",
        "lat": 39.5834294,
        "lng": 2.6370595,
        "id_ext": "4205-122668-122668"
    },
    {
        "id": "8282e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Arrendado (propiedad)",
        "strategy": "2",
        "askingPriceRent": "1077.30",
        "askingPriceSale": "167580.00",
        "address": " Amilcar 8 ",
        "postalCode": "07600",
        "city": "1107040",
        "province": "07",
        "CCAA": "44",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "176.55",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "176.55",
        "surfaceTotal": "176.55",
        "timeAvailableFrom": "9/13/22 13:25",
        "lat": 39.5061208,
        "lng": 2.7526303,
        "id_ext": "4205-122670-122670"
    },
    {
        "id": "8482e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Arrendado (propiedad)",
        "strategy": "CAMBIO DE USO",
        "askingPriceRent": "1141.00",
        "askingPriceSale": "125510.00",
        "address": "Plaza Miquel Dolç 1 ",
        "postalCode": "07008",
        "city": "1107040",
        "province": "07",
        "CCAA": "44",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "144.98",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "144.98",
        "surfaceTotal": "144.98",
        "timeAvailableFrom": "9/13/22 13:25",
        "lat": 39.576622,
        "lng": 2.668205,
        "id_ext": "4205-122672-122672"
    },
    {
        "id": "8682e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "1",
        "askingPriceRent": "1511.09",
        "askingPriceSale": "241774.40",
        "address": " Marcelo Celayeta 72 ",
        "postalCode": "31014",
        "city": "1131201",
        "province": "31",
        "CCAA": "11",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "215.87",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "215.87",
        "surfaceTotal": "215.87",
        "timeAvailableFrom": "9/13/22 13:25",
        "lat": 42.8280129,
        "lng": -1.6485522,
        "id_ext": "4205-122686-122686"
    },
    {
        "id": "8882e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "1",
        "askingPriceRent": "1560.94",
        "askingPriceSale": "227046.40",
        "address": " Joan Servera Camp 20 ",
        "postalCode": "07560",
        "city": "1107560",
        "province": "07",
        "CCAA": "44",
        "country": "ES",
        "use": "5",
        "surfacebr": "212.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "36.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "128.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "163.60",
        "surfaceTotal": "376.00",
        "timeAvailableFrom": "9/13/22 13:25",
        "lat": 39.603833,
        "lng": 3.3844639,
        "id_ext": "4205-122702-122702"
    },
    {
        "id": "8a82e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - En legal",
        "strategy": "2",
        "askingPriceRent": "630.00",
        "askingPriceSale": "88200.00",
        "address": "Carretera De Jesus 18 ",
        "postalCode": "23790",
        "city": "1123069",
        "province": "23",
        "CCAA": "51",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "180.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "180.00",
        "surfaceTotal": "180.00",
        "timeAvailableFrom": "9/13/22 13:25",
        "lat": 37.8698808,
        "lng": -4.1846569,
        "id_ext": "4205-122703-122703"
    },
    {
        "id": "8e82e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "1",
        "askingPriceRent": "406.92",
        "askingPriceSale": "61038.60",
        "address": "Plaza Mayor 28 ",
        "postalCode": "09300",
        "city": "1109321",
        "province": "09",
        "CCAA": "59",
        "country": "ES",
        "use": "5",
        "surfacebr": "40.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "170.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "182.00",
        "surfaceTotal": "210.00",
        "timeAvailableFrom": "9/13/22 13:25",
        "lat": 40.4158346,
        "lng": -3.7071805,
        "id_ext": "4205-122754-122754"
    },
    {
        "id": "9082e90a-5633-ed11-9db1-0022489c4873",
        "active": false,
        "status": "Vendido",
        "strategy": "1",
        "askingPriceRent": "425.04",
        "askingPriceSale": "57960.00",
        "address": " Damian Parras 4 ",
        "postalCode": "23760",
        "city": "1123006",
        "province": "23",
        "CCAA": "51",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "140.46",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "140.46",
        "surfaceTotal": "140.46",
        "timeAvailableFrom": "9/13/22 13:25",
        "lat": 37.93681,
        "lng": -4.05649,
        "id_ext": "4205-122770-122770"
    },
    {
        "id": "9282e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "2",
        "askingPriceRent": "914.97",
        "askingPriceSale": "123520.95",
        "address": " Teresa Pamies ",
        "postalCode": "43204",
        "city": "1143123",
        "province": "43",
        "CCAA": "55",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "130.71",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "130.71",
        "surfaceTotal": "130.71",
        "timeAvailableFrom": "9/13/22 13:25",
        "lat": 41.1498259,
        "lng": 1.1055321,
        "id_ext": "4205-122798-122798"
    },
    {
        "id": "9482e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "2",
        "askingPriceRent": "2940.00",
        "askingPriceSale": "462000.00",
        "address": "Rua Da Fonte De Santo Antonio 21 ",
        "postalCode": "15702",
        "city": "1115078",
        "province": "15",
        "CCAA": "60",
        "country": "ES",
        "use": "5",
        "surfacebr": "162.51",
        "surfaceMezzanine": "0.00",
        "surfacepb": "769.17",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "310.58",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "973.21",
        "surfaceTotal": "1242.26",
        "timeAvailableFrom": "9/13/22 13:25",
        "lat": 42.8769458,
        "lng": -8.5437164,
        "id_ext": "4205-122841-122841"
    },
    {
        "id": "9682e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "2",
        "askingPriceRent": "563.50",
        "askingPriceSale": "67620.00",
        "address": "Avenida De Jose Quintana 2 ",
        "postalCode": "34100",
        "city": "1134157",
        "province": "34",
        "CCAA": "59",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "148.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "148.00",
        "surfaceTotal": "148.00",
        "timeAvailableFrom": "9/13/22 13:25",
        "lat": 42.5221381,
        "lng": -4.7373332,
        "id_ext": "4205-122855-122855"
    },
    {
        "id": "9882e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "2",
        "askingPriceRent": "1470.00",
        "askingPriceSale": "205800.00",
        "address": "Calle Real 22 ",
        "postalCode": "11100",
        "city": "1111031",
        "province": "11",
        "CCAA": "51",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "200.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "200.00",
        "surfaceTotal": "200.00",
        "timeAvailableFrom": "9/13/22 13:25",
        "lat": 36.46650950000001,
        "lng": -6.195422199999999,
        "id_ext": "4205-122866-122866"
    },
    {
        "id": "9a82e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "2",
        "askingPriceRent": "1248.80",
        "askingPriceSale": "117075.00",
        "address": " Cardenal Mendoza 17 ",
        "postalCode": "19250",
        "city": "1119257",
        "province": "19",
        "CCAA": "40",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "200.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "200.00",
        "surfaceTotal": "200.00",
        "timeAvailableFrom": "9/13/22 13:25",
        "lat": 41.0678503,
        "lng": -2.6428906,
        "id_ext": "4205-122871-122871"
    },
    {
        "id": "9c82e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "2",
        "askingPriceRent": "1285.90",
        "askingPriceSale": "191716.00",
        "address": "Avenida Malecon 25 ",
        "postalCode": "15960",
        "city": "1115635",
        "province": "15",
        "CCAA": "60",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "266.44",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "266.44",
        "surfaceTotal": "266.44",
        "timeAvailableFrom": "9/13/22 13:25",
        "lat": 42.5541748,
        "lng": -8.989874799999999,
        "id_ext": "4205-122874-122874"
    },
    {
        "id": "9e82e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "2",
        "askingPriceRent": "1756.30",
        "askingPriceSale": "243180.00",
        "address": " Raval 31 ",
        "postalCode": "08770",
        "city": "1108240",
        "province": "08",
        "CCAA": "55",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "193.26",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "193.26",
        "surfaceTotal": "193.26",
        "timeAvailableFrom": "9/13/22 13:25",
        "lat": 41.4239735,
        "lng": 1.7841296,
        "id_ext": "4205-122924-122924"
    },
    {
        "id": "a082e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Arrendado (propiedad)",
        "strategy": "2",
        "askingPriceRent": "1638.00",
        "askingPriceSale": "245700.00",
        "address": " Mosen Jacinto Verdaguer, 122 ",
        "postalCode": "08620",
        "city": "1108263",
        "province": "08",
        "CCAA": "55",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "180.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "180.00",
        "surfaceTotal": "180.00",
        "timeAvailableFrom": "9/13/22 13:25",
        "lat": 41.3969203,
        "lng": 2.0081523,
        "id_ext": "4205-122934-122934"
    },
    {
        "id": "a282e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Arrendado (propiedad)",
        "strategy": "SINGULARES",
        "askingPriceRent": "2915.50",
        "askingPriceSale": "333200.00",
        "address": " Garcia De Vinuesa 10 ",
        "postalCode": "41001",
        "city": "1141091",
        "province": "41",
        "CCAA": "51",
        "country": "ES",
        "use": "5",
        "surfacebr": "555.18",
        "surfaceMezzanine": "0.00",
        "surfacepb": "894.40",
        "surfaceBasement1": "724.00",
        "surfaceBasement2": "716.40",
        "surfaceRest": "712.00",
        "surfacesr": "2152.40",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "546.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "2137.15",
        "surfaceTotal": "3601.98",
        "timeAvailableFrom": "9/13/22 13:25",
        "lat": 37.3866607,
        "lng": -5.9944886,
        "id_ext": "4205-122935-122935"
    },
    {
        "id": "a482e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "2",
        "askingPriceRent": "1320.90",
        "askingPriceSale": "186480.00",
        "address": "Poligono Ind. Parsi ",
        "postalCode": "41020",
        "city": "1141091",
        "province": "41",
        "CCAA": "51",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "222.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "222.00",
        "surfaceTotal": "222.00",
        "timeAvailableFrom": "9/13/22 13:25",
        "lat": 37.3778056,
        "lng": -5.9193871,
        "id_ext": "4205-122956-122956"
    },
    {
        "id": "a682e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "2",
        "askingPriceRent": "853.02",
        "askingPriceSale": "113736.00",
        "address": " Guadalajara (Alonso Mingo-Bellavista) ",
        "postalCode": "41014",
        "city": "1141091",
        "province": "41",
        "CCAA": "51",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "135.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "135.00",
        "surfaceTotal": "135.00",
        "timeAvailableFrom": "9/13/22 13:25",
        "lat": 37.3221374,
        "lng": -5.9659406,
        "id_ext": "4205-122957-122957"
    },
    {
        "id": "a882e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "2",
        "askingPriceRent": "1176.00",
        "askingPriceSale": "147000.00",
        "address": " Montsolis 1 ",
        "postalCode": "17403",
        "city": "1117164",
        "province": "17",
        "CCAA": "55",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "283.57",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "283.57",
        "surfaceTotal": "283.57",
        "timeAvailableFrom": "9/13/22 13:25",
        "lat": 41.8797349,
        "lng": 2.5089246,
        "id_ext": "4205-122969-122969"
    },
    {
        "id": "aa82e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Arrendado (propiedad)",
        "strategy": "2",
        "askingPriceRent": "981.12",
        "askingPriceSale": "147840.00",
        "address": " Bulto 20 ",
        "postalCode": "29620",
        "city": "1129901",
        "province": "29",
        "CCAA": "51",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "123.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "123.00",
        "surfaceTotal": "123.00",
        "timeAvailableFrom": "9/13/22 13:25",
        "lat": 36.6102965,
        "lng": -4.5036486,
        "id_ext": "4205-123009-123009"
    },
    {
        "id": "ac82e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Arrendado (propiedad)",
        "strategy": "2",
        "address": "Avenida De La Arboleda s/n ",
        "postalCode": "41940",
        "city": "1141093",
        "province": "41",
        "CCAA": "51",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "156.45",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "156.45",
        "surfaceTotal": "156.45",
        "timeAvailableFrom": "9/13/22 13:25",
        "lat": 37.3733763,
        "lng": -6.0394403,
        "id_ext": "4205-123011-123011"
    },
    {
        "id": "ae82e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - En legal",
        "strategy": "1",
        "askingPriceRent": "567.00",
        "askingPriceSale": "75600.00",
        "address": "Plaza Del Ferial 34 ",
        "postalCode": "31420",
        "city": "1131243",
        "province": "31",
        "CCAA": "11",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "121.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "121.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "181.50",
        "surfaceTotal": "242.00",
        "timeAvailableFrom": "9/13/22 13:25",
        "lat": 42.777709,
        "lng": -1.4589319,
        "id_ext": "4205-123054-123054"
    },
    {
        "id": "b082e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "2",
        "askingPriceRent": "1281.00",
        "askingPriceSale": "179340.00",
        "address": " Mayor 6 y 8 ",
        "postalCode": "20170",
        "city": "1120073",
        "province": "20",
        "CCAA": "53",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "161.90",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "161.90",
        "surfaceTotal": "161.90",
        "timeAvailableFrom": "9/13/22 13:25",
        "lat": 43.2714405,
        "lng": -2.0498543,
        "id_ext": "4205-123056-123056"
    },
    {
        "id": "b282e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "2",
        "askingPriceRent": "1036.00",
        "askingPriceSale": "155400.00",
        "address": "Avenida Onze De Setembre 16 ",
        "postalCode": "08170",
        "city": "1108136",
        "province": "08",
        "CCAA": "55",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "158.35",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "158.35",
        "surfaceTotal": "158.35",
        "timeAvailableFrom": "9/13/22 13:25",
        "lat": 41.5434195,
        "lng": 2.2649724,
        "id_ext": "4205-123058-123058"
    },
    {
        "id": "b482e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "1",
        "askingPriceRent": "1132.88",
        "askingPriceSale": "168098.00",
        "address": " Luis Espada 43 ",
        "postalCode": "32600",
        "city": "1132085",
        "province": "32",
        "CCAA": "60",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "80.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "91.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "125.50",
        "surfaceTotal": "171.00",
        "timeAvailableFrom": "9/13/22 13:25",
        "lat": 41.9402367,
        "lng": -7.4379209,
        "id_ext": "4205-123082-123082"
    },
    {
        "id": "b682e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "SINGULARES",
        "askingPriceSale": "7572908.00",
        "address": " Policarpo Sanz 23 ",
        "postalCode": "36202",
        "city": "1136057",
        "province": "36",
        "CCAA": "60",
        "country": "ES",
        "use": "5",
        "surfacebr": "295.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "859.00",
        "surfaceBasement1": "291.00",
        "surfaceBasement2": "995.00",
        "surfaceRest": "1507.00",
        "surfacesr": "2793.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "295.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "2344.00",
        "surfaceTotal": "3947.00",
        "timeAvailableFrom": "9/13/22 13:25",
        "lat": 42.2377456,
        "lng": -8.721668600000001,
        "id_ext": "4205-123089-123089"
    },
    {
        "id": "b882e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "2",
        "askingPriceSale": "924924.00",
        "address": " Venezuela 34 ",
        "postalCode": "36203",
        "city": "1136057",
        "province": "36",
        "CCAA": "60",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "439.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "439.00",
        "surfaceTotal": "439.00",
        "timeAvailableFrom": "9/13/22 13:25",
        "lat": 42.24059889999999,
        "lng": -8.7207268,
        "id_ext": "4205-123101-123101"
    },
    {
        "id": "ba82e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "2",
        "address": "Avenida De La Florida 47 ",
        "postalCode": "36210",
        "city": "1136057",
        "province": "36",
        "CCAA": "60",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "200.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "200.00",
        "surfaceTotal": "200.00",
        "timeAvailableFrom": "9/13/22 13:25",
        "lat": 42.218136,
        "lng": -8.736222099999999,
        "id_ext": "4205-123102-123102"
    },
    {
        "id": "bc82e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "1",
        "askingPriceRent": "273.00",
        "askingPriceSale": "38220.00",
        "address": " Plaza Mayor 18 ",
        "postalCode": "37160",
        "city": "1137364",
        "province": "37",
        "CCAA": "59",
        "country": "ES",
        "use": "5",
        "surfacebr": "57.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "57.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "57.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "102.60",
        "surfaceTotal": "171.00",
        "timeAvailableFrom": "9/13/22 13:25",
        "lat": 40.4153281,
        "lng": -3.7082971,
        "id_ext": "4205-123116-123116"
    },
    {
        "id": "be82e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Arrendado (propiedad)",
        "strategy": "2",
        "askingPriceRent": "3827.60",
        "askingPriceSale": "535864.00",
        "address": "Plaza De Galicia 7 ",
        "postalCode": "36600",
        "city": "1136060",
        "province": "36",
        "CCAA": "60",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "98.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "241.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "218.50",
        "surfaceTotal": "339.00",
        "timeAvailableFrom": "9/13/22 13:25",
        "lat": 42.59541919999999,
        "lng": -8.7656036,
        "id_ext": "4205-123120-123120"
    },
    {
        "id": "c082e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "1",
        "askingPriceRent": "1089.48",
        "askingPriceSale": "174316.80",
        "address": " Archiduque Carlos 107-109 ",
        "postalCode": "46014",
        "city": "1146250",
        "province": "46",
        "CCAA": "42",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "155.64",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "155.64",
        "surfaceTotal": "155.64",
        "timeAvailableFrom": "9/13/22 13:25",
        "id_ext": "4205-123159-123159"
    },
    {
        "id": "c282e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Arrendado (propiedad)",
        "strategy": "2",
        "askingPriceRent": "3071.25",
        "askingPriceSale": "482108.87",
        "address": " Tierra De Medina 5 ",
        "postalCode": "47008",
        "city": "1147186",
        "province": "47",
        "CCAA": "59",
        "country": "ES",
        "use": "11",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "324.90",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "324.90",
        "surfaceTotal": "324.90",
        "timeAvailableFrom": "9/13/22 13:25",
        "lat": 41.6193578,
        "lng": -4.7490384,
        "id_ext": "4205-123172-123172"
    },
    {
        "id": "c482e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "2",
        "askingPriceRent": "1020.60",
        "askingPriceSale": "147336.00",
        "address": " Santa Lucia 19 ",
        "postalCode": "47004",
        "city": "1147186",
        "province": "47",
        "CCAA": "59",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "323.80",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "323.80",
        "surfaceTotal": "323.80",
        "timeAvailableFrom": "9/13/22 13:25",
        "lat": 41.6504505,
        "lng": -4.7164699,
        "id_ext": "4205-123173-123173"
    },
    {
        "id": "c682e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "2",
        "askingPriceRent": "204.40",
        "askingPriceSale": "28616.00",
        "address": " Gran Via SN ",
        "postalCode": "25690",
        "city": "1125254",
        "province": "25",
        "CCAA": "55",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "72.92",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "72.92",
        "surfaceTotal": "72.92",
        "timeAvailableFrom": "9/13/22 13:25",
        "lat": 41.6896179,
        "lng": 0.7278493,
        "id_ext": "4205-123185-123185"
    },
    {
        "id": "c882e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "1",
        "askingPriceRent": "1577.80",
        "askingPriceSale": "315560.00",
        "address": "Avenida Do Xubia 15 ",
        "postalCode": "15570",
        "city": "1115054",
        "province": "15",
        "CCAA": "60",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "163.62",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "130.10",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "228.67",
        "surfaceTotal": "293.72",
        "timeAvailableFrom": "9/13/22 13:25",
        "lat": 43.516211,
        "lng": -8.1506487,
        "id_ext": "4205-123199-123199"
    },
    {
        "id": "ca82e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Arrendado (propiedad)",
        "strategy": "2",
        "askingPriceRent": "767.20",
        "askingPriceSale": "105490.00",
        "address": "Carretera De Logroño 48-50-52 ",
        "postalCode": "50620",
        "city": "1150297",
        "province": "50",
        "CCAA": "10",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "0.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "150.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "75.00",
        "surfaceTotal": "150.00",
        "timeAvailableFrom": "9/13/22 13:25",
        "lat": 41.7190642,
        "lng": -1.0282995,
        "id_ext": "4205-123222-123222"
    },
    {
        "id": "cc82e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Arrendado (propiedad)",
        "strategy": "2",
        "askingPriceRent": "1114.74",
        "askingPriceSale": "153276.20",
        "address": " Del Mar ",
        "postalCode": "04620",
        "city": "1104100",
        "province": "04",
        "CCAA": "51",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "65.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "188.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "159.00",
        "surfaceTotal": "253.00",
        "timeAvailableFrom": "9/13/22 13:25",
        "id_ext": "4205-123278-123278"
    },
    {
        "id": "ce82e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "2",
        "askingPriceRent": "5390.00",
        "askingPriceSale": "770000.00",
        "address": " Isabel La Catolica, 2 ",
        "postalCode": "18009",
        "city": "1118087",
        "province": "18",
        "CCAA": "51",
        "country": "ES",
        "use": "5",
        "surfacebr": "87.65",
        "surfaceMezzanine": "0.00",
        "surfacepb": "225.31",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "73.16",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "288.19",
        "surfaceTotal": "386.12",
        "timeAvailableFrom": "9/13/22 13:25",
        "lat": 37.1751959,
        "lng": -3.5976027,
        "id_ext": "4205-123346-123346"
    },
    {
        "id": "d082e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Arrendado (propiedad)",
        "strategy": "2",
        "address": "Calle Antonio Gaudí 6 ",
        "postalCode": "14005",
        "city": "1114021",
        "province": "14",
        "CCAA": "51",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "2368.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "2368.00",
        "surfaceTotal": "2368.00",
        "timeAvailableFrom": "9/13/22 13:25",
        "lat": 37.8876537,
        "lng": -4.7884569,
        "id_ext": "4205-123349-123349"
    },
    {
        "id": "6c845e94-6233-ed11-9db1-0022489ca4d1",
        "active": false,
        "status": "Vendido",
        "address": "Calle Antonio Gaudí 6 ",
        "postalCode": "14005",
        "city": "1114021",
        "province": "14",
        "CCAA": "51",
        "country": "ES",
        "use": "8",
        "surfacebr": "24.72",
        "surfaceMezzanine": "0.00",
        "surfacepb": "0.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "7.42",
        "surfaceTotal": "24.72",
        "timeAvailableFrom": "9/13/22 14:50",
        "lat": 37.8876537,
        "lng": -4.7884569,
        "id_ext": "4205-123349-123350"
    },
    {
        "id": "6e845e94-6233-ed11-9db1-0022489ca4d1",
        "active": false,
        "status": "Vendido",
        "address": "Calle Antonio Gaudí 6 ",
        "postalCode": "14005",
        "city": "1114021",
        "province": "14",
        "CCAA": "51",
        "country": "ES",
        "use": "8",
        "surfacebr": "29.02",
        "surfaceMezzanine": "0.00",
        "surfacepb": "0.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "8.71",
        "surfaceTotal": "29.02",
        "timeAvailableFrom": "9/13/22 14:50",
        "lat": 37.8876537,
        "lng": -4.7884569,
        "id_ext": "4205-123349-123351"
    },
    {
        "id": "70845e94-6233-ed11-9db1-0022489ca4d1",
        "active": false,
        "status": "Vendido",
        "address": "Calle Antonio Gaudí 6 ",
        "postalCode": "14005",
        "city": "1114021",
        "province": "14",
        "CCAA": "51",
        "country": "ES",
        "use": "8",
        "surfacebr": "28.31",
        "surfaceMezzanine": "0.00",
        "surfacepb": "0.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "8.49",
        "surfaceTotal": "28.31",
        "timeAvailableFrom": "9/13/22 14:50",
        "lat": 37.8876537,
        "lng": -4.7884569,
        "id_ext": "4205-123349-123352"
    },
    {
        "id": "72845e94-6233-ed11-9db1-0022489ca4d1",
        "active": true,
        "status": "Comercializable",
        "address": "Calle Antonio Gaudí 6 ",
        "postalCode": "14005",
        "city": "1114021",
        "province": "14",
        "CCAA": "51",
        "country": "ES",
        "use": "8",
        "surfacebr": "26.25",
        "surfaceMezzanine": "0.00",
        "surfacepb": "0.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "7.88",
        "surfaceTotal": "26.25",
        "timeAvailableFrom": "9/13/22 14:50",
        "lat": 37.8876537,
        "lng": -4.7884569,
        "id_ext": "4205-123349-123353"
    },
    {
        "id": "74845e94-6233-ed11-9db1-0022489ca4d1",
        "active": false,
        "status": "Vendido",
        "address": "Calle Antonio Gaudí 6 ",
        "postalCode": "14005",
        "city": "1114021",
        "province": "14",
        "CCAA": "51",
        "country": "ES",
        "use": "8",
        "surfacebr": "20.88",
        "surfaceMezzanine": "0.00",
        "surfacepb": "0.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "6.26",
        "surfaceTotal": "20.88",
        "timeAvailableFrom": "9/13/22 14:50",
        "lat": 37.8876537,
        "lng": -4.7884569,
        "id_ext": "4205-123349-123354"
    },
    {
        "id": "76845e94-6233-ed11-9db1-0022489ca4d1",
        "active": false,
        "status": "Vendido",
        "address": "Calle Antonio Gaudí 6 ",
        "postalCode": "14005",
        "city": "1114021",
        "province": "14",
        "CCAA": "51",
        "country": "ES",
        "use": "8",
        "surfacebr": "23.57",
        "surfaceMezzanine": "0.00",
        "surfacepb": "0.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "7.07",
        "surfaceTotal": "23.57",
        "timeAvailableFrom": "9/13/22 14:50",
        "lat": 37.8876537,
        "lng": -4.7884569,
        "id_ext": "4205-123349-123355"
    },
    {
        "id": "78845e94-6233-ed11-9db1-0022489ca4d1",
        "active": true,
        "status": "Comercializable",
        "askingPriceRent": "854.28",
        "askingPriceSale": "129724.00",
        "address": "Calle Antonio Gaudí 6 ",
        "postalCode": "14005",
        "city": "1114021",
        "province": "14",
        "CCAA": "51",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "680.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "680.00",
        "surfaceTotal": "680.00",
        "timeAvailableFrom": "9/13/22 14:50",
        "lat": 37.8876537,
        "lng": -4.7884569,
        "id_ext": "4205-123349-123357"
    },
    {
        "id": "d282e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "2",
        "askingPriceRent": "854.28",
        "askingPriceSale": "129724.00",
        "address": " Feria 3 ",
        "postalCode": "49004",
        "city": "1149275",
        "province": "49",
        "CCAA": "59",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "226.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "226.00",
        "surfaceTotal": "226.00",
        "timeAvailableFrom": "9/13/22 13:25",
        "lat": 41.5034712,
        "lng": -5.7467879,
        "id_ext": "4205-123356-123356"
    },
    {
        "id": "d482e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "2",
        "address": "Carretera de Vigo 25 ",
        "postalCode": "321450",
        "city": "1132025",
        "province": "32",
        "CCAA": "60",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "114.54",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "114.54",
        "surfaceTotal": "114.54",
        "timeAvailableFrom": "9/13/22 13:25",
        "lat": 42.3208853,
        "lng": -7.8800601,
        "id_ext": "4205-123359-123359"
    },
    {
        "id": "d682e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "2",
        "address": "Calle Ribeira Ribeira de Maio 2 ",
        "postalCode": "15240",
        "city": "1115053",
        "province": "15",
        "CCAA": "60",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "96.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "96.00",
        "surfaceTotal": "96.00",
        "timeAvailableFrom": "9/13/22 13:25",
        "lat": 42.7914625,
        "lng": -8.988729600000001,
        "id_ext": "4205-123360-123360"
    },
    {
        "id": "d882e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "2",
        "askingPriceRent": "4833.29",
        "askingPriceSale": "790902.00",
        "address": " Independencia 6 ",
        "postalCode": "24001",
        "city": "1124089",
        "province": "24",
        "CCAA": "59",
        "country": "ES",
        "use": "5",
        "surfacebr": "287.79",
        "surfaceMezzanine": "0.00",
        "surfacepb": "0.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "411.97",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "292.32",
        "surfaceTotal": "699.76",
        "timeAvailableFrom": "9/13/22 13:25",
        "lat": 42.5959597,
        "lng": -5.5710184,
        "id_ext": "4205-123493-123493"
    },
    {
        "id": "da82e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "2",
        "askingPriceRent": "1789.20",
        "askingPriceSale": "268380.00",
        "address": "Calle Pages Del Corro 79 ",
        "postalCode": "41010",
        "city": "1141091",
        "province": "41",
        "CCAA": "51",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "201.40",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "201.40",
        "surfaceTotal": "201.40",
        "timeAvailableFrom": "9/13/22 13:25",
        "lat": 37.383313,
        "lng": -6.0043666,
        "id_ext": "4205-123550-123550"
    },
    {
        "id": "dc82e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "2",
        "askingPriceSale": "954800.00",
        "address": "Calle Fuentecillas 8 ",
        "postalCode": "40410",
        "city": "1140076",
        "province": "40",
        "CCAA": "59",
        "country": "ES",
        "use": "2",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "0.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "548.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "274.00",
        "surfaceTotal": "548.00",
        "timeAvailableFrom": "9/13/22 13:25",
        "lat": 40.7339528,
        "lng": -4.1866376,
        "id_ext": "4205-123754-123754"
    },
    {
        "id": "e282e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "1",
        "askingPriceRent": "1334.11",
        "askingPriceSale": "251851.60",
        "address": "Paseo De Valldaura 212 ",
        "postalCode": "08042",
        "city": "1108019",
        "province": "08",
        "CCAA": "55",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "0.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "81.77",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "40.89",
        "surfaceTotal": "81.77",
        "timeAvailableFrom": "9/13/22 13:25",
        "lat": 41.4384129,
        "lng": 2.1727764,
        "id_ext": "4205-123915-123915"
    },
    {
        "id": "e482e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "2",
        "askingPriceRent": "2744.00",
        "askingPriceSale": "372400.00",
        "address": " Real 31 ",
        "postalCode": "28400",
        "city": "1128047",
        "province": "28",
        "CCAA": "54",
        "country": "ES",
        "use": "5",
        "surfacebr": "103.80",
        "surfaceMezzanine": "0.00",
        "surfacepb": "171.22",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "202.36",
        "surfaceTotal": "275.02",
        "timeAvailableFrom": "9/13/22 13:25",
        "lat": 40.6308775,
        "lng": -4.0055605,
        "id_ext": "4205-123919-123919"
    },
    {
        "id": "e682e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "1",
        "askingPriceRent": "1676.50",
        "askingPriceSale": "234710.00",
        "address": "Calle Gándara 8 ",
        "postalCode": "36619",
        "city": "1136057",
        "province": "36",
        "CCAA": "60",
        "country": "ES",
        "use": "6",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "286.53",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "286.53",
        "surfaceTotal": "286.53",
        "timeAvailableFrom": "9/13/22 13:25",
        "lat": 42.1644134,
        "lng": -8.7180884,
        "id_ext": "4205-123937-123937"
    },
    {
        "id": "e882e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "1",
        "askingPriceRent": "4697.28",
        "askingPriceSale": "587160.00",
        "address": "Calle Carrasco I Formiguera ",
        "postalCode": "08302",
        "city": "1108121",
        "province": "08",
        "CCAA": "55",
        "country": "ES",
        "use": "8",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "2796.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "2796.00",
        "surfaceTotal": "2796.00",
        "timeAvailableFrom": "9/13/22 13:25",
        "lat": 41.5323575,
        "lng": 2.4270995,
        "id_ext": "4205-123953-123953"
    },
    {
        "id": "ea82e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "2",
        "askingPriceRent": "1724.80",
        "askingPriceSale": "190344.00",
        "address": " Residencial Al- Baida Pueblo Arabe ",
        "postalCode": "04740",
        "city": "1104079",
        "province": "04",
        "CCAA": "51",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "224.25",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "224.25",
        "surfaceTotal": "224.25",
        "timeAvailableFrom": "9/13/22 13:25",
        "lat": 36.7284193,
        "lng": -2.6230286,
        "id_ext": "4205-123958-123958"
    },
    {
        "id": "ec82e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "1",
        "askingPriceRent": "991.20",
        "askingPriceSale": "161070.00",
        "address": " Barcelona 10 12 ",
        "postalCode": "15100",
        "city": "1115019",
        "province": "15",
        "CCAA": "60",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "173.35",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "173.35",
        "surfaceTotal": "173.35",
        "timeAvailableFrom": "9/13/22 13:25",
        "lat": 41.3873974,
        "lng": 2.168568,
        "id_ext": "4205-123960-123960"
    },
    {
        "id": "ee82e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "2",
        "askingPriceRent": "2275.00",
        "askingPriceSale": "350000.00",
        "address": " Ramon y Cajal 2 ",
        "postalCode": "36600",
        "city": "1136060",
        "province": "36",
        "CCAA": "60",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "239.82",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "239.82",
        "surfaceTotal": "239.82",
        "timeAvailableFrom": "9/13/22 13:25",
        "lat": 42.5961673,
        "lng": -8.765377899999999,
        "id_ext": "4205-123961-123961"
    },
    {
        "id": "f082e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "1",
        "askingPriceRent": "2372.58",
        "askingPriceSale": "342706.00",
        "address": "Plaza Peregrina 50 ",
        "postalCode": "36001",
        "city": "1136038",
        "province": "36",
        "CCAA": "60",
        "country": "ES",
        "use": "5",
        "surfacebr": "91.50",
        "surfaceMezzanine": "0.00",
        "surfacepb": "128.40",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "66.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "188.85",
        "surfaceTotal": "285.90",
        "timeAvailableFrom": "9/13/22 13:25",
        "lat": 42.4308514,
        "lng": -8.644010399999999,
        "id_ext": "4205-123962-123962"
    },
    {
        "id": "f282e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "2",
        "askingPriceRent": "4081.00",
        "askingPriceSale": "489300.00",
        "address": " Maria De Zayas Plaza 11 ",
        "postalCode": "09001",
        "city": "1109059",
        "province": "09",
        "CCAA": "59",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "0.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "379.13",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "189.57",
        "surfaceTotal": "379.13",
        "timeAvailableFrom": "9/13/22 13:25",
        "lat": 42.3273055,
        "lng": -3.6985778,
        "id_ext": "4205-123965-123965"
    },
    {
        "id": "f482e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "1",
        "askingPriceRent": "917.70",
        "askingPriceSale": "135660.00",
        "address": "Avenida Villajoyosa ",
        "postalCode": "03502",
        "city": "1103031",
        "province": "03",
        "CCAA": "42",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "57.14",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "57.14",
        "surfaceTotal": "57.14",
        "timeAvailableFrom": "9/13/22 13:25",
        "lat": 38.6005665,
        "lng": -0.1357372,
        "id_ext": "4205-123973-123973"
    },
    {
        "id": "f682e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "1",
        "askingPriceRent": "1329.44",
        "askingPriceSale": "265888.00",
        "address": " Partida La Cala ",
        "postalCode": "03502",
        "city": "1103031",
        "province": "03",
        "CCAA": "42",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "94.96",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "94.96",
        "surfaceTotal": "94.96",
        "timeAvailableFrom": "9/13/22 13:25",
        "lat": 38.5234756,
        "lng": -0.1691137,
        "id_ext": "4205-123974-123974"
    },
    {
        "id": "f882e90a-5633-ed11-9db1-0022489c4873",
        "active": false,
        "status": "Vendido",
        "strategy": "1",
        "askingPriceRent": "1433.15",
        "askingPriceSale": "266156.80",
        "address": "Avenida España 15 ",
        "postalCode": "28100",
        "city": "1128006",
        "province": "28",
        "CCAA": "54",
        "country": "ES",
        "use": "5",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "146.24",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "146.24",
        "surfaceTotal": "146.24",
        "timeAvailableFrom": "9/13/22 13:25",
        "lat": 40.5482918,
        "lng": -3.6403653,
        "id_ext": "4205-123977-123977"
    },
    {
        "id": "fa82e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "2",
        "address": "Calle Nuñez De Balboa 56 ",
        "district": "2807904",
        "postalCode": "28001",
        "city": "1128079",
        "province": "28",
        "CCAA": "54",
        "country": "ES",
        "use": "7",
        "surfacebr": "272.80",
        "surfaceMezzanine": "0.00",
        "surfacepb": "243.82",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "272.80",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "325.66",
        "surfaceTotal": "516.62",
        "timeAvailableFrom": "9/13/22 13:25",
        "lat": 40.4285843,
        "lng": -3.6823934,
        "id_ext": "4205-124223-124223"
    }
]